/*! For license information please see main.js.LICENSE.txt */
!(function () {
  var e = {
      440: function (e) {
        e.exports = (function (e) {
          function t(r) {
            if (n[r]) return n[r].exports;
            var i = (n[r] = { exports: {}, id: r, loaded: !1 });
            return (
              e[r].call(i.exports, i, i.exports, t), (i.loaded = !0), i.exports
            );
          }
          var n = {};
          return (t.m = e), (t.c = n), (t.p = ''), t(0);
        })([
          function (e, t, n) {
            'use strict';
            var r = (function (e) {
              return e && e.__esModule ? e : { default: e };
            })(n(2));
            e.exports = r.default;
          },
          function (e, t) {
            e.exports = function (e) {
              var t = typeof e;
              return null != e && ('object' == t || 'function' == t);
            };
          },
          function (e, t, n) {
            'use strict';
            function r(e) {
              return e && e.__esModule ? e : { default: e };
            }
            Object.defineProperty(t, '__esModule', { value: !0 });
            var i = r(n(9)),
              s = r(n(3)),
              a = n(4);
            t.default = (function () {
              if ('undefined' != typeof window) {
                var e = { history: [] },
                  t = { offset: {}, threshold: 0, test: a.inViewport },
                  n = (0, i.default)(function () {
                    e.history.forEach(function (t) {
                      e[t].check();
                    });
                  }, 100);
                ['scroll', 'resize', 'load'].forEach(function (e) {
                  return addEventListener(e, n);
                }),
                  window.MutationObserver &&
                    addEventListener('DOMContentLoaded', function () {
                      new MutationObserver(n).observe(document.body, {
                        attributes: !0,
                        childList: !0,
                        subtree: !0,
                      });
                    });
                var r = function (n) {
                  if ('string' == typeof n) {
                    var r = [].slice.call(document.querySelectorAll(n));
                    return (
                      e.history.indexOf(n) > -1
                        ? (e[n].elements = r)
                        : ((e[n] = (0, s.default)(r, t)), e.history.push(n)),
                      e[n]
                    );
                  }
                };
                return (
                  (r.offset = function (e) {
                    if (void 0 === e) return t.offset;
                    var n = function (e) {
                      return 'number' == typeof e;
                    };
                    return (
                      ['top', 'right', 'bottom', 'left'].forEach(
                        n(e)
                          ? function (n) {
                              return (t.offset[n] = e);
                            }
                          : function (r) {
                              return n(e[r]) ? (t.offset[r] = e[r]) : null;
                            }
                      ),
                      t.offset
                    );
                  }),
                  (r.threshold = function (e) {
                    return 'number' == typeof e && e >= 0 && e <= 1
                      ? (t.threshold = e)
                      : t.threshold;
                  }),
                  (r.test = function (e) {
                    return 'function' == typeof e ? (t.test = e) : t.test;
                  }),
                  (r.is = function (e) {
                    return t.test(e, t);
                  }),
                  r.offset(0),
                  r
                );
              }
            })();
          },
          function (e, t) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 });
            var n = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    (r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      'value' in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r);
                  }
                }
                return function (t, n, r) {
                  return n && e(t.prototype, n), r && e(t, r), t;
                };
              })(),
              r = (function () {
                function e(t, n) {
                  (function (e, t) {
                    if (!(e instanceof t))
                      throw new TypeError('Cannot call a class as a function');
                  })(this, e),
                    (this.options = n),
                    (this.elements = t),
                    (this.current = []),
                    (this.handlers = { enter: [], exit: [] }),
                    (this.singles = { enter: [], exit: [] });
                }
                return (
                  n(e, [
                    {
                      key: 'check',
                      value: function () {
                        var e = this;
                        return (
                          this.elements.forEach(function (t) {
                            var n = e.options.test(t, e.options),
                              r = e.current.indexOf(t),
                              i = r > -1,
                              s = !n && i;
                            n && !i && (e.current.push(t), e.emit('enter', t)),
                              s && (e.current.splice(r, 1), e.emit('exit', t));
                          }),
                          this
                        );
                      },
                    },
                    {
                      key: 'on',
                      value: function (e, t) {
                        return this.handlers[e].push(t), this;
                      },
                    },
                    {
                      key: 'once',
                      value: function (e, t) {
                        return this.singles[e].unshift(t), this;
                      },
                    },
                    {
                      key: 'emit',
                      value: function (e, t) {
                        for (; this.singles[e].length; )
                          this.singles[e].pop()(t);
                        for (var n = this.handlers[e].length; --n > -1; )
                          this.handlers[e][n](t);
                        return this;
                      },
                    },
                  ]),
                  e
                );
              })();
            t.default = function (e, t) {
              return new r(e, t);
            };
          },
          function (e, t) {
            'use strict';
            Object.defineProperty(t, '__esModule', { value: !0 }),
              (t.inViewport = function (e, t) {
                var n = e.getBoundingClientRect(),
                  r = n.top,
                  i = n.right,
                  s = n.bottom,
                  a = n.left,
                  o = n.width,
                  l = n.height,
                  c = s,
                  u = window.innerWidth - a,
                  d = window.innerHeight - r,
                  p = i,
                  f = t.threshold * o,
                  h = t.threshold * l;
                return (
                  c > t.offset.top + h &&
                  u > t.offset.right + f &&
                  d > t.offset.bottom + h &&
                  p > t.offset.left + f
                );
              });
          },
          function (e, t) {
            (function (t) {
              var n = 'object' == typeof t && t && t.Object === Object && t;
              e.exports = n;
            }).call(
              t,
              (function () {
                return this;
              })()
            );
          },
          function (e, t, n) {
            var r = n(5),
              i =
                'object' == typeof self &&
                self &&
                self.Object === Object &&
                self,
              s = r || i || Function('return this')();
            e.exports = s;
          },
          function (e, t, n) {
            var r = n(1),
              i = n(8),
              s = n(10),
              a = 'Expected a function',
              o = Math.max,
              l = Math.min;
            e.exports = function (e, t, n) {
              function c(t) {
                var n = h,
                  r = m;
                return (h = m = void 0), (w = t), (v = e.apply(r, n));
              }
              function u(e) {
                var n = e - b;
                return void 0 === b || n >= t || n < 0 || (T && e - w >= g);
              }
              function d() {
                var e = i();
                return u(e)
                  ? p(e)
                  : void (y = setTimeout(
                      d,
                      (function (e) {
                        var n = t - (e - b);
                        return T ? l(n, g - (e - w)) : n;
                      })(e)
                    ));
              }
              function p(e) {
                return (y = void 0), E && h ? c(e) : ((h = m = void 0), v);
              }
              function f() {
                var e = i(),
                  n = u(e);
                if (((h = arguments), (m = this), (b = e), n)) {
                  if (void 0 === y)
                    return (function (e) {
                      return (w = e), (y = setTimeout(d, t)), x ? c(e) : v;
                    })(b);
                  if (T) return (y = setTimeout(d, t)), c(b);
                }
                return void 0 === y && (y = setTimeout(d, t)), v;
              }
              var h,
                m,
                g,
                v,
                y,
                b,
                w = 0,
                x = !1,
                T = !1,
                E = !0;
              if ('function' != typeof e) throw new TypeError(a);
              return (
                (t = s(t) || 0),
                r(n) &&
                  ((x = !!n.leading),
                  (g = (T = 'maxWait' in n) ? o(s(n.maxWait) || 0, t) : g),
                  (E = 'trailing' in n ? !!n.trailing : E)),
                (f.cancel = function () {
                  void 0 !== y && clearTimeout(y),
                    (w = 0),
                    (h = b = m = y = void 0);
                }),
                (f.flush = function () {
                  return void 0 === y ? v : p(i());
                }),
                f
              );
            };
          },
          function (e, t, n) {
            var r = n(6);
            e.exports = function () {
              return r.Date.now();
            };
          },
          function (e, t, n) {
            var r = n(7),
              i = n(1),
              s = 'Expected a function';
            e.exports = function (e, t, n) {
              var a = !0,
                o = !0;
              if ('function' != typeof e) throw new TypeError(s);
              return (
                i(n) &&
                  ((a = 'leading' in n ? !!n.leading : a),
                  (o = 'trailing' in n ? !!n.trailing : o)),
                r(e, t, { leading: a, maxWait: t, trailing: o })
              );
            };
          },
          function (e, t) {
            e.exports = function (e) {
              return e;
            };
          },
        ]);
      },
      755: function (e, t) {
        var n;
        !(function (t, n) {
          'use strict';
          'object' == typeof e.exports
            ? (e.exports = t.document
                ? n(t, !0)
                : function (e) {
                    if (!e.document)
                      throw new Error(
                        'jQuery requires a window with a document'
                      );
                    return n(e);
                  })
            : n(t);
        })('undefined' != typeof window ? window : this, function (r, i) {
          'use strict';
          var s = [],
            a = Object.getPrototypeOf,
            o = s.slice,
            l = s.flat
              ? function (e) {
                  return s.flat.call(e);
                }
              : function (e) {
                  return s.concat.apply([], e);
                },
            c = s.push,
            u = s.indexOf,
            d = {},
            p = d.toString,
            f = d.hasOwnProperty,
            h = f.toString,
            m = h.call(Object),
            g = {},
            v = function (e) {
              return (
                'function' == typeof e &&
                'number' != typeof e.nodeType &&
                'function' != typeof e.item
              );
            },
            y = function (e) {
              return null != e && e === e.window;
            },
            b = r.document,
            w = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function x(e, t, n) {
            var r,
              i,
              s = (n = n || b).createElement('script');
            if (((s.text = e), t))
              for (r in w)
                (i = t[r] || (t.getAttribute && t.getAttribute(r))) &&
                  s.setAttribute(r, i);
            n.head.appendChild(s).parentNode.removeChild(s);
          }
          function T(e) {
            return null == e
              ? e + ''
              : 'object' == typeof e || 'function' == typeof e
              ? d[p.call(e)] || 'object'
              : typeof e;
          }
          var E = '3.7.0',
            _ = /HTML$/i,
            S = function (e, t) {
              return new S.fn.init(e, t);
            };
          function C(e) {
            var t = !!e && 'length' in e && e.length,
              n = T(e);
            return (
              !v(e) &&
              !y(e) &&
              ('array' === n ||
                0 === t ||
                ('number' == typeof t && t > 0 && t - 1 in e))
            );
          }
          function M(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          (S.fn = S.prototype =
            {
              jquery: E,
              constructor: S,
              length: 0,
              toArray: function () {
                return o.call(this);
              },
              get: function (e) {
                return null == e
                  ? o.call(this)
                  : e < 0
                  ? this[e + this.length]
                  : this[e];
              },
              pushStack: function (e) {
                var t = S.merge(this.constructor(), e);
                return (t.prevObject = this), t;
              },
              each: function (e) {
                return S.each(this, e);
              },
              map: function (e) {
                return this.pushStack(
                  S.map(this, function (t, n) {
                    return e.call(t, n, t);
                  })
                );
              },
              slice: function () {
                return this.pushStack(o.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  S.grep(this, function (e, t) {
                    return (t + 1) % 2;
                  })
                );
              },
              odd: function () {
                return this.pushStack(
                  S.grep(this, function (e, t) {
                    return t % 2;
                  })
                );
              },
              eq: function (e) {
                var t = this.length,
                  n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: c,
              sort: s.sort,
              splice: s.splice,
            }),
            (S.extend = S.fn.extend =
              function () {
                var e,
                  t,
                  n,
                  r,
                  i,
                  s,
                  a = arguments[0] || {},
                  o = 1,
                  l = arguments.length,
                  c = !1;
                for (
                  'boolean' == typeof a &&
                    ((c = a), (a = arguments[o] || {}), o++),
                    'object' == typeof a || v(a) || (a = {}),
                    o === l && ((a = this), o--);
                  o < l;
                  o++
                )
                  if (null != (e = arguments[o]))
                    for (t in e)
                      (r = e[t]),
                        '__proto__' !== t &&
                          a !== r &&
                          (c &&
                          r &&
                          (S.isPlainObject(r) || (i = Array.isArray(r)))
                            ? ((n = a[t]),
                              (s =
                                i && !Array.isArray(n)
                                  ? []
                                  : i || S.isPlainObject(n)
                                  ? n
                                  : {}),
                              (i = !1),
                              (a[t] = S.extend(c, s, r)))
                            : void 0 !== r && (a[t] = r));
                return a;
              }),
            S.extend({
              expando: 'jQuery' + (E + Math.random()).replace(/\D/g, ''),
              isReady: !0,
              error: function (e) {
                throw new Error(e);
              },
              noop: function () {},
              isPlainObject: function (e) {
                var t, n;
                return !(
                  !e ||
                  '[object Object]' !== p.call(e) ||
                  ((t = a(e)) &&
                    ('function' !=
                      typeof (n = f.call(t, 'constructor') && t.constructor) ||
                      h.call(n) !== m))
                );
              },
              isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
              },
              globalEval: function (e, t, n) {
                x(e, { nonce: t && t.nonce }, n);
              },
              each: function (e, t) {
                var n,
                  r = 0;
                if (C(e))
                  for (
                    n = e.length;
                    r < n && !1 !== t.call(e[r], r, e[r]);
                    r++
                  );
                else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
              },
              text: function (e) {
                var t,
                  n = '',
                  r = 0,
                  i = e.nodeType;
                if (i) {
                  if (1 === i || 9 === i || 11 === i) return e.textContent;
                  if (3 === i || 4 === i) return e.nodeValue;
                } else for (; (t = e[r++]); ) n += S.text(t);
                return n;
              },
              makeArray: function (e, t) {
                var n = t || [];
                return (
                  null != e &&
                    (C(Object(e))
                      ? S.merge(n, 'string' == typeof e ? [e] : e)
                      : c.call(n, e)),
                  n
                );
              },
              inArray: function (e, t, n) {
                return null == t ? -1 : u.call(t, e, n);
              },
              isXMLDoc: function (e) {
                var t = e && e.namespaceURI,
                  n = e && (e.ownerDocument || e).documentElement;
                return !_.test(t || (n && n.nodeName) || 'HTML');
              },
              merge: function (e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++)
                  e[i++] = t[r];
                return (e.length = i), e;
              },
              grep: function (e, t, n) {
                for (var r = [], i = 0, s = e.length, a = !n; i < s; i++)
                  !t(e[i], i) !== a && r.push(e[i]);
                return r;
              },
              map: function (e, t, n) {
                var r,
                  i,
                  s = 0,
                  a = [];
                if (C(e))
                  for (r = e.length; s < r; s++)
                    null != (i = t(e[s], s, n)) && a.push(i);
                else for (s in e) null != (i = t(e[s], s, n)) && a.push(i);
                return l(a);
              },
              guid: 1,
              support: g,
            }),
            'function' == typeof Symbol &&
              (S.fn[Symbol.iterator] = s[Symbol.iterator]),
            S.each(
              'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
                ' '
              ),
              function (e, t) {
                d['[object ' + t + ']'] = t.toLowerCase();
              }
            );
          var k = s.pop,
            A = s.sort,
            P = s.splice,
            L = '[\\x20\\t\\r\\n\\f]',
            O = new RegExp(
              '^' + L + '+|((?:^|[^\\\\])(?:\\\\.)*)' + L + '+$',
              'g'
            );
          S.contains = function (e, t) {
            var n = t && t.parentNode;
            return (
              e === n ||
              !(
                !n ||
                1 !== n.nodeType ||
                !(e.contains
                  ? e.contains(n)
                  : e.compareDocumentPosition &&
                    16 & e.compareDocumentPosition(n))
              )
            );
          };
          var D = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
          function I(e, t) {
            return t
              ? '\0' === e
                ? '�'
                : e.slice(0, -1) +
                  '\\' +
                  e.charCodeAt(e.length - 1).toString(16) +
                  ' '
              : '\\' + e;
          }
          S.escapeSelector = function (e) {
            return (e + '').replace(D, I);
          };
          var z = b,
            R = c;
          !(function () {
            var e,
              t,
              n,
              i,
              a,
              l,
              c,
              d,
              p,
              h,
              m = R,
              v = S.expando,
              y = 0,
              b = 0,
              w = ee(),
              x = ee(),
              T = ee(),
              E = ee(),
              _ = function (e, t) {
                return e === t && (a = !0), 0;
              },
              C =
                'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
              D =
                '(?:\\\\[\\da-fA-F]{1,6}' +
                L +
                '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
              I =
                '\\[' +
                L +
                '*(' +
                D +
                ')(?:' +
                L +
                '*([*^$|!~]?=)' +
                L +
                '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
                D +
                '))|)' +
                L +
                '*\\]',
              j =
                ':(' +
                D +
                ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
                I +
                ')*)|.*)\\)|)',
              N = new RegExp(L + '+', 'g'),
              $ = new RegExp('^' + L + '*,' + L + '*'),
              F = new RegExp('^' + L + '*([>+~]|' + L + ')' + L + '*'),
              q = new RegExp(L + '|>'),
              H = new RegExp(j),
              B = new RegExp('^' + D + '$'),
              X = {
                ID: new RegExp('^#(' + D + ')'),
                CLASS: new RegExp('^\\.(' + D + ')'),
                TAG: new RegExp('^(' + D + '|[*])'),
                ATTR: new RegExp('^' + I),
                PSEUDO: new RegExp('^' + j),
                CHILD: new RegExp(
                  '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                    L +
                    '*(even|odd|(([+-]|)(\\d*)n|)' +
                    L +
                    '*(?:([+-]|)' +
                    L +
                    '*(\\d+)|))' +
                    L +
                    '*\\)|)',
                  'i'
                ),
                bool: new RegExp('^(?:' + C + ')$', 'i'),
                needsContext: new RegExp(
                  '^' +
                    L +
                    '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                    L +
                    '*((?:-\\d)?\\d*)' +
                    L +
                    '*\\)|)(?=[^-]|$)',
                  'i'
                ),
              },
              Y = /^(?:input|select|textarea|button)$/i,
              G = /^h\d$/i,
              W = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              V = /[+~]/,
              U = new RegExp(
                '\\\\[\\da-fA-F]{1,6}' + L + '?|\\\\([^\\r\\n\\f])',
                'g'
              ),
              K = function (e, t) {
                var n = '0x' + e.slice(1) - 65536;
                return (
                  t ||
                  (n < 0
                    ? String.fromCharCode(n + 65536)
                    : String.fromCharCode(
                        (n >> 10) | 55296,
                        (1023 & n) | 56320
                      ))
                );
              },
              Q = function () {
                le();
              },
              Z = pe(
                function (e) {
                  return !0 === e.disabled && M(e, 'fieldset');
                },
                { dir: 'parentNode', next: 'legend' }
              );
            try {
              m.apply((s = o.call(z.childNodes)), z.childNodes),
                s[z.childNodes.length].nodeType;
            } catch (e) {
              m = {
                apply: function (e, t) {
                  R.apply(e, o.call(t));
                },
                call: function (e) {
                  R.apply(e, o.call(arguments, 1));
                },
              };
            }
            function J(e, t, n, r) {
              var i,
                s,
                a,
                o,
                c,
                u,
                f,
                h = t && t.ownerDocument,
                y = t ? t.nodeType : 9;
              if (
                ((n = n || []),
                'string' != typeof e || !e || (1 !== y && 9 !== y && 11 !== y))
              )
                return n;
              if (!r && (le(t), (t = t || l), d)) {
                if (11 !== y && (c = W.exec(e)))
                  if ((i = c[1])) {
                    if (9 === y) {
                      if (!(a = t.getElementById(i))) return n;
                      if (a.id === i) return m.call(n, a), n;
                    } else if (
                      h &&
                      (a = h.getElementById(i)) &&
                      J.contains(t, a) &&
                      a.id === i
                    )
                      return m.call(n, a), n;
                  } else {
                    if (c[2]) return m.apply(n, t.getElementsByTagName(e)), n;
                    if ((i = c[3]) && t.getElementsByClassName)
                      return m.apply(n, t.getElementsByClassName(i)), n;
                  }
                if (!(E[e + ' '] || (p && p.test(e)))) {
                  if (((f = e), (h = t), 1 === y && (q.test(e) || F.test(e)))) {
                    for (
                      ((h = (V.test(e) && oe(t.parentNode)) || t) == t &&
                        g.scope) ||
                        ((o = t.getAttribute('id'))
                          ? (o = S.escapeSelector(o))
                          : t.setAttribute('id', (o = v))),
                        s = (u = ue(e)).length;
                      s--;

                    )
                      u[s] = (o ? '#' + o : ':scope') + ' ' + de(u[s]);
                    f = u.join(',');
                  }
                  try {
                    return m.apply(n, h.querySelectorAll(f)), n;
                  } catch (t) {
                    E(e, !0);
                  } finally {
                    o === v && t.removeAttribute('id');
                  }
                }
              }
              return ye(e.replace(O, '$1'), t, n, r);
            }
            function ee() {
              var e = [];
              return function n(r, i) {
                return (
                  e.push(r + ' ') > t.cacheLength && delete n[e.shift()],
                  (n[r + ' '] = i)
                );
              };
            }
            function te(e) {
              return (e[v] = !0), e;
            }
            function ne(e) {
              var t = l.createElement('fieldset');
              try {
                return !!e(t);
              } catch (e) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
              }
            }
            function re(e) {
              return function (t) {
                return M(t, 'input') && t.type === e;
              };
            }
            function ie(e) {
              return function (t) {
                return (M(t, 'input') || M(t, 'button')) && t.type === e;
              };
            }
            function se(e) {
              return function (t) {
                return 'form' in t
                  ? t.parentNode && !1 === t.disabled
                    ? 'label' in t
                      ? 'label' in t.parentNode
                        ? t.parentNode.disabled === e
                        : t.disabled === e
                      : t.isDisabled === e ||
                        (t.isDisabled !== !e && Z(t) === e)
                    : t.disabled === e
                  : 'label' in t && t.disabled === e;
              };
            }
            function ae(e) {
              return te(function (t) {
                return (
                  (t = +t),
                  te(function (n, r) {
                    for (var i, s = e([], n.length, t), a = s.length; a--; )
                      n[(i = s[a])] && (n[i] = !(r[i] = n[i]));
                  })
                );
              });
            }
            function oe(e) {
              return e && void 0 !== e.getElementsByTagName && e;
            }
            function le(e) {
              var n,
                r = e ? e.ownerDocument || e : z;
              return r != l && 9 === r.nodeType && r.documentElement
                ? ((c = (l = r).documentElement),
                  (d = !S.isXMLDoc(l)),
                  (h =
                    c.matches ||
                    c.webkitMatchesSelector ||
                    c.msMatchesSelector),
                  z != l &&
                    (n = l.defaultView) &&
                    n.top !== n &&
                    n.addEventListener('unload', Q),
                  (g.getById = ne(function (e) {
                    return (
                      (c.appendChild(e).id = S.expando),
                      !l.getElementsByName ||
                        !l.getElementsByName(S.expando).length
                    );
                  })),
                  (g.disconnectedMatch = ne(function (e) {
                    return h.call(e, '*');
                  })),
                  (g.scope = ne(function () {
                    return l.querySelectorAll(':scope');
                  })),
                  (g.cssHas = ne(function () {
                    try {
                      return l.querySelector(':has(*,:jqfake)'), !1;
                    } catch (e) {
                      return !0;
                    }
                  })),
                  g.getById
                    ? ((t.filter.ID = function (e) {
                        var t = e.replace(U, K);
                        return function (e) {
                          return e.getAttribute('id') === t;
                        };
                      }),
                      (t.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && d) {
                          var n = t.getElementById(e);
                          return n ? [n] : [];
                        }
                      }))
                    : ((t.filter.ID = function (e) {
                        var t = e.replace(U, K);
                        return function (e) {
                          var n =
                            void 0 !== e.getAttributeNode &&
                            e.getAttributeNode('id');
                          return n && n.value === t;
                        };
                      }),
                      (t.find.ID = function (e, t) {
                        if (void 0 !== t.getElementById && d) {
                          var n,
                            r,
                            i,
                            s = t.getElementById(e);
                          if (s) {
                            if ((n = s.getAttributeNode('id')) && n.value === e)
                              return [s];
                            for (
                              i = t.getElementsByName(e), r = 0;
                              (s = i[r++]);

                            )
                              if (
                                (n = s.getAttributeNode('id')) &&
                                n.value === e
                              )
                                return [s];
                          }
                          return [];
                        }
                      })),
                  (t.find.TAG = function (e, t) {
                    return void 0 !== t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : t.querySelectorAll(e);
                  }),
                  (t.find.CLASS = function (e, t) {
                    if (void 0 !== t.getElementsByClassName && d)
                      return t.getElementsByClassName(e);
                  }),
                  (p = []),
                  ne(function (e) {
                    var t;
                    (c.appendChild(e).innerHTML =
                      "<a id='" +
                      v +
                      "' href='' disabled='disabled'></a><select id='" +
                      v +
                      "-\r\\' disabled='disabled'><option selected=''></option></select>"),
                      e.querySelectorAll('[selected]').length ||
                        p.push('\\[' + L + '*(?:value|' + C + ')'),
                      e.querySelectorAll('[id~=' + v + '-]').length ||
                        p.push('~='),
                      e.querySelectorAll('a#' + v + '+*').length ||
                        p.push('.#.+[+~]'),
                      e.querySelectorAll(':checked').length ||
                        p.push(':checked'),
                      (t = l.createElement('input')).setAttribute(
                        'type',
                        'hidden'
                      ),
                      e.appendChild(t).setAttribute('name', 'D'),
                      (c.appendChild(e).disabled = !0),
                      2 !== e.querySelectorAll(':disabled').length &&
                        p.push(':enabled', ':disabled'),
                      (t = l.createElement('input')).setAttribute('name', ''),
                      e.appendChild(t),
                      e.querySelectorAll("[name='']").length ||
                        p.push(
                          '\\[' + L + '*name' + L + '*=' + L + '*(?:\'\'|"")'
                        );
                  }),
                  g.cssHas || p.push(':has'),
                  (p = p.length && new RegExp(p.join('|'))),
                  (_ = function (e, t) {
                    if (e === t) return (a = !0), 0;
                    var n =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      n ||
                      (1 &
                        (n =
                          (e.ownerDocument || e) == (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!g.sortDetached && t.compareDocumentPosition(e) === n)
                        ? e === l || (e.ownerDocument == z && J.contains(z, e))
                          ? -1
                          : t === l ||
                            (t.ownerDocument == z && J.contains(z, t))
                          ? 1
                          : i
                          ? u.call(i, e) - u.call(i, t)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }),
                  l)
                : l;
            }
            for (e in ((J.matches = function (e, t) {
              return J(e, null, null, t);
            }),
            (J.matchesSelector = function (e, t) {
              if ((le(e), d && !E[t + ' '] && (!p || !p.test(t))))
                try {
                  var n = h.call(e, t);
                  if (
                    n ||
                    g.disconnectedMatch ||
                    (e.document && 11 !== e.document.nodeType)
                  )
                    return n;
                } catch (e) {
                  E(t, !0);
                }
              return J(t, l, null, [e]).length > 0;
            }),
            (J.contains = function (e, t) {
              return (e.ownerDocument || e) != l && le(e), S.contains(e, t);
            }),
            (J.attr = function (e, n) {
              (e.ownerDocument || e) != l && le(e);
              var r = t.attrHandle[n.toLowerCase()],
                i =
                  r && f.call(t.attrHandle, n.toLowerCase())
                    ? r(e, n, !d)
                    : void 0;
              return void 0 !== i ? i : e.getAttribute(n);
            }),
            (J.error = function (e) {
              throw new Error('Syntax error, unrecognized expression: ' + e);
            }),
            (S.uniqueSort = function (e) {
              var t,
                n = [],
                r = 0,
                s = 0;
              if (
                ((a = !g.sortStable),
                (i = !g.sortStable && o.call(e, 0)),
                A.call(e, _),
                a)
              ) {
                for (; (t = e[s++]); ) t === e[s] && (r = n.push(s));
                for (; r--; ) P.call(e, n[r], 1);
              }
              return (i = null), e;
            }),
            (S.fn.uniqueSort = function () {
              return this.pushStack(S.uniqueSort(o.apply(this)));
            }),
            (t = S.expr =
              {
                cacheLength: 50,
                createPseudo: te,
                match: X,
                attrHandle: {},
                find: {},
                relative: {
                  '>': { dir: 'parentNode', first: !0 },
                  ' ': { dir: 'parentNode' },
                  '+': { dir: 'previousSibling', first: !0 },
                  '~': { dir: 'previousSibling' },
                },
                preFilter: {
                  ATTR: function (e) {
                    return (
                      (e[1] = e[1].replace(U, K)),
                      (e[3] = (e[3] || e[4] || e[5] || '').replace(U, K)),
                      '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
                      e.slice(0, 4)
                    );
                  },
                  CHILD: function (e) {
                    return (
                      (e[1] = e[1].toLowerCase()),
                      'nth' === e[1].slice(0, 3)
                        ? (e[3] || J.error(e[0]),
                          (e[4] = +(e[4]
                            ? e[5] + (e[6] || 1)
                            : 2 * ('even' === e[3] || 'odd' === e[3]))),
                          (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                        : e[3] && J.error(e[0]),
                      e
                    );
                  },
                  PSEUDO: function (e) {
                    var t,
                      n = !e[6] && e[2];
                    return X.CHILD.test(e[0])
                      ? null
                      : (e[3]
                          ? (e[2] = e[4] || e[5] || '')
                          : n &&
                            H.test(n) &&
                            (t = ue(n, !0)) &&
                            (t = n.indexOf(')', n.length - t) - n.length) &&
                            ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                        e.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (e) {
                    var t = e.replace(U, K).toLowerCase();
                    return '*' === e
                      ? function () {
                          return !0;
                        }
                      : function (e) {
                          return M(e, t);
                        };
                  },
                  CLASS: function (e) {
                    var t = w[e + ' '];
                    return (
                      t ||
                      ((t = new RegExp(
                        '(^|' + L + ')' + e + '(' + L + '|$)'
                      )) &&
                        w(e, function (e) {
                          return t.test(
                            ('string' == typeof e.className && e.className) ||
                              (void 0 !== e.getAttribute &&
                                e.getAttribute('class')) ||
                              ''
                          );
                        }))
                    );
                  },
                  ATTR: function (e, t, n) {
                    return function (r) {
                      var i = J.attr(r, e);
                      return null == i
                        ? '!=' === t
                        : !t ||
                            ((i += ''),
                            '=' === t
                              ? i === n
                              : '!=' === t
                              ? i !== n
                              : '^=' === t
                              ? n && 0 === i.indexOf(n)
                              : '*=' === t
                              ? n && i.indexOf(n) > -1
                              : '$=' === t
                              ? n && i.slice(-n.length) === n
                              : '~=' === t
                              ? (' ' + i.replace(N, ' ') + ' ').indexOf(n) > -1
                              : '|=' === t &&
                                (i === n ||
                                  i.slice(0, n.length + 1) === n + '-'));
                    };
                  },
                  CHILD: function (e, t, n, r, i) {
                    var s = 'nth' !== e.slice(0, 3),
                      a = 'last' !== e.slice(-4),
                      o = 'of-type' === t;
                    return 1 === r && 0 === i
                      ? function (e) {
                          return !!e.parentNode;
                        }
                      : function (t, n, l) {
                          var c,
                            u,
                            d,
                            p,
                            f,
                            h = s !== a ? 'nextSibling' : 'previousSibling',
                            m = t.parentNode,
                            g = o && t.nodeName.toLowerCase(),
                            b = !l && !o,
                            w = !1;
                          if (m) {
                            if (s) {
                              for (; h; ) {
                                for (d = t; (d = d[h]); )
                                  if (o ? M(d, g) : 1 === d.nodeType) return !1;
                                f = h = 'only' === e && !f && 'nextSibling';
                              }
                              return !0;
                            }
                            if (
                              ((f = [a ? m.firstChild : m.lastChild]), a && b)
                            ) {
                              for (
                                w =
                                  (p =
                                    (c =
                                      (u = m[v] || (m[v] = {}))[e] || [])[0] ===
                                      y && c[1]) && c[2],
                                  d = p && m.childNodes[p];
                                (d =
                                  (++p && d && d[h]) || (w = p = 0) || f.pop());

                              )
                                if (1 === d.nodeType && ++w && d === t) {
                                  u[e] = [y, p, w];
                                  break;
                                }
                            } else if (
                              (b &&
                                (w = p =
                                  (c =
                                    (u = t[v] || (t[v] = {}))[e] || [])[0] ===
                                    y && c[1]),
                              !1 === w)
                            )
                              for (
                                ;
                                (d =
                                  (++p && d && d[h]) ||
                                  (w = p = 0) ||
                                  f.pop()) &&
                                (!(o ? M(d, g) : 1 === d.nodeType) ||
                                  !++w ||
                                  (b && ((u = d[v] || (d[v] = {}))[e] = [y, w]),
                                  d !== t));

                              );
                            return (w -= i) === r || (w % r == 0 && w / r >= 0);
                          }
                        };
                  },
                  PSEUDO: function (e, n) {
                    var r,
                      i =
                        t.pseudos[e] ||
                        t.setFilters[e.toLowerCase()] ||
                        J.error('unsupported pseudo: ' + e);
                    return i[v]
                      ? i(n)
                      : i.length > 1
                      ? ((r = [e, e, '', n]),
                        t.setFilters.hasOwnProperty(e.toLowerCase())
                          ? te(function (e, t) {
                              for (var r, s = i(e, n), a = s.length; a--; )
                                e[(r = u.call(e, s[a]))] = !(t[r] = s[a]);
                            })
                          : function (e) {
                              return i(e, 0, r);
                            })
                      : i;
                  },
                },
                pseudos: {
                  not: te(function (e) {
                    var t = [],
                      n = [],
                      r = ve(e.replace(O, '$1'));
                    return r[v]
                      ? te(function (e, t, n, i) {
                          for (
                            var s, a = r(e, null, i, []), o = e.length;
                            o--;

                          )
                            (s = a[o]) && (e[o] = !(t[o] = s));
                        })
                      : function (e, i, s) {
                          return (
                            (t[0] = e),
                            r(t, null, s, n),
                            (t[0] = null),
                            !n.pop()
                          );
                        };
                  }),
                  has: te(function (e) {
                    return function (t) {
                      return J(e, t).length > 0;
                    };
                  }),
                  contains: te(function (e) {
                    return (
                      (e = e.replace(U, K)),
                      function (t) {
                        return (t.textContent || S.text(t)).indexOf(e) > -1;
                      }
                    );
                  }),
                  lang: te(function (e) {
                    return (
                      B.test(e || '') || J.error('unsupported lang: ' + e),
                      (e = e.replace(U, K).toLowerCase()),
                      function (t) {
                        var n;
                        do {
                          if (
                            (n = d
                              ? t.lang
                              : t.getAttribute('xml:lang') ||
                                t.getAttribute('lang'))
                          )
                            return (
                              (n = n.toLowerCase()) === e ||
                              0 === n.indexOf(e + '-')
                            );
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (e) {
                    var t = r.location && r.location.hash;
                    return t && t.slice(1) === e.id;
                  },
                  root: function (e) {
                    return e === c;
                  },
                  focus: function (e) {
                    return (
                      e ===
                        (function () {
                          try {
                            return l.activeElement;
                          } catch (e) {}
                        })() &&
                      l.hasFocus() &&
                      !!(e.type || e.href || ~e.tabIndex)
                    );
                  },
                  enabled: se(!1),
                  disabled: se(!0),
                  checked: function (e) {
                    return (
                      (M(e, 'input') && !!e.checked) ||
                      (M(e, 'option') && !!e.selected)
                    );
                  },
                  selected: function (e) {
                    return (
                      e.parentNode && e.parentNode.selectedIndex,
                      !0 === e.selected
                    );
                  },
                  empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                      if (e.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (e) {
                    return !t.pseudos.empty(e);
                  },
                  header: function (e) {
                    return G.test(e.nodeName);
                  },
                  input: function (e) {
                    return Y.test(e.nodeName);
                  },
                  button: function (e) {
                    return (
                      (M(e, 'input') && 'button' === e.type) || M(e, 'button')
                    );
                  },
                  text: function (e) {
                    var t;
                    return (
                      M(e, 'input') &&
                      'text' === e.type &&
                      (null == (t = e.getAttribute('type')) ||
                        'text' === t.toLowerCase())
                    );
                  },
                  first: ae(function () {
                    return [0];
                  }),
                  last: ae(function (e, t) {
                    return [t - 1];
                  }),
                  eq: ae(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                  }),
                  even: ae(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  odd: ae(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  lt: ae(function (e, t, n) {
                    var r;
                    for (r = n < 0 ? n + t : n > t ? t : n; --r >= 0; )
                      e.push(r);
                    return e;
                  }),
                  gt: ae(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                  }),
                },
              }),
            (t.pseudos.nth = t.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              t.pseudos[e] = re(e);
            for (e in { submit: !0, reset: !0 }) t.pseudos[e] = ie(e);
            function ce() {}
            function ue(e, n) {
              var r,
                i,
                s,
                a,
                o,
                l,
                c,
                u = x[e + ' '];
              if (u) return n ? 0 : u.slice(0);
              for (o = e, l = [], c = t.preFilter; o; ) {
                for (a in ((r && !(i = $.exec(o))) ||
                  (i && (o = o.slice(i[0].length) || o), l.push((s = []))),
                (r = !1),
                (i = F.exec(o)) &&
                  ((r = i.shift()),
                  s.push({ value: r, type: i[0].replace(O, ' ') }),
                  (o = o.slice(r.length))),
                t.filter))
                  !(i = X[a].exec(o)) ||
                    (c[a] && !(i = c[a](i))) ||
                    ((r = i.shift()),
                    s.push({ value: r, type: a, matches: i }),
                    (o = o.slice(r.length)));
                if (!r) break;
              }
              return n ? o.length : o ? J.error(e) : x(e, l).slice(0);
            }
            function de(e) {
              for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
              return r;
            }
            function pe(e, t, n) {
              var r = t.dir,
                i = t.next,
                s = i || r,
                a = n && 'parentNode' === s,
                o = b++;
              return t.first
                ? function (t, n, i) {
                    for (; (t = t[r]); )
                      if (1 === t.nodeType || a) return e(t, n, i);
                    return !1;
                  }
                : function (t, n, l) {
                    var c,
                      u,
                      d = [y, o];
                    if (l) {
                      for (; (t = t[r]); )
                        if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                    } else
                      for (; (t = t[r]); )
                        if (1 === t.nodeType || a)
                          if (((u = t[v] || (t[v] = {})), i && M(t, i)))
                            t = t[r] || t;
                          else {
                            if ((c = u[s]) && c[0] === y && c[1] === o)
                              return (d[2] = c[2]);
                            if (((u[s] = d), (d[2] = e(t, n, l)))) return !0;
                          }
                    return !1;
                  };
            }
            function fe(e) {
              return e.length > 1
                ? function (t, n, r) {
                    for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
                    return !0;
                  }
                : e[0];
            }
            function he(e, t, n, r, i) {
              for (
                var s, a = [], o = 0, l = e.length, c = null != t;
                o < l;
                o++
              )
                (s = e[o]) &&
                  ((n && !n(s, r, i)) || (a.push(s), c && t.push(o)));
              return a;
            }
            function me(e, t, n, r, i, s) {
              return (
                r && !r[v] && (r = me(r)),
                i && !i[v] && (i = me(i, s)),
                te(function (s, a, o, l) {
                  var c,
                    d,
                    p,
                    f,
                    h = [],
                    g = [],
                    v = a.length,
                    y =
                      s ||
                      (function (e, t, n) {
                        for (var r = 0, i = t.length; r < i; r++) J(e, t[r], n);
                        return n;
                      })(t || '*', o.nodeType ? [o] : o, []),
                    b = !e || (!s && t) ? y : he(y, h, e, o, l);
                  if (
                    (n
                      ? n(b, (f = i || (s ? e : v || r) ? [] : a), o, l)
                      : (f = b),
                    r)
                  )
                    for (c = he(f, g), r(c, [], o, l), d = c.length; d--; )
                      (p = c[d]) && (f[g[d]] = !(b[g[d]] = p));
                  if (s) {
                    if (i || e) {
                      if (i) {
                        for (c = [], d = f.length; d--; )
                          (p = f[d]) && c.push((b[d] = p));
                        i(null, (f = []), c, l);
                      }
                      for (d = f.length; d--; )
                        (p = f[d]) &&
                          (c = i ? u.call(s, p) : h[d]) > -1 &&
                          (s[c] = !(a[c] = p));
                    }
                  } else (f = he(f === a ? f.splice(v, f.length) : f)), i ? i(null, a, f, l) : m.apply(a, f);
                })
              );
            }
            function ge(e) {
              for (
                var r,
                  i,
                  s,
                  a = e.length,
                  o = t.relative[e[0].type],
                  l = o || t.relative[' '],
                  c = o ? 1 : 0,
                  d = pe(
                    function (e) {
                      return e === r;
                    },
                    l,
                    !0
                  ),
                  p = pe(
                    function (e) {
                      return u.call(r, e) > -1;
                    },
                    l,
                    !0
                  ),
                  f = [
                    function (e, t, i) {
                      var s =
                        (!o && (i || t != n)) ||
                        ((r = t).nodeType ? d(e, t, i) : p(e, t, i));
                      return (r = null), s;
                    },
                  ];
                c < a;
                c++
              )
                if ((i = t.relative[e[c].type])) f = [pe(fe(f), i)];
                else {
                  if ((i = t.filter[e[c].type].apply(null, e[c].matches))[v]) {
                    for (s = ++c; s < a && !t.relative[e[s].type]; s++);
                    return me(
                      c > 1 && fe(f),
                      c > 1 &&
                        de(
                          e
                            .slice(0, c - 1)
                            .concat({ value: ' ' === e[c - 2].type ? '*' : '' })
                        ).replace(O, '$1'),
                      i,
                      c < s && ge(e.slice(c, s)),
                      s < a && ge((e = e.slice(s))),
                      s < a && de(e)
                    );
                  }
                  f.push(i);
                }
              return fe(f);
            }
            function ve(e, r) {
              var i,
                s = [],
                a = [],
                o = T[e + ' '];
              if (!o) {
                for (r || (r = ue(e)), i = r.length; i--; )
                  (o = ge(r[i]))[v] ? s.push(o) : a.push(o);
                (o = T(
                  e,
                  (function (e, r) {
                    var i = r.length > 0,
                      s = e.length > 0,
                      a = function (a, o, c, u, p) {
                        var f,
                          h,
                          g,
                          v = 0,
                          b = '0',
                          w = a && [],
                          x = [],
                          T = n,
                          E = a || (s && t.find.TAG('*', p)),
                          _ = (y += null == T ? 1 : Math.random() || 0.1),
                          C = E.length;
                        for (
                          p && (n = o == l || o || p);
                          b !== C && null != (f = E[b]);
                          b++
                        ) {
                          if (s && f) {
                            for (
                              h = 0,
                                o || f.ownerDocument == l || (le(f), (c = !d));
                              (g = e[h++]);

                            )
                              if (g(f, o || l, c)) {
                                m.call(u, f);
                                break;
                              }
                            p && (y = _);
                          }
                          i && ((f = !g && f) && v--, a && w.push(f));
                        }
                        if (((v += b), i && b !== v)) {
                          for (h = 0; (g = r[h++]); ) g(w, x, o, c);
                          if (a) {
                            if (v > 0)
                              for (; b--; ) w[b] || x[b] || (x[b] = k.call(u));
                            x = he(x);
                          }
                          m.apply(u, x),
                            p &&
                              !a &&
                              x.length > 0 &&
                              v + r.length > 1 &&
                              S.uniqueSort(u);
                        }
                        return p && ((y = _), (n = T)), w;
                      };
                    return i ? te(a) : a;
                  })(a, s)
                )),
                  (o.selector = e);
              }
              return o;
            }
            function ye(e, n, r, i) {
              var s,
                a,
                o,
                l,
                c,
                u = 'function' == typeof e && e,
                p = !i && ue((e = u.selector || e));
              if (((r = r || []), 1 === p.length)) {
                if (
                  (a = p[0] = p[0].slice(0)).length > 2 &&
                  'ID' === (o = a[0]).type &&
                  9 === n.nodeType &&
                  d &&
                  t.relative[a[1].type]
                ) {
                  if (
                    !(n = (t.find.ID(o.matches[0].replace(U, K), n) || [])[0])
                  )
                    return r;
                  u && (n = n.parentNode),
                    (e = e.slice(a.shift().value.length));
                }
                for (
                  s = X.needsContext.test(e) ? 0 : a.length;
                  s-- && ((o = a[s]), !t.relative[(l = o.type)]);

                )
                  if (
                    (c = t.find[l]) &&
                    (i = c(
                      o.matches[0].replace(U, K),
                      (V.test(a[0].type) && oe(n.parentNode)) || n
                    ))
                  ) {
                    if ((a.splice(s, 1), !(e = i.length && de(a))))
                      return m.apply(r, i), r;
                    break;
                  }
              }
              return (
                (u || ve(e, p))(
                  i,
                  n,
                  !d,
                  r,
                  !n || (V.test(e) && oe(n.parentNode)) || n
                ),
                r
              );
            }
            (ce.prototype = t.filters = t.pseudos),
              (t.setFilters = new ce()),
              (g.sortStable = v.split('').sort(_).join('') === v),
              le(),
              (g.sortDetached = ne(function (e) {
                return (
                  1 & e.compareDocumentPosition(l.createElement('fieldset'))
                );
              })),
              (S.find = J),
              (S.expr[':'] = S.expr.pseudos),
              (S.unique = S.uniqueSort),
              (J.compile = ve),
              (J.select = ye),
              (J.setDocument = le),
              (J.escape = S.escapeSelector),
              (J.getText = S.text),
              (J.isXML = S.isXMLDoc),
              (J.selectors = S.expr),
              (J.support = S.support),
              (J.uniqueSort = S.uniqueSort);
          })();
          var j = function (e, t, n) {
              for (
                var r = [], i = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;

              )
                if (1 === e.nodeType) {
                  if (i && S(e).is(n)) break;
                  r.push(e);
                }
              return r;
            },
            N = function (e, t) {
              for (var n = []; e; e = e.nextSibling)
                1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            $ = S.expr.match.needsContext,
            F =
              /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function q(e, t, n) {
            return v(t)
              ? S.grep(e, function (e, r) {
                  return !!t.call(e, r, e) !== n;
                })
              : t.nodeType
              ? S.grep(e, function (e) {
                  return (e === t) !== n;
                })
              : 'string' != typeof t
              ? S.grep(e, function (e) {
                  return u.call(t, e) > -1 !== n;
                })
              : S.filter(t, e, n);
          }
          (S.filter = function (e, t, n) {
            var r = t[0];
            return (
              n && (e = ':not(' + e + ')'),
              1 === t.length && 1 === r.nodeType
                ? S.find.matchesSelector(r, e)
                  ? [r]
                  : []
                : S.find.matches(
                    e,
                    S.grep(t, function (e) {
                      return 1 === e.nodeType;
                    })
                  )
            );
          }),
            S.fn.extend({
              find: function (e) {
                var t,
                  n,
                  r = this.length,
                  i = this;
                if ('string' != typeof e)
                  return this.pushStack(
                    S(e).filter(function () {
                      for (t = 0; t < r; t++)
                        if (S.contains(i[t], this)) return !0;
                    })
                  );
                for (n = this.pushStack([]), t = 0; t < r; t++)
                  S.find(e, i[t], n);
                return r > 1 ? S.uniqueSort(n) : n;
              },
              filter: function (e) {
                return this.pushStack(q(this, e || [], !1));
              },
              not: function (e) {
                return this.pushStack(q(this, e || [], !0));
              },
              is: function (e) {
                return !!q(
                  this,
                  'string' == typeof e && $.test(e) ? S(e) : e || [],
                  !1
                ).length;
              },
            });
          var H,
            B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((S.fn.init = function (e, t, n) {
            var r, i;
            if (!e) return this;
            if (((n = n || H), 'string' == typeof e)) {
              if (
                !(r =
                  '<' === e[0] && '>' === e[e.length - 1] && e.length >= 3
                    ? [null, e, null]
                    : B.exec(e)) ||
                (!r[1] && t)
              )
                return !t || t.jquery
                  ? (t || n).find(e)
                  : this.constructor(t).find(e);
              if (r[1]) {
                if (
                  ((t = t instanceof S ? t[0] : t),
                  S.merge(
                    this,
                    S.parseHTML(
                      r[1],
                      t && t.nodeType ? t.ownerDocument || t : b,
                      !0
                    )
                  ),
                  F.test(r[1]) && S.isPlainObject(t))
                )
                  for (r in t) v(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
              }
              return (
                (i = b.getElementById(r[2])) &&
                  ((this[0] = i), (this.length = 1)),
                this
              );
            }
            return e.nodeType
              ? ((this[0] = e), (this.length = 1), this)
              : v(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(S)
              : S.makeArray(e, this);
          }).prototype = S.fn),
            (H = S(b));
          var X = /^(?:parents|prev(?:Until|All))/,
            Y = { children: !0, contents: !0, next: !0, prev: !0 };
          function G(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
          }
          S.fn.extend({
            has: function (e) {
              var t = S(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++)
                  if (S.contains(this, t[e])) return !0;
              });
            },
            closest: function (e, t) {
              var n,
                r = 0,
                i = this.length,
                s = [],
                a = 'string' != typeof e && S(e);
              if (!$.test(e))
                for (; r < i; r++)
                  for (n = this[r]; n && n !== t; n = n.parentNode)
                    if (
                      n.nodeType < 11 &&
                      (a
                        ? a.index(n) > -1
                        : 1 === n.nodeType && S.find.matchesSelector(n, e))
                    ) {
                      s.push(n);
                      break;
                    }
              return this.pushStack(s.length > 1 ? S.uniqueSort(s) : s);
            },
            index: function (e) {
              return e
                ? 'string' == typeof e
                  ? u.call(S(e), this[0])
                  : u.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (e, t) {
              return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
            },
            addBack: function (e) {
              return this.add(
                null == e ? this.prevObject : this.prevObject.filter(e)
              );
            },
          }),
            S.each(
              {
                parent: function (e) {
                  var t = e.parentNode;
                  return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                  return j(e, 'parentNode');
                },
                parentsUntil: function (e, t, n) {
                  return j(e, 'parentNode', n);
                },
                next: function (e) {
                  return G(e, 'nextSibling');
                },
                prev: function (e) {
                  return G(e, 'previousSibling');
                },
                nextAll: function (e) {
                  return j(e, 'nextSibling');
                },
                prevAll: function (e) {
                  return j(e, 'previousSibling');
                },
                nextUntil: function (e, t, n) {
                  return j(e, 'nextSibling', n);
                },
                prevUntil: function (e, t, n) {
                  return j(e, 'previousSibling', n);
                },
                siblings: function (e) {
                  return N((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                  return N(e.firstChild);
                },
                contents: function (e) {
                  return null != e.contentDocument && a(e.contentDocument)
                    ? e.contentDocument
                    : (M(e, 'template') && (e = e.content || e),
                      S.merge([], e.childNodes));
                },
              },
              function (e, t) {
                S.fn[e] = function (n, r) {
                  var i = S.map(this, t, n);
                  return (
                    'Until' !== e.slice(-5) && (r = n),
                    r && 'string' == typeof r && (i = S.filter(r, i)),
                    this.length > 1 &&
                      (Y[e] || S.uniqueSort(i), X.test(e) && i.reverse()),
                    this.pushStack(i)
                  );
                };
              }
            );
          var W = /[^\x20\t\r\n\f]+/g;
          function V(e) {
            return e;
          }
          function U(e) {
            throw e;
          }
          function K(e, t, n, r) {
            var i;
            try {
              e && v((i = e.promise))
                ? i.call(e).done(t).fail(n)
                : e && v((i = e.then))
                ? i.call(e, t, n)
                : t.apply(void 0, [e].slice(r));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          (S.Callbacks = function (e) {
            e =
              'string' == typeof e
                ? (function (e) {
                    var t = {};
                    return (
                      S.each(e.match(W) || [], function (e, n) {
                        t[n] = !0;
                      }),
                      t
                    );
                  })(e)
                : S.extend({}, e);
            var t,
              n,
              r,
              i,
              s = [],
              a = [],
              o = -1,
              l = function () {
                for (i = i || e.once, r = t = !0; a.length; o = -1)
                  for (n = a.shift(); ++o < s.length; )
                    !1 === s[o].apply(n[0], n[1]) &&
                      e.stopOnFalse &&
                      ((o = s.length), (n = !1));
                e.memory || (n = !1), (t = !1), i && (s = n ? [] : '');
              },
              c = {
                add: function () {
                  return (
                    s &&
                      (n && !t && ((o = s.length - 1), a.push(n)),
                      (function t(n) {
                        S.each(n, function (n, r) {
                          v(r)
                            ? (e.unique && c.has(r)) || s.push(r)
                            : r && r.length && 'string' !== T(r) && t(r);
                        });
                      })(arguments),
                      n && !t && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    S.each(arguments, function (e, t) {
                      for (var n; (n = S.inArray(t, s, n)) > -1; )
                        s.splice(n, 1), n <= o && o--;
                    }),
                    this
                  );
                },
                has: function (e) {
                  return e ? S.inArray(e, s) > -1 : s.length > 0;
                },
                empty: function () {
                  return s && (s = []), this;
                },
                disable: function () {
                  return (i = a = []), (s = n = ''), this;
                },
                disabled: function () {
                  return !s;
                },
                lock: function () {
                  return (i = a = []), n || t || (s = n = ''), this;
                },
                locked: function () {
                  return !!i;
                },
                fireWith: function (e, n) {
                  return (
                    i ||
                      ((n = [e, (n = n || []).slice ? n.slice() : n]),
                      a.push(n),
                      t || l()),
                    this
                  );
                },
                fire: function () {
                  return c.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!r;
                },
              };
            return c;
          }),
            S.extend({
              Deferred: function (e) {
                var t = [
                    [
                      'notify',
                      'progress',
                      S.Callbacks('memory'),
                      S.Callbacks('memory'),
                      2,
                    ],
                    [
                      'resolve',
                      'done',
                      S.Callbacks('once memory'),
                      S.Callbacks('once memory'),
                      0,
                      'resolved',
                    ],
                    [
                      'reject',
                      'fail',
                      S.Callbacks('once memory'),
                      S.Callbacks('once memory'),
                      1,
                      'rejected',
                    ],
                  ],
                  n = 'pending',
                  i = {
                    state: function () {
                      return n;
                    },
                    always: function () {
                      return s.done(arguments).fail(arguments), this;
                    },
                    catch: function (e) {
                      return i.then(null, e);
                    },
                    pipe: function () {
                      var e = arguments;
                      return S.Deferred(function (n) {
                        S.each(t, function (t, r) {
                          var i = v(e[r[4]]) && e[r[4]];
                          s[r[1]](function () {
                            var e = i && i.apply(this, arguments);
                            e && v(e.promise)
                              ? e
                                  .promise()
                                  .progress(n.notify)
                                  .done(n.resolve)
                                  .fail(n.reject)
                              : n[r[0] + 'With'](this, i ? [e] : arguments);
                          });
                        }),
                          (e = null);
                      }).promise();
                    },
                    then: function (e, n, i) {
                      var s = 0;
                      function a(e, t, n, i) {
                        return function () {
                          var o = this,
                            l = arguments,
                            c = function () {
                              var r, c;
                              if (!(e < s)) {
                                if ((r = n.apply(o, l)) === t.promise())
                                  throw new TypeError(
                                    'Thenable self-resolution'
                                  );
                                (c =
                                  r &&
                                  ('object' == typeof r ||
                                    'function' == typeof r) &&
                                  r.then),
                                  v(c)
                                    ? i
                                      ? c.call(r, a(s, t, V, i), a(s, t, U, i))
                                      : (s++,
                                        c.call(
                                          r,
                                          a(s, t, V, i),
                                          a(s, t, U, i),
                                          a(s, t, V, t.notifyWith)
                                        ))
                                    : (n !== V && ((o = void 0), (l = [r])),
                                      (i || t.resolveWith)(o, l));
                              }
                            },
                            u = i
                              ? c
                              : function () {
                                  try {
                                    c();
                                  } catch (r) {
                                    S.Deferred.exceptionHook &&
                                      S.Deferred.exceptionHook(r, u.error),
                                      e + 1 >= s &&
                                        (n !== U && ((o = void 0), (l = [r])),
                                        t.rejectWith(o, l));
                                  }
                                };
                          e
                            ? u()
                            : (S.Deferred.getErrorHook
                                ? (u.error = S.Deferred.getErrorHook())
                                : S.Deferred.getStackHook &&
                                  (u.error = S.Deferred.getStackHook()),
                              r.setTimeout(u));
                        };
                      }
                      return S.Deferred(function (r) {
                        t[0][3].add(a(0, r, v(i) ? i : V, r.notifyWith)),
                          t[1][3].add(a(0, r, v(e) ? e : V)),
                          t[2][3].add(a(0, r, v(n) ? n : U));
                      }).promise();
                    },
                    promise: function (e) {
                      return null != e ? S.extend(e, i) : i;
                    },
                  },
                  s = {};
                return (
                  S.each(t, function (e, r) {
                    var a = r[2],
                      o = r[5];
                    (i[r[1]] = a.add),
                      o &&
                        a.add(
                          function () {
                            n = o;
                          },
                          t[3 - e][2].disable,
                          t[3 - e][3].disable,
                          t[0][2].lock,
                          t[0][3].lock
                        ),
                      a.add(r[3].fire),
                      (s[r[0]] = function () {
                        return (
                          s[r[0] + 'With'](
                            this === s ? void 0 : this,
                            arguments
                          ),
                          this
                        );
                      }),
                      (s[r[0] + 'With'] = a.fireWith);
                  }),
                  i.promise(s),
                  e && e.call(s, s),
                  s
                );
              },
              when: function (e) {
                var t = arguments.length,
                  n = t,
                  r = Array(n),
                  i = o.call(arguments),
                  s = S.Deferred(),
                  a = function (e) {
                    return function (n) {
                      (r[e] = this),
                        (i[e] = arguments.length > 1 ? o.call(arguments) : n),
                        --t || s.resolveWith(r, i);
                    };
                  };
                if (
                  t <= 1 &&
                  (K(e, s.done(a(n)).resolve, s.reject, !t),
                  'pending' === s.state() || v(i[n] && i[n].then))
                )
                  return s.then();
                for (; n--; ) K(i[n], a(n), s.reject);
                return s.promise();
              },
            });
          var Q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (S.Deferred.exceptionHook = function (e, t) {
            r.console &&
              r.console.warn &&
              e &&
              Q.test(e.name) &&
              r.console.warn(
                'jQuery.Deferred exception: ' + e.message,
                e.stack,
                t
              );
          }),
            (S.readyException = function (e) {
              r.setTimeout(function () {
                throw e;
              });
            });
          var Z = S.Deferred();
          function J() {
            b.removeEventListener('DOMContentLoaded', J),
              r.removeEventListener('load', J),
              S.ready();
          }
          (S.fn.ready = function (e) {
            return (
              Z.then(e).catch(function (e) {
                S.readyException(e);
              }),
              this
            );
          }),
            S.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (e) {
                (!0 === e ? --S.readyWait : S.isReady) ||
                  ((S.isReady = !0),
                  (!0 !== e && --S.readyWait > 0) || Z.resolveWith(b, [S]));
              },
            }),
            (S.ready.then = Z.then),
            'complete' === b.readyState ||
            ('loading' !== b.readyState && !b.documentElement.doScroll)
              ? r.setTimeout(S.ready)
              : (b.addEventListener('DOMContentLoaded', J),
                r.addEventListener('load', J));
          var ee = function (e, t, n, r, i, s, a) {
              var o = 0,
                l = e.length,
                c = null == n;
              if ('object' === T(n))
                for (o in ((i = !0), n)) ee(e, t, o, n[o], !0, s, a);
              else if (
                void 0 !== r &&
                ((i = !0),
                v(r) || (a = !0),
                c &&
                  (a
                    ? (t.call(e, r), (t = null))
                    : ((c = t),
                      (t = function (e, t, n) {
                        return c.call(S(e), n);
                      }))),
                t)
              )
                for (; o < l; o++)
                  t(e[o], n, a ? r : r.call(e[o], o, t(e[o], n)));
              return i ? e : c ? t.call(e) : l ? t(e[0], n) : s;
            },
            te = /^-ms-/,
            ne = /-([a-z])/g;
          function re(e, t) {
            return t.toUpperCase();
          }
          function ie(e) {
            return e.replace(te, 'ms-').replace(ne, re);
          }
          var se = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function ae() {
            this.expando = S.expando + ae.uid++;
          }
          (ae.uid = 1),
            (ae.prototype = {
              cache: function (e) {
                var t = e[this.expando];
                return (
                  t ||
                    ((t = {}),
                    se(e) &&
                      (e.nodeType
                        ? (e[this.expando] = t)
                        : Object.defineProperty(e, this.expando, {
                            value: t,
                            configurable: !0,
                          }))),
                  t
                );
              },
              set: function (e, t, n) {
                var r,
                  i = this.cache(e);
                if ('string' == typeof t) i[ie(t)] = n;
                else for (r in t) i[ie(r)] = t[r];
                return i;
              },
              get: function (e, t) {
                return void 0 === t
                  ? this.cache(e)
                  : e[this.expando] && e[this.expando][ie(t)];
              },
              access: function (e, t, n) {
                return void 0 === t ||
                  (t && 'string' == typeof t && void 0 === n)
                  ? this.get(e, t)
                  : (this.set(e, t, n), void 0 !== n ? n : t);
              },
              remove: function (e, t) {
                var n,
                  r = e[this.expando];
                if (void 0 !== r) {
                  if (void 0 !== t) {
                    n = (t = Array.isArray(t)
                      ? t.map(ie)
                      : (t = ie(t)) in r
                      ? [t]
                      : t.match(W) || []).length;
                    for (; n--; ) delete r[t[n]];
                  }
                  (void 0 === t || S.isEmptyObject(r)) &&
                    (e.nodeType
                      ? (e[this.expando] = void 0)
                      : delete e[this.expando]);
                }
              },
              hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !S.isEmptyObject(t);
              },
            });
          var oe = new ae(),
            le = new ae(),
            ce = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            ue = /[A-Z]/g;
          function de(e, t, n) {
            var r;
            if (void 0 === n && 1 === e.nodeType)
              if (
                ((r = 'data-' + t.replace(ue, '-$&').toLowerCase()),
                'string' == typeof (n = e.getAttribute(r)))
              ) {
                try {
                  n = (function (e) {
                    return (
                      'true' === e ||
                      ('false' !== e &&
                        ('null' === e
                          ? null
                          : e === +e + ''
                          ? +e
                          : ce.test(e)
                          ? JSON.parse(e)
                          : e))
                    );
                  })(n);
                } catch (e) {}
                le.set(e, t, n);
              } else n = void 0;
            return n;
          }
          S.extend({
            hasData: function (e) {
              return le.hasData(e) || oe.hasData(e);
            },
            data: function (e, t, n) {
              return le.access(e, t, n);
            },
            removeData: function (e, t) {
              le.remove(e, t);
            },
            _data: function (e, t, n) {
              return oe.access(e, t, n);
            },
            _removeData: function (e, t) {
              oe.remove(e, t);
            },
          }),
            S.fn.extend({
              data: function (e, t) {
                var n,
                  r,
                  i,
                  s = this[0],
                  a = s && s.attributes;
                if (void 0 === e) {
                  if (
                    this.length &&
                    ((i = le.get(s)),
                    1 === s.nodeType && !oe.get(s, 'hasDataAttrs'))
                  ) {
                    for (n = a.length; n--; )
                      a[n] &&
                        0 === (r = a[n].name).indexOf('data-') &&
                        ((r = ie(r.slice(5))), de(s, r, i[r]));
                    oe.set(s, 'hasDataAttrs', !0);
                  }
                  return i;
                }
                return 'object' == typeof e
                  ? this.each(function () {
                      le.set(this, e);
                    })
                  : ee(
                      this,
                      function (t) {
                        var n;
                        if (s && void 0 === t)
                          return void 0 !== (n = le.get(s, e)) ||
                            void 0 !== (n = de(s, e))
                            ? n
                            : void 0;
                        this.each(function () {
                          le.set(this, e, t);
                        });
                      },
                      null,
                      t,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (e) {
                return this.each(function () {
                  le.remove(this, e);
                });
              },
            }),
            S.extend({
              queue: function (e, t, n) {
                var r;
                if (e)
                  return (
                    (t = (t || 'fx') + 'queue'),
                    (r = oe.get(e, t)),
                    n &&
                      (!r || Array.isArray(n)
                        ? (r = oe.access(e, t, S.makeArray(n)))
                        : r.push(n)),
                    r || []
                  );
              },
              dequeue: function (e, t) {
                t = t || 'fx';
                var n = S.queue(e, t),
                  r = n.length,
                  i = n.shift(),
                  s = S._queueHooks(e, t);
                'inprogress' === i && ((i = n.shift()), r--),
                  i &&
                    ('fx' === t && n.unshift('inprogress'),
                    delete s.stop,
                    i.call(
                      e,
                      function () {
                        S.dequeue(e, t);
                      },
                      s
                    )),
                  !r && s && s.empty.fire();
              },
              _queueHooks: function (e, t) {
                var n = t + 'queueHooks';
                return (
                  oe.get(e, n) ||
                  oe.access(e, n, {
                    empty: S.Callbacks('once memory').add(function () {
                      oe.remove(e, [t + 'queue', n]);
                    }),
                  })
                );
              },
            }),
            S.fn.extend({
              queue: function (e, t) {
                var n = 2;
                return (
                  'string' != typeof e && ((t = e), (e = 'fx'), n--),
                  arguments.length < n
                    ? S.queue(this[0], e)
                    : void 0 === t
                    ? this
                    : this.each(function () {
                        var n = S.queue(this, e, t);
                        S._queueHooks(this, e),
                          'fx' === e &&
                            'inprogress' !== n[0] &&
                            S.dequeue(this, e);
                      })
                );
              },
              dequeue: function (e) {
                return this.each(function () {
                  S.dequeue(this, e);
                });
              },
              clearQueue: function (e) {
                return this.queue(e || 'fx', []);
              },
              promise: function (e, t) {
                var n,
                  r = 1,
                  i = S.Deferred(),
                  s = this,
                  a = this.length,
                  o = function () {
                    --r || i.resolveWith(s, [s]);
                  };
                for (
                  'string' != typeof e && ((t = e), (e = void 0)),
                    e = e || 'fx';
                  a--;

                )
                  (n = oe.get(s[a], e + 'queueHooks')) &&
                    n.empty &&
                    (r++, n.empty.add(o));
                return o(), i.promise(t);
              },
            });
          var pe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            fe = new RegExp('^(?:([+-])=|)(' + pe + ')([a-z%]*)$', 'i'),
            he = ['Top', 'Right', 'Bottom', 'Left'],
            me = b.documentElement,
            ge = function (e) {
              return S.contains(e.ownerDocument, e);
            },
            ve = { composed: !0 };
          me.getRootNode &&
            (ge = function (e) {
              return (
                S.contains(e.ownerDocument, e) ||
                e.getRootNode(ve) === e.ownerDocument
              );
            });
          var ye = function (e, t) {
            return (
              'none' === (e = t || e).style.display ||
              ('' === e.style.display &&
                ge(e) &&
                'none' === S.css(e, 'display'))
            );
          };
          function be(e, t, n, r) {
            var i,
              s,
              a = 20,
              o = r
                ? function () {
                    return r.cur();
                  }
                : function () {
                    return S.css(e, t, '');
                  },
              l = o(),
              c = (n && n[3]) || (S.cssNumber[t] ? '' : 'px'),
              u =
                e.nodeType &&
                (S.cssNumber[t] || ('px' !== c && +l)) &&
                fe.exec(S.css(e, t));
            if (u && u[3] !== c) {
              for (l /= 2, c = c || u[3], u = +l || 1; a--; )
                S.style(e, t, u + c),
                  (1 - s) * (1 - (s = o() / l || 0.5)) <= 0 && (a = 0),
                  (u /= s);
              (u *= 2), S.style(e, t, u + c), (n = n || []);
            }
            return (
              n &&
                ((u = +u || +l || 0),
                (i = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
                r && ((r.unit = c), (r.start = u), (r.end = i))),
              i
            );
          }
          var we = {};
          function xe(e) {
            var t,
              n = e.ownerDocument,
              r = e.nodeName,
              i = we[r];
            return (
              i ||
              ((t = n.body.appendChild(n.createElement(r))),
              (i = S.css(t, 'display')),
              t.parentNode.removeChild(t),
              'none' === i && (i = 'block'),
              (we[r] = i),
              i)
            );
          }
          function Te(e, t) {
            for (var n, r, i = [], s = 0, a = e.length; s < a; s++)
              (r = e[s]).style &&
                ((n = r.style.display),
                t
                  ? ('none' === n &&
                      ((i[s] = oe.get(r, 'display') || null),
                      i[s] || (r.style.display = '')),
                    '' === r.style.display && ye(r) && (i[s] = xe(r)))
                  : 'none' !== n && ((i[s] = 'none'), oe.set(r, 'display', n)));
            for (s = 0; s < a; s++) null != i[s] && (e[s].style.display = i[s]);
            return e;
          }
          S.fn.extend({
            show: function () {
              return Te(this, !0);
            },
            hide: function () {
              return Te(this);
            },
            toggle: function (e) {
              return 'boolean' == typeof e
                ? e
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ye(this) ? S(this).show() : S(this).hide();
                  });
            },
          });
          var Ee,
            _e,
            Se = /^(?:checkbox|radio)$/i,
            Ce = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            Me = /^$|^module$|\/(?:java|ecma)script/i;
          (Ee = b.createDocumentFragment().appendChild(b.createElement('div'))),
            (_e = b.createElement('input')).setAttribute('type', 'radio'),
            _e.setAttribute('checked', 'checked'),
            _e.setAttribute('name', 't'),
            Ee.appendChild(_e),
            (g.checkClone = Ee.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (Ee.innerHTML = '<textarea>x</textarea>'),
            (g.noCloneChecked = !!Ee.cloneNode(!0).lastChild.defaultValue),
            (Ee.innerHTML = '<option></option>'),
            (g.option = !!Ee.lastChild);
          var ke = {
            thead: [1, '<table>', '</table>'],
            col: [2, '<table><colgroup>', '</colgroup></table>'],
            tr: [2, '<table><tbody>', '</tbody></table>'],
            td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
            _default: [0, '', ''],
          };
          function Ae(e, t) {
            var n;
            return (
              (n =
                void 0 !== e.getElementsByTagName
                  ? e.getElementsByTagName(t || '*')
                  : void 0 !== e.querySelectorAll
                  ? e.querySelectorAll(t || '*')
                  : []),
              void 0 === t || (t && M(e, t)) ? S.merge([e], n) : n
            );
          }
          function Pe(e, t) {
            for (var n = 0, r = e.length; n < r; n++)
              oe.set(e[n], 'globalEval', !t || oe.get(t[n], 'globalEval'));
          }
          (ke.tbody = ke.tfoot = ke.colgroup = ke.caption = ke.thead),
            (ke.th = ke.td),
            g.option ||
              (ke.optgroup = ke.option =
                [1, "<select multiple='multiple'>", '</select>']);
          var Le = /<|&#?\w+;/;
          function Oe(e, t, n, r, i) {
            for (
              var s,
                a,
                o,
                l,
                c,
                u,
                d = t.createDocumentFragment(),
                p = [],
                f = 0,
                h = e.length;
              f < h;
              f++
            )
              if ((s = e[f]) || 0 === s)
                if ('object' === T(s)) S.merge(p, s.nodeType ? [s] : s);
                else if (Le.test(s)) {
                  for (
                    a = a || d.appendChild(t.createElement('div')),
                      o = (Ce.exec(s) || ['', ''])[1].toLowerCase(),
                      l = ke[o] || ke._default,
                      a.innerHTML = l[1] + S.htmlPrefilter(s) + l[2],
                      u = l[0];
                    u--;

                  )
                    a = a.lastChild;
                  S.merge(p, a.childNodes),
                    ((a = d.firstChild).textContent = '');
                } else p.push(t.createTextNode(s));
            for (d.textContent = '', f = 0; (s = p[f++]); )
              if (r && S.inArray(s, r) > -1) i && i.push(s);
              else if (
                ((c = ge(s)),
                (a = Ae(d.appendChild(s), 'script')),
                c && Pe(a),
                n)
              )
                for (u = 0; (s = a[u++]); ) Me.test(s.type || '') && n.push(s);
            return d;
          }
          var De = /^([^.]*)(?:\.(.+)|)/;
          function Ie() {
            return !0;
          }
          function ze() {
            return !1;
          }
          function Re(e, t, n, r, i, s) {
            var a, o;
            if ('object' == typeof t) {
              for (o in ('string' != typeof n && ((r = r || n), (n = void 0)),
              t))
                Re(e, o, n, r, t[o], s);
              return e;
            }
            if (
              (null == r && null == i
                ? ((i = n), (r = n = void 0))
                : null == i &&
                  ('string' == typeof n
                    ? ((i = r), (r = void 0))
                    : ((i = r), (r = n), (n = void 0))),
              !1 === i)
            )
              i = ze;
            else if (!i) return e;
            return (
              1 === s &&
                ((a = i),
                (i = function (e) {
                  return S().off(e), a.apply(this, arguments);
                }),
                (i.guid = a.guid || (a.guid = S.guid++))),
              e.each(function () {
                S.event.add(this, t, i, r, n);
              })
            );
          }
          function je(e, t, n) {
            n
              ? (oe.set(e, t, !1),
                S.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                    var n,
                      r = oe.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                      if (r)
                        (S.event.special[t] || {}).delegateType &&
                          e.stopPropagation();
                      else if (
                        ((r = o.call(arguments)),
                        oe.set(this, t, r),
                        this[t](),
                        (n = oe.get(this, t)),
                        oe.set(this, t, !1),
                        r !== n)
                      )
                        return (
                          e.stopImmediatePropagation(), e.preventDefault(), n
                        );
                    } else
                      r &&
                        (oe.set(
                          this,
                          t,
                          S.event.trigger(r[0], r.slice(1), this)
                        ),
                        e.stopPropagation(),
                        (e.isImmediatePropagationStopped = Ie));
                  },
                }))
              : void 0 === oe.get(e, t) && S.event.add(e, t, Ie);
          }
          (S.event = {
            global: {},
            add: function (e, t, n, r, i) {
              var s,
                a,
                o,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g = oe.get(e);
              if (se(e))
                for (
                  n.handler && ((n = (s = n).handler), (i = s.selector)),
                    i && S.find.matchesSelector(me, i),
                    n.guid || (n.guid = S.guid++),
                    (l = g.events) || (l = g.events = Object.create(null)),
                    (a = g.handle) ||
                      (a = g.handle =
                        function (t) {
                          return void 0 !== S && S.event.triggered !== t.type
                            ? S.event.dispatch.apply(e, arguments)
                            : void 0;
                        }),
                    c = (t = (t || '').match(W) || ['']).length;
                  c--;

                )
                  (f = m = (o = De.exec(t[c]) || [])[1]),
                    (h = (o[2] || '').split('.').sort()),
                    f &&
                      ((d = S.event.special[f] || {}),
                      (f = (i ? d.delegateType : d.bindType) || f),
                      (d = S.event.special[f] || {}),
                      (u = S.extend(
                        {
                          type: f,
                          origType: m,
                          data: r,
                          handler: n,
                          guid: n.guid,
                          selector: i,
                          needsContext: i && S.expr.match.needsContext.test(i),
                          namespace: h.join('.'),
                        },
                        s
                      )),
                      (p = l[f]) ||
                        (((p = l[f] = []).delegateCount = 0),
                        (d.setup && !1 !== d.setup.call(e, r, h, a)) ||
                          (e.addEventListener && e.addEventListener(f, a))),
                      d.add &&
                        (d.add.call(e, u),
                        u.handler.guid || (u.handler.guid = n.guid)),
                      i ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                      (S.event.global[f] = !0));
            },
            remove: function (e, t, n, r, i) {
              var s,
                a,
                o,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g = oe.hasData(e) && oe.get(e);
              if (g && (l = g.events)) {
                for (c = (t = (t || '').match(W) || ['']).length; c--; )
                  if (
                    ((f = m = (o = De.exec(t[c]) || [])[1]),
                    (h = (o[2] || '').split('.').sort()),
                    f)
                  ) {
                    for (
                      d = S.event.special[f] || {},
                        p =
                          l[(f = (r ? d.delegateType : d.bindType) || f)] || [],
                        o =
                          o[2] &&
                          new RegExp(
                            '(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)'
                          ),
                        a = s = p.length;
                      s--;

                    )
                      (u = p[s]),
                        (!i && m !== u.origType) ||
                          (n && n.guid !== u.guid) ||
                          (o && !o.test(u.namespace)) ||
                          (r &&
                            r !== u.selector &&
                            ('**' !== r || !u.selector)) ||
                          (p.splice(s, 1),
                          u.selector && p.delegateCount--,
                          d.remove && d.remove.call(e, u));
                    a &&
                      !p.length &&
                      ((d.teardown && !1 !== d.teardown.call(e, h, g.handle)) ||
                        S.removeEvent(e, f, g.handle),
                      delete l[f]);
                  } else for (f in l) S.event.remove(e, f + t[c], n, r, !0);
                S.isEmptyObject(l) && oe.remove(e, 'handle events');
              }
            },
            dispatch: function (e) {
              var t,
                n,
                r,
                i,
                s,
                a,
                o = new Array(arguments.length),
                l = S.event.fix(e),
                c =
                  (oe.get(this, 'events') || Object.create(null))[l.type] || [],
                u = S.event.special[l.type] || {};
              for (o[0] = l, t = 1; t < arguments.length; t++)
                o[t] = arguments[t];
              if (
                ((l.delegateTarget = this),
                !u.preDispatch || !1 !== u.preDispatch.call(this, l))
              ) {
                for (
                  a = S.event.handlers.call(this, l, c), t = 0;
                  (i = a[t++]) && !l.isPropagationStopped();

                )
                  for (
                    l.currentTarget = i.elem, n = 0;
                    (s = i.handlers[n++]) && !l.isImmediatePropagationStopped();

                  )
                    (l.rnamespace &&
                      !1 !== s.namespace &&
                      !l.rnamespace.test(s.namespace)) ||
                      ((l.handleObj = s),
                      (l.data = s.data),
                      void 0 !==
                        (r = (
                          (S.event.special[s.origType] || {}).handle ||
                          s.handler
                        ).apply(i.elem, o)) &&
                        !1 === (l.result = r) &&
                        (l.preventDefault(), l.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (e, t) {
              var n,
                r,
                i,
                s,
                a,
                o = [],
                l = t.delegateCount,
                c = e.target;
              if (l && c.nodeType && !('click' === e.type && e.button >= 1))
                for (; c !== this; c = c.parentNode || this)
                  if (
                    1 === c.nodeType &&
                    ('click' !== e.type || !0 !== c.disabled)
                  ) {
                    for (s = [], a = {}, n = 0; n < l; n++)
                      void 0 === a[(i = (r = t[n]).selector + ' ')] &&
                        (a[i] = r.needsContext
                          ? S(i, this).index(c) > -1
                          : S.find(i, this, null, [c]).length),
                        a[i] && s.push(r);
                    s.length && o.push({ elem: c, handlers: s });
                  }
              return (
                (c = this),
                l < t.length && o.push({ elem: c, handlers: t.slice(l) }),
                o
              );
            },
            addProp: function (e, t) {
              Object.defineProperty(S.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: v(t)
                  ? function () {
                      if (this.originalEvent) return t(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[e];
                    },
                set: function (t) {
                  Object.defineProperty(this, e, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t,
                  });
                },
              });
            },
            fix: function (e) {
              return e[S.expando] ? e : new S.Event(e);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (e) {
                  var t = this || e;
                  return (
                    Se.test(t.type) &&
                      t.click &&
                      M(t, 'input') &&
                      je(t, 'click', !0),
                    !1
                  );
                },
                trigger: function (e) {
                  var t = this || e;
                  return (
                    Se.test(t.type) &&
                      t.click &&
                      M(t, 'input') &&
                      je(t, 'click'),
                    !0
                  );
                },
                _default: function (e) {
                  var t = e.target;
                  return (
                    (Se.test(t.type) &&
                      t.click &&
                      M(t, 'input') &&
                      oe.get(t, 'click')) ||
                    M(t, 'a')
                  );
                },
              },
              beforeunload: {
                postDispatch: function (e) {
                  void 0 !== e.result &&
                    e.originalEvent &&
                    (e.originalEvent.returnValue = e.result);
                },
              },
            },
          }),
            (S.removeEvent = function (e, t, n) {
              e.removeEventListener && e.removeEventListener(t, n);
            }),
            (S.Event = function (e, t) {
              if (!(this instanceof S.Event)) return new S.Event(e, t);
              e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented =
                    e.defaultPrevented ||
                    (void 0 === e.defaultPrevented && !1 === e.returnValue)
                      ? Ie
                      : ze),
                  (this.target =
                    e.target && 3 === e.target.nodeType
                      ? e.target.parentNode
                      : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && S.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[S.expando] = !0);
            }),
            (S.Event.prototype = {
              constructor: S.Event,
              isDefaultPrevented: ze,
              isPropagationStopped: ze,
              isImmediatePropagationStopped: ze,
              isSimulated: !1,
              preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Ie),
                  e && !this.isSimulated && e.preventDefault();
              },
              stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Ie),
                  e && !this.isSimulated && e.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Ie),
                  e && !this.isSimulated && e.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            S.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              S.event.addProp
            ),
            S.each({ focus: 'focusin', blur: 'focusout' }, function (e, t) {
              function n(e) {
                if (b.documentMode) {
                  var n = oe.get(this, 'handle'),
                    r = S.event.fix(e);
                  (r.type = 'focusin' === e.type ? 'focus' : 'blur'),
                    (r.isSimulated = !0),
                    n(e),
                    r.target === r.currentTarget && n(r);
                } else S.event.simulate(t, e.target, S.event.fix(e));
              }
              (S.event.special[e] = {
                setup: function () {
                  var r;
                  if ((je(this, e, !0), !b.documentMode)) return !1;
                  (r = oe.get(this, t)) || this.addEventListener(t, n),
                    oe.set(this, t, (r || 0) + 1);
                },
                trigger: function () {
                  return je(this, e), !0;
                },
                teardown: function () {
                  var e;
                  if (!b.documentMode) return !1;
                  (e = oe.get(this, t) - 1)
                    ? oe.set(this, t, e)
                    : (this.removeEventListener(t, n), oe.remove(this, t));
                },
                _default: function (t) {
                  return oe.get(t.target, e);
                },
                delegateType: t,
              }),
                (S.event.special[t] = {
                  setup: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = b.documentMode ? this : r,
                      s = oe.get(i, t);
                    s ||
                      (b.documentMode
                        ? this.addEventListener(t, n)
                        : r.addEventListener(e, n, !0)),
                      oe.set(i, t, (s || 0) + 1);
                  },
                  teardown: function () {
                    var r = this.ownerDocument || this.document || this,
                      i = b.documentMode ? this : r,
                      s = oe.get(i, t) - 1;
                    s
                      ? oe.set(i, t, s)
                      : (b.documentMode
                          ? this.removeEventListener(t, n)
                          : r.removeEventListener(e, n, !0),
                        oe.remove(i, t));
                  },
                });
            }),
            S.each(
              {
                mouseenter: 'mouseover',
                mouseleave: 'mouseout',
                pointerenter: 'pointerover',
                pointerleave: 'pointerout',
              },
              function (e, t) {
                S.event.special[e] = {
                  delegateType: t,
                  bindType: t,
                  handle: function (e) {
                    var n,
                      r = e.relatedTarget,
                      i = e.handleObj;
                    return (
                      (r && (r === this || S.contains(this, r))) ||
                        ((e.type = i.origType),
                        (n = i.handler.apply(this, arguments)),
                        (e.type = t)),
                      n
                    );
                  },
                };
              }
            ),
            S.fn.extend({
              on: function (e, t, n, r) {
                return Re(this, e, t, n, r);
              },
              one: function (e, t, n, r) {
                return Re(this, e, t, n, r, 1);
              },
              off: function (e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj)
                  return (
                    (r = e.handleObj),
                    S(e.delegateTarget).off(
                      r.namespace ? r.origType + '.' + r.namespace : r.origType,
                      r.selector,
                      r.handler
                    ),
                    this
                  );
                if ('object' == typeof e) {
                  for (i in e) this.off(i, t, e[i]);
                  return this;
                }
                return (
                  (!1 !== t && 'function' != typeof t) ||
                    ((n = t), (t = void 0)),
                  !1 === n && (n = ze),
                  this.each(function () {
                    S.event.remove(this, e, n, t);
                  })
                );
              },
            });
          var Ne = /<script|<style|<link/i,
            $e = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Fe = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
          function qe(e, t) {
            return (
              (M(e, 'table') &&
                M(11 !== t.nodeType ? t : t.firstChild, 'tr') &&
                S(e).children('tbody')[0]) ||
              e
            );
          }
          function He(e) {
            return (
              (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e
            );
          }
          function Be(e) {
            return (
              'true/' === (e.type || '').slice(0, 5)
                ? (e.type = e.type.slice(5))
                : e.removeAttribute('type'),
              e
            );
          }
          function Xe(e, t) {
            var n, r, i, s, a, o;
            if (1 === t.nodeType) {
              if (oe.hasData(e) && (o = oe.get(e).events))
                for (i in (oe.remove(t, 'handle events'), o))
                  for (n = 0, r = o[i].length; n < r; n++)
                    S.event.add(t, i, o[i][n]);
              le.hasData(e) &&
                ((s = le.access(e)), (a = S.extend({}, s)), le.set(t, a));
            }
          }
          function Ye(e, t) {
            var n = t.nodeName.toLowerCase();
            'input' === n && Se.test(e.type)
              ? (t.checked = e.checked)
              : ('input' !== n && 'textarea' !== n) ||
                (t.defaultValue = e.defaultValue);
          }
          function Ge(e, t, n, r) {
            t = l(t);
            var i,
              s,
              a,
              o,
              c,
              u,
              d = 0,
              p = e.length,
              f = p - 1,
              h = t[0],
              m = v(h);
            if (
              m ||
              (p > 1 && 'string' == typeof h && !g.checkClone && $e.test(h))
            )
              return e.each(function (i) {
                var s = e.eq(i);
                m && (t[0] = h.call(this, i, s.html())), Ge(s, t, n, r);
              });
            if (
              p &&
              ((s = (i = Oe(t, e[0].ownerDocument, !1, e, r)).firstChild),
              1 === i.childNodes.length && (i = s),
              s || r)
            ) {
              for (o = (a = S.map(Ae(i, 'script'), He)).length; d < p; d++)
                (c = i),
                  d !== f &&
                    ((c = S.clone(c, !0, !0)),
                    o && S.merge(a, Ae(c, 'script'))),
                  n.call(e[d], c, d);
              if (o)
                for (
                  u = a[a.length - 1].ownerDocument, S.map(a, Be), d = 0;
                  d < o;
                  d++
                )
                  (c = a[d]),
                    Me.test(c.type || '') &&
                      !oe.access(c, 'globalEval') &&
                      S.contains(u, c) &&
                      (c.src && 'module' !== (c.type || '').toLowerCase()
                        ? S._evalUrl &&
                          !c.noModule &&
                          S._evalUrl(
                            c.src,
                            { nonce: c.nonce || c.getAttribute('nonce') },
                            u
                          )
                        : x(c.textContent.replace(Fe, ''), c, u));
            }
            return e;
          }
          function We(e, t, n) {
            for (
              var r, i = t ? S.filter(t, e) : e, s = 0;
              null != (r = i[s]);
              s++
            )
              n || 1 !== r.nodeType || S.cleanData(Ae(r)),
                r.parentNode &&
                  (n && ge(r) && Pe(Ae(r, 'script')),
                  r.parentNode.removeChild(r));
            return e;
          }
          S.extend({
            htmlPrefilter: function (e) {
              return e;
            },
            clone: function (e, t, n) {
              var r,
                i,
                s,
                a,
                o = e.cloneNode(!0),
                l = ge(e);
              if (
                !(
                  g.noCloneChecked ||
                  (1 !== e.nodeType && 11 !== e.nodeType) ||
                  S.isXMLDoc(e)
                )
              )
                for (a = Ae(o), r = 0, i = (s = Ae(e)).length; r < i; r++)
                  Ye(s[r], a[r]);
              if (t)
                if (n)
                  for (
                    s = s || Ae(e), a = a || Ae(o), r = 0, i = s.length;
                    r < i;
                    r++
                  )
                    Xe(s[r], a[r]);
                else Xe(e, o);
              return (
                (a = Ae(o, 'script')).length > 0 &&
                  Pe(a, !l && Ae(e, 'script')),
                o
              );
            },
            cleanData: function (e) {
              for (
                var t, n, r, i = S.event.special, s = 0;
                void 0 !== (n = e[s]);
                s++
              )
                if (se(n)) {
                  if ((t = n[oe.expando])) {
                    if (t.events)
                      for (r in t.events)
                        i[r]
                          ? S.event.remove(n, r)
                          : S.removeEvent(n, r, t.handle);
                    n[oe.expando] = void 0;
                  }
                  n[le.expando] && (n[le.expando] = void 0);
                }
            },
          }),
            S.fn.extend({
              detach: function (e) {
                return We(this, e, !0);
              },
              remove: function (e) {
                return We(this, e);
              },
              text: function (e) {
                return ee(
                  this,
                  function (e) {
                    return void 0 === e
                      ? S.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType &&
                            11 !== this.nodeType &&
                            9 !== this.nodeType) ||
                            (this.textContent = e);
                        });
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              append: function () {
                return Ge(this, arguments, function (e) {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    qe(this, e).appendChild(e);
                });
              },
              prepend: function () {
                return Ge(this, arguments, function (e) {
                  if (
                    1 === this.nodeType ||
                    11 === this.nodeType ||
                    9 === this.nodeType
                  ) {
                    var t = qe(this, e);
                    t.insertBefore(e, t.firstChild);
                  }
                });
              },
              before: function () {
                return Ge(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this);
                });
              },
              after: function () {
                return Ge(this, arguments, function (e) {
                  this.parentNode &&
                    this.parentNode.insertBefore(e, this.nextSibling);
                });
              },
              empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++)
                  1 === e.nodeType &&
                    (S.cleanData(Ae(e, !1)), (e.textContent = ''));
                return this;
              },
              clone: function (e, t) {
                return (
                  (e = null != e && e),
                  (t = null == t ? e : t),
                  this.map(function () {
                    return S.clone(this, e, t);
                  })
                );
              },
              html: function (e) {
                return ee(
                  this,
                  function (e) {
                    var t = this[0] || {},
                      n = 0,
                      r = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if (
                      'string' == typeof e &&
                      !Ne.test(e) &&
                      !ke[(Ce.exec(e) || ['', ''])[1].toLowerCase()]
                    ) {
                      e = S.htmlPrefilter(e);
                      try {
                        for (; n < r; n++)
                          1 === (t = this[n] || {}).nodeType &&
                            (S.cleanData(Ae(t, !1)), (t.innerHTML = e));
                        t = 0;
                      } catch (e) {}
                    }
                    t && this.empty().append(e);
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              replaceWith: function () {
                var e = [];
                return Ge(
                  this,
                  arguments,
                  function (t) {
                    var n = this.parentNode;
                    S.inArray(this, e) < 0 &&
                      (S.cleanData(Ae(this)), n && n.replaceChild(t, this));
                  },
                  e
                );
              },
            }),
            S.each(
              {
                appendTo: 'append',
                prependTo: 'prepend',
                insertBefore: 'before',
                insertAfter: 'after',
                replaceAll: 'replaceWith',
              },
              function (e, t) {
                S.fn[e] = function (e) {
                  for (
                    var n, r = [], i = S(e), s = i.length - 1, a = 0;
                    a <= s;
                    a++
                  )
                    (n = a === s ? this : this.clone(!0)),
                      S(i[a])[t](n),
                      c.apply(r, n.get());
                  return this.pushStack(r);
                };
              }
            );
          var Ve = new RegExp('^(' + pe + ')(?!px)[a-z%]+$', 'i'),
            Ue = /^--/,
            Ke = function (e) {
              var t = e.ownerDocument.defaultView;
              return (t && t.opener) || (t = r), t.getComputedStyle(e);
            },
            Qe = function (e, t, n) {
              var r,
                i,
                s = {};
              for (i in t) (s[i] = e.style[i]), (e.style[i] = t[i]);
              for (i in ((r = n.call(e)), t)) e.style[i] = s[i];
              return r;
            },
            Ze = new RegExp(he.join('|'), 'i');
          function Je(e, t, n) {
            var r,
              i,
              s,
              a,
              o = Ue.test(t),
              l = e.style;
            return (
              (n = n || Ke(e)) &&
                ((a = n.getPropertyValue(t) || n[t]),
                o && a && (a = a.replace(O, '$1') || void 0),
                '' !== a || ge(e) || (a = S.style(e, t)),
                !g.pixelBoxStyles() &&
                  Ve.test(a) &&
                  Ze.test(t) &&
                  ((r = l.width),
                  (i = l.minWidth),
                  (s = l.maxWidth),
                  (l.minWidth = l.maxWidth = l.width = a),
                  (a = n.width),
                  (l.width = r),
                  (l.minWidth = i),
                  (l.maxWidth = s))),
              void 0 !== a ? a + '' : a
            );
          }
          function et(e, t) {
            return {
              get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function e() {
              if (u) {
                (c.style.cssText =
                  'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
                  (u.style.cssText =
                    'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
                  me.appendChild(c).appendChild(u);
                var e = r.getComputedStyle(u);
                (n = '1%' !== e.top),
                  (l = 12 === t(e.marginLeft)),
                  (u.style.right = '60%'),
                  (a = 36 === t(e.right)),
                  (i = 36 === t(e.width)),
                  (u.style.position = 'absolute'),
                  (s = 12 === t(u.offsetWidth / 3)),
                  me.removeChild(c),
                  (u = null);
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              i,
              s,
              a,
              o,
              l,
              c = b.createElement('div'),
              u = b.createElement('div');
            u.style &&
              ((u.style.backgroundClip = 'content-box'),
              (u.cloneNode(!0).style.backgroundClip = ''),
              (g.clearCloneStyle = 'content-box' === u.style.backgroundClip),
              S.extend(g, {
                boxSizingReliable: function () {
                  return e(), i;
                },
                pixelBoxStyles: function () {
                  return e(), a;
                },
                pixelPosition: function () {
                  return e(), n;
                },
                reliableMarginLeft: function () {
                  return e(), l;
                },
                scrollboxSize: function () {
                  return e(), s;
                },
                reliableTrDimensions: function () {
                  var e, t, n, i;
                  return (
                    null == o &&
                      ((e = b.createElement('table')),
                      (t = b.createElement('tr')),
                      (n = b.createElement('div')),
                      (e.style.cssText =
                        'position:absolute;left:-11111px;border-collapse:separate'),
                      (t.style.cssText = 'border:1px solid'),
                      (t.style.height = '1px'),
                      (n.style.height = '9px'),
                      (n.style.display = 'block'),
                      me.appendChild(e).appendChild(t).appendChild(n),
                      (i = r.getComputedStyle(t)),
                      (o =
                        parseInt(i.height, 10) +
                          parseInt(i.borderTopWidth, 10) +
                          parseInt(i.borderBottomWidth, 10) ===
                        t.offsetHeight),
                      me.removeChild(e)),
                    o
                  );
                },
              }));
          })();
          var tt = ['Webkit', 'Moz', 'ms'],
            nt = b.createElement('div').style,
            rt = {};
          function it(e) {
            return (
              S.cssProps[e] ||
              rt[e] ||
              (e in nt
                ? e
                : (rt[e] =
                    (function (e) {
                      for (
                        var t = e[0].toUpperCase() + e.slice(1), n = tt.length;
                        n--;

                      )
                        if ((e = tt[n] + t) in nt) return e;
                    })(e) || e))
            );
          }
          var st = /^(none|table(?!-c[ea]).+)/,
            at = {
              position: 'absolute',
              visibility: 'hidden',
              display: 'block',
            },
            ot = { letterSpacing: '0', fontWeight: '400' };
          function lt(e, t, n) {
            var r = fe.exec(t);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
          }
          function ct(e, t, n, r, i, s) {
            var a = 'width' === t ? 1 : 0,
              o = 0,
              l = 0,
              c = 0;
            if (n === (r ? 'border' : 'content')) return 0;
            for (; a < 4; a += 2)
              'margin' === n && (c += S.css(e, n + he[a], !0, i)),
                r
                  ? ('content' === n &&
                      (l -= S.css(e, 'padding' + he[a], !0, i)),
                    'margin' !== n &&
                      (l -= S.css(e, 'border' + he[a] + 'Width', !0, i)))
                  : ((l += S.css(e, 'padding' + he[a], !0, i)),
                    'padding' !== n
                      ? (l += S.css(e, 'border' + he[a] + 'Width', !0, i))
                      : (o += S.css(e, 'border' + he[a] + 'Width', !0, i)));
            return (
              !r &&
                s >= 0 &&
                (l +=
                  Math.max(
                    0,
                    Math.ceil(
                      e['offset' + t[0].toUpperCase() + t.slice(1)] -
                        s -
                        l -
                        o -
                        0.5
                    )
                  ) || 0),
              l + c
            );
          }
          function ut(e, t, n) {
            var r = Ke(e),
              i =
                (!g.boxSizingReliable() || n) &&
                'border-box' === S.css(e, 'boxSizing', !1, r),
              s = i,
              a = Je(e, t, r),
              o = 'offset' + t[0].toUpperCase() + t.slice(1);
            if (Ve.test(a)) {
              if (!n) return a;
              a = 'auto';
            }
            return (
              ((!g.boxSizingReliable() && i) ||
                (!g.reliableTrDimensions() && M(e, 'tr')) ||
                'auto' === a ||
                (!parseFloat(a) && 'inline' === S.css(e, 'display', !1, r))) &&
                e.getClientRects().length &&
                ((i = 'border-box' === S.css(e, 'boxSizing', !1, r)),
                (s = o in e) && (a = e[o])),
              (a = parseFloat(a) || 0) +
                ct(e, t, n || (i ? 'border' : 'content'), s, r, a) +
                'px'
            );
          }
          function dt(e, t, n, r, i) {
            return new dt.prototype.init(e, t, n, r, i);
          }
          S.extend({
            cssHooks: {
              opacity: {
                get: function (e, t) {
                  if (t) {
                    var n = Je(e, 'opacity');
                    return '' === n ? '1' : n;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              aspectRatio: !0,
              borderImageSlice: !0,
              columnCount: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              scale: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
              fillOpacity: !0,
              floodOpacity: !0,
              stopOpacity: !0,
              strokeMiterlimit: !0,
              strokeOpacity: !0,
            },
            cssProps: {},
            style: function (e, t, n, r) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                  s,
                  a,
                  o = ie(t),
                  l = Ue.test(t),
                  c = e.style;
                if (
                  (l || (t = it(o)),
                  (a = S.cssHooks[t] || S.cssHooks[o]),
                  void 0 === n)
                )
                  return a && 'get' in a && void 0 !== (i = a.get(e, !1, r))
                    ? i
                    : c[t];
                'string' == (s = typeof n) &&
                  (i = fe.exec(n)) &&
                  i[1] &&
                  ((n = be(e, t, i)), (s = 'number')),
                  null != n &&
                    n == n &&
                    ('number' !== s ||
                      l ||
                      (n += (i && i[3]) || (S.cssNumber[o] ? '' : 'px')),
                    g.clearCloneStyle ||
                      '' !== n ||
                      0 !== t.indexOf('background') ||
                      (c[t] = 'inherit'),
                    (a && 'set' in a && void 0 === (n = a.set(e, n, r))) ||
                      (l ? c.setProperty(t, n) : (c[t] = n)));
              }
            },
            css: function (e, t, n, r) {
              var i,
                s,
                a,
                o = ie(t);
              return (
                Ue.test(t) || (t = it(o)),
                (a = S.cssHooks[t] || S.cssHooks[o]) &&
                  'get' in a &&
                  (i = a.get(e, !0, n)),
                void 0 === i && (i = Je(e, t, r)),
                'normal' === i && t in ot && (i = ot[t]),
                '' === n || n
                  ? ((s = parseFloat(i)), !0 === n || isFinite(s) ? s || 0 : i)
                  : i
              );
            },
          }),
            S.each(['height', 'width'], function (e, t) {
              S.cssHooks[t] = {
                get: function (e, n, r) {
                  if (n)
                    return !st.test(S.css(e, 'display')) ||
                      (e.getClientRects().length &&
                        e.getBoundingClientRect().width)
                      ? ut(e, t, r)
                      : Qe(e, at, function () {
                          return ut(e, t, r);
                        });
                },
                set: function (e, n, r) {
                  var i,
                    s = Ke(e),
                    a = !g.scrollboxSize() && 'absolute' === s.position,
                    o =
                      (a || r) && 'border-box' === S.css(e, 'boxSizing', !1, s),
                    l = r ? ct(e, t, r, o, s) : 0;
                  return (
                    o &&
                      a &&
                      (l -= Math.ceil(
                        e['offset' + t[0].toUpperCase() + t.slice(1)] -
                          parseFloat(s[t]) -
                          ct(e, t, 'border', !1, s) -
                          0.5
                      )),
                    l &&
                      (i = fe.exec(n)) &&
                      'px' !== (i[3] || 'px') &&
                      ((e.style[t] = n), (n = S.css(e, t))),
                    lt(0, n, l)
                  );
                },
              };
            }),
            (S.cssHooks.marginLeft = et(g.reliableMarginLeft, function (e, t) {
              if (t)
                return (
                  (parseFloat(Je(e, 'marginLeft')) ||
                    e.getBoundingClientRect().left -
                      Qe(e, { marginLeft: 0 }, function () {
                        return e.getBoundingClientRect().left;
                      })) + 'px'
                );
            })),
            S.each(
              { margin: '', padding: '', border: 'Width' },
              function (e, t) {
                (S.cssHooks[e + t] = {
                  expand: function (n) {
                    for (
                      var r = 0,
                        i = {},
                        s = 'string' == typeof n ? n.split(' ') : [n];
                      r < 4;
                      r++
                    )
                      i[e + he[r] + t] = s[r] || s[r - 2] || s[0];
                    return i;
                  },
                }),
                  'margin' !== e && (S.cssHooks[e + t].set = lt);
              }
            ),
            S.fn.extend({
              css: function (e, t) {
                return ee(
                  this,
                  function (e, t, n) {
                    var r,
                      i,
                      s = {},
                      a = 0;
                    if (Array.isArray(t)) {
                      for (r = Ke(e), i = t.length; a < i; a++)
                        s[t[a]] = S.css(e, t[a], !1, r);
                      return s;
                    }
                    return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                  },
                  e,
                  t,
                  arguments.length > 1
                );
              },
            }),
            (S.Tween = dt),
            (dt.prototype = {
              constructor: dt,
              init: function (e, t, n, r, i, s) {
                (this.elem = e),
                  (this.prop = n),
                  (this.easing = i || S.easing._default),
                  (this.options = t),
                  (this.start = this.now = this.cur()),
                  (this.end = r),
                  (this.unit = s || (S.cssNumber[n] ? '' : 'px'));
              },
              cur: function () {
                var e = dt.propHooks[this.prop];
                return e && e.get
                  ? e.get(this)
                  : dt.propHooks._default.get(this);
              },
              run: function (e) {
                var t,
                  n = dt.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = t =
                        S.easing[this.easing](
                          e,
                          this.options.duration * e,
                          0,
                          1,
                          this.options.duration
                        ))
                    : (this.pos = t = e),
                  (this.now = (this.end - this.start) * t + this.start),
                  this.options.step &&
                    this.options.step.call(this.elem, this.now, this),
                  n && n.set ? n.set(this) : dt.propHooks._default.set(this),
                  this
                );
              },
            }),
            (dt.prototype.init.prototype = dt.prototype),
            (dt.propHooks = {
              _default: {
                get: function (e) {
                  var t;
                  return 1 !== e.elem.nodeType ||
                    (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                    ? e.elem[e.prop]
                    : (t = S.css(e.elem, e.prop, '')) && 'auto' !== t
                    ? t
                    : 0;
                },
                set: function (e) {
                  S.fx.step[e.prop]
                    ? S.fx.step[e.prop](e)
                    : 1 !== e.elem.nodeType ||
                      (!S.cssHooks[e.prop] && null == e.elem.style[it(e.prop)])
                    ? (e.elem[e.prop] = e.now)
                    : S.style(e.elem, e.prop, e.now + e.unit);
                },
              },
            }),
            (dt.propHooks.scrollTop = dt.propHooks.scrollLeft =
              {
                set: function (e) {
                  e.elem.nodeType &&
                    e.elem.parentNode &&
                    (e.elem[e.prop] = e.now);
                },
              }),
            (S.easing = {
              linear: function (e) {
                return e;
              },
              swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
              },
              _default: 'swing',
            }),
            (S.fx = dt.prototype.init),
            (S.fx.step = {});
          var pt,
            ft,
            ht = /^(?:toggle|show|hide)$/,
            mt = /queueHooks$/;
          function gt() {
            ft &&
              (!1 === b.hidden && r.requestAnimationFrame
                ? r.requestAnimationFrame(gt)
                : r.setTimeout(gt, S.fx.interval),
              S.fx.tick());
          }
          function vt() {
            return (
              r.setTimeout(function () {
                pt = void 0;
              }),
              (pt = Date.now())
            );
          }
          function yt(e, t) {
            var n,
              r = 0,
              i = { height: e };
            for (t = t ? 1 : 0; r < 4; r += 2 - t)
              i['margin' + (n = he[r])] = i['padding' + n] = e;
            return t && (i.opacity = i.width = e), i;
          }
          function bt(e, t, n) {
            for (
              var r,
                i = (wt.tweeners[t] || []).concat(wt.tweeners['*']),
                s = 0,
                a = i.length;
              s < a;
              s++
            )
              if ((r = i[s].call(n, t, e))) return r;
          }
          function wt(e, t, n) {
            var r,
              i,
              s = 0,
              a = wt.prefilters.length,
              o = S.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (i) return !1;
                for (
                  var t = pt || vt(),
                    n = Math.max(0, c.startTime + c.duration - t),
                    r = 1 - (n / c.duration || 0),
                    s = 0,
                    a = c.tweens.length;
                  s < a;
                  s++
                )
                  c.tweens[s].run(r);
                return (
                  o.notifyWith(e, [c, r, n]),
                  r < 1 && a
                    ? n
                    : (a || o.notifyWith(e, [c, 1, 0]),
                      o.resolveWith(e, [c]),
                      !1)
                );
              },
              c = o.promise({
                elem: e,
                props: S.extend({}, t),
                opts: S.extend(
                  !0,
                  { specialEasing: {}, easing: S.easing._default },
                  n
                ),
                originalProperties: t,
                originalOptions: n,
                startTime: pt || vt(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                  var r = S.Tween(
                    e,
                    c.opts,
                    t,
                    n,
                    c.opts.specialEasing[t] || c.opts.easing
                  );
                  return c.tweens.push(r), r;
                },
                stop: function (t) {
                  var n = 0,
                    r = t ? c.tweens.length : 0;
                  if (i) return this;
                  for (i = !0; n < r; n++) c.tweens[n].run(1);
                  return (
                    t
                      ? (o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c, t]))
                      : o.rejectWith(e, [c, t]),
                    this
                  );
                },
              }),
              u = c.props;
            for (
              (function (e, t) {
                var n, r, i, s, a;
                for (n in e)
                  if (
                    ((i = t[(r = ie(n))]),
                    (s = e[n]),
                    Array.isArray(s) && ((i = s[1]), (s = e[n] = s[0])),
                    n !== r && ((e[r] = s), delete e[n]),
                    (a = S.cssHooks[r]) && ('expand' in a))
                  )
                    for (n in ((s = a.expand(s)), delete e[r], s))
                      (n in e) || ((e[n] = s[n]), (t[n] = i));
                  else t[r] = i;
              })(u, c.opts.specialEasing);
              s < a;
              s++
            )
              if ((r = wt.prefilters[s].call(c, e, u, c.opts)))
                return (
                  v(r.stop) &&
                    (S._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)),
                  r
                );
            return (
              S.map(u, bt, c),
              v(c.opts.start) && c.opts.start.call(e, c),
              c
                .progress(c.opts.progress)
                .done(c.opts.done, c.opts.complete)
                .fail(c.opts.fail)
                .always(c.opts.always),
              S.fx.timer(
                S.extend(l, { elem: e, anim: c, queue: c.opts.queue })
              ),
              c
            );
          }
          (S.Animation = S.extend(wt, {
            tweeners: {
              '*': [
                function (e, t) {
                  var n = this.createTween(e, t);
                  return be(n.elem, e, fe.exec(t), n), n;
                },
              ],
            },
            tweener: function (e, t) {
              v(e) ? ((t = e), (e = ['*'])) : (e = e.match(W));
              for (var n, r = 0, i = e.length; r < i; r++)
                (n = e[r]),
                  (wt.tweeners[n] = wt.tweeners[n] || []),
                  wt.tweeners[n].unshift(t);
            },
            prefilters: [
              function (e, t, n) {
                var r,
                  i,
                  s,
                  a,
                  o,
                  l,
                  c,
                  u,
                  d = 'width' in t || 'height' in t,
                  p = this,
                  f = {},
                  h = e.style,
                  m = e.nodeType && ye(e),
                  g = oe.get(e, 'fxshow');
                for (r in (n.queue ||
                  (null == (a = S._queueHooks(e, 'fx')).unqueued &&
                    ((a.unqueued = 0),
                    (o = a.empty.fire),
                    (a.empty.fire = function () {
                      a.unqueued || o();
                    })),
                  a.unqueued++,
                  p.always(function () {
                    p.always(function () {
                      a.unqueued--, S.queue(e, 'fx').length || a.empty.fire();
                    });
                  })),
                t))
                  if (((i = t[r]), ht.test(i))) {
                    if (
                      (delete t[r],
                      (s = s || 'toggle' === i),
                      i === (m ? 'hide' : 'show'))
                    ) {
                      if ('show' !== i || !g || void 0 === g[r]) continue;
                      m = !0;
                    }
                    f[r] = (g && g[r]) || S.style(e, r);
                  }
                if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(f))
                  for (r in (d &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (c = g && g.display) && (c = oe.get(e, 'display')),
                    'none' === (u = S.css(e, 'display')) &&
                      (c
                        ? (u = c)
                        : (Te([e], !0),
                          (c = e.style.display || c),
                          (u = S.css(e, 'display')),
                          Te([e]))),
                    ('inline' === u || ('inline-block' === u && null != c)) &&
                      'none' === S.css(e, 'float') &&
                      (l ||
                        (p.done(function () {
                          h.display = c;
                        }),
                        null == c &&
                          ((u = h.display), (c = 'none' === u ? '' : u))),
                      (h.display = 'inline-block'))),
                  n.overflow &&
                    ((h.overflow = 'hidden'),
                    p.always(function () {
                      (h.overflow = n.overflow[0]),
                        (h.overflowX = n.overflow[1]),
                        (h.overflowY = n.overflow[2]);
                    })),
                  (l = !1),
                  f))
                    l ||
                      (g
                        ? 'hidden' in g && (m = g.hidden)
                        : (g = oe.access(e, 'fxshow', { display: c })),
                      s && (g.hidden = !m),
                      m && Te([e], !0),
                      p.done(function () {
                        for (r in (m || Te([e]), oe.remove(e, 'fxshow'), f))
                          S.style(e, r, f[r]);
                      })),
                      (l = bt(m ? g[r] : 0, r, p)),
                      r in g ||
                        ((g[r] = l.start),
                        m && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (e, t) {
              t ? wt.prefilters.unshift(e) : wt.prefilters.push(e);
            },
          })),
            (S.speed = function (e, t, n) {
              var r =
                e && 'object' == typeof e
                  ? S.extend({}, e)
                  : {
                      complete: n || (!n && t) || (v(e) && e),
                      duration: e,
                      easing: (n && t) || (t && !v(t) && t),
                    };
              return (
                S.fx.off
                  ? (r.duration = 0)
                  : 'number' != typeof r.duration &&
                    (r.duration in S.fx.speeds
                      ? (r.duration = S.fx.speeds[r.duration])
                      : (r.duration = S.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
                (r.old = r.complete),
                (r.complete = function () {
                  v(r.old) && r.old.call(this),
                    r.queue && S.dequeue(this, r.queue);
                }),
                r
              );
            }),
            S.fn.extend({
              fadeTo: function (e, t, n, r) {
                return this.filter(ye)
                  .css('opacity', 0)
                  .show()
                  .end()
                  .animate({ opacity: t }, e, n, r);
              },
              animate: function (e, t, n, r) {
                var i = S.isEmptyObject(e),
                  s = S.speed(t, n, r),
                  a = function () {
                    var t = wt(this, S.extend({}, e), s);
                    (i || oe.get(this, 'finish')) && t.stop(!0);
                  };
                return (
                  (a.finish = a),
                  i || !1 === s.queue ? this.each(a) : this.queue(s.queue, a)
                );
              },
              stop: function (e, t, n) {
                var r = function (e) {
                  var t = e.stop;
                  delete e.stop, t(n);
                };
                return (
                  'string' != typeof e && ((n = t), (t = e), (e = void 0)),
                  t && this.queue(e || 'fx', []),
                  this.each(function () {
                    var t = !0,
                      i = null != e && e + 'queueHooks',
                      s = S.timers,
                      a = oe.get(this);
                    if (i) a[i] && a[i].stop && r(a[i]);
                    else
                      for (i in a) a[i] && a[i].stop && mt.test(i) && r(a[i]);
                    for (i = s.length; i--; )
                      s[i].elem !== this ||
                        (null != e && s[i].queue !== e) ||
                        (s[i].anim.stop(n), (t = !1), s.splice(i, 1));
                    (!t && n) || S.dequeue(this, e);
                  })
                );
              },
              finish: function (e) {
                return (
                  !1 !== e && (e = e || 'fx'),
                  this.each(function () {
                    var t,
                      n = oe.get(this),
                      r = n[e + 'queue'],
                      i = n[e + 'queueHooks'],
                      s = S.timers,
                      a = r ? r.length : 0;
                    for (
                      n.finish = !0,
                        S.queue(this, e, []),
                        i && i.stop && i.stop.call(this, !0),
                        t = s.length;
                      t--;

                    )
                      s[t].elem === this &&
                        s[t].queue === e &&
                        (s[t].anim.stop(!0), s.splice(t, 1));
                    for (t = 0; t < a; t++)
                      r[t] && r[t].finish && r[t].finish.call(this);
                    delete n.finish;
                  })
                );
              },
            }),
            S.each(['toggle', 'show', 'hide'], function (e, t) {
              var n = S.fn[t];
              S.fn[t] = function (e, r, i) {
                return null == e || 'boolean' == typeof e
                  ? n.apply(this, arguments)
                  : this.animate(yt(t, !0), e, r, i);
              };
            }),
            S.each(
              {
                slideDown: yt('show'),
                slideUp: yt('hide'),
                slideToggle: yt('toggle'),
                fadeIn: { opacity: 'show' },
                fadeOut: { opacity: 'hide' },
                fadeToggle: { opacity: 'toggle' },
              },
              function (e, t) {
                S.fn[e] = function (e, n, r) {
                  return this.animate(t, e, n, r);
                };
              }
            ),
            (S.timers = []),
            (S.fx.tick = function () {
              var e,
                t = 0,
                n = S.timers;
              for (pt = Date.now(); t < n.length; t++)
                (e = n[t])() || n[t] !== e || n.splice(t--, 1);
              n.length || S.fx.stop(), (pt = void 0);
            }),
            (S.fx.timer = function (e) {
              S.timers.push(e), S.fx.start();
            }),
            (S.fx.interval = 13),
            (S.fx.start = function () {
              ft || ((ft = !0), gt());
            }),
            (S.fx.stop = function () {
              ft = null;
            }),
            (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (S.fn.delay = function (e, t) {
              return (
                (e = (S.fx && S.fx.speeds[e]) || e),
                (t = t || 'fx'),
                this.queue(t, function (t, n) {
                  var i = r.setTimeout(t, e);
                  n.stop = function () {
                    r.clearTimeout(i);
                  };
                })
              );
            }),
            (function () {
              var e = b.createElement('input'),
                t = b
                  .createElement('select')
                  .appendChild(b.createElement('option'));
              (e.type = 'checkbox'),
                (g.checkOn = '' !== e.value),
                (g.optSelected = t.selected),
                ((e = b.createElement('input')).value = 't'),
                (e.type = 'radio'),
                (g.radioValue = 't' === e.value);
            })();
          var xt,
            Tt = S.expr.attrHandle;
          S.fn.extend({
            attr: function (e, t) {
              return ee(this, S.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
              return this.each(function () {
                S.removeAttr(this, e);
              });
            },
          }),
            S.extend({
              attr: function (e, t, n) {
                var r,
                  i,
                  s = e.nodeType;
                if (3 !== s && 8 !== s && 2 !== s)
                  return void 0 === e.getAttribute
                    ? S.prop(e, t, n)
                    : ((1 === s && S.isXMLDoc(e)) ||
                        (i =
                          S.attrHooks[t.toLowerCase()] ||
                          (S.expr.match.bool.test(t) ? xt : void 0)),
                      void 0 !== n
                        ? null === n
                          ? void S.removeAttr(e, t)
                          : i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                          ? r
                          : (e.setAttribute(t, n + ''), n)
                        : i && 'get' in i && null !== (r = i.get(e, t))
                        ? r
                        : null == (r = S.find.attr(e, t))
                        ? void 0
                        : r);
              },
              attrHooks: {
                type: {
                  set: function (e, t) {
                    if (!g.radioValue && 'radio' === t && M(e, 'input')) {
                      var n = e.value;
                      return e.setAttribute('type', t), n && (e.value = n), t;
                    }
                  },
                },
              },
              removeAttr: function (e, t) {
                var n,
                  r = 0,
                  i = t && t.match(W);
                if (i && 1 === e.nodeType)
                  for (; (n = i[r++]); ) e.removeAttribute(n);
              },
            }),
            (xt = {
              set: function (e, t, n) {
                return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
              },
            }),
            S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
              var n = Tt[t] || S.find.attr;
              Tt[t] = function (e, t, r) {
                var i,
                  s,
                  a = t.toLowerCase();
                return (
                  r ||
                    ((s = Tt[a]),
                    (Tt[a] = i),
                    (i = null != n(e, t, r) ? a : null),
                    (Tt[a] = s)),
                  i
                );
              };
            });
          var Et = /^(?:input|select|textarea|button)$/i,
            _t = /^(?:a|area)$/i;
          function St(e) {
            return (e.match(W) || []).join(' ');
          }
          function Ct(e) {
            return (e.getAttribute && e.getAttribute('class')) || '';
          }
          function Mt(e) {
            return Array.isArray(e)
              ? e
              : ('string' == typeof e && e.match(W)) || [];
          }
          S.fn.extend({
            prop: function (e, t) {
              return ee(this, S.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
              return this.each(function () {
                delete this[S.propFix[e] || e];
              });
            },
          }),
            S.extend({
              prop: function (e, t, n) {
                var r,
                  i,
                  s = e.nodeType;
                if (3 !== s && 8 !== s && 2 !== s)
                  return (
                    (1 === s && S.isXMLDoc(e)) ||
                      ((t = S.propFix[t] || t), (i = S.propHooks[t])),
                    void 0 !== n
                      ? i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                        ? r
                        : (e[t] = n)
                      : i && 'get' in i && null !== (r = i.get(e, t))
                      ? r
                      : e[t]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (e) {
                    var t = S.find.attr(e, 'tabindex');
                    return t
                      ? parseInt(t, 10)
                      : Et.test(e.nodeName) || (_t.test(e.nodeName) && e.href)
                      ? 0
                      : -1;
                  },
                },
              },
              propFix: { for: 'htmlFor', class: 'className' },
            }),
            g.optSelected ||
              (S.propHooks.selected = {
                get: function (e) {
                  var t = e.parentNode;
                  return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                  var t = e.parentNode;
                  t &&
                    (t.selectedIndex,
                    t.parentNode && t.parentNode.selectedIndex);
                },
              }),
            S.each(
              [
                'tabIndex',
                'readOnly',
                'maxLength',
                'cellSpacing',
                'cellPadding',
                'rowSpan',
                'colSpan',
                'useMap',
                'frameBorder',
                'contentEditable',
              ],
              function () {
                S.propFix[this.toLowerCase()] = this;
              }
            ),
            S.fn.extend({
              addClass: function (e) {
                var t, n, r, i, s, a;
                return v(e)
                  ? this.each(function (t) {
                      S(this).addClass(e.call(this, t, Ct(this)));
                    })
                  : (t = Mt(e)).length
                  ? this.each(function () {
                      if (
                        ((r = Ct(this)),
                        (n = 1 === this.nodeType && ' ' + St(r) + ' '))
                      ) {
                        for (s = 0; s < t.length; s++)
                          (i = t[s]),
                            n.indexOf(' ' + i + ' ') < 0 && (n += i + ' ');
                        (a = St(n)), r !== a && this.setAttribute('class', a);
                      }
                    })
                  : this;
              },
              removeClass: function (e) {
                var t, n, r, i, s, a;
                return v(e)
                  ? this.each(function (t) {
                      S(this).removeClass(e.call(this, t, Ct(this)));
                    })
                  : arguments.length
                  ? (t = Mt(e)).length
                    ? this.each(function () {
                        if (
                          ((r = Ct(this)),
                          (n = 1 === this.nodeType && ' ' + St(r) + ' '))
                        ) {
                          for (s = 0; s < t.length; s++)
                            for (i = t[s]; n.indexOf(' ' + i + ' ') > -1; )
                              n = n.replace(' ' + i + ' ', ' ');
                          (a = St(n)), r !== a && this.setAttribute('class', a);
                        }
                      })
                    : this
                  : this.attr('class', '');
              },
              toggleClass: function (e, t) {
                var n,
                  r,
                  i,
                  s,
                  a = typeof e,
                  o = 'string' === a || Array.isArray(e);
                return v(e)
                  ? this.each(function (n) {
                      S(this).toggleClass(e.call(this, n, Ct(this), t), t);
                    })
                  : 'boolean' == typeof t && o
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : ((n = Mt(e)),
                    this.each(function () {
                      if (o)
                        for (s = S(this), i = 0; i < n.length; i++)
                          (r = n[i]),
                            s.hasClass(r) ? s.removeClass(r) : s.addClass(r);
                      else
                        (void 0 !== e && 'boolean' !== a) ||
                          ((r = Ct(this)) && oe.set(this, '__className__', r),
                          this.setAttribute &&
                            this.setAttribute(
                              'class',
                              r || !1 === e
                                ? ''
                                : oe.get(this, '__className__') || ''
                            ));
                    }));
              },
              hasClass: function (e) {
                var t,
                  n,
                  r = 0;
                for (t = ' ' + e + ' '; (n = this[r++]); )
                  if (
                    1 === n.nodeType &&
                    (' ' + St(Ct(n)) + ' ').indexOf(t) > -1
                  )
                    return !0;
                return !1;
              },
            });
          var kt = /\r/g;
          S.fn.extend({
            val: function (e) {
              var t,
                n,
                r,
                i = this[0];
              return arguments.length
                ? ((r = v(e)),
                  this.each(function (n) {
                    var i;
                    1 === this.nodeType &&
                      (null == (i = r ? e.call(this, n, S(this).val()) : e)
                        ? (i = '')
                        : 'number' == typeof i
                        ? (i += '')
                        : Array.isArray(i) &&
                          (i = S.map(i, function (e) {
                            return null == e ? '' : e + '';
                          })),
                      ((t =
                        S.valHooks[this.type] ||
                        S.valHooks[this.nodeName.toLowerCase()]) &&
                        'set' in t &&
                        void 0 !== t.set(this, i, 'value')) ||
                        (this.value = i));
                  }))
                : i
                ? (t =
                    S.valHooks[i.type] ||
                    S.valHooks[i.nodeName.toLowerCase()]) &&
                  'get' in t &&
                  void 0 !== (n = t.get(i, 'value'))
                  ? n
                  : 'string' == typeof (n = i.value)
                  ? n.replace(kt, '')
                  : null == n
                  ? ''
                  : n
                : void 0;
            },
          }),
            S.extend({
              valHooks: {
                option: {
                  get: function (e) {
                    var t = S.find.attr(e, 'value');
                    return null != t ? t : St(S.text(e));
                  },
                },
                select: {
                  get: function (e) {
                    var t,
                      n,
                      r,
                      i = e.options,
                      s = e.selectedIndex,
                      a = 'select-one' === e.type,
                      o = a ? null : [],
                      l = a ? s + 1 : i.length;
                    for (r = s < 0 ? l : a ? s : 0; r < l; r++)
                      if (
                        ((n = i[r]).selected || r === s) &&
                        !n.disabled &&
                        (!n.parentNode.disabled || !M(n.parentNode, 'optgroup'))
                      ) {
                        if (((t = S(n).val()), a)) return t;
                        o.push(t);
                      }
                    return o;
                  },
                  set: function (e, t) {
                    for (
                      var n, r, i = e.options, s = S.makeArray(t), a = i.length;
                      a--;

                    )
                      ((r = i[a]).selected =
                        S.inArray(S.valHooks.option.get(r), s) > -1) &&
                        (n = !0);
                    return n || (e.selectedIndex = -1), s;
                  },
                },
              },
            }),
            S.each(['radio', 'checkbox'], function () {
              (S.valHooks[this] = {
                set: function (e, t) {
                  if (Array.isArray(t))
                    return (e.checked = S.inArray(S(e).val(), t) > -1);
                },
              }),
                g.checkOn ||
                  (S.valHooks[this].get = function (e) {
                    return null === e.getAttribute('value') ? 'on' : e.value;
                  });
            });
          var At = r.location,
            Pt = { guid: Date.now() },
            Lt = /\?/;
          S.parseXML = function (e) {
            var t, n;
            if (!e || 'string' != typeof e) return null;
            try {
              t = new r.DOMParser().parseFromString(e, 'text/xml');
            } catch (e) {}
            return (
              (n = t && t.getElementsByTagName('parsererror')[0]),
              (t && !n) ||
                S.error(
                  'Invalid XML: ' +
                    (n
                      ? S.map(n.childNodes, function (e) {
                          return e.textContent;
                        }).join('\n')
                      : e)
                ),
              t
            );
          };
          var Ot = /^(?:focusinfocus|focusoutblur)$/,
            Dt = function (e) {
              e.stopPropagation();
            };
          S.extend(S.event, {
            trigger: function (e, t, n, i) {
              var s,
                a,
                o,
                l,
                c,
                u,
                d,
                p,
                h = [n || b],
                m = f.call(e, 'type') ? e.type : e,
                g = f.call(e, 'namespace') ? e.namespace.split('.') : [];
              if (
                ((a = p = o = n = n || b),
                3 !== n.nodeType &&
                  8 !== n.nodeType &&
                  !Ot.test(m + S.event.triggered) &&
                  (m.indexOf('.') > -1 &&
                    ((g = m.split('.')), (m = g.shift()), g.sort()),
                  (c = m.indexOf(':') < 0 && 'on' + m),
                  ((e = e[S.expando]
                    ? e
                    : new S.Event(m, 'object' == typeof e && e)).isTrigger = i
                    ? 2
                    : 3),
                  (e.namespace = g.join('.')),
                  (e.rnamespace = e.namespace
                    ? new RegExp(
                        '(^|\\.)' + g.join('\\.(?:.*\\.|)') + '(\\.|$)'
                      )
                    : null),
                  (e.result = void 0),
                  e.target || (e.target = n),
                  (t = null == t ? [e] : S.makeArray(t, [e])),
                  (d = S.event.special[m] || {}),
                  i || !d.trigger || !1 !== d.trigger.apply(n, t)))
              ) {
                if (!i && !d.noBubble && !y(n)) {
                  for (
                    l = d.delegateType || m,
                      Ot.test(l + m) || (a = a.parentNode);
                    a;
                    a = a.parentNode
                  )
                    h.push(a), (o = a);
                  o === (n.ownerDocument || b) &&
                    h.push(o.defaultView || o.parentWindow || r);
                }
                for (s = 0; (a = h[s++]) && !e.isPropagationStopped(); )
                  (p = a),
                    (e.type = s > 1 ? l : d.bindType || m),
                    (u =
                      (oe.get(a, 'events') || Object.create(null))[e.type] &&
                      oe.get(a, 'handle')) && u.apply(a, t),
                    (u = c && a[c]) &&
                      u.apply &&
                      se(a) &&
                      ((e.result = u.apply(a, t)),
                      !1 === e.result && e.preventDefault());
                return (
                  (e.type = m),
                  i ||
                    e.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(h.pop(), t)) ||
                    !se(n) ||
                    (c &&
                      v(n[m]) &&
                      !y(n) &&
                      ((o = n[c]) && (n[c] = null),
                      (S.event.triggered = m),
                      e.isPropagationStopped() && p.addEventListener(m, Dt),
                      n[m](),
                      e.isPropagationStopped() && p.removeEventListener(m, Dt),
                      (S.event.triggered = void 0),
                      o && (n[c] = o))),
                  e.result
                );
              }
            },
            simulate: function (e, t, n) {
              var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
              S.event.trigger(r, null, t);
            },
          }),
            S.fn.extend({
              trigger: function (e, t) {
                return this.each(function () {
                  S.event.trigger(e, t, this);
                });
              },
              triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return S.event.trigger(e, t, n, !0);
              },
            });
          var It = /\[\]$/,
            zt = /\r?\n/g,
            Rt = /^(?:submit|button|image|reset|file)$/i,
            jt = /^(?:input|select|textarea|keygen)/i;
          function Nt(e, t, n, r) {
            var i;
            if (Array.isArray(t))
              S.each(t, function (t, i) {
                n || It.test(e)
                  ? r(e, i)
                  : Nt(
                      e +
                        '[' +
                        ('object' == typeof i && null != i ? t : '') +
                        ']',
                      i,
                      n,
                      r
                    );
              });
            else if (n || 'object' !== T(t)) r(e, t);
            else for (i in t) Nt(e + '[' + i + ']', t[i], n, r);
          }
          (S.param = function (e, t) {
            var n,
              r = [],
              i = function (e, t) {
                var n = v(t) ? t() : t;
                r[r.length] =
                  encodeURIComponent(e) +
                  '=' +
                  encodeURIComponent(null == n ? '' : n);
              };
            if (null == e) return '';
            if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
              S.each(e, function () {
                i(this.name, this.value);
              });
            else for (n in e) Nt(n, e[n], t, i);
            return r.join('&');
          }),
            S.fn.extend({
              serialize: function () {
                return S.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var e = S.prop(this, 'elements');
                  return e ? S.makeArray(e) : this;
                })
                  .filter(function () {
                    var e = this.type;
                    return (
                      this.name &&
                      !S(this).is(':disabled') &&
                      jt.test(this.nodeName) &&
                      !Rt.test(e) &&
                      (this.checked || !Se.test(e))
                    );
                  })
                  .map(function (e, t) {
                    var n = S(this).val();
                    return null == n
                      ? null
                      : Array.isArray(n)
                      ? S.map(n, function (e) {
                          return { name: t.name, value: e.replace(zt, '\r\n') };
                        })
                      : { name: t.name, value: n.replace(zt, '\r\n') };
                  })
                  .get();
              },
            });
          var $t = /%20/g,
            Ft = /#.*$/,
            qt = /([?&])_=[^&]*/,
            Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Bt = /^(?:GET|HEAD)$/,
            Xt = /^\/\//,
            Yt = {},
            Gt = {},
            Wt = '*/'.concat('*'),
            Vt = b.createElement('a');
          function Ut(e) {
            return function (t, n) {
              'string' != typeof t && ((n = t), (t = '*'));
              var r,
                i = 0,
                s = t.toLowerCase().match(W) || [];
              if (v(n))
                for (; (r = s[i++]); )
                  '+' === r[0]
                    ? ((r = r.slice(1) || '*'), (e[r] = e[r] || []).unshift(n))
                    : (e[r] = e[r] || []).push(n);
            };
          }
          function Kt(e, t, n, r) {
            var i = {},
              s = e === Gt;
            function a(o) {
              var l;
              return (
                (i[o] = !0),
                S.each(e[o] || [], function (e, o) {
                  var c = o(t, n, r);
                  return 'string' != typeof c || s || i[c]
                    ? s
                      ? !(l = c)
                      : void 0
                    : (t.dataTypes.unshift(c), a(c), !1);
                }),
                l
              );
            }
            return a(t.dataTypes[0]) || (!i['*'] && a('*'));
          }
          function Qt(e, t) {
            var n,
              r,
              i = S.ajaxSettings.flatOptions || {};
            for (n in t)
              void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
            return r && S.extend(!0, e, r), e;
          }
          (Vt.href = At.href),
            S.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: At.href,
                type: 'GET',
                isLocal:
                  /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                    At.protocol
                  ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                accepts: {
                  '*': Wt,
                  text: 'text/plain',
                  html: 'text/html',
                  xml: 'application/xml, text/xml',
                  json: 'application/json, text/javascript',
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                  xml: 'responseXML',
                  text: 'responseText',
                  json: 'responseJSON',
                },
                converters: {
                  '* text': String,
                  'text html': !0,
                  'text json': JSON.parse,
                  'text xml': S.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (e, t) {
                return t ? Qt(Qt(e, S.ajaxSettings), t) : Qt(S.ajaxSettings, e);
              },
              ajaxPrefilter: Ut(Yt),
              ajaxTransport: Ut(Gt),
              ajax: function (e, t) {
                'object' == typeof e && ((t = e), (e = void 0)), (t = t || {});
                var n,
                  i,
                  s,
                  a,
                  o,
                  l,
                  c,
                  u,
                  d,
                  p,
                  f = S.ajaxSetup({}, t),
                  h = f.context || f,
                  m = f.context && (h.nodeType || h.jquery) ? S(h) : S.event,
                  g = S.Deferred(),
                  v = S.Callbacks('once memory'),
                  y = f.statusCode || {},
                  w = {},
                  x = {},
                  T = 'canceled',
                  E = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                      var t;
                      if (c) {
                        if (!a)
                          for (a = {}; (t = Ht.exec(s)); )
                            a[t[1].toLowerCase() + ' '] = (
                              a[t[1].toLowerCase() + ' '] || []
                            ).concat(t[2]);
                        t = a[e.toLowerCase() + ' '];
                      }
                      return null == t ? null : t.join(', ');
                    },
                    getAllResponseHeaders: function () {
                      return c ? s : null;
                    },
                    setRequestHeader: function (e, t) {
                      return (
                        null == c &&
                          ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e),
                          (w[e] = t)),
                        this
                      );
                    },
                    overrideMimeType: function (e) {
                      return null == c && (f.mimeType = e), this;
                    },
                    statusCode: function (e) {
                      var t;
                      if (e)
                        if (c) E.always(e[E.status]);
                        else for (t in e) y[t] = [y[t], e[t]];
                      return this;
                    },
                    abort: function (e) {
                      var t = e || T;
                      return n && n.abort(t), _(0, t), this;
                    },
                  };
                if (
                  (g.promise(E),
                  (f.url = ((e || f.url || At.href) + '').replace(
                    Xt,
                    At.protocol + '//'
                  )),
                  (f.type = t.method || t.type || f.method || f.type),
                  (f.dataTypes = (f.dataType || '*').toLowerCase().match(W) || [
                    '',
                  ]),
                  null == f.crossDomain)
                ) {
                  l = b.createElement('a');
                  try {
                    (l.href = f.url),
                      (l.href = l.href),
                      (f.crossDomain =
                        Vt.protocol + '//' + Vt.host !=
                        l.protocol + '//' + l.host);
                  } catch (e) {
                    f.crossDomain = !0;
                  }
                }
                if (
                  (f.data &&
                    f.processData &&
                    'string' != typeof f.data &&
                    (f.data = S.param(f.data, f.traditional)),
                  Kt(Yt, f, t, E),
                  c)
                )
                  return E;
                for (d in ((u = S.event && f.global) &&
                  0 == S.active++ &&
                  S.event.trigger('ajaxStart'),
                (f.type = f.type.toUpperCase()),
                (f.hasContent = !Bt.test(f.type)),
                (i = f.url.replace(Ft, '')),
                f.hasContent
                  ? f.data &&
                    f.processData &&
                    0 ===
                      (f.contentType || '').indexOf(
                        'application/x-www-form-urlencoded'
                      ) &&
                    (f.data = f.data.replace($t, '+'))
                  : ((p = f.url.slice(i.length)),
                    f.data &&
                      (f.processData || 'string' == typeof f.data) &&
                      ((i += (Lt.test(i) ? '&' : '?') + f.data), delete f.data),
                    !1 === f.cache &&
                      ((i = i.replace(qt, '$1')),
                      (p = (Lt.test(i) ? '&' : '?') + '_=' + Pt.guid++ + p)),
                    (f.url = i + p)),
                f.ifModified &&
                  (S.lastModified[i] &&
                    E.setRequestHeader('If-Modified-Since', S.lastModified[i]),
                  S.etag[i] && E.setRequestHeader('If-None-Match', S.etag[i])),
                ((f.data && f.hasContent && !1 !== f.contentType) ||
                  t.contentType) &&
                  E.setRequestHeader('Content-Type', f.contentType),
                E.setRequestHeader(
                  'Accept',
                  f.dataTypes[0] && f.accepts[f.dataTypes[0]]
                    ? f.accepts[f.dataTypes[0]] +
                        ('*' !== f.dataTypes[0] ? ', ' + Wt + '; q=0.01' : '')
                    : f.accepts['*']
                ),
                f.headers))
                  E.setRequestHeader(d, f.headers[d]);
                if (f.beforeSend && (!1 === f.beforeSend.call(h, E, f) || c))
                  return E.abort();
                if (
                  ((T = 'abort'),
                  v.add(f.complete),
                  E.done(f.success),
                  E.fail(f.error),
                  (n = Kt(Gt, f, t, E)))
                ) {
                  if (
                    ((E.readyState = 1), u && m.trigger('ajaxSend', [E, f]), c)
                  )
                    return E;
                  f.async &&
                    f.timeout > 0 &&
                    (o = r.setTimeout(function () {
                      E.abort('timeout');
                    }, f.timeout));
                  try {
                    (c = !1), n.send(w, _);
                  } catch (e) {
                    if (c) throw e;
                    _(-1, e);
                  }
                } else _(-1, 'No Transport');
                function _(e, t, a, l) {
                  var d,
                    p,
                    b,
                    w,
                    x,
                    T = t;
                  c ||
                    ((c = !0),
                    o && r.clearTimeout(o),
                    (n = void 0),
                    (s = l || ''),
                    (E.readyState = e > 0 ? 4 : 0),
                    (d = (e >= 200 && e < 300) || 304 === e),
                    a &&
                      (w = (function (e, t, n) {
                        for (
                          var r, i, s, a, o = e.contents, l = e.dataTypes;
                          '*' === l[0];

                        )
                          l.shift(),
                            void 0 === r &&
                              (r =
                                e.mimeType ||
                                t.getResponseHeader('Content-Type'));
                        if (r)
                          for (i in o)
                            if (o[i] && o[i].test(r)) {
                              l.unshift(i);
                              break;
                            }
                        if (l[0] in n) s = l[0];
                        else {
                          for (i in n) {
                            if (!l[0] || e.converters[i + ' ' + l[0]]) {
                              s = i;
                              break;
                            }
                            a || (a = i);
                          }
                          s = s || a;
                        }
                        if (s) return s !== l[0] && l.unshift(s), n[s];
                      })(f, E, a)),
                    !d &&
                      S.inArray('script', f.dataTypes) > -1 &&
                      S.inArray('json', f.dataTypes) < 0 &&
                      (f.converters['text script'] = function () {}),
                    (w = (function (e, t, n, r) {
                      var i,
                        s,
                        a,
                        o,
                        l,
                        c = {},
                        u = e.dataTypes.slice();
                      if (u[1])
                        for (a in e.converters)
                          c[a.toLowerCase()] = e.converters[a];
                      for (s = u.shift(); s; )
                        if (
                          (e.responseFields[s] && (n[e.responseFields[s]] = t),
                          !l &&
                            r &&
                            e.dataFilter &&
                            (t = e.dataFilter(t, e.dataType)),
                          (l = s),
                          (s = u.shift()))
                        )
                          if ('*' === s) s = l;
                          else if ('*' !== l && l !== s) {
                            if (!(a = c[l + ' ' + s] || c['* ' + s]))
                              for (i in c)
                                if (
                                  (o = i.split(' '))[1] === s &&
                                  (a = c[l + ' ' + o[0]] || c['* ' + o[0]])
                                ) {
                                  !0 === a
                                    ? (a = c[i])
                                    : !0 !== c[i] &&
                                      ((s = o[0]), u.unshift(o[1]));
                                  break;
                                }
                            if (!0 !== a)
                              if (a && e.throws) t = a(t);
                              else
                                try {
                                  t = a(t);
                                } catch (e) {
                                  return {
                                    state: 'parsererror',
                                    error: a
                                      ? e
                                      : 'No conversion from ' + l + ' to ' + s,
                                  };
                                }
                          }
                      return { state: 'success', data: t };
                    })(f, w, E, d)),
                    d
                      ? (f.ifModified &&
                          ((x = E.getResponseHeader('Last-Modified')) &&
                            (S.lastModified[i] = x),
                          (x = E.getResponseHeader('etag')) && (S.etag[i] = x)),
                        204 === e || 'HEAD' === f.type
                          ? (T = 'nocontent')
                          : 304 === e
                          ? (T = 'notmodified')
                          : ((T = w.state), (p = w.data), (d = !(b = w.error))))
                      : ((b = T),
                        (!e && T) || ((T = 'error'), e < 0 && (e = 0))),
                    (E.status = e),
                    (E.statusText = (t || T) + ''),
                    d
                      ? g.resolveWith(h, [p, T, E])
                      : g.rejectWith(h, [E, T, b]),
                    E.statusCode(y),
                    (y = void 0),
                    u &&
                      m.trigger(d ? 'ajaxSuccess' : 'ajaxError', [
                        E,
                        f,
                        d ? p : b,
                      ]),
                    v.fireWith(h, [E, T]),
                    u &&
                      (m.trigger('ajaxComplete', [E, f]),
                      --S.active || S.event.trigger('ajaxStop')));
                }
                return E;
              },
              getJSON: function (e, t, n) {
                return S.get(e, t, n, 'json');
              },
              getScript: function (e, t) {
                return S.get(e, void 0, t, 'script');
              },
            }),
            S.each(['get', 'post'], function (e, t) {
              S[t] = function (e, n, r, i) {
                return (
                  v(n) && ((i = i || r), (r = n), (n = void 0)),
                  S.ajax(
                    S.extend(
                      { url: e, type: t, dataType: i, data: n, success: r },
                      S.isPlainObject(e) && e
                    )
                  )
                );
              };
            }),
            S.ajaxPrefilter(function (e) {
              var t;
              for (t in e.headers)
                'content-type' === t.toLowerCase() &&
                  (e.contentType = e.headers[t] || '');
            }),
            (S._evalUrl = function (e, t, n) {
              return S.ajax({
                url: e,
                type: 'GET',
                dataType: 'script',
                cache: !0,
                async: !1,
                global: !1,
                converters: { 'text script': function () {} },
                dataFilter: function (e) {
                  S.globalEval(e, t, n);
                },
              });
            }),
            S.fn.extend({
              wrapAll: function (e) {
                var t;
                return (
                  this[0] &&
                    (v(e) && (e = e.call(this[0])),
                    (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && t.insertBefore(this[0]),
                    t
                      .map(function () {
                        for (var e = this; e.firstElementChild; )
                          e = e.firstElementChild;
                        return e;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (e) {
                return v(e)
                  ? this.each(function (t) {
                      S(this).wrapInner(e.call(this, t));
                    })
                  : this.each(function () {
                      var t = S(this),
                        n = t.contents();
                      n.length ? n.wrapAll(e) : t.append(e);
                    });
              },
              wrap: function (e) {
                var t = v(e);
                return this.each(function (n) {
                  S(this).wrapAll(t ? e.call(this, n) : e);
                });
              },
              unwrap: function (e) {
                return (
                  this.parent(e)
                    .not('body')
                    .each(function () {
                      S(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (S.expr.pseudos.hidden = function (e) {
              return !S.expr.pseudos.visible(e);
            }),
            (S.expr.pseudos.visible = function (e) {
              return !!(
                e.offsetWidth ||
                e.offsetHeight ||
                e.getClientRects().length
              );
            }),
            (S.ajaxSettings.xhr = function () {
              try {
                return new r.XMLHttpRequest();
              } catch (e) {}
            });
          var Zt = { 0: 200, 1223: 204 },
            Jt = S.ajaxSettings.xhr();
          (g.cors = !!Jt && 'withCredentials' in Jt),
            (g.ajax = Jt = !!Jt),
            S.ajaxTransport(function (e) {
              var t, n;
              if (g.cors || (Jt && !e.crossDomain))
                return {
                  send: function (i, s) {
                    var a,
                      o = e.xhr();
                    if (
                      (o.open(e.type, e.url, e.async, e.username, e.password),
                      e.xhrFields)
                    )
                      for (a in e.xhrFields) o[a] = e.xhrFields[a];
                    for (a in (e.mimeType &&
                      o.overrideMimeType &&
                      o.overrideMimeType(e.mimeType),
                    e.crossDomain ||
                      i['X-Requested-With'] ||
                      (i['X-Requested-With'] = 'XMLHttpRequest'),
                    i))
                      o.setRequestHeader(a, i[a]);
                    (t = function (e) {
                      return function () {
                        t &&
                          ((t =
                            n =
                            o.onload =
                            o.onerror =
                            o.onabort =
                            o.ontimeout =
                            o.onreadystatechange =
                              null),
                          'abort' === e
                            ? o.abort()
                            : 'error' === e
                            ? 'number' != typeof o.status
                              ? s(0, 'error')
                              : s(o.status, o.statusText)
                            : s(
                                Zt[o.status] || o.status,
                                o.statusText,
                                'text' !== (o.responseType || 'text') ||
                                  'string' != typeof o.responseText
                                  ? { binary: o.response }
                                  : { text: o.responseText },
                                o.getAllResponseHeaders()
                              ));
                      };
                    }),
                      (o.onload = t()),
                      (n = o.onerror = o.ontimeout = t('error')),
                      void 0 !== o.onabort
                        ? (o.onabort = n)
                        : (o.onreadystatechange = function () {
                            4 === o.readyState &&
                              r.setTimeout(function () {
                                t && n();
                              });
                          }),
                      (t = t('abort'));
                    try {
                      o.send((e.hasContent && e.data) || null);
                    } catch (e) {
                      if (t) throw e;
                    }
                  },
                  abort: function () {
                    t && t();
                  },
                };
            }),
            S.ajaxPrefilter(function (e) {
              e.crossDomain && (e.contents.script = !1);
            }),
            S.ajaxSetup({
              accepts: {
                script:
                  'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                'text script': function (e) {
                  return S.globalEval(e), e;
                },
              },
            }),
            S.ajaxPrefilter('script', function (e) {
              void 0 === e.cache && (e.cache = !1),
                e.crossDomain && (e.type = 'GET');
            }),
            S.ajaxTransport('script', function (e) {
              var t, n;
              if (e.crossDomain || e.scriptAttrs)
                return {
                  send: function (r, i) {
                    (t = S('<script>')
                      .attr(e.scriptAttrs || {})
                      .prop({ charset: e.scriptCharset, src: e.url })
                      .on(
                        'load error',
                        (n = function (e) {
                          t.remove(),
                            (n = null),
                            e && i('error' === e.type ? 404 : 200, e.type);
                        })
                      )),
                      b.head.appendChild(t[0]);
                  },
                  abort: function () {
                    n && n();
                  },
                };
            });
          var en,
            tn = [],
            nn = /(=)\?(?=&|$)|\?\?/;
          S.ajaxSetup({
            jsonp: 'callback',
            jsonpCallback: function () {
              var e = tn.pop() || S.expando + '_' + Pt.guid++;
              return (this[e] = !0), e;
            },
          }),
            S.ajaxPrefilter('json jsonp', function (e, t, n) {
              var i,
                s,
                a,
                o =
                  !1 !== e.jsonp &&
                  (nn.test(e.url)
                    ? 'url'
                    : 'string' == typeof e.data &&
                      0 ===
                        (e.contentType || '').indexOf(
                          'application/x-www-form-urlencoded'
                        ) &&
                      nn.test(e.data) &&
                      'data');
              if (o || 'jsonp' === e.dataTypes[0])
                return (
                  (i = e.jsonpCallback =
                    v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                  o
                    ? (e[o] = e[o].replace(nn, '$1' + i))
                    : !1 !== e.jsonp &&
                      (e.url +=
                        (Lt.test(e.url) ? '&' : '?') + e.jsonp + '=' + i),
                  (e.converters['script json'] = function () {
                    return a || S.error(i + ' was not called'), a[0];
                  }),
                  (e.dataTypes[0] = 'json'),
                  (s = r[i]),
                  (r[i] = function () {
                    a = arguments;
                  }),
                  n.always(function () {
                    void 0 === s ? S(r).removeProp(i) : (r[i] = s),
                      e[i] && ((e.jsonpCallback = t.jsonpCallback), tn.push(i)),
                      a && v(s) && s(a[0]),
                      (a = s = void 0);
                  }),
                  'script'
                );
            }),
            (g.createHTMLDocument =
              (((en = b.implementation.createHTMLDocument('').body).innerHTML =
                '<form></form><form></form>'),
              2 === en.childNodes.length)),
            (S.parseHTML = function (e, t, n) {
              return 'string' != typeof e
                ? []
                : ('boolean' == typeof t && ((n = t), (t = !1)),
                  t ||
                    (g.createHTMLDocument
                      ? (((r = (t =
                          b.implementation.createHTMLDocument(
                            ''
                          )).createElement('base')).href = b.location.href),
                        t.head.appendChild(r))
                      : (t = b)),
                  (s = !n && []),
                  (i = F.exec(e))
                    ? [t.createElement(i[1])]
                    : ((i = Oe([e], t, s)),
                      s && s.length && S(s).remove(),
                      S.merge([], i.childNodes)));
              var r, i, s;
            }),
            (S.fn.load = function (e, t, n) {
              var r,
                i,
                s,
                a = this,
                o = e.indexOf(' ');
              return (
                o > -1 && ((r = St(e.slice(o))), (e = e.slice(0, o))),
                v(t)
                  ? ((n = t), (t = void 0))
                  : t && 'object' == typeof t && (i = 'POST'),
                a.length > 0 &&
                  S.ajax({
                    url: e,
                    type: i || 'GET',
                    dataType: 'html',
                    data: t,
                  })
                    .done(function (e) {
                      (s = arguments),
                        a.html(
                          r ? S('<div>').append(S.parseHTML(e)).find(r) : e
                        );
                    })
                    .always(
                      n &&
                        function (e, t) {
                          a.each(function () {
                            n.apply(this, s || [e.responseText, t, e]);
                          });
                        }
                    ),
                this
              );
            }),
            (S.expr.pseudos.animated = function (e) {
              return S.grep(S.timers, function (t) {
                return e === t.elem;
              }).length;
            }),
            (S.offset = {
              setOffset: function (e, t, n) {
                var r,
                  i,
                  s,
                  a,
                  o,
                  l,
                  c = S.css(e, 'position'),
                  u = S(e),
                  d = {};
                'static' === c && (e.style.position = 'relative'),
                  (o = u.offset()),
                  (s = S.css(e, 'top')),
                  (l = S.css(e, 'left')),
                  ('absolute' === c || 'fixed' === c) &&
                  (s + l).indexOf('auto') > -1
                    ? ((a = (r = u.position()).top), (i = r.left))
                    : ((a = parseFloat(s) || 0), (i = parseFloat(l) || 0)),
                  v(t) && (t = t.call(e, n, S.extend({}, o))),
                  null != t.top && (d.top = t.top - o.top + a),
                  null != t.left && (d.left = t.left - o.left + i),
                  'using' in t ? t.using.call(e, d) : u.css(d);
              },
            }),
            S.fn.extend({
              offset: function (e) {
                if (arguments.length)
                  return void 0 === e
                    ? this
                    : this.each(function (t) {
                        S.offset.setOffset(this, e, t);
                      });
                var t,
                  n,
                  r = this[0];
                return r
                  ? r.getClientRects().length
                    ? ((t = r.getBoundingClientRect()),
                      (n = r.ownerDocument.defaultView),
                      {
                        top: t.top + n.pageYOffset,
                        left: t.left + n.pageXOffset,
                      })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var e,
                    t,
                    n,
                    r = this[0],
                    i = { top: 0, left: 0 };
                  if ('fixed' === S.css(r, 'position'))
                    t = r.getBoundingClientRect();
                  else {
                    for (
                      t = this.offset(),
                        n = r.ownerDocument,
                        e = r.offsetParent || n.documentElement;
                      e &&
                      (e === n.body || e === n.documentElement) &&
                      'static' === S.css(e, 'position');

                    )
                      e = e.parentNode;
                    e &&
                      e !== r &&
                      1 === e.nodeType &&
                      (((i = S(e).offset()).top += S.css(
                        e,
                        'borderTopWidth',
                        !0
                      )),
                      (i.left += S.css(e, 'borderLeftWidth', !0)));
                  }
                  return {
                    top: t.top - i.top - S.css(r, 'marginTop', !0),
                    left: t.left - i.left - S.css(r, 'marginLeft', !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var e = this.offsetParent;
                    e && 'static' === S.css(e, 'position');

                  )
                    e = e.offsetParent;
                  return e || me;
                });
              },
            }),
            S.each(
              { scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' },
              function (e, t) {
                var n = 'pageYOffset' === t;
                S.fn[e] = function (r) {
                  return ee(
                    this,
                    function (e, r, i) {
                      var s;
                      if (
                        (y(e)
                          ? (s = e)
                          : 9 === e.nodeType && (s = e.defaultView),
                        void 0 === i)
                      )
                        return s ? s[t] : e[r];
                      s
                        ? s.scrollTo(
                            n ? s.pageXOffset : i,
                            n ? i : s.pageYOffset
                          )
                        : (e[r] = i);
                    },
                    e,
                    r,
                    arguments.length
                  );
                };
              }
            ),
            S.each(['top', 'left'], function (e, t) {
              S.cssHooks[t] = et(g.pixelPosition, function (e, n) {
                if (n)
                  return (
                    (n = Je(e, t)), Ve.test(n) ? S(e).position()[t] + 'px' : n
                  );
              });
            }),
            S.each({ Height: 'height', Width: 'width' }, function (e, t) {
              S.each(
                { padding: 'inner' + e, content: t, '': 'outer' + e },
                function (n, r) {
                  S.fn[r] = function (i, s) {
                    var a = arguments.length && (n || 'boolean' != typeof i),
                      o = n || (!0 === i || !0 === s ? 'margin' : 'border');
                    return ee(
                      this,
                      function (t, n, i) {
                        var s;
                        return y(t)
                          ? 0 === r.indexOf('outer')
                            ? t['inner' + e]
                            : t.document.documentElement['client' + e]
                          : 9 === t.nodeType
                          ? ((s = t.documentElement),
                            Math.max(
                              t.body['scroll' + e],
                              s['scroll' + e],
                              t.body['offset' + e],
                              s['offset' + e],
                              s['client' + e]
                            ))
                          : void 0 === i
                          ? S.css(t, n, o)
                          : S.style(t, n, i, o);
                      },
                      t,
                      a ? i : void 0,
                      a
                    );
                  };
                }
              );
            }),
            S.each(
              [
                'ajaxStart',
                'ajaxStop',
                'ajaxComplete',
                'ajaxError',
                'ajaxSuccess',
                'ajaxSend',
              ],
              function (e, t) {
                S.fn[t] = function (e) {
                  return this.on(t, e);
                };
              }
            ),
            S.fn.extend({
              bind: function (e, t, n) {
                return this.on(e, null, t, n);
              },
              unbind: function (e, t) {
                return this.off(e, null, t);
              },
              delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
              },
              undelegate: function (e, t, n) {
                return 1 === arguments.length
                  ? this.off(e, '**')
                  : this.off(t, e || '**', n);
              },
              hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
              },
            }),
            S.each(
              'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
                ' '
              ),
              function (e, t) {
                S.fn[t] = function (e, n) {
                  return arguments.length > 0
                    ? this.on(t, null, e, n)
                    : this.trigger(t);
                };
              }
            );
          var rn = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
          (S.proxy = function (e, t) {
            var n, r, i;
            if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
              return (
                (r = o.call(arguments, 2)),
                (i = function () {
                  return e.apply(t || this, r.concat(o.call(arguments)));
                }),
                (i.guid = e.guid = e.guid || S.guid++),
                i
              );
          }),
            (S.holdReady = function (e) {
              e ? S.readyWait++ : S.ready(!0);
            }),
            (S.isArray = Array.isArray),
            (S.parseJSON = JSON.parse),
            (S.nodeName = M),
            (S.isFunction = v),
            (S.isWindow = y),
            (S.camelCase = ie),
            (S.type = T),
            (S.now = Date.now),
            (S.isNumeric = function (e) {
              var t = S.type(e);
              return (
                ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e))
              );
            }),
            (S.trim = function (e) {
              return null == e ? '' : (e + '').replace(rn, '$1');
            }),
            void 0 ===
              (n = function () {
                return S;
              }.apply(t, [])) || (e.exports = n);
          var sn = r.jQuery,
            an = r.$;
          return (
            (S.noConflict = function (e) {
              return (
                r.$ === S && (r.$ = an),
                e && r.jQuery === S && (r.jQuery = sn),
                S
              );
            }),
            void 0 === i && (r.jQuery = r.$ = S),
            S
          );
        });
      },
      752: function (e, t) {
        var n;
        !(function () {
          'use strict';
          function r(e) {
            if (void 0 === e)
              throw new Error(
                'Pathformer [constructor]: "element" parameter is required'
              );
            if (e.constructor === String && !(e = document.getElementById(e)))
              throw new Error(
                'Pathformer [constructor]: "element" parameter is not related to an existing ID'
              );
            if (
              !(
                e instanceof window.SVGElement ||
                e instanceof window.SVGGElement ||
                /^svg$/i.test(e.nodeName)
              )
            )
              throw new Error(
                'Pathformer [constructor]: "element" parameter must be a string or a SVGelement'
              );
            (this.el = e), this.scan(e);
          }
          var i, s, a, o;
          function l(e, t, n) {
            i(),
              (this.isReady = !1),
              this.setElement(e, t),
              this.setOptions(t),
              this.setCallback(n),
              this.isReady && this.init();
          }
          (r.prototype.TYPES = [
            'line',
            'ellipse',
            'circle',
            'polygon',
            'polyline',
            'rect',
          ]),
            (r.prototype.ATTR_WATCH = [
              'cx',
              'cy',
              'points',
              'r',
              'rx',
              'ry',
              'x',
              'x1',
              'x2',
              'y',
              'y1',
              'y2',
            ]),
            (r.prototype.scan = function (e) {
              for (
                var t,
                  n,
                  r,
                  i = e.querySelectorAll(this.TYPES.join(',')),
                  s = 0;
                s < i.length;
                s++
              )
                (n = (0, this[(t = i[s]).tagName.toLowerCase() + 'ToPath'])(
                  this.parseAttr(t.attributes)
                )),
                  (r = this.pathMaker(t, n)),
                  t.parentNode.replaceChild(r, t);
            }),
            (r.prototype.lineToPath = function (e) {
              var t = {},
                n = e.x1 || 0,
                r = e.y1 || 0,
                i = e.x2 || 0,
                s = e.y2 || 0;
              return (t.d = 'M' + n + ',' + r + 'L' + i + ',' + s), t;
            }),
            (r.prototype.rectToPath = function (e) {
              var t = {},
                n = parseFloat(e.x) || 0,
                r = parseFloat(e.y) || 0,
                i = parseFloat(e.width) || 0,
                s = parseFloat(e.height) || 0;
              if (e.rx || e.ry) {
                var a = parseInt(e.rx, 10) || -1,
                  o = parseInt(e.ry, 10) || -1;
                (a = Math.min(Math.max(a < 0 ? o : a, 0), i / 2)),
                  (o = Math.min(Math.max(o < 0 ? a : o, 0), s / 2)),
                  (t.d =
                    'M ' +
                    (n + a) +
                    ',' +
                    r +
                    ' L ' +
                    (n + i - a) +
                    ',' +
                    r +
                    ' A ' +
                    a +
                    ',' +
                    o +
                    ',0,0,1,' +
                    (n + i) +
                    ',' +
                    (r + o) +
                    ' L ' +
                    (n + i) +
                    ',' +
                    (r + s - o) +
                    ' A ' +
                    a +
                    ',' +
                    o +
                    ',0,0,1,' +
                    (n + i - a) +
                    ',' +
                    (r + s) +
                    ' L ' +
                    (n + a) +
                    ',' +
                    (r + s) +
                    ' A ' +
                    a +
                    ',' +
                    o +
                    ',0,0,1,' +
                    n +
                    ',' +
                    (r + s - o) +
                    ' L ' +
                    n +
                    ',' +
                    (r + o) +
                    ' A ' +
                    a +
                    ',' +
                    o +
                    ',0,0,1,' +
                    (n + a) +
                    ',' +
                    r);
              } else
                t.d =
                  'M' +
                  n +
                  ' ' +
                  r +
                  ' L' +
                  (n + i) +
                  ' ' +
                  r +
                  ' L' +
                  (n + i) +
                  ' ' +
                  (r + s) +
                  ' L' +
                  n +
                  ' ' +
                  (r + s) +
                  ' Z';
              return t;
            }),
            (r.prototype.polylineToPath = function (e) {
              var t,
                n,
                r = {},
                i = e.points.trim().split(' ');
              if (-1 === e.points.indexOf(',')) {
                var s = [];
                for (t = 0; t < i.length; t += 2) s.push(i[t] + ',' + i[t + 1]);
                i = s;
              }
              for (n = 'M' + i[0], t = 1; t < i.length; t++)
                -1 !== i[t].indexOf(',') && (n += 'L' + i[t]);
              return (r.d = n), r;
            }),
            (r.prototype.polygonToPath = function (e) {
              var t = r.prototype.polylineToPath(e);
              return (t.d += 'Z'), t;
            }),
            (r.prototype.ellipseToPath = function (e) {
              var t = {},
                n = parseFloat(e.rx) || 0,
                r = parseFloat(e.ry) || 0,
                i = parseFloat(e.cx) || 0,
                s = parseFloat(e.cy) || 0,
                a = i - n,
                o = s,
                l = parseFloat(i) + parseFloat(n),
                c = s;
              return (
                (t.d =
                  'M' +
                  a +
                  ',' +
                  o +
                  'A' +
                  n +
                  ',' +
                  r +
                  ' 0,1,1 ' +
                  l +
                  ',' +
                  c +
                  'A' +
                  n +
                  ',' +
                  r +
                  ' 0,1,1 ' +
                  a +
                  ',' +
                  c),
                t
              );
            }),
            (r.prototype.circleToPath = function (e) {
              var t = {},
                n = parseFloat(e.r) || 0,
                r = parseFloat(e.cx) || 0,
                i = parseFloat(e.cy) || 0,
                s = r - n,
                a = i,
                o = parseFloat(r) + parseFloat(n),
                l = i;
              return (
                (t.d =
                  'M' +
                  s +
                  ',' +
                  a +
                  'A' +
                  n +
                  ',' +
                  n +
                  ' 0,1,1 ' +
                  o +
                  ',' +
                  l +
                  'A' +
                  n +
                  ',' +
                  n +
                  ' 0,1,1 ' +
                  s +
                  ',' +
                  l),
                t
              );
            }),
            (r.prototype.pathMaker = function (e, t) {
              var n,
                r,
                i = document.createElementNS(
                  'http://www.w3.org/2000/svg',
                  'path'
                );
              for (n = 0; n < e.attributes.length; n++)
                (r = e.attributes[n]),
                  -1 === this.ATTR_WATCH.indexOf(r.name) &&
                    i.setAttribute(r.name, r.value);
              for (n in t) i.setAttribute(n, t[n]);
              return i;
            }),
            (r.prototype.parseAttr = function (e) {
              for (var t, n = {}, r = 0; r < e.length; r++) {
                if (
                  ((t = e[r]),
                  -1 !== this.ATTR_WATCH.indexOf(t.name) &&
                    -1 !== t.value.indexOf('%'))
                )
                  throw new Error(
                    "Pathformer [parseAttr]: a SVG shape got values in percentage. This cannot be transformed into 'path' tags. Please use 'viewBox'."
                  );
                n[t.name] = t.value;
              }
              return n;
            }),
            (l.LINEAR = function (e) {
              return e;
            }),
            (l.EASE = function (e) {
              return -Math.cos(e * Math.PI) / 2 + 0.5;
            }),
            (l.EASE_OUT = function (e) {
              return 1 - Math.pow(1 - e, 3);
            }),
            (l.EASE_IN = function (e) {
              return Math.pow(e, 3);
            }),
            (l.EASE_OUT_BOUNCE = function (e) {
              var t = 1 - Math.cos(e * (0.5 * Math.PI)),
                n = Math.pow(t, 1.5),
                r = Math.pow(1 - e, 2);
              return 1 - r + (1 - Math.abs(Math.cos(n * (2.5 * Math.PI)))) * r;
            }),
            (l.prototype.setElement = function (e, t) {
              var n, r;
              if (void 0 === e)
                throw new Error(
                  'Vivus [constructor]: "element" parameter is required'
                );
              if (e.constructor === String && !(e = document.getElementById(e)))
                throw new Error(
                  'Vivus [constructor]: "element" parameter is not related to an existing ID'
                );
              if (((this.parentEl = e), t && t.file)) {
                (r = this),
                  (n = function () {
                    var e = document.createElement('div');
                    e.innerHTML = this.responseText;
                    var n = e.querySelector('svg');
                    if (!n)
                      throw new Error(
                        'Vivus [load]: Cannot find the SVG in the loaded file : ' +
                          t.file
                      );
                    (r.el = n),
                      r.el.setAttribute('width', '100%'),
                      r.el.setAttribute('height', '100%'),
                      r.parentEl.appendChild(r.el),
                      (r.isReady = !0),
                      r.init(),
                      (r = null);
                  });
                var i = new window.XMLHttpRequest();
                return (
                  i.addEventListener('load', n),
                  i.open('GET', t.file),
                  void i.send()
                );
              }
              switch (e.constructor) {
                case window.SVGSVGElement:
                case window.SVGElement:
                case window.SVGGElement:
                  (this.el = e), (this.isReady = !0);
                  break;
                case window.HTMLObjectElement:
                  (r = this),
                    (n = function (t) {
                      if (!r.isReady) {
                        if (
                          ((r.el =
                            e.contentDocument &&
                            e.contentDocument.querySelector('svg')),
                          !r.el && t)
                        )
                          throw new Error(
                            'Vivus [constructor]: object loaded does not contain any SVG'
                          );
                        r.el &&
                          (e.getAttribute('built-by-vivus') &&
                            (r.parentEl.insertBefore(r.el, e),
                            r.parentEl.removeChild(e),
                            r.el.setAttribute('width', '100%'),
                            r.el.setAttribute('height', '100%')),
                          (r.isReady = !0),
                          r.init(),
                          (r = null));
                      }
                    })() || e.addEventListener('load', n);
                  break;
                default:
                  throw new Error(
                    'Vivus [constructor]: "element" parameter is not valid (or miss the "file" attribute)'
                  );
              }
            }),
            (l.prototype.setOptions = function (e) {
              var t = [
                  'delayed',
                  'sync',
                  'async',
                  'nsync',
                  'oneByOne',
                  'scenario',
                  'scenario-sync',
                ],
                n = ['inViewport', 'manual', 'autostart'];
              if (void 0 !== e && e.constructor !== Object)
                throw new Error(
                  'Vivus [constructor]: "options" parameter must be an object'
                );
              if ((e = e || {}).type && -1 === t.indexOf(e.type))
                throw new Error(
                  'Vivus [constructor]: ' +
                    e.type +
                    ' is not an existing animation `type`'
                );
              if (
                ((this.type = e.type || t[0]),
                e.start && -1 === n.indexOf(e.start))
              )
                throw new Error(
                  'Vivus [constructor]: ' +
                    e.start +
                    ' is not an existing `start` option'
                );
              if (
                ((this.start = e.start || n[0]),
                (this.isIE =
                  -1 !== window.navigator.userAgent.indexOf('MSIE') ||
                  -1 !== window.navigator.userAgent.indexOf('Trident/') ||
                  -1 !== window.navigator.userAgent.indexOf('Edge/')),
                (this.duration = o(e.duration, 120)),
                (this.delay = o(e.delay, null)),
                (this.dashGap = o(e.dashGap, 1)),
                (this.forceRender = e.hasOwnProperty('forceRender')
                  ? !!e.forceRender
                  : this.isIE),
                (this.reverseStack = !!e.reverseStack),
                (this.selfDestroy = !!e.selfDestroy),
                (this.onReady = e.onReady),
                (this.map = []),
                (this.frameLength =
                  this.currentFrame =
                  this.delayUnit =
                  this.speed =
                  this.handle =
                    null),
                (this.ignoreInvisible =
                  !!e.hasOwnProperty('ignoreInvisible') && !!e.ignoreInvisible),
                (this.animTimingFunction = e.animTimingFunction || l.LINEAR),
                (this.pathTimingFunction = e.pathTimingFunction || l.LINEAR),
                this.delay >= this.duration)
              )
                throw new Error(
                  'Vivus [constructor]: delay must be shorter than duration'
                );
            }),
            (l.prototype.setCallback = function (e) {
              if (e && e.constructor !== Function)
                throw new Error(
                  'Vivus [constructor]: "callback" parameter must be a function'
                );
              this.callback = e || function () {};
            }),
            (l.prototype.mapping = function () {
              var e, t, n, r, i, s, a, l, c, u;
              for (
                l = s = a = 0,
                  t = this.el.querySelectorAll('path'),
                  u = !1,
                  e = 0;
                e < t.length;
                e++
              )
                if (((n = t[e]), !this.isInvisible(n))) {
                  if (
                    ((i = {
                      el: n,
                      length: 0,
                      startAt: 0,
                      duration: 0,
                      isResizeSensitive: !1,
                    }),
                    'non-scaling-stroke' === n.getAttribute('vector-effect'))
                  ) {
                    var d = n.getBoundingClientRect(),
                      p = n.getBBox();
                    (c = Math.max(d.width / p.width, d.height / p.height)),
                      (i.isResizeSensitive = !0),
                      (u = !0);
                  } else c = 1;
                  (i.length = Math.ceil(n.getTotalLength() * c)),
                    isNaN(i.length)
                      ? window.console &&
                        console.warn &&
                        console.warn(
                          'Vivus [mapping]: cannot retrieve a path element length',
                          n
                        )
                      : (this.map.push(i),
                        (n.style.strokeDasharray =
                          i.length + ' ' + (i.length + 2 * this.dashGap)),
                        (n.style.strokeDashoffset = i.length + this.dashGap),
                        (i.length += this.dashGap),
                        (s += i.length),
                        this.renderPath(e));
                }
              for (
                u &&
                  console.warn(
                    'Vivus: this SVG contains non-scaling-strokes. You should call instance.recalc() when the SVG is resized or you will encounter unwanted behaviour. See https://github.com/maxwellito/vivus#non-scaling for more info.'
                  ),
                  s = 0 === s ? 1 : s,
                  this.delay =
                    null === this.delay ? this.duration / 3 : this.delay,
                  this.delayUnit =
                    this.delay / (t.length > 1 ? t.length - 1 : 1),
                  this.reverseStack && this.map.reverse(),
                  e = 0;
                e < this.map.length;
                e++
              ) {
                switch (((i = this.map[e]), this.type)) {
                  case 'delayed':
                    (i.startAt = this.delayUnit * e),
                      (i.duration = this.duration - this.delay);
                    break;
                  case 'oneByOne':
                    (i.startAt = (a / s) * this.duration),
                      (i.duration = (i.length / s) * this.duration);
                    break;
                  case 'sync':
                  case 'async':
                  case 'nsync':
                    (i.startAt = 0), (i.duration = this.duration);
                    break;
                  case 'scenario-sync':
                    (n = i.el),
                      (r = this.parseAttr(n)),
                      (i.startAt =
                        l + (o(r['data-delay'], this.delayUnit) || 0)),
                      (i.duration = o(r['data-duration'], this.duration)),
                      (l =
                        void 0 !== r['data-async']
                          ? i.startAt
                          : i.startAt + i.duration),
                      (this.frameLength = Math.max(
                        this.frameLength,
                        i.startAt + i.duration
                      ));
                    break;
                  case 'scenario':
                    (n = i.el),
                      (r = this.parseAttr(n)),
                      (i.startAt = o(r['data-start'], this.delayUnit) || 0),
                      (i.duration = o(r['data-duration'], this.duration)),
                      (this.frameLength = Math.max(
                        this.frameLength,
                        i.startAt + i.duration
                      ));
                }
                (a += i.length),
                  (this.frameLength = this.frameLength || this.duration);
              }
            }),
            (l.prototype.recalc = function () {
              this.mustRecalcScale ||
                (this.mustRecalcScale = s(
                  function () {
                    this.performLineRecalc();
                  }.bind(this)
                ));
            }),
            (l.prototype.performLineRecalc = function () {
              for (var e, t, n, r, i, s = 0; s < this.map.length; s++)
                (e = this.map[s]).isResizeSensitive &&
                  ((n = (t = e.el).getBoundingClientRect()),
                  (r = t.getBBox()),
                  (i = Math.max(n.width / r.width, n.height / r.height)),
                  (e.length = Math.ceil(t.getTotalLength() * i)),
                  (t.style.strokeDasharray =
                    e.length + ' ' + (e.length + 2 * this.dashGap)));
              this.trace(), (this.mustRecalcScale = null);
            }),
            (l.prototype.draw = function () {
              var e = this;
              if (((this.currentFrame += this.speed), this.currentFrame <= 0))
                this.stop(), this.reset();
              else {
                if (!(this.currentFrame >= this.frameLength))
                  return (
                    this.trace(),
                    void (this.handle = s(function () {
                      e.draw();
                    }))
                  );
                this.stop(),
                  (this.currentFrame = this.frameLength),
                  this.trace(),
                  this.selfDestroy && this.destroy();
              }
              this.callback(this),
                this.instanceCallback &&
                  (this.instanceCallback(this), (this.instanceCallback = null));
            }),
            (l.prototype.trace = function () {
              var e, t, n, r;
              for (
                r =
                  this.animTimingFunction(
                    this.currentFrame / this.frameLength
                  ) * this.frameLength,
                  e = 0;
                e < this.map.length;
                e++
              )
                (t = (r - (n = this.map[e]).startAt) / n.duration),
                  (t = this.pathTimingFunction(Math.max(0, Math.min(1, t)))),
                  n.progress !== t &&
                    ((n.progress = t),
                    (n.el.style.strokeDashoffset = Math.floor(
                      n.length * (1 - t)
                    )),
                    this.renderPath(e));
            }),
            (l.prototype.renderPath = function (e) {
              if (this.forceRender && this.map && this.map[e]) {
                var t = this.map[e],
                  n = t.el.cloneNode(!0);
                t.el.parentNode.replaceChild(n, t.el), (t.el = n);
              }
            }),
            (l.prototype.init = function () {
              (this.frameLength = 0),
                (this.currentFrame = 0),
                (this.map = []),
                new r(this.el),
                this.mapping(),
                this.starter(),
                this.onReady && this.onReady(this);
            }),
            (l.prototype.starter = function () {
              switch (this.start) {
                case 'manual':
                  return;
                case 'autostart':
                  this.play();
                  break;
                case 'inViewport':
                  var e = this,
                    t = function () {
                      e.isInViewport(e.parentEl, 1) &&
                        (e.play(), window.removeEventListener('scroll', t));
                    };
                  window.addEventListener('scroll', t), t();
              }
            }),
            (l.prototype.getStatus = function () {
              return 0 === this.currentFrame
                ? 'start'
                : this.currentFrame === this.frameLength
                ? 'end'
                : 'progress';
            }),
            (l.prototype.reset = function () {
              return this.setFrameProgress(0);
            }),
            (l.prototype.finish = function () {
              return this.setFrameProgress(1);
            }),
            (l.prototype.setFrameProgress = function (e) {
              return (
                (e = Math.min(1, Math.max(0, e))),
                (this.currentFrame = Math.round(this.frameLength * e)),
                this.trace(),
                this
              );
            }),
            (l.prototype.play = function (e, t) {
              if (((this.instanceCallback = null), e && 'function' == typeof e))
                (this.instanceCallback = e), (e = null);
              else if (e && 'number' != typeof e)
                throw new Error('Vivus [play]: invalid speed');
              return (
                t &&
                  'function' == typeof t &&
                  !this.instanceCallback &&
                  (this.instanceCallback = t),
                (this.speed = e || 1),
                this.handle || this.draw(),
                this
              );
            }),
            (l.prototype.stop = function () {
              return (
                this.handle && (a(this.handle), (this.handle = null)), this
              );
            }),
            (l.prototype.destroy = function () {
              var e, t;
              for (this.stop(), e = 0; e < this.map.length; e++)
                ((t = this.map[e]).el.style.strokeDashoffset = null),
                  (t.el.style.strokeDasharray = null),
                  this.renderPath(e);
            }),
            (l.prototype.isInvisible = function (e) {
              var t,
                n = e.getAttribute('data-ignore');
              return null !== n
                ? 'false' !== n
                : !!this.ignoreInvisible &&
                    !(t = e.getBoundingClientRect()).width &&
                    !t.height;
            }),
            (l.prototype.parseAttr = function (e) {
              var t,
                n = {};
              if (e && e.attributes)
                for (var r = 0; r < e.attributes.length; r++)
                  n[(t = e.attributes[r]).name] = t.value;
              return n;
            }),
            (l.prototype.isInViewport = function (e, t) {
              var n = this.scrollY(),
                r = n + this.getViewportH(),
                i = e.getBoundingClientRect(),
                s = i.height,
                a = n + i.top;
              return a + s * (t = t || 0) <= r && a + s >= n;
            }),
            (l.prototype.getViewportH = function () {
              var e = this.docElem.clientHeight,
                t = window.innerHeight;
              return e < t ? t : e;
            }),
            (l.prototype.scrollY = function () {
              return window.pageYOffset || this.docElem.scrollTop;
            }),
            (i = function () {
              l.prototype.docElem ||
                ((l.prototype.docElem = window.document.documentElement),
                (s =
                  window.requestAnimationFrame ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame ||
                  window.oRequestAnimationFrame ||
                  window.msRequestAnimationFrame ||
                  function (e) {
                    return window.setTimeout(e, 1e3 / 60);
                  }),
                (a =
                  window.cancelAnimationFrame ||
                  window.webkitCancelAnimationFrame ||
                  window.mozCancelAnimationFrame ||
                  window.oCancelAnimationFrame ||
                  window.msCancelAnimationFrame ||
                  function (e) {
                    return window.clearTimeout(e);
                  }));
            }),
            (o = function (e, t) {
              var n = parseInt(e, 10);
              return n >= 0 ? n : t;
            }),
            void 0 ===
              (n = function () {
                return l;
              }.apply(t, [])) || (e.exports = n);
        })();
      },
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var s = (t[r] = { exports: {} });
    return e[r].call(s.exports, s, s.exports, n), s.exports;
  }
  (n.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return n.d(t, { a: t }), t;
  }),
    (n.d = function (e, t) {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      'use strict';
      var e = n(755),
        t = n.n(e);
      function r(e) {
        return (
          null !== e &&
          'object' == typeof e &&
          'constructor' in e &&
          e.constructor === Object
        );
      }
      function i(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n]
            ? (e[n] = t[n])
            : r(t[n]) &&
              r(e[n]) &&
              Object.keys(t[n]).length > 0 &&
              i(e[n], t[n]);
        });
      }
      const s = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function a() {
        const e = 'undefined' != typeof document ? document : {};
        return i(e, s), e;
      }
      const o = {
        document: s,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return '';
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(e) {
          return 'undefined' == typeof setTimeout
            ? (e(), null)
            : setTimeout(e, 0);
        },
        cancelAnimationFrame(e) {
          'undefined' != typeof setTimeout && clearTimeout(e);
        },
      };
      function l() {
        const e = 'undefined' != typeof window ? window : {};
        return i(e, o), e;
      }
      function c(e, t = 0) {
        return setTimeout(e, t);
      }
      function u() {
        return Date.now();
      }
      function d(e, t = 'x') {
        const n = l();
        let r, i, s;
        const a = (function (e) {
          const t = l();
          let n;
          return (
            t.getComputedStyle && (n = t.getComputedStyle(e, null)),
            !n && e.currentStyle && (n = e.currentStyle),
            n || (n = e.style),
            n
          );
        })(e);
        return (
          n.WebKitCSSMatrix
            ? ((i = a.transform || a.webkitTransform),
              i.split(',').length > 6 &&
                (i = i
                  .split(', ')
                  .map((e) => e.replace(',', '.'))
                  .join(', ')),
              (s = new n.WebKitCSSMatrix('none' === i ? '' : i)))
            : ((s =
                a.MozTransform ||
                a.OTransform ||
                a.MsTransform ||
                a.msTransform ||
                a.transform ||
                a
                  .getPropertyValue('transform')
                  .replace('translate(', 'matrix(1, 0, 0, 1,')),
              (r = s.toString().split(','))),
          'x' === t &&
            (i = n.WebKitCSSMatrix
              ? s.m41
              : 16 === r.length
              ? parseFloat(r[12])
              : parseFloat(r[4])),
          'y' === t &&
            (i = n.WebKitCSSMatrix
              ? s.m42
              : 16 === r.length
              ? parseFloat(r[13])
              : parseFloat(r[5])),
          i || 0
        );
      }
      function p(e) {
        return (
          'object' == typeof e &&
          null !== e &&
          e.constructor &&
          'Object' === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function f(...e) {
        const t = Object(e[0]),
          n = ['__proto__', 'constructor', 'prototype'];
        for (let i = 1; i < e.length; i += 1) {
          const s = e[i];
          if (
            null != s &&
            ((r = s),
            !('undefined' != typeof window && void 0 !== window.HTMLElement
              ? r instanceof HTMLElement
              : r && (1 === r.nodeType || 11 === r.nodeType)))
          ) {
            const e = Object.keys(Object(s)).filter((e) => n.indexOf(e) < 0);
            for (let n = 0, r = e.length; n < r; n += 1) {
              const r = e[n],
                i = Object.getOwnPropertyDescriptor(s, r);
              void 0 !== i &&
                i.enumerable &&
                (p(t[r]) && p(s[r])
                  ? s[r].__swiper__
                    ? (t[r] = s[r])
                    : f(t[r], s[r])
                  : !p(t[r]) && p(s[r])
                  ? ((t[r] = {}),
                    s[r].__swiper__ ? (t[r] = s[r]) : f(t[r], s[r]))
                  : (t[r] = s[r]));
            }
          }
        }
        var r;
        return t;
      }
      function h(e, t, n) {
        e.style.setProperty(t, n);
      }
      function m({ swiper: e, targetPosition: t, side: n }) {
        const r = l(),
          i = -e.translate;
        let s,
          a = null;
        const o = e.params.speed;
        (e.wrapperEl.style.scrollSnapType = 'none'),
          r.cancelAnimationFrame(e.cssModeFrameID);
        const c = t > i ? 'next' : 'prev',
          u = (e, t) => ('next' === c && e >= t) || ('prev' === c && e <= t),
          d = () => {
            (s = new Date().getTime()), null === a && (a = s);
            const l = Math.max(Math.min((s - a) / o, 1), 0),
              c = 0.5 - Math.cos(l * Math.PI) / 2;
            let p = i + c * (t - i);
            if ((u(p, t) && (p = t), e.wrapperEl.scrollTo({ [n]: p }), u(p, t)))
              return (
                (e.wrapperEl.style.overflow = 'hidden'),
                (e.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  (e.wrapperEl.style.overflow = ''),
                    e.wrapperEl.scrollTo({ [n]: p });
                }),
                void r.cancelAnimationFrame(e.cssModeFrameID)
              );
            e.cssModeFrameID = r.requestAnimationFrame(d);
          };
        d();
      }
      function g(e) {
        return (
          e.querySelector('.swiper-slide-transform') ||
          (e.shadowEl && e.shadowEl.querySelector('.swiper-slide-transform')) ||
          e
        );
      }
      function v(e, t = '') {
        return [...e.children].filter((e) => e.matches(t));
      }
      function y(e, t = []) {
        const n = document.createElement(e);
        return n.classList.add(...(Array.isArray(t) ? t : [t])), n;
      }
      function b(e) {
        const t = l(),
          n = a(),
          r = e.getBoundingClientRect(),
          i = n.body,
          s = e.clientTop || i.clientTop || 0,
          o = e.clientLeft || i.clientLeft || 0,
          c = e === t ? t.scrollY : e.scrollTop,
          u = e === t ? t.scrollX : e.scrollLeft;
        return { top: r.top + c - s, left: r.left + u - o };
      }
      function w(e, t) {
        return l().getComputedStyle(e, null).getPropertyValue(t);
      }
      function x(e) {
        let t,
          n = e;
        if (n) {
          for (t = 0; null !== (n = n.previousSibling); )
            1 === n.nodeType && (t += 1);
          return t;
        }
      }
      function T(e, t) {
        const n = [];
        let r = e.parentElement;
        for (; r; )
          t ? r.matches(t) && n.push(r) : n.push(r), (r = r.parentElement);
        return n;
      }
      function E(e, t) {
        t &&
          e.addEventListener('transitionend', function n(r) {
            r.target === e &&
              (t.call(e, r), e.removeEventListener('transitionend', n));
          });
      }
      function _(e, t, n) {
        const r = l();
        return n
          ? e['width' === t ? 'offsetWidth' : 'offsetHeight'] +
              parseFloat(
                r
                  .getComputedStyle(e, null)
                  .getPropertyValue(
                    'width' === t ? 'margin-right' : 'margin-top'
                  )
              ) +
              parseFloat(
                r
                  .getComputedStyle(e, null)
                  .getPropertyValue(
                    'width' === t ? 'margin-left' : 'margin-bottom'
                  )
              )
          : e.offsetWidth;
      }
      let S, C, M;
      function k() {
        return (
          S ||
            (S = (function () {
              const e = l(),
                t = a();
              return {
                smoothScroll:
                  t.documentElement &&
                  t.documentElement.style &&
                  'scrollBehavior' in t.documentElement.style,
                touch: !!(
                  'ontouchstart' in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
              };
            })()),
          S
        );
      }
      var A = {
        on(e, t, n) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ('function' != typeof t) return r;
          const i = n ? 'unshift' : 'push';
          return (
            e.split(' ').forEach((e) => {
              r.eventsListeners[e] || (r.eventsListeners[e] = []),
                r.eventsListeners[e][i](t);
            }),
            r
          );
        },
        once(e, t, n) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ('function' != typeof t) return r;
          function i(...n) {
            r.off(e, i),
              i.__emitterProxy && delete i.__emitterProxy,
              t.apply(r, n);
          }
          return (i.__emitterProxy = t), r.on(e, i, n);
        },
        onAny(e, t) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ('function' != typeof e) return n;
          const r = t ? 'unshift' : 'push';
          return (
            n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n
          );
        },
        offAny(e) {
          const t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsAnyListeners) return t;
          const n = t.eventsAnyListeners.indexOf(e);
          return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
        },
        off(e, t) {
          const n = this;
          return !n.eventsListeners || n.destroyed
            ? n
            : n.eventsListeners
            ? (e.split(' ').forEach((e) => {
                void 0 === t
                  ? (n.eventsListeners[e] = [])
                  : n.eventsListeners[e] &&
                    n.eventsListeners[e].forEach((r, i) => {
                      (r === t ||
                        (r.__emitterProxy && r.__emitterProxy === t)) &&
                        n.eventsListeners[e].splice(i, 1);
                    });
              }),
              n)
            : n;
        },
        emit(...e) {
          const t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsListeners) return t;
          let n, r, i;
          return (
            'string' == typeof e[0] || Array.isArray(e[0])
              ? ((n = e[0]), (r = e.slice(1, e.length)), (i = t))
              : ((n = e[0].events), (r = e[0].data), (i = e[0].context || t)),
            r.unshift(i),
            (Array.isArray(n) ? n : n.split(' ')).forEach((e) => {
              t.eventsAnyListeners &&
                t.eventsAnyListeners.length &&
                t.eventsAnyListeners.forEach((t) => {
                  t.apply(i, [e, ...r]);
                }),
                t.eventsListeners &&
                  t.eventsListeners[e] &&
                  t.eventsListeners[e].forEach((e) => {
                    e.apply(i, r);
                  });
            }),
            t
          );
        },
      };
      const P = (e, t) => {
          if (!e || e.destroyed || !e.params) return;
          const n = t.closest(
            e.isElement ? 'swiper-slide' : `.${e.params.slideClass}`
          );
          if (n) {
            const t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
            t && t.remove();
          }
        },
        L = (e, t) => {
          if (!e.slides[t]) return;
          const n = e.slides[t].querySelector('[loading="lazy"]');
          n && n.removeAttribute('loading');
        },
        O = (e) => {
          if (!e || e.destroyed || !e.params) return;
          let t = e.params.lazyPreloadPrevNext;
          const n = e.slides.length;
          if (!n || !t || t < 0) return;
          t = Math.min(t, n);
          const r =
              'auto' === e.params.slidesPerView
                ? e.slidesPerViewDynamic()
                : Math.ceil(e.params.slidesPerView),
            i = e.activeIndex;
          if (e.params.grid && e.params.grid.rows > 1) {
            const n = i,
              s = [n - t];
            return (
              s.push(...Array.from({ length: t }).map((e, t) => n + r + t)),
              void e.slides.forEach((t, n) => {
                s.includes(t.column) && L(e, n);
              })
            );
          }
          const s = i + r - 1;
          if (e.params.rewind || e.params.loop)
            for (let r = i - t; r <= s + t; r += 1) {
              const t = ((r % n) + n) % n;
              (t < i || t > s) && L(e, t);
            }
          else
            for (
              let r = Math.max(i - t, 0);
              r <= Math.min(s + t, n - 1);
              r += 1
            )
              r !== i && (r > s || r < i) && L(e, r);
        };
      var D = {
        updateSize: function () {
          const e = this;
          let t, n;
          const r = e.el;
          (t =
            void 0 !== e.params.width && null !== e.params.width
              ? e.params.width
              : r.clientWidth),
            (n =
              void 0 !== e.params.height && null !== e.params.height
                ? e.params.height
                : r.clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === n && e.isVertical()) ||
              ((t =
                t -
                parseInt(w(r, 'padding-left') || 0, 10) -
                parseInt(w(r, 'padding-right') || 0, 10)),
              (n =
                n -
                parseInt(w(r, 'padding-top') || 0, 10) -
                parseInt(w(r, 'padding-bottom') || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(n) && (n = 0),
              Object.assign(e, {
                width: t,
                height: n,
                size: e.isHorizontal() ? t : n,
              }));
        },
        updateSlides: function () {
          const e = this;
          function t(t) {
            return e.isHorizontal()
              ? t
              : {
                  width: 'height',
                  'margin-top': 'margin-left',
                  'margin-bottom ': 'margin-right',
                  'margin-left': 'margin-top',
                  'margin-right': 'margin-bottom',
                  'padding-left': 'padding-top',
                  'padding-right': 'padding-bottom',
                  marginRight: 'marginBottom',
                }[t];
          }
          function n(e, n) {
            return parseFloat(e.getPropertyValue(t(n)) || 0);
          }
          const r = e.params,
            {
              wrapperEl: i,
              slidesEl: s,
              size: a,
              rtlTranslate: o,
              wrongRTL: l,
            } = e,
            c = e.virtual && r.virtual.enabled,
            u = c ? e.virtual.slides.length : e.slides.length,
            d = v(s, `.${e.params.slideClass}, swiper-slide`),
            p = c ? e.virtual.slides.length : d.length;
          let f = [];
          const m = [],
            g = [];
          let y = r.slidesOffsetBefore;
          'function' == typeof y && (y = r.slidesOffsetBefore.call(e));
          let b = r.slidesOffsetAfter;
          'function' == typeof b && (b = r.slidesOffsetAfter.call(e));
          const x = e.snapGrid.length,
            T = e.slidesGrid.length;
          let E = r.spaceBetween,
            S = -y,
            C = 0,
            M = 0;
          if (void 0 === a) return;
          'string' == typeof E && E.indexOf('%') >= 0
            ? (E = (parseFloat(E.replace('%', '')) / 100) * a)
            : 'string' == typeof E && (E = parseFloat(E)),
            (e.virtualSize = -E),
            d.forEach((e) => {
              o ? (e.style.marginLeft = '') : (e.style.marginRight = ''),
                (e.style.marginBottom = ''),
                (e.style.marginTop = '');
            }),
            r.centeredSlides &&
              r.cssMode &&
              (h(i, '--swiper-centered-offset-before', ''),
              h(i, '--swiper-centered-offset-after', ''));
          const k = r.grid && r.grid.rows > 1 && e.grid;
          let A;
          k && e.grid.initSlides(p);
          const P =
            'auto' === r.slidesPerView &&
            r.breakpoints &&
            Object.keys(r.breakpoints).filter(
              (e) => void 0 !== r.breakpoints[e].slidesPerView
            ).length > 0;
          for (let i = 0; i < p; i += 1) {
            let s;
            if (
              ((A = 0),
              d[i] && (s = d[i]),
              k && e.grid.updateSlide(i, s, p, t),
              !d[i] || 'none' !== w(s, 'display'))
            ) {
              if ('auto' === r.slidesPerView) {
                P && (d[i].style[t('width')] = '');
                const a = getComputedStyle(s),
                  o = s.style.transform,
                  l = s.style.webkitTransform;
                if (
                  (o && (s.style.transform = 'none'),
                  l && (s.style.webkitTransform = 'none'),
                  r.roundLengths)
                )
                  A = e.isHorizontal() ? _(s, 'width', !0) : _(s, 'height', !0);
                else {
                  const e = n(a, 'width'),
                    t = n(a, 'padding-left'),
                    r = n(a, 'padding-right'),
                    i = n(a, 'margin-left'),
                    o = n(a, 'margin-right'),
                    l = a.getPropertyValue('box-sizing');
                  if (l && 'border-box' === l) A = e + i + o;
                  else {
                    const { clientWidth: n, offsetWidth: a } = s;
                    A = e + t + r + i + o + (a - n);
                  }
                }
                o && (s.style.transform = o),
                  l && (s.style.webkitTransform = l),
                  r.roundLengths && (A = Math.floor(A));
              } else
                (A = (a - (r.slidesPerView - 1) * E) / r.slidesPerView),
                  r.roundLengths && (A = Math.floor(A)),
                  d[i] && (d[i].style[t('width')] = `${A}px`);
              d[i] && (d[i].swiperSlideSize = A),
                g.push(A),
                r.centeredSlides
                  ? ((S = S + A / 2 + C / 2 + E),
                    0 === C && 0 !== i && (S = S - a / 2 - E),
                    0 === i && (S = S - a / 2 - E),
                    Math.abs(S) < 0.001 && (S = 0),
                    r.roundLengths && (S = Math.floor(S)),
                    M % r.slidesPerGroup == 0 && f.push(S),
                    m.push(S))
                  : (r.roundLengths && (S = Math.floor(S)),
                    (M - Math.min(e.params.slidesPerGroupSkip, M)) %
                      e.params.slidesPerGroup ==
                      0 && f.push(S),
                    m.push(S),
                    (S = S + A + E)),
                (e.virtualSize += A + E),
                (C = A),
                (M += 1);
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, a) + b),
            o &&
              l &&
              ('slide' === r.effect || 'coverflow' === r.effect) &&
              (i.style.width = `${e.virtualSize + E}px`),
            r.setWrapperSize &&
              (i.style[t('width')] = `${e.virtualSize + E}px`),
            k && e.grid.updateWrapperSize(A, f, t),
            !r.centeredSlides)
          ) {
            const t = [];
            for (let n = 0; n < f.length; n += 1) {
              let i = f[n];
              r.roundLengths && (i = Math.floor(i)),
                f[n] <= e.virtualSize - a && t.push(i);
            }
            (f = t),
              Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 &&
                f.push(e.virtualSize - a);
          }
          if (c && r.loop) {
            const t = g[0] + E;
            if (r.slidesPerGroup > 1) {
              const n = Math.ceil(
                  (e.virtual.slidesBefore + e.virtual.slidesAfter) /
                    r.slidesPerGroup
                ),
                i = t * r.slidesPerGroup;
              for (let e = 0; e < n; e += 1) f.push(f[f.length - 1] + i);
            }
            for (
              let n = 0;
              n < e.virtual.slidesBefore + e.virtual.slidesAfter;
              n += 1
            )
              1 === r.slidesPerGroup && f.push(f[f.length - 1] + t),
                m.push(m[m.length - 1] + t),
                (e.virtualSize += t);
          }
          if ((0 === f.length && (f = [0]), 0 !== E)) {
            const n = e.isHorizontal() && o ? 'marginLeft' : t('marginRight');
            d.filter(
              (e, t) => !(r.cssMode && !r.loop) || t !== d.length - 1
            ).forEach((e) => {
              e.style[n] = `${E}px`;
            });
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            let e = 0;
            g.forEach((t) => {
              e += t + (E || 0);
            }),
              (e -= E);
            const t = e - a;
            f = f.map((e) => (e <= 0 ? -y : e > t ? t + b : e));
          }
          if (r.centerInsufficientSlides) {
            let e = 0;
            if (
              (g.forEach((t) => {
                e += t + (E || 0);
              }),
              (e -= E),
              e < a)
            ) {
              const t = (a - e) / 2;
              f.forEach((e, n) => {
                f[n] = e - t;
              }),
                m.forEach((e, n) => {
                  m[n] = e + t;
                });
            }
          }
          if (
            (Object.assign(e, {
              slides: d,
              snapGrid: f,
              slidesGrid: m,
              slidesSizesGrid: g,
            }),
            r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
          ) {
            h(i, '--swiper-centered-offset-before', -f[0] + 'px'),
              h(
                i,
                '--swiper-centered-offset-after',
                e.size / 2 - g[g.length - 1] / 2 + 'px'
              );
            const t = -e.snapGrid[0],
              n = -e.slidesGrid[0];
            (e.snapGrid = e.snapGrid.map((e) => e + t)),
              (e.slidesGrid = e.slidesGrid.map((e) => e + n));
          }
          if (
            (p !== u && e.emit('slidesLengthChange'),
            f.length !== x &&
              (e.params.watchOverflow && e.checkOverflow(),
              e.emit('snapGridLengthChange')),
            m.length !== T && e.emit('slidesGridLengthChange'),
            r.watchSlidesProgress && e.updateSlidesOffset(),
            !(c || r.cssMode || ('slide' !== r.effect && 'fade' !== r.effect)))
          ) {
            const t = `${r.containerModifierClass}backface-hidden`,
              n = e.el.classList.contains(t);
            p <= r.maxBackfaceHiddenSlides
              ? n || e.el.classList.add(t)
              : n && e.el.classList.remove(t);
          }
        },
        updateAutoHeight: function (e) {
          const t = this,
            n = [],
            r = t.virtual && t.params.virtual.enabled;
          let i,
            s = 0;
          'number' == typeof e
            ? t.setTransition(e)
            : !0 === e && t.setTransition(t.params.speed);
          const a = (e) =>
            r ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
          if ('auto' !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              (t.visibleSlides || []).forEach((e) => {
                n.push(e);
              });
            else
              for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                const e = t.activeIndex + i;
                if (e > t.slides.length && !r) break;
                n.push(a(e));
              }
          else n.push(a(t.activeIndex));
          for (i = 0; i < n.length; i += 1)
            if (void 0 !== n[i]) {
              const e = n[i].offsetHeight;
              s = e > s ? e : s;
            }
          (s || 0 === s) && (t.wrapperEl.style.height = `${s}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides,
            n = e.isElement
              ? e.isHorizontal()
                ? e.wrapperEl.offsetLeft
                : e.wrapperEl.offsetTop
              : 0;
          for (let r = 0; r < t.length; r += 1)
            t[r].swiperSlideOffset =
              (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) -
              n -
              e.cssOverflowAdjustment();
        },
        updateSlidesProgress: function (e = (this && this.translate) || 0) {
          const t = this,
            n = t.params,
            { slides: r, rtlTranslate: i, snapGrid: s } = t;
          if (0 === r.length) return;
          void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
          let a = -e;
          i && (a = e),
            r.forEach((e) => {
              e.classList.remove(n.slideVisibleClass);
            }),
            (t.visibleSlidesIndexes = []),
            (t.visibleSlides = []);
          let o = n.spaceBetween;
          'string' == typeof o && o.indexOf('%') >= 0
            ? (o = (parseFloat(o.replace('%', '')) / 100) * t.size)
            : 'string' == typeof o && (o = parseFloat(o));
          for (let e = 0; e < r.length; e += 1) {
            const l = r[e];
            let c = l.swiperSlideOffset;
            n.cssMode && n.centeredSlides && (c -= r[0].swiperSlideOffset);
            const u =
                (a + (n.centeredSlides ? t.minTranslate() : 0) - c) /
                (l.swiperSlideSize + o),
              d =
                (a - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - c) /
                (l.swiperSlideSize + o),
              p = -(a - c),
              f = p + t.slidesSizesGrid[e];
            ((p >= 0 && p < t.size - 1) ||
              (f > 1 && f <= t.size) ||
              (p <= 0 && f >= t.size)) &&
              (t.visibleSlides.push(l),
              t.visibleSlidesIndexes.push(e),
              r[e].classList.add(n.slideVisibleClass)),
              (l.progress = i ? -u : u),
              (l.originalProgress = i ? -d : d);
          }
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const n = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * n) || 0;
          }
          const n = t.params,
            r = t.maxTranslate() - t.minTranslate();
          let { progress: i, isBeginning: s, isEnd: a, progressLoop: o } = t;
          const l = s,
            c = a;
          if (0 === r) (i = 0), (s = !0), (a = !0);
          else {
            i = (e - t.minTranslate()) / r;
            const n = Math.abs(e - t.minTranslate()) < 1,
              o = Math.abs(e - t.maxTranslate()) < 1;
            (s = n || i <= 0), (a = o || i >= 1), n && (i = 0), o && (i = 1);
          }
          if (n.loop) {
            const n = t.getSlideIndexByData(0),
              r = t.getSlideIndexByData(t.slides.length - 1),
              i = t.slidesGrid[n],
              s = t.slidesGrid[r],
              a = t.slidesGrid[t.slidesGrid.length - 1],
              l = Math.abs(e);
            (o = l >= i ? (l - i) / a : (l + a - s) / a), o > 1 && (o -= 1);
          }
          Object.assign(t, {
            progress: i,
            progressLoop: o,
            isBeginning: s,
            isEnd: a,
          }),
            (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
              t.updateSlidesProgress(e),
            s && !l && t.emit('reachBeginning toEdge'),
            a && !c && t.emit('reachEnd toEdge'),
            ((l && !s) || (c && !a)) && t.emit('fromEdge'),
            t.emit('progress', i);
        },
        updateSlidesClasses: function () {
          const e = this,
            { slides: t, params: n, slidesEl: r, activeIndex: i } = e,
            s = e.virtual && n.virtual.enabled,
            a = (e) => v(r, `.${n.slideClass}${e}, swiper-slide${e}`)[0];
          let o;
          if (
            (t.forEach((e) => {
              e.classList.remove(
                n.slideActiveClass,
                n.slideNextClass,
                n.slidePrevClass
              );
            }),
            s)
          )
            if (n.loop) {
              let t = i - e.virtual.slidesBefore;
              t < 0 && (t = e.virtual.slides.length + t),
                t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
                (o = a(`[data-swiper-slide-index="${t}"]`));
            } else o = a(`[data-swiper-slide-index="${i}"]`);
          else o = t[i];
          if (o) {
            o.classList.add(n.slideActiveClass);
            let e = (function (e, t) {
              const n = [];
              for (; e.nextElementSibling; ) {
                const r = e.nextElementSibling;
                t ? r.matches(t) && n.push(r) : n.push(r), (e = r);
              }
              return n;
            })(o, `.${n.slideClass}, swiper-slide`)[0];
            n.loop && !e && (e = t[0]), e && e.classList.add(n.slideNextClass);
            let r = (function (e, t) {
              const n = [];
              for (; e.previousElementSibling; ) {
                const r = e.previousElementSibling;
                t ? r.matches(t) && n.push(r) : n.push(r), (e = r);
              }
              return n;
            })(o, `.${n.slideClass}, swiper-slide`)[0];
            n.loop && 0 === !r && (r = t[t.length - 1]),
              r && r.classList.add(n.slidePrevClass);
          }
          e.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
          const t = this,
            n = t.rtlTranslate ? t.translate : -t.translate,
            {
              snapGrid: r,
              params: i,
              activeIndex: s,
              realIndex: a,
              snapIndex: o,
            } = t;
          let l,
            c = e;
          const u = (e) => {
            let n = e - t.virtual.slidesBefore;
            return (
              n < 0 && (n = t.virtual.slides.length + n),
              n >= t.virtual.slides.length && (n -= t.virtual.slides.length),
              n
            );
          };
          if (
            (void 0 === c &&
              (c = (function (e) {
                const { slidesGrid: t, params: n } = e,
                  r = e.rtlTranslate ? e.translate : -e.translate;
                let i;
                for (let e = 0; e < t.length; e += 1)
                  void 0 !== t[e + 1]
                    ? r >= t[e] && r < t[e + 1] - (t[e + 1] - t[e]) / 2
                      ? (i = e)
                      : r >= t[e] && r < t[e + 1] && (i = e + 1)
                    : r >= t[e] && (i = e);
                return (
                  n.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i
                );
              })(t)),
            r.indexOf(n) >= 0)
          )
            l = r.indexOf(n);
          else {
            const e = Math.min(i.slidesPerGroupSkip, c);
            l = e + Math.floor((c - e) / i.slidesPerGroup);
          }
          if ((l >= r.length && (l = r.length - 1), c === s))
            return (
              l !== o && ((t.snapIndex = l), t.emit('snapIndexChange')),
              void (
                t.params.loop &&
                t.virtual &&
                t.params.virtual.enabled &&
                (t.realIndex = u(c))
              )
            );
          let d;
          (d =
            t.virtual && i.virtual.enabled && i.loop
              ? u(c)
              : t.slides[c]
              ? parseInt(
                  t.slides[c].getAttribute('data-swiper-slide-index') || c,
                  10
                )
              : c),
            Object.assign(t, {
              previousSnapIndex: o,
              snapIndex: l,
              previousRealIndex: a,
              realIndex: d,
              previousIndex: s,
              activeIndex: c,
            }),
            t.initialized && O(t),
            t.emit('activeIndexChange'),
            t.emit('snapIndexChange'),
            a !== d && t.emit('realIndexChange'),
            (t.initialized || t.params.runCallbacksOnInit) &&
              t.emit('slideChange');
        },
        updateClickedSlide: function (e) {
          const t = this,
            n = t.params,
            r = e.closest(`.${n.slideClass}, swiper-slide`);
          let i,
            s = !1;
          if (r)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === r) {
                (s = !0), (i = e);
                break;
              }
          if (!r || !s)
            return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
          (t.clickedSlide = r),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(
                  r.getAttribute('data-swiper-slide-index'),
                  10
                ))
              : (t.clickedIndex = i),
            n.slideToClickedSlide &&
              void 0 !== t.clickedIndex &&
              t.clickedIndex !== t.activeIndex &&
              t.slideToClickedSlide();
        },
      };
      function I({ swiper: e, runCallbacks: t, direction: n, step: r }) {
        const { activeIndex: i, previousIndex: s } = e;
        let a = n;
        if (
          (a || (a = i > s ? 'next' : i < s ? 'prev' : 'reset'),
          e.emit(`transition${r}`),
          t && i !== s)
        ) {
          if ('reset' === a) return void e.emit(`slideResetTransition${r}`);
          e.emit(`slideChangeTransition${r}`),
            'next' === a
              ? e.emit(`slideNextTransition${r}`)
              : e.emit(`slidePrevTransition${r}`);
        }
      }
      var z = {
          slideTo: function (e = 0, t = this.params.speed, n = !0, r, i) {
            'string' == typeof e && (e = parseInt(e, 10));
            const s = this;
            let a = e;
            a < 0 && (a = 0);
            const {
              params: o,
              snapGrid: l,
              slidesGrid: c,
              previousIndex: u,
              activeIndex: d,
              rtlTranslate: p,
              wrapperEl: f,
              enabled: h,
            } = s;
            if (
              (s.animating && o.preventInteractionOnTransition) ||
              (!h && !r && !i)
            )
              return !1;
            const g = Math.min(s.params.slidesPerGroupSkip, a);
            let v = g + Math.floor((a - g) / s.params.slidesPerGroup);
            v >= l.length && (v = l.length - 1);
            const y = -l[v];
            if (o.normalizeSlideIndex)
              for (let e = 0; e < c.length; e += 1) {
                const t = -Math.floor(100 * y),
                  n = Math.floor(100 * c[e]),
                  r = Math.floor(100 * c[e + 1]);
                void 0 !== c[e + 1]
                  ? t >= n && t < r - (r - n) / 2
                    ? (a = e)
                    : t >= n && t < r && (a = e + 1)
                  : t >= n && (a = e);
              }
            if (s.initialized && a !== d) {
              if (
                !s.allowSlideNext &&
                (p
                  ? y > s.translate && y > s.minTranslate()
                  : y < s.translate && y < s.minTranslate())
              )
                return !1;
              if (
                !s.allowSlidePrev &&
                y > s.translate &&
                y > s.maxTranslate() &&
                (d || 0) !== a
              )
                return !1;
            }
            let b;
            if (
              (a !== (u || 0) && n && s.emit('beforeSlideChangeStart'),
              s.updateProgress(y),
              (b = a > d ? 'next' : a < d ? 'prev' : 'reset'),
              (p && -y === s.translate) || (!p && y === s.translate))
            )
              return (
                s.updateActiveIndex(a),
                o.autoHeight && s.updateAutoHeight(),
                s.updateSlidesClasses(),
                'slide' !== o.effect && s.setTranslate(y),
                'reset' !== b &&
                  (s.transitionStart(n, b), s.transitionEnd(n, b)),
                !1
              );
            if (o.cssMode) {
              const e = s.isHorizontal(),
                n = p ? y : -y;
              if (0 === t) {
                const t = s.virtual && s.params.virtual.enabled;
                t &&
                  ((s.wrapperEl.style.scrollSnapType = 'none'),
                  (s._immediateVirtual = !0)),
                  t && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0
                    ? ((s._cssModeVirtualInitialSet = !0),
                      requestAnimationFrame(() => {
                        f[e ? 'scrollLeft' : 'scrollTop'] = n;
                      }))
                    : (f[e ? 'scrollLeft' : 'scrollTop'] = n),
                  t &&
                    requestAnimationFrame(() => {
                      (s.wrapperEl.style.scrollSnapType = ''),
                        (s._immediateVirtual = !1);
                    });
              } else {
                if (!s.support.smoothScroll)
                  return (
                    m({
                      swiper: s,
                      targetPosition: n,
                      side: e ? 'left' : 'top',
                    }),
                    !0
                  );
                f.scrollTo({ [e ? 'left' : 'top']: n, behavior: 'smooth' });
              }
              return !0;
            }
            return (
              s.setTransition(t),
              s.setTranslate(y),
              s.updateActiveIndex(a),
              s.updateSlidesClasses(),
              s.emit('beforeTransitionStart', t, r),
              s.transitionStart(n, b),
              0 === t
                ? s.transitionEnd(n, b)
                : s.animating ||
                  ((s.animating = !0),
                  s.onSlideToWrapperTransitionEnd ||
                    (s.onSlideToWrapperTransitionEnd = function (e) {
                      s &&
                        !s.destroyed &&
                        e.target === this &&
                        (s.wrapperEl.removeEventListener(
                          'transitionend',
                          s.onSlideToWrapperTransitionEnd
                        ),
                        (s.onSlideToWrapperTransitionEnd = null),
                        delete s.onSlideToWrapperTransitionEnd,
                        s.transitionEnd(n, b));
                    }),
                  s.wrapperEl.addEventListener(
                    'transitionend',
                    s.onSlideToWrapperTransitionEnd
                  )),
              !0
            );
          },
          slideToLoop: function (e = 0, t = this.params.speed, n = !0, r) {
            'string' == typeof e && (e = parseInt(e, 10));
            const i = this;
            let s = e;
            return (
              i.params.loop &&
                (i.virtual && i.params.virtual.enabled
                  ? (s += i.virtual.slidesBefore)
                  : (s = i.getSlideIndexByData(s))),
              i.slideTo(s, t, n, r)
            );
          },
          slideNext: function (e = this.params.speed, t = !0, n) {
            const r = this,
              { enabled: i, params: s, animating: a } = r;
            if (!i) return r;
            let o = s.slidesPerGroup;
            'auto' === s.slidesPerView &&
              1 === s.slidesPerGroup &&
              s.slidesPerGroupAuto &&
              (o = Math.max(r.slidesPerViewDynamic('current', !0), 1));
            const l = r.activeIndex < s.slidesPerGroupSkip ? 1 : o,
              c = r.virtual && s.virtual.enabled;
            if (s.loop) {
              if (a && !c && s.loopPreventsSliding) return !1;
              r.loopFix({ direction: 'next' }),
                (r._clientLeft = r.wrapperEl.clientLeft);
            }
            return s.rewind && r.isEnd
              ? r.slideTo(0, e, t, n)
              : r.slideTo(r.activeIndex + l, e, t, n);
          },
          slidePrev: function (e = this.params.speed, t = !0, n) {
            const r = this,
              {
                params: i,
                snapGrid: s,
                slidesGrid: a,
                rtlTranslate: o,
                enabled: l,
                animating: c,
              } = r;
            if (!l) return r;
            const u = r.virtual && i.virtual.enabled;
            if (i.loop) {
              if (c && !u && i.loopPreventsSliding) return !1;
              r.loopFix({ direction: 'prev' }),
                (r._clientLeft = r.wrapperEl.clientLeft);
            }
            function d(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const p = d(o ? r.translate : -r.translate),
              f = s.map((e) => d(e));
            let h = s[f.indexOf(p) - 1];
            if (void 0 === h && i.cssMode) {
              let e;
              s.forEach((t, n) => {
                p >= t && (e = n);
              }),
                void 0 !== e && (h = s[e > 0 ? e - 1 : e]);
            }
            let m = 0;
            if (
              (void 0 !== h &&
                ((m = a.indexOf(h)),
                m < 0 && (m = r.activeIndex - 1),
                'auto' === i.slidesPerView &&
                  1 === i.slidesPerGroup &&
                  i.slidesPerGroupAuto &&
                  ((m = m - r.slidesPerViewDynamic('previous', !0) + 1),
                  (m = Math.max(m, 0)))),
              i.rewind && r.isBeginning)
            ) {
              const i =
                r.params.virtual && r.params.virtual.enabled && r.virtual
                  ? r.virtual.slides.length - 1
                  : r.slides.length - 1;
              return r.slideTo(i, e, t, n);
            }
            return r.slideTo(m, e, t, n);
          },
          slideReset: function (e = this.params.speed, t = !0, n) {
            return this.slideTo(this.activeIndex, e, t, n);
          },
          slideToClosest: function (e = this.params.speed, t = !0, n, r = 0.5) {
            const i = this;
            let s = i.activeIndex;
            const a = Math.min(i.params.slidesPerGroupSkip, s),
              o = a + Math.floor((s - a) / i.params.slidesPerGroup),
              l = i.rtlTranslate ? i.translate : -i.translate;
            if (l >= i.snapGrid[o]) {
              const e = i.snapGrid[o];
              l - e > (i.snapGrid[o + 1] - e) * r &&
                (s += i.params.slidesPerGroup);
            } else {
              const e = i.snapGrid[o - 1];
              l - e <= (i.snapGrid[o] - e) * r &&
                (s -= i.params.slidesPerGroup);
            }
            return (
              (s = Math.max(s, 0)),
              (s = Math.min(s, i.slidesGrid.length - 1)),
              i.slideTo(s, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, slidesEl: n } = e,
              r =
                'auto' === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let i,
              s = e.clickedIndex;
            const a = e.isElement ? 'swiper-slide' : `.${t.slideClass}`;
            if (t.loop) {
              if (e.animating) return;
              (i = parseInt(
                e.clickedSlide.getAttribute('data-swiper-slide-index'),
                10
              )),
                t.centeredSlides
                  ? s < e.loopedSlides - r / 2 ||
                    s > e.slides.length - e.loopedSlides + r / 2
                    ? (e.loopFix(),
                      (s = e.getSlideIndex(
                        v(n, `${a}[data-swiper-slide-index="${i}"]`)[0]
                      )),
                      c(() => {
                        e.slideTo(s);
                      }))
                    : e.slideTo(s)
                  : s > e.slides.length - r
                  ? (e.loopFix(),
                    (s = e.getSlideIndex(
                      v(n, `${a}[data-swiper-slide-index="${i}"]`)[0]
                    )),
                    c(() => {
                      e.slideTo(s);
                    }))
                  : e.slideTo(s);
            } else e.slideTo(s);
          },
        },
        R = {
          loopCreate: function (e) {
            const t = this,
              { params: n, slidesEl: r } = t;
            !n.loop ||
              (t.virtual && t.params.virtual.enabled) ||
              (v(r, `.${n.slideClass}, swiper-slide`).forEach((e, t) => {
                e.setAttribute('data-swiper-slide-index', t);
              }),
              t.loopFix({
                slideRealIndex: e,
                direction: n.centeredSlides ? void 0 : 'next',
              }));
          },
          loopFix: function ({
            slideRealIndex: e,
            slideTo: t = !0,
            direction: n,
            setTranslate: r,
            activeSlideIndex: i,
            byController: s,
            byMousewheel: a,
          } = {}) {
            const o = this;
            if (!o.params.loop) return;
            o.emit('beforeLoopFix');
            const {
              slides: l,
              allowSlidePrev: c,
              allowSlideNext: u,
              slidesEl: d,
              params: p,
            } = o;
            if (
              ((o.allowSlidePrev = !0),
              (o.allowSlideNext = !0),
              o.virtual && p.virtual.enabled)
            )
              return (
                t &&
                  (p.centeredSlides || 0 !== o.snapIndex
                    ? p.centeredSlides && o.snapIndex < p.slidesPerView
                      ? o.slideTo(
                          o.virtual.slides.length + o.snapIndex,
                          0,
                          !1,
                          !0
                        )
                      : o.snapIndex === o.snapGrid.length - 1 &&
                        o.slideTo(o.virtual.slidesBefore, 0, !1, !0)
                    : o.slideTo(o.virtual.slides.length, 0, !1, !0)),
                (o.allowSlidePrev = c),
                (o.allowSlideNext = u),
                void o.emit('loopFix')
              );
            const f =
              'auto' === p.slidesPerView
                ? o.slidesPerViewDynamic()
                : Math.ceil(parseFloat(p.slidesPerView, 10));
            let h = p.loopedSlides || f;
            h % p.slidesPerGroup != 0 &&
              (h += p.slidesPerGroup - (h % p.slidesPerGroup)),
              (o.loopedSlides = h);
            const m = [],
              g = [];
            let v = o.activeIndex;
            void 0 === i
              ? (i = o.getSlideIndex(
                  o.slides.filter((e) =>
                    e.classList.contains(p.slideActiveClass)
                  )[0]
                ))
              : (v = i);
            const y = 'next' === n || !n,
              b = 'prev' === n || !n;
            let w = 0,
              x = 0;
            if (i < h) {
              w = Math.max(h - i, p.slidesPerGroup);
              for (let e = 0; e < h - i; e += 1) {
                const t = e - Math.floor(e / l.length) * l.length;
                m.push(l.length - t - 1);
              }
            } else if (i > o.slides.length - 2 * h) {
              x = Math.max(i - (o.slides.length - 2 * h), p.slidesPerGroup);
              for (let e = 0; e < x; e += 1) {
                const t = e - Math.floor(e / l.length) * l.length;
                g.push(t);
              }
            }
            if (
              (b &&
                m.forEach((e) => {
                  (o.slides[e].swiperLoopMoveDOM = !0),
                    d.prepend(o.slides[e]),
                    (o.slides[e].swiperLoopMoveDOM = !1);
                }),
              y &&
                g.forEach((e) => {
                  (o.slides[e].swiperLoopMoveDOM = !0),
                    d.append(o.slides[e]),
                    (o.slides[e].swiperLoopMoveDOM = !1);
                }),
              o.recalcSlides(),
              'auto' === p.slidesPerView && o.updateSlides(),
              p.watchSlidesProgress && o.updateSlidesOffset(),
              t)
            )
              if (m.length > 0 && b)
                if (void 0 === e) {
                  const e = o.slidesGrid[v],
                    t = o.slidesGrid[v + w] - e;
                  a
                    ? o.setTranslate(o.translate - t)
                    : (o.slideTo(v + w, 0, !1, !0),
                      r &&
                        (o.touches[o.isHorizontal() ? 'startX' : 'startY'] +=
                          t));
                } else r && o.slideToLoop(e, 0, !1, !0);
              else if (g.length > 0 && y)
                if (void 0 === e) {
                  const e = o.slidesGrid[v],
                    t = o.slidesGrid[v - x] - e;
                  a
                    ? o.setTranslate(o.translate - t)
                    : (o.slideTo(v - x, 0, !1, !0),
                      r &&
                        (o.touches[o.isHorizontal() ? 'startX' : 'startY'] +=
                          t));
                } else o.slideToLoop(e, 0, !1, !0);
            if (
              ((o.allowSlidePrev = c),
              (o.allowSlideNext = u),
              o.controller && o.controller.control && !s)
            ) {
              const t = {
                slideRealIndex: e,
                slideTo: !1,
                direction: n,
                setTranslate: r,
                activeSlideIndex: i,
                byController: !0,
              };
              Array.isArray(o.controller.control)
                ? o.controller.control.forEach((e) => {
                    !e.destroyed && e.params.loop && e.loopFix(t);
                  })
                : o.controller.control instanceof o.constructor &&
                  o.controller.control.params.loop &&
                  o.controller.control.loopFix(t);
            }
            o.emit('loopFix');
          },
          loopDestroy: function () {
            const e = this,
              { params: t, slidesEl: n } = e;
            if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
            e.recalcSlides();
            const r = [];
            e.slides.forEach((e) => {
              const t =
                void 0 === e.swiperSlideIndex
                  ? 1 * e.getAttribute('data-swiper-slide-index')
                  : e.swiperSlideIndex;
              r[t] = e;
            }),
              e.slides.forEach((e) => {
                e.removeAttribute('data-swiper-slide-index');
              }),
              r.forEach((e) => {
                n.append(e);
              }),
              e.recalcSlides(),
              e.slideTo(e.realIndex, 0);
          },
        };
      function j(e) {
        const t = this,
          n = a(),
          r = l(),
          i = t.touchEventsData;
        i.evCache.push(e);
        const { params: s, touches: o, enabled: c } = t;
        if (!c) return;
        if (!s.simulateTouch && 'mouse' === e.pointerType) return;
        if (t.animating && s.preventInteractionOnTransition) return;
        !t.animating && s.cssMode && s.loop && t.loopFix();
        let d = e;
        d.originalEvent && (d = d.originalEvent);
        let p = d.target;
        if ('wrapper' === s.touchEventsTarget && !t.wrapperEl.contains(p))
          return;
        if ('which' in d && 3 === d.which) return;
        if ('button' in d && d.button > 0) return;
        if (i.isTouched && i.isMoved) return;
        const f = !!s.noSwipingClass && '' !== s.noSwipingClass,
          h = e.composedPath ? e.composedPath() : e.path;
        f && d.target && d.target.shadowRoot && h && (p = h[0]);
        const m = s.noSwipingSelector
            ? s.noSwipingSelector
            : `.${s.noSwipingClass}`,
          g = !(!d.target || !d.target.shadowRoot);
        if (
          s.noSwiping &&
          (g
            ? (function (e, t = this) {
                return (function t(n) {
                  if (!n || n === a() || n === l()) return null;
                  n.assignedSlot && (n = n.assignedSlot);
                  const r = n.closest(e);
                  return r || n.getRootNode
                    ? r || t(n.getRootNode().host)
                    : null;
                })(t);
              })(m, p)
            : p.closest(m))
        )
          return void (t.allowClick = !0);
        if (s.swipeHandler && !p.closest(s.swipeHandler)) return;
        (o.currentX = d.pageX), (o.currentY = d.pageY);
        const v = o.currentX,
          y = o.currentY,
          b = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
          w = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
        if (b && (v <= w || v >= r.innerWidth - w)) {
          if ('prevent' !== b) return;
          e.preventDefault();
        }
        Object.assign(i, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (o.startX = v),
          (o.startY = y),
          (i.touchStartTime = u()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          s.threshold > 0 && (i.allowThresholdMove = !1);
        let x = !0;
        p.matches(i.focusableElements) &&
          ((x = !1), 'SELECT' === p.nodeName && (i.isTouched = !1)),
          n.activeElement &&
            n.activeElement.matches(i.focusableElements) &&
            n.activeElement !== p &&
            n.activeElement.blur();
        const T = x && t.allowTouchMove && s.touchStartPreventDefault;
        (!s.touchStartForcePreventDefault && !T) ||
          p.isContentEditable ||
          d.preventDefault(),
          s.freeMode &&
            s.freeMode.enabled &&
            t.freeMode &&
            t.animating &&
            !s.cssMode &&
            t.freeMode.onTouchStart(),
          t.emit('touchStart', d);
      }
      function N(e) {
        const t = a(),
          n = this,
          r = n.touchEventsData,
          { params: i, touches: s, rtlTranslate: o, enabled: l } = n;
        if (!l) return;
        if (!i.simulateTouch && 'mouse' === e.pointerType) return;
        let c = e;
        if ((c.originalEvent && (c = c.originalEvent), !r.isTouched))
          return void (
            r.startMoving &&
            r.isScrolling &&
            n.emit('touchMoveOpposite', c)
          );
        const d = r.evCache.findIndex((e) => e.pointerId === c.pointerId);
        d >= 0 && (r.evCache[d] = c);
        const p = r.evCache.length > 1 ? r.evCache[0] : c,
          f = p.pageX,
          h = p.pageY;
        if (c.preventedByNestedSwiper)
          return (s.startX = f), void (s.startY = h);
        if (!n.allowTouchMove)
          return (
            c.target.matches(r.focusableElements) || (n.allowClick = !1),
            void (
              r.isTouched &&
              (Object.assign(s, {
                startX: f,
                startY: h,
                prevX: n.touches.currentX,
                prevY: n.touches.currentY,
                currentX: f,
                currentY: h,
              }),
              (r.touchStartTime = u()))
            )
          );
        if (i.touchReleaseOnEdges && !i.loop)
          if (n.isVertical()) {
            if (
              (h < s.startY && n.translate <= n.maxTranslate()) ||
              (h > s.startY && n.translate >= n.minTranslate())
            )
              return (r.isTouched = !1), void (r.isMoved = !1);
          } else if (
            (f < s.startX && n.translate <= n.maxTranslate()) ||
            (f > s.startX && n.translate >= n.minTranslate())
          )
            return;
        if (
          t.activeElement &&
          c.target === t.activeElement &&
          c.target.matches(r.focusableElements)
        )
          return (r.isMoved = !0), void (n.allowClick = !1);
        if (
          (r.allowTouchCallbacks && n.emit('touchMove', c),
          c.targetTouches && c.targetTouches.length > 1)
        )
          return;
        (s.currentX = f), (s.currentY = h);
        const m = s.currentX - s.startX,
          g = s.currentY - s.startY;
        if (
          n.params.threshold &&
          Math.sqrt(m ** 2 + g ** 2) < n.params.threshold
        )
          return;
        if (void 0 === r.isScrolling) {
          let e;
          (n.isHorizontal() && s.currentY === s.startY) ||
          (n.isVertical() && s.currentX === s.startX)
            ? (r.isScrolling = !1)
            : m * m + g * g >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(g), Math.abs(m))) / Math.PI),
              (r.isScrolling = n.isHorizontal()
                ? e > i.touchAngle
                : 90 - e > i.touchAngle));
        }
        if (
          (r.isScrolling && n.emit('touchMoveOpposite', c),
          void 0 === r.startMoving &&
            ((s.currentX === s.startX && s.currentY === s.startY) ||
              (r.startMoving = !0)),
          r.isScrolling ||
            (n.zoom &&
              n.params.zoom &&
              n.params.zoom.enabled &&
              r.evCache.length > 1))
        )
          return void (r.isTouched = !1);
        if (!r.startMoving) return;
        (n.allowClick = !1),
          !i.cssMode && c.cancelable && c.preventDefault(),
          i.touchMoveStopPropagation && !i.nested && c.stopPropagation();
        let v = n.isHorizontal() ? m : g,
          y = n.isHorizontal()
            ? s.currentX - s.previousX
            : s.currentY - s.previousY;
        i.oneWayMovement &&
          ((v = Math.abs(v) * (o ? 1 : -1)), (y = Math.abs(y) * (o ? 1 : -1))),
          (s.diff = v),
          (v *= i.touchRatio),
          o && ((v = -v), (y = -y));
        const b = n.touchesDirection;
        (n.swipeDirection = v > 0 ? 'prev' : 'next'),
          (n.touchesDirection = y > 0 ? 'prev' : 'next');
        const w = n.params.loop && !i.cssMode;
        if (!r.isMoved) {
          if (
            (w && n.loopFix({ direction: n.swipeDirection }),
            (r.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating)
          ) {
            const e = new window.CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
            });
            n.wrapperEl.dispatchEvent(e);
          }
          (r.allowMomentumBounce = !1),
            !i.grabCursor ||
              (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
              n.setGrabCursor(!0),
            n.emit('sliderFirstMove', c);
        }
        let x;
        r.isMoved &&
          b !== n.touchesDirection &&
          w &&
          Math.abs(v) >= 1 &&
          (n.loopFix({ direction: n.swipeDirection, setTranslate: !0 }),
          (x = !0)),
          n.emit('sliderMove', c),
          (r.isMoved = !0),
          (r.currentTranslate = v + r.startTranslate);
        let T = !0,
          E = i.resistanceRatio;
        if (
          (i.touchReleaseOnEdges && (E = 0),
          v > 0
            ? (w &&
                !x &&
                r.currentTranslate >
                  (i.centeredSlides
                    ? n.minTranslate() - n.size / 2
                    : n.minTranslate()) &&
                n.loopFix({
                  direction: 'prev',
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              r.currentTranslate > n.minTranslate() &&
                ((T = !1),
                i.resistance &&
                  (r.currentTranslate =
                    n.minTranslate() -
                    1 +
                    (-n.minTranslate() + r.startTranslate + v) ** E)))
            : v < 0 &&
              (w &&
                !x &&
                r.currentTranslate <
                  (i.centeredSlides
                    ? n.maxTranslate() + n.size / 2
                    : n.maxTranslate()) &&
                n.loopFix({
                  direction: 'next',
                  setTranslate: !0,
                  activeSlideIndex:
                    n.slides.length -
                    ('auto' === i.slidesPerView
                      ? n.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(i.slidesPerView, 10))),
                }),
              r.currentTranslate < n.maxTranslate() &&
                ((T = !1),
                i.resistance &&
                  (r.currentTranslate =
                    n.maxTranslate() +
                    1 -
                    (n.maxTranslate() - r.startTranslate - v) ** E))),
          T && (c.preventedByNestedSwiper = !0),
          !n.allowSlideNext &&
            'next' === n.swipeDirection &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !n.allowSlidePrev &&
            'prev' === n.swipeDirection &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          n.allowSlidePrev ||
            n.allowSlideNext ||
            (r.currentTranslate = r.startTranslate),
          i.threshold > 0)
        ) {
          if (!(Math.abs(v) > i.threshold || r.allowThresholdMove))
            return void (r.currentTranslate = r.startTranslate);
          if (!r.allowThresholdMove)
            return (
              (r.allowThresholdMove = !0),
              (s.startX = s.currentX),
              (s.startY = s.currentY),
              (r.currentTranslate = r.startTranslate),
              void (s.diff = n.isHorizontal()
                ? s.currentX - s.startX
                : s.currentY - s.startY)
            );
        }
        i.followFinger &&
          !i.cssMode &&
          (((i.freeMode && i.freeMode.enabled && n.freeMode) ||
            i.watchSlidesProgress) &&
            (n.updateActiveIndex(), n.updateSlidesClasses()),
          i.freeMode &&
            i.freeMode.enabled &&
            n.freeMode &&
            n.freeMode.onTouchMove(),
          n.updateProgress(r.currentTranslate),
          n.setTranslate(r.currentTranslate));
      }
      function $(e) {
        const t = this,
          n = t.touchEventsData,
          r = n.evCache.findIndex((t) => t.pointerId === e.pointerId);
        if (
          (r >= 0 && n.evCache.splice(r, 1),
          ['pointercancel', 'pointerout', 'pointerleave'].includes(e.type) &&
            ('pointercancel' !== e.type ||
              (!t.browser.isSafari && !t.browser.isWebView)))
        )
          return;
        const {
          params: i,
          touches: s,
          rtlTranslate: a,
          slidesGrid: o,
          enabled: l,
        } = t;
        if (!l) return;
        if (!i.simulateTouch && 'mouse' === e.pointerType) return;
        let d = e;
        if (
          (d.originalEvent && (d = d.originalEvent),
          n.allowTouchCallbacks && t.emit('touchEnd', d),
          (n.allowTouchCallbacks = !1),
          !n.isTouched)
        )
          return (
            n.isMoved && i.grabCursor && t.setGrabCursor(!1),
            (n.isMoved = !1),
            void (n.startMoving = !1)
          );
        i.grabCursor &&
          n.isMoved &&
          n.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const p = u(),
          f = p - n.touchStartTime;
        if (t.allowClick) {
          const e = d.path || (d.composedPath && d.composedPath());
          t.updateClickedSlide((e && e[0]) || d.target),
            t.emit('tap click', d),
            f < 300 &&
              p - n.lastClickTime < 300 &&
              t.emit('doubleTap doubleClick', d);
        }
        if (
          ((n.lastClickTime = u()),
          c(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !n.isTouched ||
            !n.isMoved ||
            !t.swipeDirection ||
            0 === s.diff ||
            n.currentTranslate === n.startTranslate)
        )
          return (
            (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
          );
        let h;
        if (
          ((n.isTouched = !1),
          (n.isMoved = !1),
          (n.startMoving = !1),
          (h = i.followFinger
            ? a
              ? t.translate
              : -t.translate
            : -n.currentTranslate),
          i.cssMode)
        )
          return;
        if (i.freeMode && i.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: h });
        let m = 0,
          g = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < o.length;
          e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
        ) {
          const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== o[e + t]
            ? h >= o[e] && h < o[e + t] && ((m = e), (g = o[e + t] - o[e]))
            : h >= o[e] && ((m = e), (g = o[o.length - 1] - o[o.length - 2]));
        }
        let v = null,
          y = null;
        i.rewind &&
          (t.isBeginning
            ? (y =
                i.virtual && i.virtual.enabled && t.virtual
                  ? t.virtual.slides.length - 1
                  : t.slides.length - 1)
            : t.isEnd && (v = 0));
        const b = (h - o[m]) / g,
          w = m < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        if (f > i.longSwipesMs) {
          if (!i.longSwipes) return void t.slideTo(t.activeIndex);
          'next' === t.swipeDirection &&
            (b >= i.longSwipesRatio
              ? t.slideTo(i.rewind && t.isEnd ? v : m + w)
              : t.slideTo(m)),
            'prev' === t.swipeDirection &&
              (b > 1 - i.longSwipesRatio
                ? t.slideTo(m + w)
                : null !== y && b < 0 && Math.abs(b) > i.longSwipesRatio
                ? t.slideTo(y)
                : t.slideTo(m));
        } else {
          if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
          !t.navigation ||
          (d.target !== t.navigation.nextEl && d.target !== t.navigation.prevEl)
            ? ('next' === t.swipeDirection && t.slideTo(null !== v ? v : m + w),
              'prev' === t.swipeDirection && t.slideTo(null !== y ? y : m))
            : d.target === t.navigation.nextEl
            ? t.slideTo(m + w)
            : t.slideTo(m);
        }
      }
      function F() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: i, snapGrid: s } = e,
          a = e.virtual && e.params.virtual.enabled;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses();
        const o = a && t.loop;
        !('auto' === t.slidesPerView || t.slidesPerView > 1) ||
        !e.isEnd ||
        e.isBeginning ||
        e.params.centeredSlides ||
        o
          ? e.params.loop && !a
            ? e.slideToLoop(e.realIndex, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0)
          : e.slideTo(e.slides.length - 1, 0, !1, !0),
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            (clearTimeout(e.autoplay.resizeTimeout),
            (e.autoplay.resizeTimeout = setTimeout(() => {
              e.autoplay &&
                e.autoplay.running &&
                e.autoplay.paused &&
                e.autoplay.resume();
            }, 500))),
          (e.allowSlidePrev = i),
          (e.allowSlideNext = r),
          e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
      }
      function q(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function H() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
        if (!r) return;
        let i;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const s = e.maxTranslate() - e.minTranslate();
        (i = 0 === s ? 0 : (e.translate - e.minTranslate()) / s),
          i !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit('setTranslate', e.translate, !1);
      }
      function B(e) {
        const t = this;
        P(t, e.target),
          t.params.cssMode ||
            ('auto' !== t.params.slidesPerView && !t.params.autoHeight) ||
            t.update();
      }
      let X = !1;
      function Y() {}
      const G = (e, t) => {
          const n = a(),
            { params: r, el: i, wrapperEl: s, device: o } = e,
            l = !!r.nested,
            c = 'on' === t ? 'addEventListener' : 'removeEventListener',
            u = t;
          i[c]('pointerdown', e.onTouchStart, { passive: !1 }),
            n[c]('pointermove', e.onTouchMove, { passive: !1, capture: l }),
            n[c]('pointerup', e.onTouchEnd, { passive: !0 }),
            n[c]('pointercancel', e.onTouchEnd, { passive: !0 }),
            n[c]('pointerout', e.onTouchEnd, { passive: !0 }),
            n[c]('pointerleave', e.onTouchEnd, { passive: !0 }),
            (r.preventClicks || r.preventClicksPropagation) &&
              i[c]('click', e.onClick, !0),
            r.cssMode && s[c]('scroll', e.onScroll),
            r.updateOnWindowResize
              ? e[u](
                  o.ios || o.android
                    ? 'resize orientationchange observerUpdate'
                    : 'resize observerUpdate',
                  F,
                  !0
                )
              : e[u]('observerUpdate', F, !0),
            i[c]('load', e.onLoad, { capture: !0 });
        },
        W = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      var V = {
        init: !0,
        direction: 'horizontal',
        oneWayMovement: !1,
        touchEventsTarget: 'wrapper',
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        enabled: !0,
        focusableElements:
          'input, select, option, textarea, button, video, label',
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: 'slide',
        breakpoints: void 0,
        breakpointsBase: 'window',
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 5,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        loop: !1,
        loopedSlides: null,
        loopPreventsSliding: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: 'swiper-',
        slideClass: 'swiper-slide',
        slideActiveClass: 'swiper-slide-active',
        slideVisibleClass: 'swiper-slide-visible',
        slideNextClass: 'swiper-slide-next',
        slidePrevClass: 'swiper-slide-prev',
        wrapperClass: 'swiper-wrapper',
        lazyPreloaderClass: 'swiper-lazy-preloader',
        lazyPreloadPrevNext: 0,
        runCallbacksOnInit: !0,
        _emitClasses: !1,
      };
      function U(e, t) {
        return function (n = {}) {
          const r = Object.keys(n)[0],
            i = n[r];
          'object' == typeof i && null !== i
            ? (['navigation', 'pagination', 'scrollbar'].indexOf(r) >= 0 &&
                !0 === e[r] &&
                (e[r] = { auto: !0 }),
              r in e && 'enabled' in i
                ? (!0 === e[r] && (e[r] = { enabled: !0 }),
                  'object' != typeof e[r] ||
                    'enabled' in e[r] ||
                    (e[r].enabled = !0),
                  e[r] || (e[r] = { enabled: !1 }),
                  f(t, n))
                : f(t, n))
            : f(t, n);
        };
      }
      const K = {
          eventsEmitter: A,
          update: D,
          translate: {
            getTranslate: function (e = this.isHorizontal() ? 'x' : 'y') {
              const {
                params: t,
                rtlTranslate: n,
                translate: r,
                wrapperEl: i,
              } = this;
              if (t.virtualTranslate) return n ? -r : r;
              if (t.cssMode) return r;
              let s = d(i, e);
              return (s += this.cssOverflowAdjustment()), n && (s = -s), s || 0;
            },
            setTranslate: function (e, t) {
              const n = this,
                { rtlTranslate: r, params: i, wrapperEl: s, progress: a } = n;
              let o,
                l = 0,
                c = 0;
              n.isHorizontal() ? (l = r ? -e : e) : (c = e),
                i.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
                (n.previousTranslate = n.translate),
                (n.translate = n.isHorizontal() ? l : c),
                i.cssMode
                  ? (s[n.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                      n.isHorizontal() ? -l : -c)
                  : i.virtualTranslate ||
                    (n.isHorizontal()
                      ? (l -= n.cssOverflowAdjustment())
                      : (c -= n.cssOverflowAdjustment()),
                    (s.style.transform = `translate3d(${l}px, ${c}px, 0px)`));
              const u = n.maxTranslate() - n.minTranslate();
              (o = 0 === u ? 0 : (e - n.minTranslate()) / u),
                o !== a && n.updateProgress(e),
                n.emit('setTranslate', n.translate, t);
            },
            minTranslate: function () {
              return -this.snapGrid[0];
            },
            maxTranslate: function () {
              return -this.snapGrid[this.snapGrid.length - 1];
            },
            translateTo: function (
              e = 0,
              t = this.params.speed,
              n = !0,
              r = !0,
              i
            ) {
              const s = this,
                { params: a, wrapperEl: o } = s;
              if (s.animating && a.preventInteractionOnTransition) return !1;
              const l = s.minTranslate(),
                c = s.maxTranslate();
              let u;
              if (
                ((u = r && e > l ? l : r && e < c ? c : e),
                s.updateProgress(u),
                a.cssMode)
              ) {
                const e = s.isHorizontal();
                if (0 === t) o[e ? 'scrollLeft' : 'scrollTop'] = -u;
                else {
                  if (!s.support.smoothScroll)
                    return (
                      m({
                        swiper: s,
                        targetPosition: -u,
                        side: e ? 'left' : 'top',
                      }),
                      !0
                    );
                  o.scrollTo({ [e ? 'left' : 'top']: -u, behavior: 'smooth' });
                }
                return !0;
              }
              return (
                0 === t
                  ? (s.setTransition(0),
                    s.setTranslate(u),
                    n &&
                      (s.emit('beforeTransitionStart', t, i),
                      s.emit('transitionEnd')))
                  : (s.setTransition(t),
                    s.setTranslate(u),
                    n &&
                      (s.emit('beforeTransitionStart', t, i),
                      s.emit('transitionStart')),
                    s.animating ||
                      ((s.animating = !0),
                      s.onTranslateToWrapperTransitionEnd ||
                        (s.onTranslateToWrapperTransitionEnd = function (e) {
                          s &&
                            !s.destroyed &&
                            e.target === this &&
                            (s.wrapperEl.removeEventListener(
                              'transitionend',
                              s.onTranslateToWrapperTransitionEnd
                            ),
                            (s.onTranslateToWrapperTransitionEnd = null),
                            delete s.onTranslateToWrapperTransitionEnd,
                            n && s.emit('transitionEnd'));
                        }),
                      s.wrapperEl.addEventListener(
                        'transitionend',
                        s.onTranslateToWrapperTransitionEnd
                      ))),
                !0
              );
            },
          },
          transition: {
            setTransition: function (e, t) {
              const n = this;
              n.params.cssMode ||
                (n.wrapperEl.style.transitionDuration = `${e}ms`),
                n.emit('setTransition', e, t);
            },
            transitionStart: function (e = !0, t) {
              const n = this,
                { params: r } = n;
              r.cssMode ||
                (r.autoHeight && n.updateAutoHeight(),
                I({ swiper: n, runCallbacks: e, direction: t, step: 'Start' }));
            },
            transitionEnd: function (e = !0, t) {
              const n = this,
                { params: r } = n;
              (n.animating = !1),
                r.cssMode ||
                  (n.setTransition(0),
                  I({ swiper: n, runCallbacks: e, direction: t, step: 'End' }));
            },
          },
          slide: z,
          loop: R,
          grabCursor: {
            setGrabCursor: function (e) {
              const t = this;
              if (
                !t.params.simulateTouch ||
                (t.params.watchOverflow && t.isLocked) ||
                t.params.cssMode
              )
                return;
              const n =
                'container' === t.params.touchEventsTarget ? t.el : t.wrapperEl;
              t.isElement && (t.__preventObserver__ = !0),
                (n.style.cursor = 'move'),
                (n.style.cursor = e ? 'grabbing' : 'grab'),
                t.isElement &&
                  requestAnimationFrame(() => {
                    t.__preventObserver__ = !1;
                  });
            },
            unsetGrabCursor: function () {
              const e = this;
              (e.params.watchOverflow && e.isLocked) ||
                e.params.cssMode ||
                (e.isElement && (e.__preventObserver__ = !0),
                (e[
                  'container' === e.params.touchEventsTarget
                    ? 'el'
                    : 'wrapperEl'
                ].style.cursor = ''),
                e.isElement &&
                  requestAnimationFrame(() => {
                    e.__preventObserver__ = !1;
                  }));
            },
          },
          events: {
            attachEvents: function () {
              const e = this,
                t = a(),
                { params: n } = e;
              (e.onTouchStart = j.bind(e)),
                (e.onTouchMove = N.bind(e)),
                (e.onTouchEnd = $.bind(e)),
                n.cssMode && (e.onScroll = H.bind(e)),
                (e.onClick = q.bind(e)),
                (e.onLoad = B.bind(e)),
                X || (t.addEventListener('touchstart', Y), (X = !0)),
                G(e, 'on');
            },
            detachEvents: function () {
              G(this, 'off');
            },
          },
          breakpoints: {
            setBreakpoint: function () {
              const e = this,
                { realIndex: t, initialized: n, params: r, el: i } = e,
                s = r.breakpoints;
              if (!s || (s && 0 === Object.keys(s).length)) return;
              const a = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
              if (!a || e.currentBreakpoint === a) return;
              const o = (a in s ? s[a] : void 0) || e.originalParams,
                l = W(e, r),
                c = W(e, o),
                u = r.enabled;
              l && !c
                ? (i.classList.remove(
                    `${r.containerModifierClass}grid`,
                    `${r.containerModifierClass}grid-column`
                  ),
                  e.emitContainerClasses())
                : !l &&
                  c &&
                  (i.classList.add(`${r.containerModifierClass}grid`),
                  ((o.grid.fill && 'column' === o.grid.fill) ||
                    (!o.grid.fill && 'column' === r.grid.fill)) &&
                    i.classList.add(`${r.containerModifierClass}grid-column`),
                  e.emitContainerClasses()),
                ['navigation', 'pagination', 'scrollbar'].forEach((t) => {
                  if (void 0 === o[t]) return;
                  const n = r[t] && r[t].enabled,
                    i = o[t] && o[t].enabled;
                  n && !i && e[t].disable(), !n && i && e[t].enable();
                });
              const d = o.direction && o.direction !== r.direction,
                p = r.loop && (o.slidesPerView !== r.slidesPerView || d);
              d && n && e.changeDirection(), f(e.params, o);
              const h = e.params.enabled;
              Object.assign(e, {
                allowTouchMove: e.params.allowTouchMove,
                allowSlideNext: e.params.allowSlideNext,
                allowSlidePrev: e.params.allowSlidePrev,
              }),
                u && !h ? e.disable() : !u && h && e.enable(),
                (e.currentBreakpoint = a),
                e.emit('_beforeBreakpoint', o),
                p && n && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()),
                e.emit('breakpoint', o);
            },
            getBreakpoint: function (e, t = 'window', n) {
              if (!e || ('container' === t && !n)) return;
              let r = !1;
              const i = l(),
                s = 'window' === t ? i.innerHeight : n.clientHeight,
                a = Object.keys(e).map((e) => {
                  if ('string' == typeof e && 0 === e.indexOf('@')) {
                    const t = parseFloat(e.substr(1));
                    return { value: s * t, point: e };
                  }
                  return { value: e, point: e };
                });
              a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
              for (let e = 0; e < a.length; e += 1) {
                const { point: s, value: o } = a[e];
                'window' === t
                  ? i.matchMedia(`(min-width: ${o}px)`).matches && (r = s)
                  : o <= n.clientWidth && (r = s);
              }
              return r || 'max';
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              const e = this,
                { isLocked: t, params: n } = e,
                { slidesOffsetBefore: r } = n;
              if (r) {
                const t = e.slides.length - 1,
                  n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
                e.isLocked = e.size > n;
              } else e.isLocked = 1 === e.snapGrid.length;
              !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                t && t !== e.isLocked && (e.isEnd = !1),
                t !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock');
            },
          },
          classes: {
            addClasses: function () {
              const e = this,
                { classNames: t, params: n, rtl: r, el: i, device: s } = e,
                a = (function (e, t) {
                  const n = [];
                  return (
                    e.forEach((e) => {
                      'object' == typeof e
                        ? Object.keys(e).forEach((r) => {
                            e[r] && n.push(t + r);
                          })
                        : 'string' == typeof e && n.push(t + e);
                    }),
                    n
                  );
                })(
                  [
                    'initialized',
                    n.direction,
                    { 'free-mode': e.params.freeMode && n.freeMode.enabled },
                    { autoheight: n.autoHeight },
                    { rtl: r },
                    { grid: n.grid && n.grid.rows > 1 },
                    {
                      'grid-column':
                        n.grid && n.grid.rows > 1 && 'column' === n.grid.fill,
                    },
                    { android: s.android },
                    { ios: s.ios },
                    { 'css-mode': n.cssMode },
                    { centered: n.cssMode && n.centeredSlides },
                    { 'watch-progress': n.watchSlidesProgress },
                  ],
                  n.containerModifierClass
                );
              t.push(...a), i.classList.add(...t), e.emitContainerClasses();
            },
            removeClasses: function () {
              const { el: e, classNames: t } = this;
              e.classList.remove(...t), this.emitContainerClasses();
            },
          },
        },
        Q = {};
      class Z {
        constructor(...e) {
          let t, n;
          1 === e.length &&
          e[0].constructor &&
          'Object' === Object.prototype.toString.call(e[0]).slice(8, -1)
            ? (n = e[0])
            : ([t, n] = e),
            n || (n = {}),
            (n = f({}, n)),
            t && !n.el && (n.el = t);
          const r = a();
          if (
            n.el &&
            'string' == typeof n.el &&
            r.querySelectorAll(n.el).length > 1
          ) {
            const e = [];
            return (
              r.querySelectorAll(n.el).forEach((t) => {
                const r = f({}, n, { el: t });
                e.push(new Z(r));
              }),
              e
            );
          }
          const i = this;
          (i.__swiper__ = !0),
            (i.support = k()),
            (i.device = (function (e = {}) {
              return (
                C ||
                  (C = (function ({ userAgent: e } = {}) {
                    const t = k(),
                      n = l(),
                      r = n.navigator.platform,
                      i = e || n.navigator.userAgent,
                      s = { ios: !1, android: !1 },
                      a = n.screen.width,
                      o = n.screen.height,
                      c = i.match(/(Android);?[\s\/]+([\d.]+)?/);
                    let u = i.match(/(iPad).*OS\s([\d_]+)/);
                    const d = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                      p = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                      f = 'Win32' === r;
                    let h = 'MacIntel' === r;
                    return (
                      !u &&
                        h &&
                        t.touch &&
                        [
                          '1024x1366',
                          '1366x1024',
                          '834x1194',
                          '1194x834',
                          '834x1112',
                          '1112x834',
                          '768x1024',
                          '1024x768',
                          '820x1180',
                          '1180x820',
                          '810x1080',
                          '1080x810',
                        ].indexOf(`${a}x${o}`) >= 0 &&
                        ((u = i.match(/(Version)\/([\d.]+)/)),
                        u || (u = [0, 1, '13_0_0']),
                        (h = !1)),
                      c && !f && ((s.os = 'android'), (s.android = !0)),
                      (u || p || d) && ((s.os = 'ios'), (s.ios = !0)),
                      s
                    );
                  })(e)),
                C
              );
            })({ userAgent: n.userAgent })),
            (i.browser =
              (M ||
                (M = (function () {
                  const e = l();
                  let t = !1;
                  function n() {
                    const t = e.navigator.userAgent.toLowerCase();
                    return (
                      t.indexOf('safari') >= 0 &&
                      t.indexOf('chrome') < 0 &&
                      t.indexOf('android') < 0
                    );
                  }
                  if (n()) {
                    const n = String(e.navigator.userAgent);
                    if (n.includes('Version/')) {
                      const [e, r] = n
                        .split('Version/')[1]
                        .split(' ')[0]
                        .split('.')
                        .map((e) => Number(e));
                      t = e < 16 || (16 === e && r < 2);
                    }
                  }
                  return {
                    isSafari: t || n(),
                    needPerspectiveFix: t,
                    isWebView:
                      /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                        e.navigator.userAgent
                      ),
                  };
                })()),
              M)),
            (i.eventsListeners = {}),
            (i.eventsAnyListeners = []),
            (i.modules = [...i.__modules__]),
            n.modules &&
              Array.isArray(n.modules) &&
              i.modules.push(...n.modules);
          const s = {};
          i.modules.forEach((e) => {
            e({
              params: n,
              swiper: i,
              extendParams: U(n, s),
              on: i.on.bind(i),
              once: i.once.bind(i),
              off: i.off.bind(i),
              emit: i.emit.bind(i),
            });
          });
          const o = f({}, V, s);
          return (
            (i.params = f({}, o, Q, n)),
            (i.originalParams = f({}, i.params)),
            (i.passedParams = f({}, n)),
            i.params &&
              i.params.on &&
              Object.keys(i.params.on).forEach((e) => {
                i.on(e, i.params.on[e]);
              }),
            i.params && i.params.onAny && i.onAny(i.params.onAny),
            Object.assign(i, {
              enabled: i.params.enabled,
              el: t,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return 'horizontal' === i.params.direction;
              },
              isVertical() {
                return 'vertical' === i.params.direction;
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: i.params.allowSlideNext,
              allowSlidePrev: i.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: i.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                evCache: [],
              },
              allowClick: !0,
              allowTouchMove: i.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            i.emit('_swiper'),
            i.params.init && i.init(),
            i
          );
        }
        getSlideIndex(e) {
          const { slidesEl: t, params: n } = this,
            r = x(v(t, `.${n.slideClass}, swiper-slide`)[0]);
          return x(e) - r;
        }
        getSlideIndexByData(e) {
          return this.getSlideIndex(
            this.slides.filter(
              (t) => 1 * t.getAttribute('data-swiper-slide-index') === e
            )[0]
          );
        }
        recalcSlides() {
          const { slidesEl: e, params: t } = this;
          this.slides = v(e, `.${t.slideClass}, swiper-slide`);
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit('enable'));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit('disable'));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const r = n.minTranslate(),
            i = (n.maxTranslate() - r) * e + r;
          n.translateTo(i, void 0 === t ? 0 : t),
            n.updateActiveIndex(),
            n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(' ')
            .filter(
              (t) =>
                0 === t.indexOf('swiper') ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit('_containerClasses', t.join(' '));
        }
        getSlideClasses(e) {
          const t = this;
          return t.destroyed
            ? ''
            : e.className
                .split(' ')
                .filter(
                  (e) =>
                    0 === e.indexOf('swiper-slide') ||
                    0 === e.indexOf(t.params.slideClass)
                )
                .join(' ');
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.forEach((n) => {
            const r = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: r }), e.emit('_slideClass', n, r);
          }),
            e.emit('_slideClasses', t);
        }
        slidesPerViewDynamic(e = 'current', t = !1) {
          const {
            params: n,
            slides: r,
            slidesGrid: i,
            slidesSizesGrid: s,
            size: a,
            activeIndex: o,
          } = this;
          let l = 1;
          if (n.centeredSlides) {
            let e,
              t = r[o] ? r[o].swiperSlideSize : 0;
            for (let n = o + 1; n < r.length; n += 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (l += 1), t > a && (e = !0));
            for (let n = o - 1; n >= 0; n -= 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (l += 1), t > a && (e = !0));
          } else if ('current' === e)
            for (let e = o + 1; e < r.length; e += 1)
              (t ? i[e] + s[e] - i[o] < a : i[e] - i[o] < a) && (l += 1);
          else for (let e = o - 1; e >= 0; e -= 1) i[o] - i[e] < a && (l += 1);
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function r() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let i;
          if (
            (n.breakpoints && e.setBreakpoint(),
            [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
              t.complete && P(e, t);
            }),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            n.freeMode && n.freeMode.enabled && !n.cssMode)
          )
            r(), n.autoHeight && e.updateAutoHeight();
          else {
            if (
              ('auto' === n.slidesPerView || n.slidesPerView > 1) &&
              e.isEnd &&
              !n.centeredSlides
            ) {
              const t =
                e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
              i = e.slideTo(t.length - 1, 0, !1, !0);
            } else i = e.slideTo(e.activeIndex, 0, !1, !0);
            i || r();
          }
          n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit('update');
        }
        changeDirection(e, t = !0) {
          const n = this,
            r = n.params.direction;
          return (
            e || (e = 'horizontal' === r ? 'vertical' : 'horizontal'),
            e === r ||
              ('horizontal' !== e && 'vertical' !== e) ||
              (n.el.classList.remove(`${n.params.containerModifierClass}${r}`),
              n.el.classList.add(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.forEach((t) => {
                'vertical' === e ? (t.style.width = '') : (t.style.height = '');
              }),
              n.emit('changeDirection'),
              t && n.update()),
            n
          );
        }
        changeLanguageDirection(e) {
          const t = this;
          (t.rtl && 'rtl' === e) ||
            (!t.rtl && 'ltr' === e) ||
            ((t.rtl = 'rtl' === e),
            (t.rtlTranslate = 'horizontal' === t.params.direction && t.rtl),
            t.rtl
              ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = 'rtl'))
              : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = 'ltr')),
            t.update());
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          let n = e || t.params.el;
          if (('string' == typeof n && (n = document.querySelector(n)), !n))
            return !1;
          (n.swiper = t), n.shadowEl && (t.isElement = !0);
          const r = () =>
            `.${(t.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let i =
            n && n.shadowRoot && n.shadowRoot.querySelector
              ? n.shadowRoot.querySelector(r())
              : v(n, r())[0];
          return (
            !i &&
              t.params.createElements &&
              ((i = y('div', t.params.wrapperClass)),
              n.append(i),
              v(n, `.${t.params.slideClass}`).forEach((e) => {
                i.append(e);
              })),
            Object.assign(t, {
              el: n,
              wrapperEl: i,
              slidesEl: t.isElement ? n : i,
              mounted: !0,
              rtl: 'rtl' === n.dir.toLowerCase() || 'rtl' === w(n, 'direction'),
              rtlTranslate:
                'horizontal' === t.params.direction &&
                ('rtl' === n.dir.toLowerCase() || 'rtl' === w(n, 'direction')),
              wrongRTL: '-webkit-box' === w(i, 'display'),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit('beforeInit'),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.loop && t.virtual && t.params.virtual.enabled
                ? t.slideTo(
                    t.params.initialSlide + t.virtual.slidesBefore,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  ),
              t.params.loop && t.loopCreate(),
              t.attachEvents(),
              [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
                e.complete
                  ? P(t, e)
                  : e.addEventListener('load', (e) => {
                      P(t, e.target);
                    });
              }),
              O(t),
              (t.initialized = !0),
              O(t),
              t.emit('init'),
              t.emit('afterInit')),
            t
          );
        }
        destroy(e = !0, t = !0) {
          const n = this,
            { params: r, el: i, wrapperEl: s, slides: a } = n;
          return (
            void 0 === n.params ||
              n.destroyed ||
              (n.emit('beforeDestroy'),
              (n.initialized = !1),
              n.detachEvents(),
              r.loop && n.loopDestroy(),
              t &&
                (n.removeClasses(),
                i.removeAttribute('style'),
                s.removeAttribute('style'),
                a &&
                  a.length &&
                  a.forEach((e) => {
                    e.classList.remove(
                      r.slideVisibleClass,
                      r.slideActiveClass,
                      r.slideNextClass,
                      r.slidePrevClass
                    ),
                      e.removeAttribute('style'),
                      e.removeAttribute('data-swiper-slide-index');
                  })),
              n.emit('destroy'),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e &&
                ((n.el.swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          f(Q, e);
        }
        static get extendedDefaults() {
          return Q;
        }
        static get defaults() {
          return V;
        }
        static installModule(e) {
          Z.prototype.__modules__ || (Z.prototype.__modules__ = []);
          const t = Z.prototype.__modules__;
          'function' == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => Z.installModule(e)), Z)
            : (Z.installModule(e), Z);
        }
      }
      Object.keys(K).forEach((e) => {
        Object.keys(K[e]).forEach((t) => {
          Z.prototype[t] = K[e][t];
        });
      }),
        Z.use([
          function ({ swiper: e, on: t, emit: n }) {
            const r = l();
            let i = null,
              s = null;
            const a = () => {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  (n('beforeResize'), n('resize'));
              },
              o = () => {
                e && !e.destroyed && e.initialized && n('orientationchange');
              };
            t('init', () => {
              e.params.resizeObserver && void 0 !== r.ResizeObserver
                ? e &&
                  !e.destroyed &&
                  e.initialized &&
                  ((i = new ResizeObserver((t) => {
                    s = r.requestAnimationFrame(() => {
                      const { width: n, height: r } = e;
                      let i = n,
                        s = r;
                      t.forEach(
                        ({ contentBoxSize: t, contentRect: n, target: r }) => {
                          (r && r !== e.el) ||
                            ((i = n ? n.width : (t[0] || t).inlineSize),
                            (s = n ? n.height : (t[0] || t).blockSize));
                        }
                      ),
                        (i === n && s === r) || a();
                    });
                  })),
                  i.observe(e.el))
                : (r.addEventListener('resize', a),
                  r.addEventListener('orientationchange', o));
            }),
              t('destroy', () => {
                s && r.cancelAnimationFrame(s),
                  i && i.unobserve && e.el && (i.unobserve(e.el), (i = null)),
                  r.removeEventListener('resize', a),
                  r.removeEventListener('orientationchange', o);
              });
          },
          function ({ swiper: e, extendParams: t, on: n, emit: r }) {
            const i = [],
              s = l(),
              a = (t, n = {}) => {
                const a = new (s.MutationObserver || s.WebkitMutationObserver)(
                  (t) => {
                    if (e.__preventObserver__) return;
                    if (1 === t.length) return void r('observerUpdate', t[0]);
                    const n = function () {
                      r('observerUpdate', t[0]);
                    };
                    s.requestAnimationFrame
                      ? s.requestAnimationFrame(n)
                      : s.setTimeout(n, 0);
                  }
                );
                a.observe(t, {
                  attributes: void 0 === n.attributes || n.attributes,
                  childList: void 0 === n.childList || n.childList,
                  characterData: void 0 === n.characterData || n.characterData,
                }),
                  i.push(a);
              };
            t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              n('init', () => {
                if (e.params.observer) {
                  if (e.params.observeParents) {
                    const t = T(e.el);
                    for (let e = 0; e < t.length; e += 1) a(t[e]);
                  }
                  a(e.el, { childList: e.params.observeSlideChildren }),
                    a(e.wrapperEl, { attributes: !1 });
                }
              }),
              n('destroy', () => {
                i.forEach((e) => {
                  e.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      var J = Z;
      function ee(e, t, n, r) {
        return (
          e.params.createElements &&
            Object.keys(r).forEach((i) => {
              if (!n[i] && !0 === n.auto) {
                let s = v(e.el, `.${r[i]}`)[0];
                s ||
                  ((s = y('div', r[i])), (s.className = r[i]), e.el.append(s)),
                  (n[i] = s),
                  (t[i] = s);
              }
            }),
          n
        );
      }
      function te(e = '') {
        return `.${e
          .trim()
          .replace(/([\.:!+\/])/g, '\\$1')
          .replace(/ /g, '.')}`;
      }
      function ne(e) {
        const t = this,
          { params: n, slidesEl: r } = t;
        n.loop && t.loopDestroy();
        const i = (e) => {
          if ('string' == typeof e) {
            const t = document.createElement('div');
            (t.innerHTML = e), r.append(t.children[0]), (t.innerHTML = '');
          } else r.append(e);
        };
        if ('object' == typeof e && 'length' in e)
          for (let t = 0; t < e.length; t += 1) e[t] && i(e[t]);
        else i(e);
        t.recalcSlides(),
          n.loop && t.loopCreate(),
          (n.observer && !t.isElement) || t.update();
      }
      function re(e) {
        const t = this,
          { params: n, activeIndex: r, slidesEl: i } = t;
        n.loop && t.loopDestroy();
        let s = r + 1;
        const a = (e) => {
          if ('string' == typeof e) {
            const t = document.createElement('div');
            (t.innerHTML = e), i.prepend(t.children[0]), (t.innerHTML = '');
          } else i.prepend(e);
        };
        if ('object' == typeof e && 'length' in e) {
          for (let t = 0; t < e.length; t += 1) e[t] && a(e[t]);
          s = r + e.length;
        } else a(e);
        t.recalcSlides(),
          n.loop && t.loopCreate(),
          (n.observer && !t.isElement) || t.update(),
          t.slideTo(s, 0, !1);
      }
      function ie(e, t) {
        const n = this,
          { params: r, activeIndex: i, slidesEl: s } = n;
        let a = i;
        r.loop && ((a -= n.loopedSlides), n.loopDestroy(), n.recalcSlides());
        const o = n.slides.length;
        if (e <= 0) return void n.prependSlide(t);
        if (e >= o) return void n.appendSlide(t);
        let l = a > e ? a + 1 : a;
        const c = [];
        for (let t = o - 1; t >= e; t -= 1) {
          const e = n.slides[t];
          e.remove(), c.unshift(e);
        }
        if ('object' == typeof t && 'length' in t) {
          for (let e = 0; e < t.length; e += 1) t[e] && s.append(t[e]);
          l = a > e ? a + t.length : a;
        } else s.append(t);
        for (let e = 0; e < c.length; e += 1) s.append(c[e]);
        n.recalcSlides(),
          r.loop && n.loopCreate(),
          (r.observer && !n.isElement) || n.update(),
          r.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
      }
      function se(e) {
        const t = this,
          { params: n, activeIndex: r } = t;
        let i = r;
        n.loop && ((i -= t.loopedSlides), t.loopDestroy());
        let s,
          a = i;
        if ('object' == typeof e && 'length' in e) {
          for (let n = 0; n < e.length; n += 1)
            (s = e[n]), t.slides[s] && t.slides[s].remove(), s < a && (a -= 1);
          a = Math.max(a, 0);
        } else
          (s = e),
            t.slides[s] && t.slides[s].remove(),
            s < a && (a -= 1),
            (a = Math.max(a, 0));
        t.recalcSlides(),
          n.loop && t.loopCreate(),
          (n.observer && !t.isElement) || t.update(),
          n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
      }
      function ae() {
        const e = this,
          t = [];
        for (let n = 0; n < e.slides.length; n += 1) t.push(n);
        e.removeSlide(t);
      }
      function oe(e) {
        const {
          effect: t,
          swiper: n,
          on: r,
          setTranslate: i,
          setTransition: s,
          overwriteParams: a,
          perspective: o,
          recreateShadows: l,
          getEffectParams: c,
        } = e;
        let u;
        r('beforeInit', () => {
          if (n.params.effect !== t) return;
          n.classNames.push(`${n.params.containerModifierClass}${t}`),
            o &&
              o() &&
              n.classNames.push(`${n.params.containerModifierClass}3d`);
          const e = a ? a() : {};
          Object.assign(n.params, e), Object.assign(n.originalParams, e);
        }),
          r('setTranslate', () => {
            n.params.effect === t && i();
          }),
          r('setTransition', (e, r) => {
            n.params.effect === t && s(r);
          }),
          r('transitionEnd', () => {
            if (n.params.effect === t && l) {
              if (!c || !c().slideShadows) return;
              n.slides.forEach((e) => {
                e.querySelectorAll(
                  '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                ).forEach((e) => e.remove());
              }),
                l();
            }
          }),
          r('virtualUpdate', () => {
            n.params.effect === t &&
              (n.slides.length || (u = !0),
              requestAnimationFrame(() => {
                u && n.slides && n.slides.length && (i(), (u = !1));
              }));
          });
      }
      function le(e, t) {
        const n = g(t);
        return (
          n !== t &&
            ((n.style.backfaceVisibility = 'hidden'),
            (n.style['-webkit-backface-visibility'] = 'hidden')),
          n
        );
      }
      function ce({
        swiper: e,
        duration: t,
        transformElements: n,
        allSlides: r,
      }) {
        const { activeIndex: i } = e;
        if (e.params.virtualTranslate && 0 !== t) {
          let t,
            s = !1;
          (t = r
            ? n
            : n.filter((t) => {
                const n = t.classList.contains('swiper-slide-transform')
                  ? ((t) =>
                      t.parentElement
                        ? t.parentElement
                        : e.slides.filter(
                            (e) => e.shadowEl && e.shadowEl === t.parentNode
                          )[0])(t)
                  : t;
                return e.getSlideIndex(n) === i;
              })),
            t.forEach((t) => {
              E(t, () => {
                if (s) return;
                if (!e || e.destroyed) return;
                (s = !0), (e.animating = !1);
                const t = new window.CustomEvent('transitionend', {
                  bubbles: !0,
                  cancelable: !0,
                });
                e.wrapperEl.dispatchEvent(t);
              });
            });
        }
      }
      function ue(e, t, n) {
        const r = 'swiper-slide-shadow' + (n ? `-${n}` : ''),
          i = g(t);
        let s = i.querySelector(`.${r}`);
        return (
          s ||
            ((s = y('div', 'swiper-slide-shadow' + (n ? `-${n}` : ''))),
            i.append(s)),
          s
        );
      }
      const de = [
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          let i;
          t({
            virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              renderExternalUpdate: !0,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          });
          const s = a();
          e.virtual = {
            cache: {},
            from: void 0,
            to: void 0,
            slides: [],
            offset: 0,
            slidesGrid: [],
          };
          const o = s.createElement('div');
          function l(t, n) {
            const r = e.params.virtual;
            if (r.cache && e.virtual.cache[n]) return e.virtual.cache[n];
            let i;
            return (
              r.renderSlide
                ? ((i = r.renderSlide.call(e, t, n)),
                  'string' == typeof i &&
                    ((o.innerHTML = i), (i = o.children[0])))
                : (i = e.isElement
                    ? y('swiper-slide')
                    : y('div', e.params.slideClass)),
              i.setAttribute('data-swiper-slide-index', n),
              r.renderSlide || (i.innerHTML = t),
              r.cache && (e.virtual.cache[n] = i),
              i
            );
          }
          function c(t) {
            const {
                slidesPerView: n,
                slidesPerGroup: i,
                centeredSlides: s,
                loop: a,
              } = e.params,
              { addSlidesBefore: o, addSlidesAfter: c } = e.params.virtual,
              {
                from: u,
                to: d,
                slides: p,
                slidesGrid: f,
                offset: h,
              } = e.virtual;
            e.params.cssMode || e.updateActiveIndex();
            const m = e.activeIndex || 0;
            let g, y, b;
            (g = e.rtlTranslate ? 'right' : e.isHorizontal() ? 'left' : 'top'),
              s
                ? ((y = Math.floor(n / 2) + i + c),
                  (b = Math.floor(n / 2) + i + o))
                : ((y = n + (i - 1) + c), (b = (a ? n : i) + o));
            let w = m - b,
              x = m + y;
            a || ((w = Math.max(w, 0)), (x = Math.min(x, p.length - 1)));
            let T = (e.slidesGrid[w] || 0) - (e.slidesGrid[0] || 0);
            function E() {
              e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                r('virtualUpdate');
            }
            if (
              (a && m >= b
                ? ((w -= b), s || (T += e.slidesGrid[0]))
                : a && m < b && ((w = -b), s && (T += e.slidesGrid[0])),
              Object.assign(e.virtual, {
                from: w,
                to: x,
                offset: T,
                slidesGrid: e.slidesGrid,
                slidesBefore: b,
                slidesAfter: y,
              }),
              u === w && d === x && !t)
            )
              return (
                e.slidesGrid !== f &&
                  T !== h &&
                  e.slides.forEach((t) => {
                    t.style[g] = T - Math.abs(e.cssOverflowAdjustment()) + 'px';
                  }),
                e.updateProgress(),
                void r('virtualUpdate')
              );
            if (e.params.virtual.renderExternal)
              return (
                e.params.virtual.renderExternal.call(e, {
                  offset: T,
                  from: w,
                  to: x,
                  slides: (function () {
                    const e = [];
                    for (let t = w; t <= x; t += 1) e.push(p[t]);
                    return e;
                  })(),
                }),
                void (e.params.virtual.renderExternalUpdate
                  ? E()
                  : r('virtualUpdate'))
              );
            const _ = [],
              S = [],
              C = (e) => {
                let t = e;
                return (
                  e < 0 ? (t = p.length + e) : t >= p.length && (t -= p.length),
                  t
                );
              };
            if (t)
              e.slidesEl
                .querySelectorAll(`.${e.params.slideClass}, swiper-slide`)
                .forEach((e) => {
                  e.remove();
                });
            else
              for (let t = u; t <= d; t += 1)
                if (t < w || t > x) {
                  const n = C(t);
                  e.slidesEl
                    .querySelectorAll(
                      `.${e.params.slideClass}[data-swiper-slide-index="${n}"], swiper-slide[data-swiper-slide-index="${n}"]`
                    )
                    .forEach((e) => {
                      e.remove();
                    });
                }
            const M = a ? -p.length : 0,
              k = a ? 2 * p.length : p.length;
            for (let e = M; e < k; e += 1)
              if (e >= w && e <= x) {
                const n = C(e);
                void 0 === d || t
                  ? S.push(n)
                  : (e > d && S.push(n), e < u && _.push(n));
              }
            if (
              (S.forEach((t) => {
                e.slidesEl.append(l(p[t], t));
              }),
              a)
            )
              for (let t = _.length - 1; t >= 0; t -= 1) {
                const n = _[t];
                e.slidesEl.prepend(l(p[n], n));
              }
            else
              _.sort((e, t) => t - e),
                _.forEach((t) => {
                  e.slidesEl.prepend(l(p[t], t));
                });
            v(e.slidesEl, '.swiper-slide, swiper-slide').forEach((t) => {
              t.style[g] = T - Math.abs(e.cssOverflowAdjustment()) + 'px';
            }),
              E();
          }
          n('beforeInit', () => {
            if (!e.params.virtual.enabled) return;
            let t;
            if (void 0 === e.passedParams.virtual.slides) {
              const n = [...e.slidesEl.children].filter((t) =>
                t.matches(`.${e.params.slideClass}, swiper-slide`)
              );
              n &&
                n.length &&
                ((e.virtual.slides = [...n]),
                (t = !0),
                n.forEach((t, n) => {
                  t.setAttribute('data-swiper-slide-index', n),
                    (e.virtual.cache[n] = t),
                    t.remove();
                }));
            }
            t || (e.virtual.slides = e.params.virtual.slides),
              e.classNames.push(`${e.params.containerModifierClass}virtual`),
              (e.params.watchSlidesProgress = !0),
              (e.originalParams.watchSlidesProgress = !0),
              e.params.initialSlide || c();
          }),
            n('setTranslate', () => {
              e.params.virtual.enabled &&
                (e.params.cssMode && !e._immediateVirtual
                  ? (clearTimeout(i),
                    (i = setTimeout(() => {
                      c();
                    }, 100)))
                  : c());
            }),
            n('init update resize', () => {
              e.params.virtual.enabled &&
                e.params.cssMode &&
                h(e.wrapperEl, '--swiper-virtual-size', `${e.virtualSize}px`);
            }),
            Object.assign(e.virtual, {
              appendSlide: function (t) {
                if ('object' == typeof t && 'length' in t)
                  for (let n = 0; n < t.length; n += 1)
                    t[n] && e.virtual.slides.push(t[n]);
                else e.virtual.slides.push(t);
                c(!0);
              },
              prependSlide: function (t) {
                const n = e.activeIndex;
                let r = n + 1,
                  i = 1;
                if (Array.isArray(t)) {
                  for (let n = 0; n < t.length; n += 1)
                    t[n] && e.virtual.slides.unshift(t[n]);
                  (r = n + t.length), (i = t.length);
                } else e.virtual.slides.unshift(t);
                if (e.params.virtual.cache) {
                  const t = e.virtual.cache,
                    n = {};
                  Object.keys(t).forEach((e) => {
                    const r = t[e],
                      s = r.getAttribute('data-swiper-slide-index');
                    s &&
                      r.setAttribute(
                        'data-swiper-slide-index',
                        parseInt(s, 10) + i
                      ),
                      (n[parseInt(e, 10) + i] = r);
                  }),
                    (e.virtual.cache = n);
                }
                c(!0), e.slideTo(r, 0);
              },
              removeSlide: function (t) {
                if (null == t) return;
                let n = e.activeIndex;
                if (Array.isArray(t))
                  for (let r = t.length - 1; r >= 0; r -= 1)
                    e.virtual.slides.splice(t[r], 1),
                      e.params.virtual.cache && delete e.virtual.cache[t[r]],
                      t[r] < n && (n -= 1),
                      (n = Math.max(n, 0));
                else
                  e.virtual.slides.splice(t, 1),
                    e.params.virtual.cache && delete e.virtual.cache[t],
                    t < n && (n -= 1),
                    (n = Math.max(n, 0));
                c(!0), e.slideTo(n, 0);
              },
              removeAllSlides: function () {
                (e.virtual.slides = []),
                  e.params.virtual.cache && (e.virtual.cache = {}),
                  c(!0),
                  e.slideTo(0, 0);
              },
              update: c,
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = a(),
            s = l();
          function o(t) {
            if (!e.enabled) return;
            const { rtlTranslate: n } = e;
            let a = t;
            a.originalEvent && (a = a.originalEvent);
            const o = a.keyCode || a.charCode,
              l = e.params.keyboard.pageUpDown,
              c = l && 33 === o,
              u = l && 34 === o,
              d = 37 === o,
              p = 39 === o,
              f = 38 === o,
              h = 40 === o;
            if (
              !e.allowSlideNext &&
              ((e.isHorizontal() && p) || (e.isVertical() && h) || u)
            )
              return !1;
            if (
              !e.allowSlidePrev &&
              ((e.isHorizontal() && d) || (e.isVertical() && f) || c)
            )
              return !1;
            if (
              !(
                a.shiftKey ||
                a.altKey ||
                a.ctrlKey ||
                a.metaKey ||
                (i.activeElement &&
                  i.activeElement.nodeName &&
                  ('input' === i.activeElement.nodeName.toLowerCase() ||
                    'textarea' === i.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (
                e.params.keyboard.onlyInViewport &&
                (c || u || d || p || f || h)
              ) {
                let t = !1;
                if (
                  T(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 &&
                  0 === T(e.el, `.${e.params.slideActiveClass}`).length
                )
                  return;
                const r = e.el,
                  i = r.clientWidth,
                  a = r.clientHeight,
                  o = s.innerWidth,
                  l = s.innerHeight,
                  c = b(r);
                n && (c.left -= r.scrollLeft);
                const u = [
                  [c.left, c.top],
                  [c.left + i, c.top],
                  [c.left, c.top + a],
                  [c.left + i, c.top + a],
                ];
                for (let e = 0; e < u.length; e += 1) {
                  const n = u[e];
                  if (n[0] >= 0 && n[0] <= o && n[1] >= 0 && n[1] <= l) {
                    if (0 === n[0] && 0 === n[1]) continue;
                    t = !0;
                  }
                }
                if (!t) return;
              }
              e.isHorizontal()
                ? ((c || u || d || p) &&
                    (a.preventDefault
                      ? a.preventDefault()
                      : (a.returnValue = !1)),
                  (((u || p) && !n) || ((c || d) && n)) && e.slideNext(),
                  (((c || d) && !n) || ((u || p) && n)) && e.slidePrev())
                : ((c || u || f || h) &&
                    (a.preventDefault
                      ? a.preventDefault()
                      : (a.returnValue = !1)),
                  (u || h) && e.slideNext(),
                  (c || f) && e.slidePrev()),
                r('keyPress', o);
            }
          }
          function c() {
            e.keyboard.enabled ||
              (i.addEventListener('keydown', o), (e.keyboard.enabled = !0));
          }
          function u() {
            e.keyboard.enabled &&
              (i.removeEventListener('keydown', o), (e.keyboard.enabled = !1));
          }
          (e.keyboard = { enabled: !1 }),
            t({
              keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 },
            }),
            n('init', () => {
              e.params.keyboard.enabled && c();
            }),
            n('destroy', () => {
              e.keyboard.enabled && u();
            }),
            Object.assign(e.keyboard, { enable: c, disable: u });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = l();
          let s;
          t({
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarget: 'container',
              thresholdDelta: null,
              thresholdTime: null,
              noMousewheelClass: 'swiper-no-mousewheel',
            },
          }),
            (e.mousewheel = { enabled: !1 });
          let a,
            o = u();
          const d = [];
          function p() {
            e.enabled && (e.mouseEntered = !0);
          }
          function f() {
            e.enabled && (e.mouseEntered = !1);
          }
          function h(t) {
            return !(
              (e.params.mousewheel.thresholdDelta &&
                t.delta < e.params.mousewheel.thresholdDelta) ||
              (e.params.mousewheel.thresholdTime &&
                u() - o < e.params.mousewheel.thresholdTime) ||
              (!(t.delta >= 6 && u() - o < 60) &&
                (t.direction < 0
                  ? (e.isEnd && !e.params.loop) ||
                    e.animating ||
                    (e.slideNext(), r('scroll', t.raw))
                  : (e.isBeginning && !e.params.loop) ||
                    e.animating ||
                    (e.slidePrev(), r('scroll', t.raw)),
                (o = new i.Date().getTime()),
                1))
            );
          }
          function m(t) {
            let n = t,
              i = !0;
            if (!e.enabled) return;
            if (t.target.closest(`.${e.params.mousewheel.noMousewheelClass}`))
              return;
            const o = e.params.mousewheel;
            e.params.cssMode && n.preventDefault();
            let l = e.el;
            'container' !== e.params.mousewheel.eventsTarget &&
              (l = document.querySelector(e.params.mousewheel.eventsTarget));
            const p = l && l.contains(n.target);
            if (!e.mouseEntered && !p && !o.releaseOnEdges) return !0;
            n.originalEvent && (n = n.originalEvent);
            let f = 0;
            const m = e.rtlTranslate ? -1 : 1,
              g = (function (e) {
                let t = 0,
                  n = 0,
                  r = 0,
                  i = 0;
                return (
                  'detail' in e && (n = e.detail),
                  'wheelDelta' in e && (n = -e.wheelDelta / 120),
                  'wheelDeltaY' in e && (n = -e.wheelDeltaY / 120),
                  'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120),
                  'axis' in e &&
                    e.axis === e.HORIZONTAL_AXIS &&
                    ((t = n), (n = 0)),
                  (r = 10 * t),
                  (i = 10 * n),
                  'deltaY' in e && (i = e.deltaY),
                  'deltaX' in e && (r = e.deltaX),
                  e.shiftKey && !r && ((r = i), (i = 0)),
                  (r || i) &&
                    e.deltaMode &&
                    (1 === e.deltaMode
                      ? ((r *= 40), (i *= 40))
                      : ((r *= 800), (i *= 800))),
                  r && !t && (t = r < 1 ? -1 : 1),
                  i && !n && (n = i < 1 ? -1 : 1),
                  { spinX: t, spinY: n, pixelX: r, pixelY: i }
                );
              })(n);
            if (o.forceToAxis)
              if (e.isHorizontal()) {
                if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
                f = -g.pixelX * m;
              } else {
                if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
                f = -g.pixelY;
              }
            else
              f =
                Math.abs(g.pixelX) > Math.abs(g.pixelY)
                  ? -g.pixelX * m
                  : -g.pixelY;
            if (0 === f) return !0;
            o.invert && (f = -f);
            let v = e.getTranslate() + f * o.sensitivity;
            if (
              (v >= e.minTranslate() && (v = e.minTranslate()),
              v <= e.maxTranslate() && (v = e.maxTranslate()),
              (i =
                !!e.params.loop ||
                !(v === e.minTranslate() || v === e.maxTranslate())),
              i && e.params.nested && n.stopPropagation(),
              e.params.freeMode && e.params.freeMode.enabled)
            ) {
              const t = {
                  time: u(),
                  delta: Math.abs(f),
                  direction: Math.sign(f),
                },
                i =
                  a &&
                  t.time < a.time + 500 &&
                  t.delta <= a.delta &&
                  t.direction === a.direction;
              if (!i) {
                a = void 0;
                let l = e.getTranslate() + f * o.sensitivity;
                const u = e.isBeginning,
                  p = e.isEnd;
                if (
                  (l >= e.minTranslate() && (l = e.minTranslate()),
                  l <= e.maxTranslate() && (l = e.maxTranslate()),
                  e.setTransition(0),
                  e.setTranslate(l),
                  e.updateProgress(),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses(),
                  ((!u && e.isBeginning) || (!p && e.isEnd)) &&
                    e.updateSlidesClasses(),
                  e.params.loop &&
                    e.loopFix({
                      direction: t.direction < 0 ? 'next' : 'prev',
                      byMousewheel: !0,
                    }),
                  e.params.freeMode.sticky)
                ) {
                  clearTimeout(s), (s = void 0), d.length >= 15 && d.shift();
                  const n = d.length ? d[d.length - 1] : void 0,
                    r = d[0];
                  if (
                    (d.push(t),
                    n && (t.delta > n.delta || t.direction !== n.direction))
                  )
                    d.splice(0);
                  else if (
                    d.length >= 15 &&
                    t.time - r.time < 500 &&
                    r.delta - t.delta >= 1 &&
                    t.delta <= 6
                  ) {
                    const n = f > 0 ? 0.8 : 0.2;
                    (a = t),
                      d.splice(0),
                      (s = c(() => {
                        e.slideToClosest(e.params.speed, !0, void 0, n);
                      }, 0));
                  }
                  s ||
                    (s = c(() => {
                      (a = t),
                        d.splice(0),
                        e.slideToClosest(e.params.speed, !0, void 0, 0.5);
                    }, 500));
                }
                if (
                  (i || r('scroll', n),
                  e.params.autoplay &&
                    e.params.autoplayDisableOnInteraction &&
                    e.autoplay.stop(),
                  l === e.minTranslate() || l === e.maxTranslate())
                )
                  return !0;
              }
            } else {
              const n = {
                time: u(),
                delta: Math.abs(f),
                direction: Math.sign(f),
                raw: t,
              };
              d.length >= 2 && d.shift();
              const r = d.length ? d[d.length - 1] : void 0;
              if (
                (d.push(n),
                r
                  ? (n.direction !== r.direction ||
                      n.delta > r.delta ||
                      n.time > r.time + 150) &&
                    h(n)
                  : h(n),
                (function (t) {
                  const n = e.params.mousewheel;
                  if (t.direction < 0) {
                    if (e.isEnd && !e.params.loop && n.releaseOnEdges)
                      return !0;
                  } else if (
                    e.isBeginning &&
                    !e.params.loop &&
                    n.releaseOnEdges
                  )
                    return !0;
                  return !1;
                })(n))
              )
                return !0;
            }
            return (
              n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1
            );
          }
          function g(t) {
            let n = e.el;
            'container' !== e.params.mousewheel.eventsTarget &&
              (n = document.querySelector(e.params.mousewheel.eventsTarget)),
              n[t]('mouseenter', p),
              n[t]('mouseleave', f),
              n[t]('wheel', m);
          }
          function v() {
            return e.params.cssMode
              ? (e.wrapperEl.removeEventListener('wheel', m), !0)
              : !e.mousewheel.enabled &&
                  (g('addEventListener'), (e.mousewheel.enabled = !0), !0);
          }
          function y() {
            return e.params.cssMode
              ? (e.wrapperEl.addEventListener(event, m), !0)
              : !!e.mousewheel.enabled &&
                  (g('removeEventListener'), (e.mousewheel.enabled = !1), !0);
          }
          n('init', () => {
            !e.params.mousewheel.enabled && e.params.cssMode && y(),
              e.params.mousewheel.enabled && v();
          }),
            n('destroy', () => {
              e.params.cssMode && v(), e.mousewheel.enabled && y();
            }),
            Object.assign(e.mousewheel, { enable: v, disable: y });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          t({
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: 'swiper-button-disabled',
              hiddenClass: 'swiper-button-hidden',
              lockClass: 'swiper-button-lock',
              navigationDisabledClass: 'swiper-navigation-disabled',
            },
          }),
            (e.navigation = { nextEl: null, prevEl: null });
          const i = (e) => (
            Array.isArray(e) || (e = [e].filter((e) => !!e)), e
          );
          function s(t) {
            let n;
            return t &&
              'string' == typeof t &&
              e.isElement &&
              ((n = e.el.shadowRoot.querySelector(t)), n)
              ? n
              : (t &&
                  ('string' == typeof t &&
                    (n = [...document.querySelectorAll(t)]),
                  e.params.uniqueNavElements &&
                    'string' == typeof t &&
                    n.length > 1 &&
                    1 === e.el.querySelectorAll(t).length &&
                    (n = e.el.querySelector(t))),
                t && !n ? t : n);
          }
          function a(t, n) {
            const r = e.params.navigation;
            (t = i(t)).forEach((t) => {
              t &&
                (t.classList[n ? 'add' : 'remove'](
                  ...r.disabledClass.split(' ')
                ),
                'BUTTON' === t.tagName && (t.disabled = n),
                e.params.watchOverflow &&
                  e.enabled &&
                  t.classList[e.isLocked ? 'add' : 'remove'](r.lockClass));
            });
          }
          function o() {
            const { nextEl: t, prevEl: n } = e.navigation;
            if (e.params.loop) return a(n, !1), void a(t, !1);
            a(n, e.isBeginning && !e.params.rewind),
              a(t, e.isEnd && !e.params.rewind);
          }
          function l(t) {
            t.preventDefault(),
              (!e.isBeginning || e.params.loop || e.params.rewind) &&
                (e.slidePrev(), r('navigationPrev'));
          }
          function c(t) {
            t.preventDefault(),
              (!e.isEnd || e.params.loop || e.params.rewind) &&
                (e.slideNext(), r('navigationNext'));
          }
          function u() {
            const t = e.params.navigation;
            if (
              ((e.params.navigation = ee(
                e,
                e.originalParams.navigation,
                e.params.navigation,
                { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
              )),
              !t.nextEl && !t.prevEl)
            )
              return;
            let n = s(t.nextEl),
              r = s(t.prevEl);
            Object.assign(e.navigation, { nextEl: n, prevEl: r }),
              (n = i(n)),
              (r = i(r));
            const a = (n, r) => {
              n && n.addEventListener('click', 'next' === r ? c : l),
                !e.enabled && n && n.classList.add(...t.lockClass.split(' '));
            };
            n.forEach((e) => a(e, 'next')), r.forEach((e) => a(e, 'prev'));
          }
          function d() {
            let { nextEl: t, prevEl: n } = e.navigation;
            (t = i(t)), (n = i(n));
            const r = (t, n) => {
              t.removeEventListener('click', 'next' === n ? c : l),
                t.classList.remove(
                  ...e.params.navigation.disabledClass.split(' ')
                );
            };
            t.forEach((e) => r(e, 'next')), n.forEach((e) => r(e, 'prev'));
          }
          n('init', () => {
            !1 === e.params.navigation.enabled ? p() : (u(), o());
          }),
            n('toEdge fromEdge lock unlock', () => {
              o();
            }),
            n('destroy', () => {
              d();
            }),
            n('enable disable', () => {
              let { nextEl: t, prevEl: n } = e.navigation;
              (t = i(t)),
                (n = i(n)),
                [...t, ...n]
                  .filter((e) => !!e)
                  .forEach((t) =>
                    t.classList[e.enabled ? 'remove' : 'add'](
                      e.params.navigation.lockClass
                    )
                  );
            }),
            n('click', (t, n) => {
              let { nextEl: s, prevEl: a } = e.navigation;
              (s = i(s)), (a = i(a));
              const o = n.target;
              if (
                e.params.navigation.hideOnClick &&
                !a.includes(o) &&
                !s.includes(o)
              ) {
                if (
                  e.pagination &&
                  e.params.pagination &&
                  e.params.pagination.clickable &&
                  (e.pagination.el === o || e.pagination.el.contains(o))
                )
                  return;
                let t;
                s.length
                  ? (t = s[0].classList.contains(
                      e.params.navigation.hiddenClass
                    ))
                  : a.length &&
                    (t = a[0].classList.contains(
                      e.params.navigation.hiddenClass
                    )),
                  r(!0 === t ? 'navigationShow' : 'navigationHide'),
                  [...s, ...a]
                    .filter((e) => !!e)
                    .forEach((t) =>
                      t.classList.toggle(e.params.navigation.hiddenClass)
                    );
              }
            });
          const p = () => {
            e.el.classList.add(
              ...e.params.navigation.navigationDisabledClass.split(' ')
            ),
              d();
          };
          Object.assign(e.navigation, {
            enable: () => {
              e.el.classList.remove(
                ...e.params.navigation.navigationDisabledClass.split(' ')
              ),
                u(),
                o();
            },
            disable: p,
            update: o,
            init: u,
            destroy: d,
          });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = 'swiper-pagination';
          let s;
          t({
            pagination: {
              el: null,
              bulletElement: 'span',
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: 'bullets',
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: (e) => e,
              formatFractionTotal: (e) => e,
              bulletClass: `${i}-bullet`,
              bulletActiveClass: `${i}-bullet-active`,
              modifierClass: `${i}-`,
              currentClass: `${i}-current`,
              totalClass: `${i}-total`,
              hiddenClass: `${i}-hidden`,
              progressbarFillClass: `${i}-progressbar-fill`,
              progressbarOppositeClass: `${i}-progressbar-opposite`,
              clickableClass: `${i}-clickable`,
              lockClass: `${i}-lock`,
              horizontalClass: `${i}-horizontal`,
              verticalClass: `${i}-vertical`,
              paginationDisabledClass: `${i}-disabled`,
            },
          }),
            (e.pagination = { el: null, bullets: [] });
          let a = 0;
          const o = (e) => (
            Array.isArray(e) || (e = [e].filter((e) => !!e)), e
          );
          function l() {
            return (
              !e.params.pagination.el ||
              !e.pagination.el ||
              (Array.isArray(e.pagination.el) && 0 === e.pagination.el.length)
            );
          }
          function c(t, n) {
            const { bulletActiveClass: r } = e.params.pagination;
            t &&
              (t =
                t[('prev' === n ? 'previous' : 'next') + 'ElementSibling']) &&
              (t.classList.add(`${r}-${n}`),
              (t =
                t[('prev' === n ? 'previous' : 'next') + 'ElementSibling']) &&
                t.classList.add(`${r}-${n}-${n}`));
          }
          function u(t) {
            const n = t.target.closest(te(e.params.pagination.bulletClass));
            if (!n) return;
            t.preventDefault();
            const r = x(n) * e.params.slidesPerGroup;
            if (e.params.loop) {
              if (e.realIndex === r) return;
              const t = e.getSlideIndexByData(r),
                n = e.getSlideIndexByData(e.realIndex);
              t > e.slides.length - e.loopedSlides &&
                e.loopFix({
                  direction: t > n ? 'next' : 'prev',
                  activeSlideIndex: t,
                  slideTo: !1,
                }),
                e.slideToLoop(r);
            } else e.slideTo(r);
          }
          function d() {
            const t = e.rtl,
              n = e.params.pagination;
            if (l()) return;
            let i,
              u,
              d = e.pagination.el;
            d = o(d);
            const p =
                e.virtual && e.params.virtual.enabled
                  ? e.virtual.slides.length
                  : e.slides.length,
              f = e.params.loop
                ? Math.ceil(p / e.params.slidesPerGroup)
                : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((u = e.previousRealIndex || 0),
                  (i =
                    e.params.slidesPerGroup > 1
                      ? Math.floor(e.realIndex / e.params.slidesPerGroup)
                      : e.realIndex))
                : void 0 !== e.snapIndex
                ? ((i = e.snapIndex), (u = e.previousSnapIndex))
                : ((u = e.previousIndex || 0), (i = e.activeIndex || 0)),
              'bullets' === n.type &&
                e.pagination.bullets &&
                e.pagination.bullets.length > 0)
            ) {
              const r = e.pagination.bullets;
              let o, l, p;
              if (
                (n.dynamicBullets &&
                  ((s = _(r[0], e.isHorizontal() ? 'width' : 'height', !0)),
                  d.forEach((t) => {
                    t.style[e.isHorizontal() ? 'width' : 'height'] =
                      s * (n.dynamicMainBullets + 4) + 'px';
                  }),
                  n.dynamicMainBullets > 1 &&
                    void 0 !== u &&
                    ((a += i - (u || 0)),
                    a > n.dynamicMainBullets - 1
                      ? (a = n.dynamicMainBullets - 1)
                      : a < 0 && (a = 0)),
                  (o = Math.max(i - a, 0)),
                  (l = o + (Math.min(r.length, n.dynamicMainBullets) - 1)),
                  (p = (l + o) / 2)),
                r.forEach((e) => {
                  const t = [
                    ...[
                      '',
                      '-next',
                      '-next-next',
                      '-prev',
                      '-prev-prev',
                      '-main',
                    ].map((e) => `${n.bulletActiveClass}${e}`),
                  ]
                    .map((e) =>
                      'string' == typeof e && e.includes(' ') ? e.split(' ') : e
                    )
                    .flat();
                  e.classList.remove(...t);
                }),
                d.length > 1)
              )
                r.forEach((t) => {
                  const r = x(t);
                  r === i
                    ? t.classList.add(...n.bulletActiveClass.split(' '))
                    : e.isElement && t.setAttribute('part', 'bullet'),
                    n.dynamicBullets &&
                      (r >= o &&
                        r <= l &&
                        t.classList.add(
                          ...`${n.bulletActiveClass}-main`.split(' ')
                        ),
                      r === o && c(t, 'prev'),
                      r === l && c(t, 'next'));
                });
              else {
                const t = r[i];
                if (
                  (t && t.classList.add(...n.bulletActiveClass.split(' ')),
                  e.isElement &&
                    r.forEach((e, t) => {
                      e.setAttribute(
                        'part',
                        t === i ? 'bullet-active' : 'bullet'
                      );
                    }),
                  n.dynamicBullets)
                ) {
                  const e = r[o],
                    t = r[l];
                  for (let e = o; e <= l; e += 1)
                    r[e] &&
                      r[e].classList.add(
                        ...`${n.bulletActiveClass}-main`.split(' ')
                      );
                  c(e, 'prev'), c(t, 'next');
                }
              }
              if (n.dynamicBullets) {
                const i = Math.min(r.length, n.dynamicMainBullets + 4),
                  a = (s * i - s) / 2 - p * s,
                  o = t ? 'right' : 'left';
                r.forEach((t) => {
                  t.style[e.isHorizontal() ? o : 'top'] = `${a}px`;
                });
              }
            }
            d.forEach((t, s) => {
              if (
                ('fraction' === n.type &&
                  (t.querySelectorAll(te(n.currentClass)).forEach((e) => {
                    e.textContent = n.formatFractionCurrent(i + 1);
                  }),
                  t.querySelectorAll(te(n.totalClass)).forEach((e) => {
                    e.textContent = n.formatFractionTotal(f);
                  })),
                'progressbar' === n.type)
              ) {
                let r;
                r = n.progressbarOpposite
                  ? e.isHorizontal()
                    ? 'vertical'
                    : 'horizontal'
                  : e.isHorizontal()
                  ? 'horizontal'
                  : 'vertical';
                const s = (i + 1) / f;
                let a = 1,
                  o = 1;
                'horizontal' === r ? (a = s) : (o = s),
                  t
                    .querySelectorAll(te(n.progressbarFillClass))
                    .forEach((t) => {
                      (t.style.transform = `translate3d(0,0,0) scaleX(${a}) scaleY(${o})`),
                        (t.style.transitionDuration = `${e.params.speed}ms`);
                    });
              }
              'custom' === n.type && n.renderCustom
                ? ((t.innerHTML = n.renderCustom(e, i + 1, f)),
                  0 === s && r('paginationRender', t))
                : (0 === s && r('paginationRender', t),
                  r('paginationUpdate', t)),
                e.params.watchOverflow &&
                  e.enabled &&
                  t.classList[e.isLocked ? 'add' : 'remove'](n.lockClass);
            });
          }
          function p() {
            const t = e.params.pagination;
            if (l()) return;
            const n =
              e.virtual && e.params.virtual.enabled
                ? e.virtual.slides.length
                : e.slides.length;
            let i = e.pagination.el;
            i = o(i);
            let s = '';
            if ('bullets' === t.type) {
              let r = e.params.loop
                ? Math.ceil(n / e.params.slidesPerGroup)
                : e.snapGrid.length;
              e.params.freeMode &&
                e.params.freeMode.enabled &&
                r > n &&
                (r = n);
              for (let n = 0; n < r; n += 1)
                t.renderBullet
                  ? (s += t.renderBullet.call(e, n, t.bulletClass))
                  : (s += `<${t.bulletElement} ${
                      e.isElement ? 'part="bullet"' : ''
                    } class="${t.bulletClass}"></${t.bulletElement}>`);
            }
            'fraction' === t.type &&
              (s = t.renderFraction
                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
              'progressbar' === t.type &&
                (s = t.renderProgressbar
                  ? t.renderProgressbar.call(e, t.progressbarFillClass)
                  : `<span class="${t.progressbarFillClass}"></span>`),
              (e.pagination.bullets = []),
              i.forEach((n) => {
                'custom' !== t.type && (n.innerHTML = s || ''),
                  'bullets' === t.type &&
                    e.pagination.bullets.push(
                      ...n.querySelectorAll(te(t.bulletClass))
                    );
              }),
              'custom' !== t.type && r('paginationRender', i[0]);
          }
          function f() {
            e.params.pagination = ee(
              e,
              e.originalParams.pagination,
              e.params.pagination,
              { el: 'swiper-pagination' }
            );
            const t = e.params.pagination;
            if (!t.el) return;
            let n;
            'string' == typeof t.el &&
              e.isElement &&
              (n = e.el.shadowRoot.querySelector(t.el)),
              n ||
                'string' != typeof t.el ||
                (n = [...document.querySelectorAll(t.el)]),
              n || (n = t.el),
              n &&
                0 !== n.length &&
                (e.params.uniqueNavElements &&
                  'string' == typeof t.el &&
                  Array.isArray(n) &&
                  n.length > 1 &&
                  ((n = [...e.el.querySelectorAll(t.el)]),
                  n.length > 1 &&
                    (n = n.filter((t) => T(t, '.swiper')[0] === e.el)[0])),
                Array.isArray(n) && 1 === n.length && (n = n[0]),
                Object.assign(e.pagination, { el: n }),
                (n = o(n)),
                n.forEach((n) => {
                  'bullets' === t.type &&
                    t.clickable &&
                    n.classList.add(t.clickableClass),
                    n.classList.add(t.modifierClass + t.type),
                    n.classList.add(
                      e.isHorizontal() ? t.horizontalClass : t.verticalClass
                    ),
                    'bullets' === t.type &&
                      t.dynamicBullets &&
                      (n.classList.add(`${t.modifierClass}${t.type}-dynamic`),
                      (a = 0),
                      t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                    'progressbar' === t.type &&
                      t.progressbarOpposite &&
                      n.classList.add(t.progressbarOppositeClass),
                    t.clickable && n.addEventListener('click', u),
                    e.enabled || n.classList.add(t.lockClass);
                }));
          }
          function h() {
            const t = e.params.pagination;
            if (l()) return;
            let n = e.pagination.el;
            n &&
              ((n = o(n)),
              n.forEach((n) => {
                n.classList.remove(t.hiddenClass),
                  n.classList.remove(t.modifierClass + t.type),
                  n.classList.remove(
                    e.isHorizontal() ? t.horizontalClass : t.verticalClass
                  ),
                  t.clickable && n.removeEventListener('click', u);
              })),
              e.pagination.bullets &&
                e.pagination.bullets.forEach((e) =>
                  e.classList.remove(...t.bulletActiveClass.split(' '))
                );
          }
          n('changeDirection', () => {
            if (!e.pagination || !e.pagination.el) return;
            const t = e.params.pagination;
            let { el: n } = e.pagination;
            (n = o(n)),
              n.forEach((n) => {
                n.classList.remove(t.horizontalClass, t.verticalClass),
                  n.classList.add(
                    e.isHorizontal() ? t.horizontalClass : t.verticalClass
                  );
              });
          }),
            n('init', () => {
              !1 === e.params.pagination.enabled ? m() : (f(), p(), d());
            }),
            n('activeIndexChange', () => {
              void 0 === e.snapIndex && d();
            }),
            n('snapIndexChange', () => {
              d();
            }),
            n('snapGridLengthChange', () => {
              p(), d();
            }),
            n('destroy', () => {
              h();
            }),
            n('enable disable', () => {
              let { el: t } = e.pagination;
              t &&
                ((t = o(t)),
                t.forEach((t) =>
                  t.classList[e.enabled ? 'remove' : 'add'](
                    e.params.pagination.lockClass
                  )
                ));
            }),
            n('lock unlock', () => {
              d();
            }),
            n('click', (t, n) => {
              const i = n.target;
              let { el: s } = e.pagination;
              if (
                (Array.isArray(s) || (s = [s].filter((e) => !!e)),
                e.params.pagination.el &&
                  e.params.pagination.hideOnClick &&
                  s &&
                  s.length > 0 &&
                  !i.classList.contains(e.params.pagination.bulletClass))
              ) {
                if (
                  e.navigation &&
                  ((e.navigation.nextEl && i === e.navigation.nextEl) ||
                    (e.navigation.prevEl && i === e.navigation.prevEl))
                )
                  return;
                const t = s[0].classList.contains(
                  e.params.pagination.hiddenClass
                );
                r(!0 === t ? 'paginationShow' : 'paginationHide'),
                  s.forEach((t) =>
                    t.classList.toggle(e.params.pagination.hiddenClass)
                  );
              }
            });
          const m = () => {
            e.el.classList.add(e.params.pagination.paginationDisabledClass);
            let { el: t } = e.pagination;
            t &&
              ((t = o(t)),
              t.forEach((t) =>
                t.classList.add(e.params.pagination.paginationDisabledClass)
              )),
              h();
          };
          Object.assign(e.pagination, {
            enable: () => {
              e.el.classList.remove(
                e.params.pagination.paginationDisabledClass
              );
              let { el: t } = e.pagination;
              t &&
                ((t = o(t)),
                t.forEach((t) =>
                  t.classList.remove(
                    e.params.pagination.paginationDisabledClass
                  )
                )),
                f(),
                p(),
                d();
            },
            disable: m,
            render: p,
            update: d,
            init: f,
            destroy: h,
          });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = a();
          let s,
            o,
            l,
            u,
            d = !1,
            p = null,
            f = null;
          function h() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t, rtlTranslate: n } = e,
              { dragEl: r, el: i } = t,
              s = e.params.scrollbar,
              a = e.params.loop ? e.progressLoop : e.progress;
            let c = o,
              u = (l - o) * a;
            n
              ? ((u = -u),
                u > 0 ? ((c = o - u), (u = 0)) : -u + o > l && (c = l + u))
              : u < 0
              ? ((c = o + u), (u = 0))
              : u + o > l && (c = l - u),
              e.isHorizontal()
                ? ((r.style.transform = `translate3d(${u}px, 0, 0)`),
                  (r.style.width = `${c}px`))
                : ((r.style.transform = `translate3d(0px, ${u}px, 0)`),
                  (r.style.height = `${c}px`)),
              s.hide &&
                (clearTimeout(p),
                (i.style.opacity = 1),
                (p = setTimeout(() => {
                  (i.style.opacity = 0), (i.style.transitionDuration = '400ms');
                }, 1e3)));
          }
          function m() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t } = e,
              { dragEl: n, el: r } = t;
            (n.style.width = ''),
              (n.style.height = ''),
              (l = e.isHorizontal() ? r.offsetWidth : r.offsetHeight),
              (u =
                e.size /
                (e.virtualSize +
                  e.params.slidesOffsetBefore -
                  (e.params.centeredSlides ? e.snapGrid[0] : 0))),
              (o =
                'auto' === e.params.scrollbar.dragSize
                  ? l * u
                  : parseInt(e.params.scrollbar.dragSize, 10)),
              e.isHorizontal()
                ? (n.style.width = `${o}px`)
                : (n.style.height = `${o}px`),
              (r.style.display = u >= 1 ? 'none' : ''),
              e.params.scrollbar.hide && (r.style.opacity = 0),
              e.params.watchOverflow &&
                e.enabled &&
                t.el.classList[e.isLocked ? 'add' : 'remove'](
                  e.params.scrollbar.lockClass
                );
          }
          function g(t) {
            return e.isHorizontal() ? t.clientX : t.clientY;
          }
          function v(t) {
            const { scrollbar: n, rtlTranslate: r } = e,
              { el: i } = n;
            let a;
            (a =
              (g(t) -
                b(i)[e.isHorizontal() ? 'left' : 'top'] -
                (null !== s ? s : o / 2)) /
              (l - o)),
              (a = Math.max(Math.min(a, 1), 0)),
              r && (a = 1 - a);
            const c =
              e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * a;
            e.updateProgress(c),
              e.setTranslate(c),
              e.updateActiveIndex(),
              e.updateSlidesClasses();
          }
          function w(t) {
            const n = e.params.scrollbar,
              { scrollbar: i, wrapperEl: a } = e,
              { el: o, dragEl: l } = i;
            (d = !0),
              (s =
                t.target === l
                  ? g(t) -
                    t.target.getBoundingClientRect()[
                      e.isHorizontal() ? 'left' : 'top'
                    ]
                  : null),
              t.preventDefault(),
              t.stopPropagation(),
              (a.style.transitionDuration = '100ms'),
              (l.style.transitionDuration = '100ms'),
              v(t),
              clearTimeout(f),
              (o.style.transitionDuration = '0ms'),
              n.hide && (o.style.opacity = 1),
              e.params.cssMode &&
                (e.wrapperEl.style['scroll-snap-type'] = 'none'),
              r('scrollbarDragStart', t);
          }
          function x(t) {
            const { scrollbar: n, wrapperEl: i } = e,
              { el: s, dragEl: a } = n;
            d &&
              (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
              v(t),
              (i.style.transitionDuration = '0ms'),
              (s.style.transitionDuration = '0ms'),
              (a.style.transitionDuration = '0ms'),
              r('scrollbarDragMove', t));
          }
          function T(t) {
            const n = e.params.scrollbar,
              { scrollbar: i, wrapperEl: s } = e,
              { el: a } = i;
            d &&
              ((d = !1),
              e.params.cssMode &&
                ((e.wrapperEl.style['scroll-snap-type'] = ''),
                (s.style.transitionDuration = '')),
              n.hide &&
                (clearTimeout(f),
                (f = c(() => {
                  (a.style.opacity = 0), (a.style.transitionDuration = '400ms');
                }, 1e3))),
              r('scrollbarDragEnd', t),
              n.snapOnRelease && e.slideToClosest());
          }
          function E(t) {
            const { scrollbar: n, params: r } = e,
              s = n.el;
            if (!s) return;
            const a = s,
              o = !!r.passiveListeners && { passive: !1, capture: !1 },
              l = !!r.passiveListeners && { passive: !0, capture: !1 };
            if (!a) return;
            const c = 'on' === t ? 'addEventListener' : 'removeEventListener';
            a[c]('pointerdown', w, o),
              i[c]('pointermove', x, o),
              i[c]('pointerup', T, l);
          }
          function _() {
            const { scrollbar: t, el: n } = e;
            e.params.scrollbar = ee(
              e,
              e.originalParams.scrollbar,
              e.params.scrollbar,
              { el: 'swiper-scrollbar' }
            );
            const r = e.params.scrollbar;
            if (!r.el) return;
            let s, a;
            'string' == typeof r.el &&
              e.isElement &&
              (s = e.el.shadowRoot.querySelector(r.el)),
              s || 'string' != typeof r.el
                ? s || (s = r.el)
                : (s = i.querySelectorAll(r.el)),
              e.params.uniqueNavElements &&
                'string' == typeof r.el &&
                s.length > 1 &&
                1 === n.querySelectorAll(r.el).length &&
                (s = n.querySelector(r.el)),
              s.length > 0 && (s = s[0]),
              s.classList.add(
                e.isHorizontal() ? r.horizontalClass : r.verticalClass
              ),
              s &&
                ((a = s.querySelector(`.${e.params.scrollbar.dragClass}`)),
                a ||
                  ((a = y('div', e.params.scrollbar.dragClass)), s.append(a))),
              Object.assign(t, { el: s, dragEl: a }),
              r.draggable && e.params.scrollbar.el && e.scrollbar.el && E('on'),
              s &&
                s.classList[e.enabled ? 'remove' : 'add'](
                  e.params.scrollbar.lockClass
                );
          }
          function S() {
            const t = e.params.scrollbar,
              n = e.scrollbar.el;
            n &&
              n.classList.remove(
                e.isHorizontal() ? t.horizontalClass : t.verticalClass
              ),
              e.params.scrollbar.el && e.scrollbar.el && E('off');
          }
          t({
            scrollbar: {
              el: null,
              dragSize: 'auto',
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: 'swiper-scrollbar-lock',
              dragClass: 'swiper-scrollbar-drag',
              scrollbarDisabledClass: 'swiper-scrollbar-disabled',
              horizontalClass: 'swiper-scrollbar-horizontal',
              verticalClass: 'swiper-scrollbar-vertical',
            },
          }),
            (e.scrollbar = { el: null, dragEl: null }),
            n('init', () => {
              !1 === e.params.scrollbar.enabled ? C() : (_(), m(), h());
            }),
            n('update resize observerUpdate lock unlock', () => {
              m();
            }),
            n('setTranslate', () => {
              h();
            }),
            n('setTransition', (t, n) => {
              !(function (t) {
                e.params.scrollbar.el &&
                  e.scrollbar.el &&
                  (e.scrollbar.dragEl.style.transitionDuration = `${t}ms`);
              })(n);
            }),
            n('enable disable', () => {
              const { el: t } = e.scrollbar;
              t &&
                t.classList[e.enabled ? 'remove' : 'add'](
                  e.params.scrollbar.lockClass
                );
            }),
            n('destroy', () => {
              S();
            });
          const C = () => {
            e.el.classList.add(e.params.scrollbar.scrollbarDisabledClass),
              e.scrollbar.el &&
                e.scrollbar.el.classList.add(
                  e.params.scrollbar.scrollbarDisabledClass
                ),
              S();
          };
          Object.assign(e.scrollbar, {
            enable: () => {
              e.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass),
                e.scrollbar.el &&
                  e.scrollbar.el.classList.remove(
                    e.params.scrollbar.scrollbarDisabledClass
                  ),
                _(),
                m(),
                h();
            },
            disable: C,
            updateSize: m,
            setTranslate: h,
            init: _,
            destroy: S,
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ parallax: { enabled: !1 } });
          const r = (t, n) => {
              const { rtl: r } = e,
                i = r ? -1 : 1,
                s = t.getAttribute('data-swiper-parallax') || '0';
              let a = t.getAttribute('data-swiper-parallax-x'),
                o = t.getAttribute('data-swiper-parallax-y');
              const l = t.getAttribute('data-swiper-parallax-scale'),
                c = t.getAttribute('data-swiper-parallax-opacity'),
                u = t.getAttribute('data-swiper-parallax-rotate');
              if (
                (a || o
                  ? ((a = a || '0'), (o = o || '0'))
                  : e.isHorizontal()
                  ? ((a = s), (o = '0'))
                  : ((o = s), (a = '0')),
                (a =
                  a.indexOf('%') >= 0
                    ? parseInt(a, 10) * n * i + '%'
                    : a * n * i + 'px'),
                (o =
                  o.indexOf('%') >= 0
                    ? parseInt(o, 10) * n + '%'
                    : o * n + 'px'),
                null != c)
              ) {
                const e = c - (c - 1) * (1 - Math.abs(n));
                t.style.opacity = e;
              }
              let d = `translate3d(${a}, ${o}, 0px)`;
              null != l && (d += ` scale(${l - (l - 1) * (1 - Math.abs(n))})`),
                u && null != u && (d += ` rotate(${u * n * -1}deg)`),
                (t.style.transform = d);
            },
            i = () => {
              const { el: t, slides: n, progress: i, snapGrid: s } = e;
              v(
                t,
                '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
              ).forEach((e) => {
                r(e, i);
              }),
                n.forEach((t, n) => {
                  let a = t.progress;
                  e.params.slidesPerGroup > 1 &&
                    'auto' !== e.params.slidesPerView &&
                    (a += Math.ceil(n / 2) - i * (s.length - 1)),
                    (a = Math.min(Math.max(a, -1), 1)),
                    t
                      .querySelectorAll(
                        '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]'
                      )
                      .forEach((e) => {
                        r(e, a);
                      });
                });
            };
          n('beforeInit', () => {
            e.params.parallax.enabled &&
              ((e.params.watchSlidesProgress = !0),
              (e.originalParams.watchSlidesProgress = !0));
          }),
            n('init', () => {
              e.params.parallax.enabled && i();
            }),
            n('setTranslate', () => {
              e.params.parallax.enabled && i();
            }),
            n('setTransition', (t, n) => {
              e.params.parallax.enabled &&
                ((t = e.params.speed) => {
                  const { el: n } = e;
                  n.querySelectorAll(
                    '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
                  ).forEach((e) => {
                    let n =
                      parseInt(
                        e.getAttribute('data-swiper-parallax-duration'),
                        10
                      ) || t;
                    0 === t && (n = 0), (e.style.transitionDuration = `${n}ms`);
                  });
                })(n);
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = l();
          t({
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: 'swiper-zoom-container',
              zoomedSlideClass: 'swiper-slide-zoomed',
            },
          }),
            (e.zoom = { enabled: !1 });
          let s,
            a,
            o = 1,
            c = !1;
          const u = [],
            p = {
              originX: 0,
              originY: 0,
              slideEl: void 0,
              slideWidth: void 0,
              slideHeight: void 0,
              imageEl: void 0,
              imageWrapEl: void 0,
              maxRatio: 3,
            },
            f = {
              isTouched: void 0,
              isMoved: void 0,
              currentX: void 0,
              currentY: void 0,
              minX: void 0,
              minY: void 0,
              maxX: void 0,
              maxY: void 0,
              width: void 0,
              height: void 0,
              startX: void 0,
              startY: void 0,
              touchesStart: {},
              touchesCurrent: {},
            },
            h = {
              x: void 0,
              y: void 0,
              prevPositionX: void 0,
              prevPositionY: void 0,
              prevTime: void 0,
            };
          let m = 1;
          function g() {
            if (u.length < 2) return 1;
            const e = u[0].pageX,
              t = u[0].pageY,
              n = u[1].pageX,
              r = u[1].pageY;
            return Math.sqrt((n - e) ** 2 + (r - t) ** 2);
          }
          function y(t) {
            const n = e.isElement ? 'swiper-slide' : `.${e.params.slideClass}`;
            return (
              !!t.target.matches(n) ||
              e.slides.filter((e) => e.contains(t.target)).length > 0
            );
          }
          function w(t) {
            if (('mouse' === t.pointerType && u.splice(0, u.length), !y(t)))
              return;
            const n = e.params.zoom;
            if (((s = !1), (a = !1), u.push(t), !(u.length < 2))) {
              if (((s = !0), (p.scaleStart = g()), !p.slideEl)) {
                (p.slideEl = t.target.closest(
                  `.${e.params.slideClass}, swiper-slide`
                )),
                  p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
                let r = p.slideEl.querySelector(`.${n.containerClass}`);
                if (
                  (r &&
                    (r = r.querySelectorAll(
                      'picture, img, svg, canvas, .swiper-zoom-target'
                    )[0]),
                  (p.imageEl = r),
                  (p.imageWrapEl = r
                    ? T(p.imageEl, `.${n.containerClass}`)[0]
                    : void 0),
                  !p.imageWrapEl)
                )
                  return void (p.imageEl = void 0);
                p.maxRatio =
                  p.imageWrapEl.getAttribute('data-swiper-zoom') || n.maxRatio;
              }
              if (p.imageEl) {
                const [e, t] = (function () {
                  if (u.length < 2) return { x: null, y: null };
                  const e = p.imageEl.getBoundingClientRect();
                  return [
                    (u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - e.x) / o,
                    (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - e.y) / o,
                  ];
                })();
                (p.originX = e),
                  (p.originY = t),
                  (p.imageEl.style.transitionDuration = '0ms');
              }
              c = !0;
            }
          }
          function x(t) {
            if (!y(t)) return;
            const n = e.params.zoom,
              r = e.zoom,
              i = u.findIndex((e) => e.pointerId === t.pointerId);
            i >= 0 && (u[i] = t),
              u.length < 2 ||
                ((a = !0),
                (p.scaleMove = g()),
                p.imageEl &&
                  ((r.scale = (p.scaleMove / p.scaleStart) * o),
                  r.scale > p.maxRatio &&
                    (r.scale =
                      p.maxRatio - 1 + (r.scale - p.maxRatio + 1) ** 0.5),
                  r.scale < n.minRatio &&
                    (r.scale =
                      n.minRatio + 1 - (n.minRatio - r.scale + 1) ** 0.5),
                  (p.imageEl.style.transform = `translate3d(0,0,0) scale(${r.scale})`)));
          }
          function E(t) {
            if (!y(t)) return;
            if ('mouse' === t.pointerType && 'pointerout' === t.type) return;
            const n = e.params.zoom,
              r = e.zoom,
              i = u.findIndex((e) => e.pointerId === t.pointerId);
            i >= 0 && u.splice(i, 1),
              s &&
                a &&
                ((s = !1),
                (a = !1),
                p.imageEl &&
                  ((r.scale = Math.max(
                    Math.min(r.scale, p.maxRatio),
                    n.minRatio
                  )),
                  (p.imageEl.style.transitionDuration = `${e.params.speed}ms`),
                  (p.imageEl.style.transform = `translate3d(0,0,0) scale(${r.scale})`),
                  (o = r.scale),
                  (c = !1),
                  r.scale > 1 && p.slideEl
                    ? p.slideEl.classList.add(`${n.zoomedSlideClass}`)
                    : r.scale <= 1 &&
                      p.slideEl &&
                      p.slideEl.classList.remove(`${n.zoomedSlideClass}`),
                  1 === r.scale &&
                    ((p.originX = 0), (p.originY = 0), (p.slideEl = void 0))));
          }
          function _(t) {
            if (
              !y(t) ||
              !(function (t) {
                const n = `.${e.params.zoom.containerClass}`;
                return (
                  !!t.target.matches(n) ||
                  [...e.el.querySelectorAll(n)].filter((e) =>
                    e.contains(t.target)
                  ).length > 0
                );
              })(t)
            )
              return;
            const n = e.zoom;
            if (!p.imageEl) return;
            if (!f.isTouched || !p.slideEl) return;
            f.isMoved ||
              ((f.width = p.imageEl.offsetWidth),
              (f.height = p.imageEl.offsetHeight),
              (f.startX = d(p.imageWrapEl, 'x') || 0),
              (f.startY = d(p.imageWrapEl, 'y') || 0),
              (p.slideWidth = p.slideEl.offsetWidth),
              (p.slideHeight = p.slideEl.offsetHeight),
              (p.imageWrapEl.style.transitionDuration = '0ms'));
            const r = f.width * n.scale,
              i = f.height * n.scale;
            if (r < p.slideWidth && i < p.slideHeight) return;
            if (
              ((f.minX = Math.min(p.slideWidth / 2 - r / 2, 0)),
              (f.maxX = -f.minX),
              (f.minY = Math.min(p.slideHeight / 2 - i / 2, 0)),
              (f.maxY = -f.minY),
              (f.touchesCurrent.x = u.length > 0 ? u[0].pageX : t.pageX),
              (f.touchesCurrent.y = u.length > 0 ? u[0].pageY : t.pageY),
              Math.max(
                Math.abs(f.touchesCurrent.x - f.touchesStart.x),
                Math.abs(f.touchesCurrent.y - f.touchesStart.y)
              ) > 5 && (e.allowClick = !1),
              !f.isMoved && !c)
            ) {
              if (
                e.isHorizontal() &&
                ((Math.floor(f.minX) === Math.floor(f.startX) &&
                  f.touchesCurrent.x < f.touchesStart.x) ||
                  (Math.floor(f.maxX) === Math.floor(f.startX) &&
                    f.touchesCurrent.x > f.touchesStart.x))
              )
                return void (f.isTouched = !1);
              if (
                !e.isHorizontal() &&
                ((Math.floor(f.minY) === Math.floor(f.startY) &&
                  f.touchesCurrent.y < f.touchesStart.y) ||
                  (Math.floor(f.maxY) === Math.floor(f.startY) &&
                    f.touchesCurrent.y > f.touchesStart.y))
              )
                return void (f.isTouched = !1);
            }
            t.cancelable && t.preventDefault(),
              t.stopPropagation(),
              (f.isMoved = !0);
            const s = (n.scale - o) / (p.maxRatio - e.params.zoom.minRatio),
              { originX: a, originY: l } = p;
            (f.currentX =
              f.touchesCurrent.x -
              f.touchesStart.x +
              f.startX +
              s * (f.width - 2 * a)),
              (f.currentY =
                f.touchesCurrent.y -
                f.touchesStart.y +
                f.startY +
                s * (f.height - 2 * l)),
              f.currentX < f.minX &&
                (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8),
              f.currentX > f.maxX &&
                (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8),
              f.currentY < f.minY &&
                (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8),
              f.currentY > f.maxY &&
                (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8),
              h.prevPositionX || (h.prevPositionX = f.touchesCurrent.x),
              h.prevPositionY || (h.prevPositionY = f.touchesCurrent.y),
              h.prevTime || (h.prevTime = Date.now()),
              (h.x =
                (f.touchesCurrent.x - h.prevPositionX) /
                (Date.now() - h.prevTime) /
                2),
              (h.y =
                (f.touchesCurrent.y - h.prevPositionY) /
                (Date.now() - h.prevTime) /
                2),
              Math.abs(f.touchesCurrent.x - h.prevPositionX) < 2 && (h.x = 0),
              Math.abs(f.touchesCurrent.y - h.prevPositionY) < 2 && (h.y = 0),
              (h.prevPositionX = f.touchesCurrent.x),
              (h.prevPositionY = f.touchesCurrent.y),
              (h.prevTime = Date.now()),
              (p.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`);
          }
          function S() {
            const t = e.zoom;
            p.slideEl &&
              e.activeIndex !== e.slides.indexOf(p.slideEl) &&
              (p.imageEl &&
                (p.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
              p.imageWrapEl &&
                (p.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
              p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`),
              (t.scale = 1),
              (o = 1),
              (p.slideEl = void 0),
              (p.imageEl = void 0),
              (p.imageWrapEl = void 0),
              (p.originX = 0),
              (p.originY = 0));
          }
          function C(t) {
            const n = e.zoom,
              r = e.params.zoom;
            if (!p.slideEl) {
              t &&
                t.target &&
                (p.slideEl = t.target.closest(
                  `.${e.params.slideClass}, swiper-slide`
                )),
                p.slideEl ||
                  (e.params.virtual && e.params.virtual.enabled && e.virtual
                    ? (p.slideEl = v(
                        e.slidesEl,
                        `.${e.params.slideActiveClass}`
                      )[0])
                    : (p.slideEl = e.slides[e.activeIndex]));
              let n = p.slideEl.querySelector(`.${r.containerClass}`);
              n &&
                (n = n.querySelectorAll(
                  'picture, img, svg, canvas, .swiper-zoom-target'
                )[0]),
                (p.imageEl = n),
                (p.imageWrapEl = n
                  ? T(p.imageEl, `.${r.containerClass}`)[0]
                  : void 0);
            }
            if (!p.imageEl || !p.imageWrapEl) return;
            let s, a, l, c, u, d, h, m, g, y, w, x, E, _, S, C, M, k;
            e.params.cssMode &&
              ((e.wrapperEl.style.overflow = 'hidden'),
              (e.wrapperEl.style.touchAction = 'none')),
              p.slideEl.classList.add(`${r.zoomedSlideClass}`),
              void 0 === f.touchesStart.x && t
                ? ((s = t.pageX), (a = t.pageY))
                : ((s = f.touchesStart.x), (a = f.touchesStart.y));
            const A = 'number' == typeof t ? t : null;
            1 === o && A && ((s = void 0), (a = void 0)),
              (n.scale =
                A ||
                p.imageWrapEl.getAttribute('data-swiper-zoom') ||
                r.maxRatio),
              (o =
                A ||
                p.imageWrapEl.getAttribute('data-swiper-zoom') ||
                r.maxRatio),
              !t || (1 === o && A)
                ? ((h = 0), (m = 0))
                : ((M = p.slideEl.offsetWidth),
                  (k = p.slideEl.offsetHeight),
                  (l = b(p.slideEl).left + i.scrollX),
                  (c = b(p.slideEl).top + i.scrollY),
                  (u = l + M / 2 - s),
                  (d = c + k / 2 - a),
                  (g = p.imageEl.offsetWidth),
                  (y = p.imageEl.offsetHeight),
                  (w = g * n.scale),
                  (x = y * n.scale),
                  (E = Math.min(M / 2 - w / 2, 0)),
                  (_ = Math.min(k / 2 - x / 2, 0)),
                  (S = -E),
                  (C = -_),
                  (h = u * n.scale),
                  (m = d * n.scale),
                  h < E && (h = E),
                  h > S && (h = S),
                  m < _ && (m = _),
                  m > C && (m = C)),
              A && 1 === n.scale && ((p.originX = 0), (p.originY = 0)),
              (p.imageWrapEl.style.transitionDuration = '300ms'),
              (p.imageWrapEl.style.transform = `translate3d(${h}px, ${m}px,0)`),
              (p.imageEl.style.transitionDuration = '300ms'),
              (p.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`);
          }
          function M() {
            const t = e.zoom,
              n = e.params.zoom;
            if (!p.slideEl) {
              e.params.virtual && e.params.virtual.enabled && e.virtual
                ? (p.slideEl = v(
                    e.slidesEl,
                    `.${e.params.slideActiveClass}`
                  )[0])
                : (p.slideEl = e.slides[e.activeIndex]);
              let t = p.slideEl.querySelector(`.${n.containerClass}`);
              t &&
                (t = t.querySelectorAll(
                  'picture, img, svg, canvas, .swiper-zoom-target'
                )[0]),
                (p.imageEl = t),
                (p.imageWrapEl = t
                  ? T(p.imageEl, `.${n.containerClass}`)[0]
                  : void 0);
            }
            p.imageEl &&
              p.imageWrapEl &&
              (e.params.cssMode &&
                ((e.wrapperEl.style.overflow = ''),
                (e.wrapperEl.style.touchAction = '')),
              (t.scale = 1),
              (o = 1),
              (p.imageWrapEl.style.transitionDuration = '300ms'),
              (p.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
              (p.imageEl.style.transitionDuration = '300ms'),
              (p.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
              p.slideEl.classList.remove(`${n.zoomedSlideClass}`),
              (p.slideEl = void 0),
              (p.originX = 0),
              (p.originY = 0));
          }
          function k(t) {
            const n = e.zoom;
            n.scale && 1 !== n.scale ? M() : C(t);
          }
          function A() {
            return {
              passiveListener: !!e.params.passiveListeners && {
                passive: !0,
                capture: !1,
              },
              activeListenerWithCapture: !e.params.passiveListeners || {
                passive: !1,
                capture: !0,
              },
            };
          }
          function P() {
            const t = e.zoom;
            if (t.enabled) return;
            t.enabled = !0;
            const { passiveListener: n, activeListenerWithCapture: r } = A();
            e.wrapperEl.addEventListener('pointerdown', w, n),
              e.wrapperEl.addEventListener('pointermove', x, r),
              ['pointerup', 'pointercancel', 'pointerout'].forEach((t) => {
                e.wrapperEl.addEventListener(t, E, n);
              }),
              e.wrapperEl.addEventListener('pointermove', _, r);
          }
          function L() {
            const t = e.zoom;
            if (!t.enabled) return;
            t.enabled = !1;
            const { passiveListener: n, activeListenerWithCapture: r } = A();
            e.wrapperEl.removeEventListener('pointerdown', w, n),
              e.wrapperEl.removeEventListener('pointermove', x, r),
              ['pointerup', 'pointercancel', 'pointerout'].forEach((t) => {
                e.wrapperEl.removeEventListener(t, E, n);
              }),
              e.wrapperEl.removeEventListener('pointermove', _, r);
          }
          Object.defineProperty(e.zoom, 'scale', {
            get() {
              return m;
            },
            set(e) {
              if (m !== e) {
                const t = p.imageEl,
                  n = p.slideEl;
                r('zoomChange', e, t, n);
              }
              m = e;
            },
          }),
            n('init', () => {
              e.params.zoom.enabled && P();
            }),
            n('destroy', () => {
              L();
            }),
            n('touchStart', (t, n) => {
              e.zoom.enabled &&
                (function (t) {
                  const n = e.device;
                  if (!p.imageEl) return;
                  if (f.isTouched) return;
                  n.android && t.cancelable && t.preventDefault(),
                    (f.isTouched = !0);
                  const r = u.length > 0 ? u[0] : t;
                  (f.touchesStart.x = r.pageX), (f.touchesStart.y = r.pageY);
                })(n);
            }),
            n('touchEnd', (t, n) => {
              e.zoom.enabled &&
                (function () {
                  const t = e.zoom;
                  if (!p.imageEl) return;
                  if (!f.isTouched || !f.isMoved)
                    return (f.isTouched = !1), void (f.isMoved = !1);
                  (f.isTouched = !1), (f.isMoved = !1);
                  let n = 300,
                    r = 300;
                  const i = h.x * n,
                    s = f.currentX + i,
                    a = h.y * r,
                    o = f.currentY + a;
                  0 !== h.x && (n = Math.abs((s - f.currentX) / h.x)),
                    0 !== h.y && (r = Math.abs((o - f.currentY) / h.y));
                  const l = Math.max(n, r);
                  (f.currentX = s), (f.currentY = o);
                  const c = f.width * t.scale,
                    u = f.height * t.scale;
                  (f.minX = Math.min(p.slideWidth / 2 - c / 2, 0)),
                    (f.maxX = -f.minX),
                    (f.minY = Math.min(p.slideHeight / 2 - u / 2, 0)),
                    (f.maxY = -f.minY),
                    (f.currentX = Math.max(
                      Math.min(f.currentX, f.maxX),
                      f.minX
                    )),
                    (f.currentY = Math.max(
                      Math.min(f.currentY, f.maxY),
                      f.minY
                    )),
                    (p.imageWrapEl.style.transitionDuration = `${l}ms`),
                    (p.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`);
                })();
            }),
            n('doubleTap', (t, n) => {
              !e.animating &&
                e.params.zoom.enabled &&
                e.zoom.enabled &&
                e.params.zoom.toggle &&
                k(n);
            }),
            n('transitionEnd', () => {
              e.zoom.enabled && e.params.zoom.enabled && S();
            }),
            n('slideChange', () => {
              e.zoom.enabled &&
                e.params.zoom.enabled &&
                e.params.cssMode &&
                S();
            }),
            Object.assign(e.zoom, {
              enable: P,
              disable: L,
              in: C,
              out: M,
              toggle: k,
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          function r(e, t) {
            const n = (function () {
              let e, t, n;
              return (r, i) => {
                for (t = -1, e = r.length; e - t > 1; )
                  (n = (e + t) >> 1), r[n] <= i ? (t = n) : (e = n);
                return e;
              };
            })();
            let r, i;
            return (
              (this.x = e),
              (this.y = t),
              (this.lastIndex = e.length - 1),
              (this.interpolate = function (e) {
                return e
                  ? ((i = n(this.x, e)),
                    (r = i - 1),
                    ((e - this.x[r]) * (this.y[i] - this.y[r])) /
                      (this.x[i] - this.x[r]) +
                      this.y[r])
                  : 0;
              }),
              this
            );
          }
          function i() {
            e.controller.control &&
              e.controller.spline &&
              ((e.controller.spline = void 0), delete e.controller.spline);
          }
          t({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
            (e.controller = { control: void 0 }),
            n('beforeInit', () => {
              if (
                'undefined' != typeof window &&
                ('string' == typeof e.params.controller.control ||
                  e.params.controller.control instanceof HTMLElement)
              ) {
                const t = document.querySelector(e.params.controller.control);
                if (t && t.swiper) e.controller.control = t.swiper;
                else if (t) {
                  const n = (r) => {
                    (e.controller.control = r.detail[0]),
                      e.update(),
                      t.removeEventListener('init', n);
                  };
                  t.addEventListener('init', n);
                }
              } else e.controller.control = e.params.controller.control;
            }),
            n('update', () => {
              i();
            }),
            n('resize', () => {
              i();
            }),
            n('observerUpdate', () => {
              i();
            }),
            n('setTranslate', (t, n, r) => {
              e.controller.control &&
                !e.controller.control.destroyed &&
                e.controller.setTranslate(n, r);
            }),
            n('setTransition', (t, n, r) => {
              e.controller.control &&
                !e.controller.control.destroyed &&
                e.controller.setTransition(n, r);
            }),
            Object.assign(e.controller, {
              setTranslate: function (t, n) {
                const i = e.controller.control;
                let s, a;
                const o = e.constructor;
                function l(t) {
                  if (t.destroyed) return;
                  const n = e.rtlTranslate ? -e.translate : e.translate;
                  'slide' === e.params.controller.by &&
                    ((function (t) {
                      e.controller.spline = e.params.loop
                        ? new r(e.slidesGrid, t.slidesGrid)
                        : new r(e.snapGrid, t.snapGrid);
                    })(t),
                    (a = -e.controller.spline.interpolate(-n))),
                    (a && 'container' !== e.params.controller.by) ||
                      ((s =
                        (t.maxTranslate() - t.minTranslate()) /
                        (e.maxTranslate() - e.minTranslate())),
                      (!Number.isNaN(s) && Number.isFinite(s)) || (s = 1),
                      (a = (n - e.minTranslate()) * s + t.minTranslate())),
                    e.params.controller.inverse && (a = t.maxTranslate() - a),
                    t.updateProgress(a),
                    t.setTranslate(a, e),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses();
                }
                if (Array.isArray(i))
                  for (let e = 0; e < i.length; e += 1)
                    i[e] !== n && i[e] instanceof o && l(i[e]);
                else i instanceof o && n !== i && l(i);
              },
              setTransition: function (t, n) {
                const r = e.constructor,
                  i = e.controller.control;
                let s;
                function a(n) {
                  n.destroyed ||
                    (n.setTransition(t, e),
                    0 !== t &&
                      (n.transitionStart(),
                      n.params.autoHeight &&
                        c(() => {
                          n.updateAutoHeight();
                        }),
                      E(n.wrapperEl, () => {
                        i && n.transitionEnd();
                      })));
                }
                if (Array.isArray(i))
                  for (s = 0; s < i.length; s += 1)
                    i[s] !== n && i[s] instanceof r && a(i[s]);
                else i instanceof r && n !== i && a(i);
              },
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            a11y: {
              enabled: !0,
              notificationClass: 'swiper-notification',
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
              firstSlideMessage: 'This is the first slide',
              lastSlideMessage: 'This is the last slide',
              paginationBulletMessage: 'Go to slide {{index}}',
              slideLabelMessage: '{{index}} / {{slidesLength}}',
              containerMessage: null,
              containerRoleDescriptionMessage: null,
              itemRoleDescriptionMessage: null,
              slideRole: 'group',
              id: null,
            },
          }),
            (e.a11y = { clicked: !1 });
          let r = null;
          function i(e) {
            const t = r;
            0 !== t.length && ((t.innerHTML = ''), (t.innerHTML = e));
          }
          const s = (e) => (
            Array.isArray(e) || (e = [e].filter((e) => !!e)), e
          );
          function a(e) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('tabIndex', '0');
            });
          }
          function o(e) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('tabIndex', '-1');
            });
          }
          function l(e, t) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('role', t);
            });
          }
          function c(e, t) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('aria-roledescription', t);
            });
          }
          function u(e, t) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('aria-label', t);
            });
          }
          function d(e) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('aria-disabled', !0);
            });
          }
          function p(e) {
            (e = s(e)).forEach((e) => {
              e.setAttribute('aria-disabled', !1);
            });
          }
          function f(t) {
            if (13 !== t.keyCode && 32 !== t.keyCode) return;
            const n = e.params.a11y,
              r = t.target;
            (e.pagination &&
              e.pagination.el &&
              (r === e.pagination.el || e.pagination.el.contains(t.target)) &&
              !t.target.matches(te(e.params.pagination.bulletClass))) ||
              (e.navigation &&
                e.navigation.nextEl &&
                r === e.navigation.nextEl &&
                ((e.isEnd && !e.params.loop) || e.slideNext(),
                e.isEnd ? i(n.lastSlideMessage) : i(n.nextSlideMessage)),
              e.navigation &&
                e.navigation.prevEl &&
                r === e.navigation.prevEl &&
                ((e.isBeginning && !e.params.loop) || e.slidePrev(),
                e.isBeginning ? i(n.firstSlideMessage) : i(n.prevSlideMessage)),
              e.pagination &&
                r.matches(te(e.params.pagination.bulletClass)) &&
                r.click());
          }
          function h() {
            return (
              e.pagination &&
              e.pagination.bullets &&
              e.pagination.bullets.length
            );
          }
          function m() {
            return h() && e.params.pagination.clickable;
          }
          const g = (e, t, n) => {
              a(e),
                'BUTTON' !== e.tagName &&
                  (l(e, 'button'), e.addEventListener('keydown', f)),
                u(e, n),
                (function (e, t) {
                  (e = s(e)).forEach((e) => {
                    e.setAttribute('aria-controls', t);
                  });
                })(e, t);
            },
            v = () => {
              e.a11y.clicked = !0;
            },
            b = () => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  e.destroyed || (e.a11y.clicked = !1);
                });
              });
            },
            w = (t) => {
              if (e.a11y.clicked) return;
              const n = t.target.closest(
                `.${e.params.slideClass}, swiper-slide`
              );
              if (!n || !e.slides.includes(n)) return;
              const r = e.slides.indexOf(n) === e.activeIndex,
                i =
                  e.params.watchSlidesProgress &&
                  e.visibleSlides &&
                  e.visibleSlides.includes(n);
              r ||
                i ||
                (t.sourceCapabilities &&
                  t.sourceCapabilities.firesTouchEvents) ||
                (e.isHorizontal()
                  ? (e.el.scrollLeft = 0)
                  : (e.el.scrollTop = 0),
                e.slideTo(e.slides.indexOf(n), 0));
            },
            T = () => {
              const t = e.params.a11y;
              t.itemRoleDescriptionMessage &&
                c(e.slides, t.itemRoleDescriptionMessage),
                t.slideRole && l(e.slides, t.slideRole);
              const n = e.slides.length;
              t.slideLabelMessage &&
                e.slides.forEach((r, i) => {
                  const s = e.params.loop
                    ? parseInt(r.getAttribute('data-swiper-slide-index'), 10)
                    : i;
                  u(
                    r,
                    t.slideLabelMessage
                      .replace(/\{\{index\}\}/, s + 1)
                      .replace(/\{\{slidesLength\}\}/, n)
                  );
                });
            };
          n('beforeInit', () => {
            (r = y('span', e.params.a11y.notificationClass)),
              r.setAttribute('aria-live', 'assertive'),
              r.setAttribute('aria-atomic', 'true');
          }),
            n('afterInit', () => {
              e.params.a11y.enabled &&
                (() => {
                  const t = e.params.a11y;
                  e.isElement ? e.el.shadowEl.append(r) : e.el.append(r);
                  const n = e.el;
                  t.containerRoleDescriptionMessage &&
                    c(n, t.containerRoleDescriptionMessage),
                    t.containerMessage && u(n, t.containerMessage);
                  const i = e.wrapperEl,
                    a =
                      t.id ||
                      i.getAttribute('id') ||
                      `swiper-wrapper-${(function (e = 16) {
                        return 'x'
                          .repeat(e)
                          .replace(/x/g, () =>
                            Math.round(16 * Math.random()).toString(16)
                          );
                      })(16)}`,
                    o =
                      e.params.autoplay && e.params.autoplay.enabled
                        ? 'off'
                        : 'polite';
                  var l;
                  (l = a),
                    s(i).forEach((e) => {
                      e.setAttribute('id', l);
                    }),
                    (function (e, t) {
                      (e = s(e)).forEach((e) => {
                        e.setAttribute('aria-live', t);
                      });
                    })(i, o),
                    T();
                  let { nextEl: d, prevEl: p } = e.navigation
                    ? e.navigation
                    : {};
                  (d = s(d)),
                    (p = s(p)),
                    d && d.forEach((e) => g(e, a, t.nextSlideMessage)),
                    p && p.forEach((e) => g(e, a, t.prevSlideMessage)),
                    m() &&
                      (Array.isArray(e.pagination.el)
                        ? e.pagination.el
                        : [e.pagination.el]
                      ).forEach((e) => {
                        e.addEventListener('keydown', f);
                      }),
                    e.el.addEventListener('focus', w, !0),
                    e.el.addEventListener('pointerdown', v, !0),
                    e.el.addEventListener('pointerup', b, !0);
                })();
            }),
            n(
              'slidesLengthChange snapGridLengthChange slidesGridLengthChange',
              () => {
                e.params.a11y.enabled && T();
              }
            ),
            n('fromEdge toEdge afterInit lock unlock', () => {
              e.params.a11y.enabled &&
                (function () {
                  if (e.params.loop || e.params.rewind || !e.navigation) return;
                  const { nextEl: t, prevEl: n } = e.navigation;
                  n && (e.isBeginning ? (d(n), o(n)) : (p(n), a(n))),
                    t && (e.isEnd ? (d(t), o(t)) : (p(t), a(t)));
                })();
            }),
            n('paginationUpdate', () => {
              e.params.a11y.enabled &&
                (function () {
                  const t = e.params.a11y;
                  h() &&
                    e.pagination.bullets.forEach((n) => {
                      e.params.pagination.clickable &&
                        (a(n),
                        e.params.pagination.renderBullet ||
                          (l(n, 'button'),
                          u(
                            n,
                            t.paginationBulletMessage.replace(
                              /\{\{index\}\}/,
                              x(n) + 1
                            )
                          ))),
                        n.matches(te(e.params.pagination.bulletActiveClass))
                          ? n.setAttribute('aria-current', 'true')
                          : n.removeAttribute('aria-current');
                    });
                })();
            }),
            n('destroy', () => {
              e.params.a11y.enabled &&
                (function () {
                  r && r.remove();
                  let { nextEl: t, prevEl: n } = e.navigation
                    ? e.navigation
                    : {};
                  (t = s(t)),
                    (n = s(n)),
                    t && t.forEach((e) => e.removeEventListener('keydown', f)),
                    n && n.forEach((e) => e.removeEventListener('keydown', f)),
                    m() &&
                      (Array.isArray(e.pagination.el)
                        ? e.pagination.el
                        : [e.pagination.el]
                      ).forEach((e) => {
                        e.removeEventListener('keydown', f);
                      }),
                    e.el.removeEventListener('focus', w, !0),
                    e.el.removeEventListener('pointerdown', v, !0),
                    e.el.removeEventListener('pointerup', b, !0);
                })();
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            history: {
              enabled: !1,
              root: '',
              replaceState: !1,
              key: 'slides',
              keepQuery: !1,
            },
          });
          let r = !1,
            i = {};
          const s = (e) =>
              e
                .toString()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
                .replace(/^-+/, '')
                .replace(/-+$/, ''),
            a = (e) => {
              const t = l();
              let n;
              n = e ? new URL(e) : t.location;
              const r = n.pathname
                  .slice(1)
                  .split('/')
                  .filter((e) => '' !== e),
                i = r.length;
              return { key: r[i - 2], value: r[i - 1] };
            },
            o = (t, n) => {
              const i = l();
              if (!r || !e.params.history.enabled) return;
              let a;
              a = e.params.url ? new URL(e.params.url) : i.location;
              const o = e.slides[n];
              let c = s(o.getAttribute('data-history'));
              if (e.params.history.root.length > 0) {
                let n = e.params.history.root;
                '/' === n[n.length - 1] && (n = n.slice(0, n.length - 1)),
                  (c = `${n}/${t ? `${t}/` : ''}${c}`);
              } else a.pathname.includes(t) || (c = `${t ? `${t}/` : ''}${c}`);
              e.params.history.keepQuery && (c += a.search);
              const u = i.history.state;
              (u && u.value === c) ||
                (e.params.history.replaceState
                  ? i.history.replaceState({ value: c }, null, c)
                  : i.history.pushState({ value: c }, null, c));
            },
            c = (t, n, r) => {
              if (n)
                for (let i = 0, a = e.slides.length; i < a; i += 1) {
                  const a = e.slides[i];
                  if (s(a.getAttribute('data-history')) === n) {
                    const n = e.getSlideIndex(a);
                    e.slideTo(n, t, r);
                  }
                }
              else e.slideTo(0, t, r);
            },
            u = () => {
              (i = a(e.params.url)), c(e.params.speed, i.value, !1);
            };
          n('init', () => {
            e.params.history.enabled &&
              (() => {
                const t = l();
                if (e.params.history) {
                  if (!t.history || !t.history.pushState)
                    return (
                      (e.params.history.enabled = !1),
                      void (e.params.hashNavigation.enabled = !0)
                    );
                  (r = !0),
                    (i = a(e.params.url)),
                    i.key || i.value
                      ? (c(0, i.value, e.params.runCallbacksOnInit),
                        e.params.history.replaceState ||
                          t.addEventListener('popstate', u))
                      : e.params.history.replaceState ||
                        t.addEventListener('popstate', u);
                }
              })();
          }),
            n('destroy', () => {
              e.params.history.enabled &&
                (() => {
                  const t = l();
                  e.params.history.replaceState ||
                    t.removeEventListener('popstate', u);
                })();
            }),
            n('transitionEnd _freeModeNoMomentumRelease', () => {
              r && o(e.params.history.key, e.activeIndex);
            }),
            n('slideChange', () => {
              r && e.params.cssMode && o(e.params.history.key, e.activeIndex);
            });
        },
        function ({ swiper: e, extendParams: t, emit: n, on: r }) {
          let i = !1;
          const s = a(),
            o = l();
          t({
            hashNavigation: {
              enabled: !1,
              replaceState: !1,
              watchState: !1,
              getSlideIndex(t, n) {
                if (e.virtual && e.params.virtual.enabled) {
                  const t = e.slides.filter(
                    (e) => e.getAttribute('data-hash') === n
                  )[0];
                  return t
                    ? parseInt(t.getAttribute('data-swiper-slide-index'), 10)
                    : 0;
                }
                return e.getSlideIndex(
                  v(
                    e.slidesEl,
                    `.${e.params.slideClass}[data-hash="${n}"], swiper-slide[data-hash="${n}"]`
                  )[0]
                );
              },
            },
          });
          const c = () => {
              n('hashChange');
              const t = s.location.hash.replace('#', ''),
                r =
                  e.virtual && e.params.virtual.enabled
                    ? e.slidesEl.querySelector(
                        `[data-swiper-slide-index="${e.activeIndex}"]`
                      )
                    : e.slides[e.activeIndex];
              if (t !== (r ? r.getAttribute('data-hash') : '')) {
                const n = e.params.hashNavigation.getSlideIndex(e, t);
                if (void 0 === n || Number.isNaN(n)) return;
                e.slideTo(n);
              }
            },
            u = () => {
              if (!i || !e.params.hashNavigation.enabled) return;
              const t =
                  e.virtual && e.params.virtual.enabled
                    ? e.slidesEl.querySelector(
                        `[data-swiper-slide-index="${e.activeIndex}"]`
                      )
                    : e.slides[e.activeIndex],
                r = t
                  ? t.getAttribute('data-hash') ||
                    t.getAttribute('data-history')
                  : '';
              e.params.hashNavigation.replaceState &&
              o.history &&
              o.history.replaceState
                ? (o.history.replaceState(null, null, `#${r}` || ''),
                  n('hashSet'))
                : ((s.location.hash = r || ''), n('hashSet'));
            };
          r('init', () => {
            e.params.hashNavigation.enabled &&
              (() => {
                if (
                  !e.params.hashNavigation.enabled ||
                  (e.params.history && e.params.history.enabled)
                )
                  return;
                i = !0;
                const t = s.location.hash.replace('#', '');
                if (t) {
                  const n = 0,
                    r = e.params.hashNavigation.getSlideIndex(e, t);
                  e.slideTo(r || 0, n, e.params.runCallbacksOnInit, !0);
                }
                e.params.hashNavigation.watchState &&
                  o.addEventListener('hashchange', c);
              })();
          }),
            r('destroy', () => {
              e.params.hashNavigation.enabled &&
                e.params.hashNavigation.watchState &&
                o.removeEventListener('hashchange', c);
            }),
            r('transitionEnd _freeModeNoMomentumRelease', () => {
              i && u();
            }),
            r('slideChange', () => {
              i && e.params.cssMode && u();
            });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r, params: i }) {
          let s, o;
          (e.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
            t({
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1,
              },
            });
          let l,
            c,
            u,
            d,
            p,
            f,
            h,
            m = i && i.autoplay ? i.autoplay.delay : 3e3,
            g = i && i.autoplay ? i.autoplay.delay : 3e3,
            v = new Date().getTime;
          function y(t) {
            e &&
              !e.destroyed &&
              e.wrapperEl &&
              t.target === e.wrapperEl &&
              (e.wrapperEl.removeEventListener('transitionend', y), _());
          }
          const b = () => {
              if (e.destroyed || !e.autoplay.running) return;
              e.autoplay.paused ? (c = !0) : c && ((g = l), (c = !1));
              const t = e.autoplay.paused ? l : v + g - new Date().getTime();
              (e.autoplay.timeLeft = t),
                r('autoplayTimeLeft', t, t / m),
                (o = requestAnimationFrame(() => {
                  b();
                }));
            },
            w = (t) => {
              if (e.destroyed || !e.autoplay.running) return;
              cancelAnimationFrame(o), b();
              let n = void 0 === t ? e.params.autoplay.delay : t;
              (m = e.params.autoplay.delay), (g = e.params.autoplay.delay);
              const i = (() => {
                let t;
                if (
                  ((t =
                    e.virtual && e.params.virtual.enabled
                      ? e.slides.filter((e) =>
                          e.classList.contains('swiper-slide-active')
                        )[0]
                      : e.slides[e.activeIndex]),
                  t)
                )
                  return parseInt(t.getAttribute('data-swiper-autoplay'), 10);
              })();
              !Number.isNaN(i) &&
                i > 0 &&
                void 0 === t &&
                ((n = i), (m = i), (g = i)),
                (l = n);
              const a = e.params.speed,
                c = () => {
                  e &&
                    !e.destroyed &&
                    (e.params.autoplay.reverseDirection
                      ? !e.isBeginning || e.params.loop || e.params.rewind
                        ? (e.slidePrev(a, !0, !0), r('autoplay'))
                        : e.params.autoplay.stopOnLastSlide ||
                          (e.slideTo(e.slides.length - 1, a, !0, !0),
                          r('autoplay'))
                      : !e.isEnd || e.params.loop || e.params.rewind
                      ? (e.slideNext(a, !0, !0), r('autoplay'))
                      : e.params.autoplay.stopOnLastSlide ||
                        (e.slideTo(0, a, !0, !0), r('autoplay')),
                    e.params.cssMode &&
                      ((v = new Date().getTime()),
                      requestAnimationFrame(() => {
                        w();
                      })));
                };
              return (
                n > 0
                  ? (clearTimeout(s),
                    (s = setTimeout(() => {
                      c();
                    }, n)))
                  : requestAnimationFrame(() => {
                      c();
                    }),
                n
              );
            },
            x = () => {
              (e.autoplay.running = !0), w(), r('autoplayStart');
            },
            T = () => {
              (e.autoplay.running = !1),
                clearTimeout(s),
                cancelAnimationFrame(o),
                r('autoplayStop');
            },
            E = (t, n) => {
              if (e.destroyed || !e.autoplay.running) return;
              clearTimeout(s), t || (h = !0);
              const i = () => {
                r('autoplayPause'),
                  e.params.autoplay.waitForTransition
                    ? e.wrapperEl.addEventListener('transitionend', y)
                    : _();
              };
              if (((e.autoplay.paused = !0), n))
                return f && (l = e.params.autoplay.delay), (f = !1), void i();
              const a = l || e.params.autoplay.delay;
              (l = a - (new Date().getTime() - v)),
                (e.isEnd && l < 0 && !e.params.loop) || (l < 0 && (l = 0), i());
            },
            _ = () => {
              (e.isEnd && l < 0 && !e.params.loop) ||
                e.destroyed ||
                !e.autoplay.running ||
                ((v = new Date().getTime()),
                h ? ((h = !1), w(l)) : w(),
                (e.autoplay.paused = !1),
                r('autoplayResume'));
            },
            S = () => {
              if (e.destroyed || !e.autoplay.running) return;
              const t = a();
              'hidden' === t.visibilityState && ((h = !0), E(!0)),
                'visible' === t.visibilityState && _();
            },
            C = (e) => {
              'mouse' === e.pointerType && ((h = !0), E(!0));
            },
            M = (t) => {
              'mouse' === t.pointerType && e.autoplay.paused && _();
            };
          n('init', () => {
            e.params.autoplay.enabled &&
              (e.params.autoplay.pauseOnMouseEnter &&
                (e.el.addEventListener('pointerenter', C),
                e.el.addEventListener('pointerleave', M)),
              a().addEventListener('visibilitychange', S),
              (v = new Date().getTime()),
              x());
          }),
            n('destroy', () => {
              e.el.removeEventListener('pointerenter', C),
                e.el.removeEventListener('pointerleave', M),
                a().removeEventListener('visibilitychange', S),
                e.autoplay.running && T();
            }),
            n('beforeTransitionStart', (t, n, r) => {
              !e.destroyed &&
                e.autoplay.running &&
                (r || !e.params.autoplay.disableOnInteraction
                  ? E(!0, !0)
                  : T());
            }),
            n('sliderFirstMove', () => {
              !e.destroyed &&
                e.autoplay.running &&
                (e.params.autoplay.disableOnInteraction
                  ? T()
                  : ((u = !0),
                    (d = !1),
                    (h = !1),
                    (p = setTimeout(() => {
                      (h = !0), (d = !0), E(!0);
                    }, 200))));
            }),
            n('touchEnd', () => {
              if (!e.destroyed && e.autoplay.running && u) {
                if (
                  (clearTimeout(p),
                  clearTimeout(s),
                  e.params.autoplay.disableOnInteraction)
                )
                  return (d = !1), void (u = !1);
                d && e.params.cssMode && _(), (d = !1), (u = !1);
              }
            }),
            n('slideChange', () => {
              !e.destroyed && e.autoplay.running && (f = !0);
            }),
            Object.assign(e.autoplay, {
              start: x,
              stop: T,
              pause: E,
              resume: _,
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: 'swiper-slide-thumb-active',
              thumbsContainerClass: 'swiper-thumbs',
            },
          });
          let r = !1,
            i = !1;
          function s() {
            const t = e.thumbs.swiper;
            if (!t || t.destroyed) return;
            const n = t.clickedIndex,
              r = t.clickedSlide;
            if (
              r &&
              r.classList.contains(e.params.thumbs.slideThumbActiveClass)
            )
              return;
            if (null == n) return;
            let i;
            (i = t.params.loop
              ? parseInt(
                  t.clickedSlide.getAttribute('data-swiper-slide-index'),
                  10
                )
              : n),
              e.params.loop ? e.slideToLoop(i) : e.slideTo(i);
          }
          function o() {
            const { thumbs: t } = e.params;
            if (r) return !1;
            r = !0;
            const n = e.constructor;
            if (t.swiper instanceof n)
              (e.thumbs.swiper = t.swiper),
                Object.assign(e.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Object.assign(e.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                e.thumbs.swiper.update();
            else if (p(t.swiper)) {
              const r = Object.assign({}, t.swiper);
              Object.assign(r, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
                (e.thumbs.swiper = new n(r)),
                (i = !0);
            }
            return (
              e.thumbs.swiper.el.classList.add(
                e.params.thumbs.thumbsContainerClass
              ),
              e.thumbs.swiper.on('tap', s),
              !0
            );
          }
          function l(t) {
            const n = e.thumbs.swiper;
            if (!n || n.destroyed) return;
            const r =
              'auto' === n.params.slidesPerView
                ? n.slidesPerViewDynamic()
                : n.params.slidesPerView;
            let i = 1;
            const s = e.params.thumbs.slideThumbActiveClass;
            if (
              (e.params.slidesPerView > 1 &&
                !e.params.centeredSlides &&
                (i = e.params.slidesPerView),
              e.params.thumbs.multipleActiveThumbs || (i = 1),
              (i = Math.floor(i)),
              n.slides.forEach((e) => e.classList.remove(s)),
              n.params.loop || (n.params.virtual && n.params.virtual.enabled))
            )
              for (let t = 0; t < i; t += 1)
                v(
                  n.slidesEl,
                  `[data-swiper-slide-index="${e.realIndex + t}"]`
                ).forEach((e) => {
                  e.classList.add(s);
                });
            else
              for (let t = 0; t < i; t += 1)
                n.slides[e.realIndex + t] &&
                  n.slides[e.realIndex + t].classList.add(s);
            const a = e.params.thumbs.autoScrollOffset,
              o = a && !n.params.loop;
            if (e.realIndex !== n.realIndex || o) {
              const i = n.activeIndex;
              let s, l;
              if (n.params.loop) {
                const t = n.slides.filter(
                  (t) =>
                    t.getAttribute('data-swiper-slide-index') ===
                    `${e.realIndex}`
                )[0];
                (s = n.slides.indexOf(t)),
                  (l = e.activeIndex > e.previousIndex ? 'next' : 'prev');
              } else
                (s = e.realIndex), (l = s > e.previousIndex ? 'next' : 'prev');
              o && (s += 'next' === l ? a : -1 * a),
                n.visibleSlidesIndexes &&
                  n.visibleSlidesIndexes.indexOf(s) < 0 &&
                  (n.params.centeredSlides
                    ? (s =
                        s > i
                          ? s - Math.floor(r / 2) + 1
                          : s + Math.floor(r / 2) - 1)
                    : s > i && n.params.slidesPerGroup,
                  n.slideTo(s, t ? 0 : void 0));
            }
          }
          (e.thumbs = { swiper: null }),
            n('beforeInit', () => {
              const { thumbs: t } = e.params;
              if (t && t.swiper)
                if (
                  'string' == typeof t.swiper ||
                  t.swiper instanceof HTMLElement
                ) {
                  const n = a(),
                    r = () => {
                      const r =
                        'string' == typeof t.swiper
                          ? n.querySelector(t.swiper)
                          : t.swiper;
                      if (r && r.swiper) (t.swiper = r.swiper), o(), l(!0);
                      else if (r) {
                        const n = (i) => {
                          (t.swiper = i.detail[0]),
                            r.removeEventListener('init', n),
                            o(),
                            l(!0),
                            t.swiper.update(),
                            e.update();
                        };
                        r.addEventListener('init', n);
                      }
                      return r;
                    },
                    i = () => {
                      e.destroyed || r() || requestAnimationFrame(i);
                    };
                  requestAnimationFrame(i);
                } else o(), l(!0);
            }),
            n('slideChange update resize observerUpdate', () => {
              l();
            }),
            n('setTransition', (t, n) => {
              const r = e.thumbs.swiper;
              r && !r.destroyed && r.setTransition(n);
            }),
            n('beforeDestroy', () => {
              const t = e.thumbs.swiper;
              t && !t.destroyed && i && t.destroy();
            }),
            Object.assign(e.thumbs, { init: o, update: l });
        },
        function ({ swiper: e, extendParams: t, emit: n, once: r }) {
          t({
            freeMode: {
              enabled: !1,
              momentum: !0,
              momentumRatio: 1,
              momentumBounce: !0,
              momentumBounceRatio: 1,
              momentumVelocityRatio: 1,
              sticky: !1,
              minimumVelocity: 0.02,
            },
          }),
            Object.assign(e, {
              freeMode: {
                onTouchStart: function () {
                  if (e.params.cssMode) return;
                  const t = e.getTranslate();
                  e.setTranslate(t),
                    e.setTransition(0),
                    (e.touchEventsData.velocities.length = 0),
                    e.freeMode.onTouchEnd({
                      currentPos: e.rtl ? e.translate : -e.translate,
                    });
                },
                onTouchMove: function () {
                  if (e.params.cssMode) return;
                  const { touchEventsData: t, touches: n } = e;
                  0 === t.velocities.length &&
                    t.velocities.push({
                      position: n[e.isHorizontal() ? 'startX' : 'startY'],
                      time: t.touchStartTime,
                    }),
                    t.velocities.push({
                      position: n[e.isHorizontal() ? 'currentX' : 'currentY'],
                      time: u(),
                    });
                },
                onTouchEnd: function ({ currentPos: t }) {
                  if (e.params.cssMode) return;
                  const {
                      params: i,
                      wrapperEl: s,
                      rtlTranslate: a,
                      snapGrid: o,
                      touchEventsData: l,
                    } = e,
                    c = u() - l.touchStartTime;
                  if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
                  else if (t > -e.maxTranslate())
                    e.slides.length < o.length
                      ? e.slideTo(o.length - 1)
                      : e.slideTo(e.slides.length - 1);
                  else {
                    if (i.freeMode.momentum) {
                      if (l.velocities.length > 1) {
                        const t = l.velocities.pop(),
                          n = l.velocities.pop(),
                          r = t.position - n.position,
                          s = t.time - n.time;
                        (e.velocity = r / s),
                          (e.velocity /= 2),
                          Math.abs(e.velocity) < i.freeMode.minimumVelocity &&
                            (e.velocity = 0),
                          (s > 150 || u() - t.time > 300) && (e.velocity = 0);
                      } else e.velocity = 0;
                      (e.velocity *= i.freeMode.momentumVelocityRatio),
                        (l.velocities.length = 0);
                      let t = 1e3 * i.freeMode.momentumRatio;
                      const c = e.velocity * t;
                      let d = e.translate + c;
                      a && (d = -d);
                      let p,
                        f = !1;
                      const h =
                        20 *
                        Math.abs(e.velocity) *
                        i.freeMode.momentumBounceRatio;
                      let m;
                      if (d < e.maxTranslate())
                        i.freeMode.momentumBounce
                          ? (d + e.maxTranslate() < -h &&
                              (d = e.maxTranslate() - h),
                            (p = e.maxTranslate()),
                            (f = !0),
                            (l.allowMomentumBounce = !0))
                          : (d = e.maxTranslate()),
                          i.loop && i.centeredSlides && (m = !0);
                      else if (d > e.minTranslate())
                        i.freeMode.momentumBounce
                          ? (d - e.minTranslate() > h &&
                              (d = e.minTranslate() + h),
                            (p = e.minTranslate()),
                            (f = !0),
                            (l.allowMomentumBounce = !0))
                          : (d = e.minTranslate()),
                          i.loop && i.centeredSlides && (m = !0);
                      else if (i.freeMode.sticky) {
                        let t;
                        for (let e = 0; e < o.length; e += 1)
                          if (o[e] > -d) {
                            t = e;
                            break;
                          }
                        (d =
                          Math.abs(o[t] - d) < Math.abs(o[t - 1] - d) ||
                          'next' === e.swipeDirection
                            ? o[t]
                            : o[t - 1]),
                          (d = -d);
                      }
                      if (
                        (m &&
                          r('transitionEnd', () => {
                            e.loopFix();
                          }),
                        0 !== e.velocity)
                      ) {
                        if (
                          ((t = a
                            ? Math.abs((-d - e.translate) / e.velocity)
                            : Math.abs((d - e.translate) / e.velocity)),
                          i.freeMode.sticky)
                        ) {
                          const n = Math.abs((a ? -d : d) - e.translate),
                            r = e.slidesSizesGrid[e.activeIndex];
                          t =
                            n < r
                              ? i.speed
                              : n < 2 * r
                              ? 1.5 * i.speed
                              : 2.5 * i.speed;
                        }
                      } else if (i.freeMode.sticky)
                        return void e.slideToClosest();
                      i.freeMode.momentumBounce && f
                        ? (e.updateProgress(p),
                          e.setTransition(t),
                          e.setTranslate(d),
                          e.transitionStart(!0, e.swipeDirection),
                          (e.animating = !0),
                          E(s, () => {
                            e &&
                              !e.destroyed &&
                              l.allowMomentumBounce &&
                              (n('momentumBounce'),
                              e.setTransition(i.speed),
                              setTimeout(() => {
                                e.setTranslate(p),
                                  E(s, () => {
                                    e && !e.destroyed && e.transitionEnd();
                                  });
                              }, 0));
                          }))
                        : e.velocity
                        ? (n('_freeModeNoMomentumRelease'),
                          e.updateProgress(d),
                          e.setTransition(t),
                          e.setTranslate(d),
                          e.transitionStart(!0, e.swipeDirection),
                          e.animating ||
                            ((e.animating = !0),
                            E(s, () => {
                              e && !e.destroyed && e.transitionEnd();
                            })))
                        : e.updateProgress(d),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses();
                    } else {
                      if (i.freeMode.sticky) return void e.slideToClosest();
                      i.freeMode && n('_freeModeNoMomentumRelease');
                    }
                    (!i.freeMode.momentum || c >= i.longSwipesMs) &&
                      (e.updateProgress(),
                      e.updateActiveIndex(),
                      e.updateSlidesClasses());
                  }
                },
              },
            });
        },
        function ({ swiper: e, extendParams: t }) {
          let n, r, i;
          t({ grid: { rows: 1, fill: 'column' } });
          const s = () => {
            let t = e.params.spaceBetween;
            return (
              'string' == typeof t && t.indexOf('%') >= 0
                ? (t = (parseFloat(t.replace('%', '')) / 100) * e.size)
                : 'string' == typeof t && (t = parseFloat(t)),
              t
            );
          };
          e.grid = {
            initSlides: (t) => {
              const { slidesPerView: s } = e.params,
                { rows: a, fill: o } = e.params.grid;
              (i = Math.floor(t / a)),
                (n = Math.floor(t / a) === t / a ? t : Math.ceil(t / a) * a),
                'auto' !== s && 'row' === o && (n = Math.max(n, s * a)),
                (r = n / a);
            },
            updateSlide: (t, a, o, l) => {
              const { slidesPerGroup: c } = e.params,
                u = s(),
                { rows: d, fill: p } = e.params.grid;
              let f, h, m;
              if ('row' === p && c > 1) {
                const e = Math.floor(t / (c * d)),
                  r = t - d * c * e,
                  i = 0 === e ? c : Math.min(Math.ceil((o - e * d * c) / d), c);
                (m = Math.floor(r / i)),
                  (h = r - m * i + e * c),
                  (f = h + (m * n) / d),
                  (a.style.order = f);
              } else
                'column' === p
                  ? ((h = Math.floor(t / d)),
                    (m = t - h * d),
                    (h > i || (h === i && m === d - 1)) &&
                      ((m += 1), m >= d && ((m = 0), (h += 1))))
                  : ((m = Math.floor(t / r)), (h = t - m * r));
              (a.row = m),
                (a.column = h),
                (a.style[l('margin-top')] = 0 !== m ? u && `${u}px` : '');
            },
            updateWrapperSize: (t, r, i) => {
              const { centeredSlides: a, roundLengths: o } = e.params,
                l = s(),
                { rows: c } = e.params.grid;
              if (
                ((e.virtualSize = (t + l) * n),
                (e.virtualSize = Math.ceil(e.virtualSize / c) - l),
                (e.wrapperEl.style[i('width')] = `${e.virtualSize + l}px`),
                a)
              ) {
                const t = [];
                for (let n = 0; n < r.length; n += 1) {
                  let i = r[n];
                  o && (i = Math.floor(i)),
                    r[n] < e.virtualSize + r[0] && t.push(i);
                }
                r.splice(0, r.length), r.push(...t);
              }
            },
          };
        },
        function ({ swiper: e }) {
          Object.assign(e, {
            appendSlide: ne.bind(e),
            prependSlide: re.bind(e),
            addSlide: ie.bind(e),
            removeSlide: se.bind(e),
            removeAllSlides: ae.bind(e),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ fadeEffect: { crossFade: !1 } }),
            oe({
              effect: 'fade',
              swiper: e,
              on: n,
              setTranslate: () => {
                const { slides: t } = e;
                e.params.fadeEffect;
                for (let n = 0; n < t.length; n += 1) {
                  const t = e.slides[n];
                  let r = -t.swiperSlideOffset;
                  e.params.virtualTranslate || (r -= e.translate);
                  let i = 0;
                  e.isHorizontal() || ((i = r), (r = 0));
                  const s = e.params.fadeEffect.crossFade
                      ? Math.max(1 - Math.abs(t.progress), 0)
                      : 1 + Math.min(Math.max(t.progress, -1), 0),
                    a = le(0, t);
                  (a.style.opacity = s),
                    (a.style.transform = `translate3d(${r}px, ${i}px, 0px)`);
                }
              },
              setTransition: (t) => {
                const n = e.slides.map((e) => g(e));
                n.forEach((e) => {
                  e.style.transitionDuration = `${t}ms`;
                }),
                  ce({
                    swiper: e,
                    duration: t,
                    transformElements: n,
                    allSlides: !0,
                  });
              },
              overwriteParams: () => ({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !e.params.cssMode,
              }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            cubeEffect: {
              slideShadows: !0,
              shadow: !0,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          });
          const r = (e, t, n) => {
            let r = n
                ? e.querySelector('.swiper-slide-shadow-left')
                : e.querySelector('.swiper-slide-shadow-top'),
              i = n
                ? e.querySelector('.swiper-slide-shadow-right')
                : e.querySelector('.swiper-slide-shadow-bottom');
            r ||
              ((r = y('div', 'swiper-slide-shadow-' + (n ? 'left' : 'top'))),
              e.append(r)),
              i ||
                ((i = y(
                  'div',
                  'swiper-slide-shadow-' + (n ? 'right' : 'bottom')
                )),
                e.append(i)),
              r && (r.style.opacity = Math.max(-t, 0)),
              i && (i.style.opacity = Math.max(t, 0));
          };
          oe({
            effect: 'cube',
            swiper: e,
            on: n,
            setTranslate: () => {
              const {
                  el: t,
                  wrapperEl: n,
                  slides: i,
                  width: s,
                  height: a,
                  rtlTranslate: o,
                  size: l,
                  browser: c,
                } = e,
                u = e.params.cubeEffect,
                d = e.isHorizontal(),
                p = e.virtual && e.params.virtual.enabled;
              let f,
                h = 0;
              u.shadow &&
                (d
                  ? ((f = e.slidesEl.querySelector('.swiper-cube-shadow')),
                    f ||
                      ((f = y('div', 'swiper-cube-shadow')),
                      e.slidesEl.append(f)),
                    (f.style.height = `${s}px`))
                  : ((f = t.querySelector('.swiper-cube-shadow')),
                    f || ((f = y('div', 'swiper-cube-shadow')), t.append(f))));
              for (let e = 0; e < i.length; e += 1) {
                const t = i[e];
                let n = e;
                p &&
                  (n = parseInt(t.getAttribute('data-swiper-slide-index'), 10));
                let s = 90 * n,
                  a = Math.floor(s / 360);
                o && ((s = -s), (a = Math.floor(-s / 360)));
                const c = Math.max(Math.min(t.progress, 1), -1);
                let f = 0,
                  m = 0,
                  g = 0;
                n % 4 == 0
                  ? ((f = 4 * -a * l), (g = 0))
                  : (n - 1) % 4 == 0
                  ? ((f = 0), (g = 4 * -a * l))
                  : (n - 2) % 4 == 0
                  ? ((f = l + 4 * a * l), (g = l))
                  : (n - 3) % 4 == 0 && ((f = -l), (g = 3 * l + 4 * l * a)),
                  o && (f = -f),
                  d || ((m = f), (f = 0));
                const v = `rotateX(${d ? 0 : -s}deg) rotateY(${
                  d ? s : 0
                }deg) translate3d(${f}px, ${m}px, ${g}px)`;
                c <= 1 &&
                  c > -1 &&
                  ((h = 90 * n + 90 * c), o && (h = 90 * -n - 90 * c)),
                  (t.style.transform = v),
                  u.slideShadows && r(t, c, d);
              }
              if (
                ((n.style.transformOrigin = `50% 50% -${l / 2}px`),
                (n.style['-webkit-transform-origin'] = `50% 50% -${l / 2}px`),
                u.shadow)
              )
                if (d)
                  f.style.transform = `translate3d(0px, ${
                    s / 2 + u.shadowOffset
                  }px, ${-s / 2}px) rotateX(90deg) rotateZ(0deg) scale(${
                    u.shadowScale
                  })`;
                else {
                  const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                    t =
                      1.5 -
                      (Math.sin((2 * e * Math.PI) / 360) / 2 +
                        Math.cos((2 * e * Math.PI) / 360) / 2),
                    n = u.shadowScale,
                    r = u.shadowScale / t,
                    i = u.shadowOffset;
                  f.style.transform = `scale3d(${n}, 1, ${r}) translate3d(0px, ${
                    a / 2 + i
                  }px, ${-a / 2 / r}px) rotateX(-90deg)`;
                }
              const m =
                (c.isSafari || c.isWebView) && c.needPerspectiveFix
                  ? -l / 2
                  : 0;
              (n.style.transform = `translate3d(0px,0,${m}px) rotateX(${
                e.isHorizontal() ? 0 : h
              }deg) rotateY(${e.isHorizontal() ? -h : 0}deg)`),
                n.style.setProperty('--swiper-cube-translate-z', `${m}px`);
            },
            setTransition: (t) => {
              const { el: n, slides: r } = e;
              if (
                (r.forEach((e) => {
                  (e.style.transitionDuration = `${t}ms`),
                    e
                      .querySelectorAll(
                        '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                      )
                      .forEach((e) => {
                        e.style.transitionDuration = `${t}ms`;
                      });
                }),
                e.params.cubeEffect.shadow && !e.isHorizontal())
              ) {
                const e = n.querySelector('.swiper-cube-shadow');
                e && (e.style.transitionDuration = `${t}ms`);
              }
            },
            recreateShadows: () => {
              const t = e.isHorizontal();
              e.slides.forEach((e) => {
                const n = Math.max(Math.min(e.progress, 1), -1);
                r(e, n, t);
              });
            },
            getEffectParams: () => e.params.cubeEffect,
            perspective: () => !0,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              resistanceRatio: 0,
              spaceBetween: 0,
              centeredSlides: !1,
              virtualTranslate: !0,
            }),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
          const r = (t, n, r) => {
            let i = e.isHorizontal()
                ? t.querySelector('.swiper-slide-shadow-left')
                : t.querySelector('.swiper-slide-shadow-top'),
              s = e.isHorizontal()
                ? t.querySelector('.swiper-slide-shadow-right')
                : t.querySelector('.swiper-slide-shadow-bottom');
            i || (i = ue(0, t, e.isHorizontal() ? 'left' : 'top')),
              s || (s = ue(0, t, e.isHorizontal() ? 'right' : 'bottom')),
              i && (i.style.opacity = Math.max(-n, 0)),
              s && (s.style.opacity = Math.max(n, 0));
          };
          oe({
            effect: 'flip',
            swiper: e,
            on: n,
            setTranslate: () => {
              const { slides: t, rtlTranslate: n } = e,
                i = e.params.flipEffect;
              for (let s = 0; s < t.length; s += 1) {
                const a = t[s];
                let o = a.progress;
                e.params.flipEffect.limitRotation &&
                  (o = Math.max(Math.min(a.progress, 1), -1));
                const l = a.swiperSlideOffset;
                let c = -180 * o,
                  u = 0,
                  d = e.params.cssMode ? -l - e.translate : -l,
                  p = 0;
                e.isHorizontal()
                  ? n && (c = -c)
                  : ((p = d), (d = 0), (u = -c), (c = 0)),
                  (a.style.zIndex = -Math.abs(Math.round(o)) + t.length),
                  i.slideShadows && r(a, o);
                const f = `translate3d(${d}px, ${p}px, 0px) rotateX(${u}deg) rotateY(${c}deg)`;
                le(0, a).style.transform = f;
              }
            },
            setTransition: (t) => {
              const n = e.slides.map((e) => g(e));
              n.forEach((e) => {
                (e.style.transitionDuration = `${t}ms`),
                  e
                    .querySelectorAll(
                      '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                    )
                    .forEach((e) => {
                      e.style.transitionDuration = `${t}ms`;
                    });
              }),
                ce({ swiper: e, duration: t, transformElements: n });
            },
            recreateShadows: () => {
              e.params.flipEffect,
                e.slides.forEach((t) => {
                  let n = t.progress;
                  e.params.flipEffect.limitRotation &&
                    (n = Math.max(Math.min(t.progress, 1), -1)),
                    r(t, n);
                });
            },
            getEffectParams: () => e.params.flipEffect,
            perspective: () => !0,
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !e.params.cssMode,
            }),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              scale: 1,
              modifier: 1,
              slideShadows: !0,
            },
          }),
            oe({
              effect: 'coverflow',
              swiper: e,
              on: n,
              setTranslate: () => {
                const {
                    width: t,
                    height: n,
                    slides: r,
                    slidesSizesGrid: i,
                  } = e,
                  s = e.params.coverflowEffect,
                  a = e.isHorizontal(),
                  o = e.translate,
                  l = a ? t / 2 - o : n / 2 - o,
                  c = a ? s.rotate : -s.rotate,
                  u = s.depth;
                for (let e = 0, t = r.length; e < t; e += 1) {
                  const t = r[e],
                    n = i[e],
                    o = (l - t.swiperSlideOffset - n / 2) / n,
                    d =
                      'function' == typeof s.modifier
                        ? s.modifier(o)
                        : o * s.modifier;
                  let p = a ? c * d : 0,
                    f = a ? 0 : c * d,
                    h = -u * Math.abs(d),
                    m = s.stretch;
                  'string' == typeof m &&
                    -1 !== m.indexOf('%') &&
                    (m = (parseFloat(s.stretch) / 100) * n);
                  let g = a ? 0 : m * d,
                    v = a ? m * d : 0,
                    y = 1 - (1 - s.scale) * Math.abs(d);
                  Math.abs(v) < 0.001 && (v = 0),
                    Math.abs(g) < 0.001 && (g = 0),
                    Math.abs(h) < 0.001 && (h = 0),
                    Math.abs(p) < 0.001 && (p = 0),
                    Math.abs(f) < 0.001 && (f = 0),
                    Math.abs(y) < 0.001 && (y = 0);
                  const b = `translate3d(${v}px,${g}px,${h}px)  rotateX(${f}deg) rotateY(${p}deg) scale(${y})`;
                  if (
                    ((le(0, t).style.transform = b),
                    (t.style.zIndex = 1 - Math.abs(Math.round(d))),
                    s.slideShadows)
                  ) {
                    let e = a
                        ? t.querySelector('.swiper-slide-shadow-left')
                        : t.querySelector('.swiper-slide-shadow-top'),
                      n = a
                        ? t.querySelector('.swiper-slide-shadow-right')
                        : t.querySelector('.swiper-slide-shadow-bottom');
                    e || (e = ue(0, t, a ? 'left' : 'top')),
                      n || (n = ue(0, t, a ? 'right' : 'bottom')),
                      e && (e.style.opacity = d > 0 ? d : 0),
                      n && (n.style.opacity = -d > 0 ? -d : 0);
                  }
                }
              },
              setTransition: (t) => {
                e.slides
                  .map((e) => g(e))
                  .forEach((e) => {
                    (e.style.transitionDuration = `${t}ms`),
                      e
                        .querySelectorAll(
                          '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                        )
                        .forEach((e) => {
                          e.style.transitionDuration = `${t}ms`;
                        });
                  });
              },
              perspective: () => !0,
              overwriteParams: () => ({ watchSlidesProgress: !0 }),
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            creativeEffect: {
              limitProgress: 1,
              shadowPerProgress: !1,
              progressMultiplier: 1,
              perspective: !0,
              prev: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
              },
              next: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
              },
            },
          });
          const r = (e) => ('string' == typeof e ? e : `${e}px`);
          oe({
            effect: 'creative',
            swiper: e,
            on: n,
            setTranslate: () => {
              const { slides: t, wrapperEl: n, slidesSizesGrid: i } = e,
                s = e.params.creativeEffect,
                { progressMultiplier: a } = s,
                o = e.params.centeredSlides;
              if (o) {
                const t = i[0] / 2 - e.params.slidesOffsetBefore || 0;
                n.style.transform = `translateX(calc(50% - ${t}px))`;
              }
              for (let n = 0; n < t.length; n += 1) {
                const i = t[n],
                  l = i.progress,
                  c = Math.min(
                    Math.max(i.progress, -s.limitProgress),
                    s.limitProgress
                  );
                let u = c;
                o ||
                  (u = Math.min(
                    Math.max(i.originalProgress, -s.limitProgress),
                    s.limitProgress
                  ));
                const d = i.swiperSlideOffset,
                  p = [e.params.cssMode ? -d - e.translate : -d, 0, 0],
                  f = [0, 0, 0];
                let h = !1;
                e.isHorizontal() || ((p[1] = p[0]), (p[0] = 0));
                let m = {
                  translate: [0, 0, 0],
                  rotate: [0, 0, 0],
                  scale: 1,
                  opacity: 1,
                };
                c < 0
                  ? ((m = s.next), (h = !0))
                  : c > 0 && ((m = s.prev), (h = !0)),
                  p.forEach((e, t) => {
                    p[t] = `calc(${e}px + (${r(m.translate[t])} * ${Math.abs(
                      c * a
                    )}))`;
                  }),
                  f.forEach((e, t) => {
                    f[t] = m.rotate[t] * Math.abs(c * a);
                  }),
                  (i.style.zIndex = -Math.abs(Math.round(l)) + t.length);
                const g = p.join(', '),
                  v = `rotateX(${f[0]}deg) rotateY(${f[1]}deg) rotateZ(${f[2]}deg)`,
                  y =
                    u < 0
                      ? `scale(${1 + (1 - m.scale) * u * a})`
                      : `scale(${1 - (1 - m.scale) * u * a})`,
                  b =
                    u < 0
                      ? 1 + (1 - m.opacity) * u * a
                      : 1 - (1 - m.opacity) * u * a,
                  w = `translate3d(${g}) ${v} ${y}`;
                if ((h && m.shadow) || !h) {
                  let e = i.querySelector('.swiper-slide-shadow');
                  if ((!e && m.shadow && (e = ue(0, i)), e)) {
                    const t = s.shadowPerProgress
                      ? c * (1 / s.limitProgress)
                      : c;
                    e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                  }
                }
                const x = le(0, i);
                (x.style.transform = w),
                  (x.style.opacity = b),
                  m.origin && (x.style.transformOrigin = m.origin);
              }
            },
            setTransition: (t) => {
              const n = e.slides.map((e) => g(e));
              n.forEach((e) => {
                (e.style.transitionDuration = `${t}ms`),
                  e.querySelectorAll('.swiper-slide-shadow').forEach((e) => {
                    e.style.transitionDuration = `${t}ms`;
                  });
              }),
                ce({
                  swiper: e,
                  duration: t,
                  transformElements: n,
                  allSlides: !0,
                });
            },
            perspective: () => e.params.creativeEffect.perspective,
            overwriteParams: () => ({
              watchSlidesProgress: !0,
              virtualTranslate: !e.params.cssMode,
            }),
          });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            cardsEffect: {
              slideShadows: !0,
              rotate: !0,
              perSlideRotate: 2,
              perSlideOffset: 8,
            },
          }),
            oe({
              effect: 'cards',
              swiper: e,
              on: n,
              setTranslate: () => {
                const { slides: t, activeIndex: n, rtlTranslate: r } = e,
                  i = e.params.cardsEffect,
                  { startTranslate: s, isTouched: a } = e.touchEventsData,
                  o = r ? -e.translate : e.translate;
                for (let l = 0; l < t.length; l += 1) {
                  const c = t[l],
                    u = c.progress,
                    d = Math.min(Math.max(u, -4), 4);
                  let p = c.swiperSlideOffset;
                  e.params.centeredSlides &&
                    !e.params.cssMode &&
                    (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`),
                    e.params.centeredSlides &&
                      e.params.cssMode &&
                      (p -= t[0].swiperSlideOffset);
                  let f = e.params.cssMode ? -p - e.translate : -p,
                    h = 0;
                  const m = -100 * Math.abs(d);
                  let g = 1,
                    v = -i.perSlideRotate * d,
                    y = i.perSlideOffset - 0.75 * Math.abs(d);
                  const b =
                      e.virtual && e.params.virtual.enabled
                        ? e.virtual.from + l
                        : l,
                    w =
                      (b === n || b === n - 1) &&
                      d > 0 &&
                      d < 1 &&
                      (a || e.params.cssMode) &&
                      o < s,
                    x =
                      (b === n || b === n + 1) &&
                      d < 0 &&
                      d > -1 &&
                      (a || e.params.cssMode) &&
                      o > s;
                  if (w || x) {
                    const e = (1 - Math.abs((Math.abs(d) - 0.5) / 0.5)) ** 0.5;
                    (v += -28 * d * e),
                      (g += -0.5 * e),
                      (y += 96 * e),
                      (h = -25 * e * Math.abs(d) + '%');
                  }
                  if (
                    ((f =
                      d < 0
                        ? `calc(${f}px ${r ? '-' : '+'} (${y * Math.abs(d)}%))`
                        : d > 0
                        ? `calc(${f}px ${r ? '-' : '+'} (-${y * Math.abs(d)}%))`
                        : `${f}px`),
                    !e.isHorizontal())
                  ) {
                    const e = h;
                    (h = f), (f = e);
                  }
                  const T =
                      d < 0 ? '' + (1 + (1 - g) * d) : '' + (1 - (1 - g) * d),
                    E = `\n        translate3d(${f}, ${h}, ${m}px)\n        rotateZ(${
                      i.rotate ? (r ? -v : v) : 0
                    }deg)\n        scale(${T})\n      `;
                  if (i.slideShadows) {
                    let e = c.querySelector('.swiper-slide-shadow');
                    e || (e = ue(0, c)),
                      e &&
                        (e.style.opacity = Math.min(
                          Math.max((Math.abs(d) - 0.5) / 0.5, 0),
                          1
                        ));
                  }
                  (c.style.zIndex = -Math.abs(Math.round(u)) + t.length),
                    (le(0, c).style.transform = E);
                }
              },
              setTransition: (t) => {
                const n = e.slides.map((e) => g(e));
                n.forEach((e) => {
                  (e.style.transitionDuration = `${t}ms`),
                    e.querySelectorAll('.swiper-slide-shadow').forEach((e) => {
                      e.style.transitionDuration = `${t}ms`;
                    });
                }),
                  ce({ swiper: e, duration: t, transformElements: n });
              },
              perspective: () => !0,
              overwriteParams: () => ({
                watchSlidesProgress: !0,
                virtualTranslate: !e.params.cssMode,
              }),
            });
        },
      ];
      J.use(de);
      var pe = n(440),
        fe = n.n(pe),
        he = function (e) {
          e.text('0');
          var t = e.attr('data-speed'),
            n = Number(e.attr('data-increment'));
          !(function r() {
            var i = e.attr('data-count'),
              s = Number(e.text());
            s < i
              ? (e.text(''.concat(Math.ceil(s + n))), setTimeout(r, t))
              : e.text(i);
          })();
        };
      function me(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function ge(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = t);
      }
      var ve,
        ye,
        be,
        we,
        xe,
        Te,
        Ee,
        _e,
        Se,
        Ce,
        Me,
        ke,
        Ae,
        Pe,
        Le,
        Oe = {
          autoSleep: 120,
          force3D: 'auto',
          nullTargetWarn: 1,
          units: { lineHeight: '' },
        },
        De = { duration: 0.5, overwrite: !1, delay: 0 },
        Ie = 1e8,
        ze = 1e-8,
        Re = 2 * Math.PI,
        je = Re / 4,
        Ne = 0,
        $e = Math.sqrt,
        Fe = Math.cos,
        qe = Math.sin,
        He = function (e) {
          return 'string' == typeof e;
        },
        Be = function (e) {
          return 'function' == typeof e;
        },
        Xe = function (e) {
          return 'number' == typeof e;
        },
        Ye = function (e) {
          return void 0 === e;
        },
        Ge = function (e) {
          return 'object' == typeof e;
        },
        We = function (e) {
          return !1 !== e;
        },
        Ve = function () {
          return 'undefined' != typeof window;
        },
        Ue = function (e) {
          return Be(e) || He(e);
        },
        Ke =
          ('function' == typeof ArrayBuffer && ArrayBuffer.isView) ||
          function () {},
        Qe = Array.isArray,
        Ze = /(?:-?\.?\d|\.)+/gi,
        Je = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        et = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        tt = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        nt = /[+-]=-?[.\d]+/,
        rt = /[^,'"\[\]\s]+/gi,
        it = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        st = {},
        at = {},
        ot = function (e) {
          return (at = Rt(e, st)) && jr;
        },
        lt = function (e, t) {
          return console.warn(
            'Invalid property',
            e,
            'set to',
            t,
            'Missing plugin? gsap.registerPlugin()'
          );
        },
        ct = function (e, t) {
          return !t && console.warn(e);
        },
        ut = function (e, t) {
          return (e && (st[e] = t) && at && (at[e] = t)) || st;
        },
        dt = function () {
          return 0;
        },
        pt = { suppressEvents: !0, isStart: !0, kill: !1 },
        ft = { suppressEvents: !0, kill: !1 },
        ht = { suppressEvents: !0 },
        mt = {},
        gt = [],
        vt = {},
        yt = {},
        bt = {},
        wt = 30,
        xt = [],
        Tt = '',
        Et = function (e) {
          var t,
            n,
            r = e[0];
          if ((Ge(r) || Be(r) || (e = [e]), !(t = (r._gsap || {}).harness))) {
            for (n = xt.length; n-- && !xt[n].targetTest(r); );
            t = xt[n];
          }
          for (n = e.length; n--; )
            (e[n] && (e[n]._gsap || (e[n]._gsap = new Qn(e[n], t)))) ||
              e.splice(n, 1);
          return e;
        },
        _t = function (e) {
          return e._gsap || Et(hn(e))[0]._gsap;
        },
        St = function (e, t, n) {
          return (n = e[t]) && Be(n)
            ? e[t]()
            : (Ye(n) && e.getAttribute && e.getAttribute(t)) || n;
        },
        Ct = function (e, t) {
          return (e = e.split(',')).forEach(t) || e;
        },
        Mt = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        kt = function (e) {
          return Math.round(1e7 * e) / 1e7 || 0;
        },
        At = function (e, t) {
          var n = t.charAt(0),
            r = parseFloat(t.substr(2));
          return (
            (e = parseFloat(e)),
            '+' === n ? e + r : '-' === n ? e - r : '*' === n ? e * r : e / r
          );
        },
        Pt = function (e, t) {
          for (var n = t.length, r = 0; e.indexOf(t[r]) < 0 && ++r < n; );
          return r < n;
        },
        Lt = function () {
          var e,
            t,
            n = gt.length,
            r = gt.slice(0);
          for (vt = {}, gt.length = 0, e = 0; e < n; e++)
            (t = r[e]) &&
              t._lazy &&
              (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        },
        Ot = function (e, t, n, r) {
          gt.length && !ye && Lt(),
            e.render(t, n, r || (ye && t < 0 && (e._initted || e._startAt))),
            gt.length && !ye && Lt();
        },
        Dt = function (e) {
          var t = parseFloat(e);
          return (t || 0 === t) && (e + '').match(rt).length < 2
            ? t
            : He(e)
            ? e.trim()
            : e;
        },
        It = function (e) {
          return e;
        },
        zt = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        Rt = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        jt = function e(t, n) {
          for (var r in n)
            '__proto__' !== r &&
              'constructor' !== r &&
              'prototype' !== r &&
              (t[r] = Ge(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
          return t;
        },
        Nt = function (e, t) {
          var n,
            r = {};
          for (n in e) n in t || (r[n] = e[n]);
          return r;
        },
        $t = function (e) {
          var t,
            n = e.parent || we,
            r = e.keyframes
              ? ((t = Qe(e.keyframes)),
                function (e, n) {
                  for (var r in n)
                    r in e ||
                      ('duration' === r && t) ||
                      'ease' === r ||
                      (e[r] = n[r]);
                })
              : zt;
          if (We(e.inherit))
            for (; n; ) r(e, n.vars.defaults), (n = n.parent || n._dp);
          return e;
        },
        Ft = function (e, t, n, r, i) {
          void 0 === n && (n = '_first'), void 0 === r && (r = '_last');
          var s,
            a = e[r];
          if (i) for (s = t[i]; a && a[i] > s; ) a = a._prev;
          return (
            a
              ? ((t._next = a._next), (a._next = t))
              : ((t._next = e[n]), (e[n] = t)),
            t._next ? (t._next._prev = t) : (e[r] = t),
            (t._prev = a),
            (t.parent = t._dp = e),
            t
          );
        },
        qt = function (e, t, n, r) {
          void 0 === n && (n = '_first'), void 0 === r && (r = '_last');
          var i = t._prev,
            s = t._next;
          i ? (i._next = s) : e[n] === t && (e[n] = s),
            s ? (s._prev = i) : e[r] === t && (e[r] = i),
            (t._next = t._prev = t.parent = null);
        },
        Ht = function (e, t) {
          e.parent &&
            (!t || e.parent.autoRemoveChildren) &&
            e.parent.remove &&
            e.parent.remove(e),
            (e._act = 0);
        },
        Bt = function (e, t) {
          if (e && (!t || t._end > e._dur || t._start < 0))
            for (var n = e; n; ) (n._dirty = 1), (n = n.parent);
          return e;
        },
        Xt = function (e, t, n, r) {
          return (
            e._startAt &&
            (ye
              ? e._startAt.revert(ft)
              : (e.vars.immediateRender && !e.vars.autoRevert) ||
                e._startAt.render(t, !0, r))
          );
        },
        Yt = function e(t) {
          return !t || (t._ts && e(t.parent));
        },
        Gt = function (e) {
          return e._repeat
            ? Wt(e._tTime, (e = e.duration() + e._rDelay)) * e
            : 0;
        },
        Wt = function (e, t) {
          var n = Math.floor((e /= t));
          return e && n === e ? n - 1 : n;
        },
        Vt = function (e, t) {
          return (
            (e - t._start) * t._ts +
            (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
          );
        },
        Ut = function (e) {
          return (e._end = kt(
            e._start + (e._tDur / Math.abs(e._ts || e._rts || ze) || 0)
          ));
        },
        Kt = function (e, t) {
          var n = e._dp;
          return (
            n &&
              n.smoothChildTiming &&
              e._ts &&
              ((e._start = kt(
                n._time -
                  (e._ts > 0
                    ? t / e._ts
                    : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)
              )),
              Ut(e),
              n._dirty || Bt(n, e)),
            e
          );
        },
        Qt = function (e, t) {
          var n;
          if (
            ((t._time || (t._initted && !t._dur)) &&
              ((n = Vt(e.rawTime(), t)),
              (!t._dur || un(0, t.totalDuration(), n) - t._tTime > ze) &&
                t.render(n, !0)),
            Bt(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
          ) {
            if (e._dur < e.duration())
              for (n = e; n._dp; )
                n.rawTime() >= 0 && n.totalTime(n._tTime), (n = n._dp);
            e._zTime = -1e-8;
          }
        },
        Zt = function (e, t, n, r) {
          return (
            t.parent && Ht(t),
            (t._start = kt(
              (Xe(n) ? n : n || e !== we ? on(e, n, t) : e._time) + t._delay
            )),
            (t._end = kt(
              t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)
            )),
            Ft(e, t, '_first', '_last', e._sort ? '_start' : 0),
            nn(t) || (e._recent = t),
            r || Qt(e, t),
            e._ts < 0 && Kt(e, e._tTime),
            e
          );
        },
        Jt = function (e, t) {
          return (
            (st.ScrollTrigger || lt('scrollTrigger', t)) &&
            st.ScrollTrigger.create(t, e)
          );
        },
        en = function (e, t, n, r, i) {
          return (
            sr(e, t, i),
            e._initted
              ? !n &&
                e._pt &&
                !ye &&
                ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) &&
                Se !== Nn.frame
                ? (gt.push(e), (e._lazy = [i, r]), 1)
                : void 0
              : 1
          );
        },
        tn = function e(t) {
          var n = t.parent;
          return (
            n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n))
          );
        },
        nn = function (e) {
          var t = e.data;
          return 'isFromStart' === t || 'isStart' === t;
        },
        rn = function (e, t, n, r) {
          var i = e._repeat,
            s = kt(t) || 0,
            a = e._tTime / e._tDur;
          return (
            a && !r && (e._time *= s / e._dur),
            (e._dur = s),
            (e._tDur = i
              ? i < 0
                ? 1e10
                : kt(s * (i + 1) + e._rDelay * i)
              : s),
            a > 0 && !r && Kt(e, (e._tTime = e._tDur * a)),
            e.parent && Ut(e),
            n || Bt(e.parent, e),
            e
          );
        },
        sn = function (e) {
          return e instanceof Jn ? Bt(e) : rn(e, e._dur);
        },
        an = { _start: 0, endTime: dt, totalDuration: dt },
        on = function e(t, n, r) {
          var i,
            s,
            a,
            o = t.labels,
            l = t._recent || an,
            c = t.duration() >= Ie ? l.endTime(!1) : t._dur;
          return He(n) && (isNaN(n) || n in o)
            ? ((s = n.charAt(0)),
              (a = '%' === n.substr(-1)),
              (i = n.indexOf('=')),
              '<' === s || '>' === s
                ? (i >= 0 && (n = n.replace(/=/, '')),
                  ('<' === s ? l._start : l.endTime(l._repeat >= 0)) +
                    (parseFloat(n.substr(1)) || 0) *
                      (a ? (i < 0 ? l : r).totalDuration() / 100 : 1))
                : i < 0
                ? (n in o || (o[n] = c), o[n])
                : ((s = parseFloat(n.charAt(i - 1) + n.substr(i + 1))),
                  a &&
                    r &&
                    (s = (s / 100) * (Qe(r) ? r[0] : r).totalDuration()),
                  i > 1 ? e(t, n.substr(0, i - 1), r) + s : c + s))
            : null == n
            ? c
            : +n;
        },
        ln = function (e, t, n) {
          var r,
            i,
            s = Xe(t[1]),
            a = (s ? 2 : 1) + (e < 2 ? 0 : 1),
            o = t[a];
          if ((s && (o.duration = t[1]), (o.parent = n), e)) {
            for (r = o, i = n; i && !('immediateRender' in r); )
              (r = i.vars.defaults || {}), (i = We(i.vars.inherit) && i.parent);
            (o.immediateRender = We(r.immediateRender)),
              e < 2 ? (o.runBackwards = 1) : (o.startAt = t[a - 1]);
          }
          return new ur(t[0], o, t[a + 1]);
        },
        cn = function (e, t) {
          return e || 0 === e ? t(e) : t;
        },
        un = function (e, t, n) {
          return n < e ? e : n > t ? t : n;
        },
        dn = function (e, t) {
          return He(e) && (t = it.exec(e)) ? t[1] : '';
        },
        pn = [].slice,
        fn = function (e, t) {
          return (
            e &&
            Ge(e) &&
            'length' in e &&
            ((!t && !e.length) || (e.length - 1 in e && Ge(e[0]))) &&
            !e.nodeType &&
            e !== xe
          );
        },
        hn = function (e, t, n) {
          return be && !t && be.selector
            ? be.selector(e)
            : !He(e) || n || (!Te && $n())
            ? Qe(e)
              ? (function (e, t, n) {
                  return (
                    void 0 === n && (n = []),
                    e.forEach(function (e) {
                      var r;
                      return (He(e) && !t) || fn(e, 1)
                        ? (r = n).push.apply(r, hn(e))
                        : n.push(e);
                    }) || n
                  );
                })(e, n)
              : fn(e)
              ? pn.call(e, 0)
              : e
              ? [e]
              : []
            : pn.call((t || Ee).querySelectorAll(e), 0);
        },
        mn = function (e) {
          return (
            (e = hn(e)[0] || ct('Invalid scope') || {}),
            function (t) {
              var n = e.current || e.nativeElement || e;
              return hn(
                t,
                n.querySelectorAll
                  ? n
                  : n === e
                  ? ct('Invalid scope') || Ee.createElement('div')
                  : e
              );
            }
          );
        },
        gn = function (e) {
          return e.sort(function () {
            return 0.5 - Math.random();
          });
        },
        vn = function (e) {
          if (Be(e)) return e;
          var t = Ge(e) ? e : { each: e },
            n = Gn(t.ease),
            r = t.from || 0,
            i = parseFloat(t.base) || 0,
            s = {},
            a = r > 0 && r < 1,
            o = isNaN(r) || a,
            l = t.axis,
            c = r,
            u = r;
          return (
            He(r)
              ? (c = u = { center: 0.5, edges: 0.5, end: 1 }[r] || 0)
              : !a && o && ((c = r[0]), (u = r[1])),
            function (e, a, d) {
              var p,
                f,
                h,
                m,
                g,
                v,
                y,
                b,
                w,
                x = (d || t).length,
                T = s[x];
              if (!T) {
                if (!(w = 'auto' === t.grid ? 0 : (t.grid || [1, Ie])[1])) {
                  for (
                    y = -Ie;
                    y < (y = d[w++].getBoundingClientRect().left) && w < x;

                  );
                  w--;
                }
                for (
                  T = s[x] = [],
                    p = o ? Math.min(w, x) * c - 0.5 : r % w,
                    f = w === Ie ? 0 : o ? (x * u) / w - 0.5 : (r / w) | 0,
                    y = 0,
                    b = Ie,
                    v = 0;
                  v < x;
                  v++
                )
                  (h = (v % w) - p),
                    (m = f - ((v / w) | 0)),
                    (T[v] = g =
                      l ? Math.abs('y' === l ? m : h) : $e(h * h + m * m)),
                    g > y && (y = g),
                    g < b && (b = g);
                'random' === r && gn(T),
                  (T.max = y - b),
                  (T.min = b),
                  (T.v = x =
                    (parseFloat(t.amount) ||
                      parseFloat(t.each) *
                        (w > x
                          ? x - 1
                          : l
                          ? 'y' === l
                            ? x / w
                            : w
                          : Math.max(w, x / w)) ||
                      0) * ('edges' === r ? -1 : 1)),
                  (T.b = x < 0 ? i - x : i),
                  (T.u = dn(t.amount || t.each) || 0),
                  (n = n && x < 0 ? Xn(n) : n);
              }
              return (
                (x = (T[e] - T.min) / T.max || 0),
                kt(T.b + (n ? n(x) : x) * T.v) + T.u
              );
            }
          );
        },
        yn = function (e) {
          var t = Math.pow(10, ((e + '').split('.')[1] || '').length);
          return function (n) {
            var r = kt(Math.round(parseFloat(n) / e) * e * t);
            return (r - (r % 1)) / t + (Xe(n) ? 0 : dn(n));
          };
        },
        bn = function (e, t) {
          var n,
            r,
            i = Qe(e);
          return (
            !i &&
              Ge(e) &&
              ((n = i = e.radius || Ie),
              e.values
                ? ((e = hn(e.values)), (r = !Xe(e[0])) && (n *= n))
                : (e = yn(e.increment))),
            cn(
              t,
              i
                ? Be(e)
                  ? function (t) {
                      return (r = e(t)), Math.abs(r - t) <= n ? r : t;
                    }
                  : function (t) {
                      for (
                        var i,
                          s,
                          a = parseFloat(r ? t.x : t),
                          o = parseFloat(r ? t.y : 0),
                          l = Ie,
                          c = 0,
                          u = e.length;
                        u--;

                      )
                        (i = r
                          ? (i = e[u].x - a) * i + (s = e[u].y - o) * s
                          : Math.abs(e[u] - a)) < l && ((l = i), (c = u));
                      return (
                        (c = !n || l <= n ? e[c] : t),
                        r || c === t || Xe(t) ? c : c + dn(t)
                      );
                    }
                : yn(e)
            )
          );
        },
        wn = function (e, t, n, r) {
          return cn(Qe(e) ? !t : !0 === n ? !!(n = 0) : !r, function () {
            return Qe(e)
              ? e[~~(Math.random() * e.length)]
              : (n = n || 1e-5) &&
                  (r = n < 1 ? Math.pow(10, (n + '').length - 2) : 1) &&
                  Math.floor(
                    Math.round(
                      (e - n / 2 + Math.random() * (t - e + 0.99 * n)) / n
                    ) *
                      n *
                      r
                  ) / r;
          });
        },
        xn = function (e, t, n) {
          return cn(n, function (n) {
            return e[~~t(n)];
          });
        },
        Tn = function (e) {
          for (var t, n, r, i, s = 0, a = ''; ~(t = e.indexOf('random(', s)); )
            (r = e.indexOf(')', t)),
              (i = '[' === e.charAt(t + 7)),
              (n = e.substr(t + 7, r - t - 7).match(i ? rt : Ze)),
              (a +=
                e.substr(s, t - s) +
                wn(i ? n : +n[0], i ? 0 : +n[1], +n[2] || 1e-5)),
              (s = r + 1);
          return a + e.substr(s, e.length - s);
        },
        En = function (e, t, n, r, i) {
          var s = t - e,
            a = r - n;
          return cn(i, function (t) {
            return n + (((t - e) / s) * a || 0);
          });
        },
        _n = function (e, t, n) {
          var r,
            i,
            s,
            a = e.labels,
            o = Ie;
          for (r in a)
            (i = a[r] - t) < 0 == !!n &&
              i &&
              o > (i = Math.abs(i)) &&
              ((s = r), (o = i));
          return s;
        },
        Sn = function (e, t, n) {
          var r,
            i,
            s,
            a = e.vars,
            o = a[t],
            l = be,
            c = e._ctx;
          if (o)
            return (
              (r = a[t + 'Params']),
              (i = a.callbackScope || e),
              n && gt.length && Lt(),
              c && (be = c),
              (s = r ? o.apply(i, r) : o.call(i)),
              (be = l),
              s
            );
        },
        Cn = function (e) {
          return (
            Ht(e),
            e.scrollTrigger && e.scrollTrigger.kill(!!ye),
            e.progress() < 1 && Sn(e, 'onInterrupt'),
            e
          );
        },
        Mn = [],
        kn = function (e) {
          if (Ve() && e) {
            var t = (e = (!e.name && e.default) || e).name,
              n = Be(e),
              r =
                t && !n && e.init
                  ? function () {
                      this._props = [];
                    }
                  : e,
              i = {
                init: dt,
                render: br,
                add: rr,
                kill: xr,
                modifier: wr,
                rawVars: 0,
              },
              s = {
                targetTest: 0,
                get: 0,
                getSetter: mr,
                aliases: {},
                register: 0,
              };
            if (($n(), e !== r)) {
              if (yt[t]) return;
              zt(r, zt(Nt(e, i), s)),
                Rt(r.prototype, Rt(i, Nt(e, s))),
                (yt[(r.prop = t)] = r),
                e.targetTest && (xt.push(r), (mt[t] = 1)),
                (t =
                  ('css' === t
                    ? 'CSS'
                    : t.charAt(0).toUpperCase() + t.substr(1)) + 'Plugin');
            }
            ut(t, r), e.register && e.register(jr, r, _r);
          } else e && Mn.push(e);
        },
        An = 255,
        Pn = {
          aqua: [0, An, An],
          lime: [0, An, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, An],
          navy: [0, 0, 128],
          white: [An, An, An],
          olive: [128, 128, 0],
          yellow: [An, An, 0],
          orange: [An, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [An, 0, 0],
          pink: [An, 192, 203],
          cyan: [0, An, An],
          transparent: [An, An, An, 0],
        },
        Ln = function (e, t, n) {
          return (
            ((6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1
              ? t + (n - t) * e * 6
              : e < 0.5
              ? n
              : 3 * e < 2
              ? t + (n - t) * (2 / 3 - e) * 6
              : t) *
              An +
              0.5) |
            0
          );
        },
        On = function (e, t, n) {
          var r,
            i,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f = e ? (Xe(e) ? [e >> 16, (e >> 8) & An, e & An] : 0) : Pn.black;
          if (!f) {
            if (
              (',' === e.substr(-1) && (e = e.substr(0, e.length - 1)), Pn[e])
            )
              f = Pn[e];
            else if ('#' === e.charAt(0)) {
              if (
                (e.length < 6 &&
                  ((r = e.charAt(1)),
                  (i = e.charAt(2)),
                  (s = e.charAt(3)),
                  (e =
                    '#' +
                    r +
                    r +
                    i +
                    i +
                    s +
                    s +
                    (5 === e.length ? e.charAt(4) + e.charAt(4) : ''))),
                9 === e.length)
              )
                return [
                  (f = parseInt(e.substr(1, 6), 16)) >> 16,
                  (f >> 8) & An,
                  f & An,
                  parseInt(e.substr(7), 16) / 255,
                ];
              f = [
                (e = parseInt(e.substr(1), 16)) >> 16,
                (e >> 8) & An,
                e & An,
              ];
            } else if ('hsl' === e.substr(0, 3))
              if (((f = p = e.match(Ze)), t)) {
                if (~e.indexOf('='))
                  return (f = e.match(Je)), n && f.length < 4 && (f[3] = 1), f;
              } else
                (a = (+f[0] % 360) / 360),
                  (o = +f[1] / 100),
                  (r =
                    2 * (l = +f[2] / 100) -
                    (i = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                  f.length > 3 && (f[3] *= 1),
                  (f[0] = Ln(a + 1 / 3, r, i)),
                  (f[1] = Ln(a, r, i)),
                  (f[2] = Ln(a - 1 / 3, r, i));
            else f = e.match(Ze) || Pn.transparent;
            f = f.map(Number);
          }
          return (
            t &&
              !p &&
              ((r = f[0] / An),
              (i = f[1] / An),
              (s = f[2] / An),
              (l = ((c = Math.max(r, i, s)) + (u = Math.min(r, i, s))) / 2),
              c === u
                ? (a = o = 0)
                : ((d = c - u),
                  (o = l > 0.5 ? d / (2 - c - u) : d / (c + u)),
                  (a =
                    c === r
                      ? (i - s) / d + (i < s ? 6 : 0)
                      : c === i
                      ? (s - r) / d + 2
                      : (r - i) / d + 4),
                  (a *= 60)),
              (f[0] = ~~(a + 0.5)),
              (f[1] = ~~(100 * o + 0.5)),
              (f[2] = ~~(100 * l + 0.5))),
            n && f.length < 4 && (f[3] = 1),
            f
          );
        },
        Dn = function (e) {
          var t = [],
            n = [],
            r = -1;
          return (
            e.split(zn).forEach(function (e) {
              var i = e.match(et) || [];
              t.push.apply(t, i), n.push((r += i.length + 1));
            }),
            (t.c = n),
            t
          );
        },
        In = function (e, t, n) {
          var r,
            i,
            s,
            a,
            o = '',
            l = (e + o).match(zn),
            c = t ? 'hsla(' : 'rgba(',
            u = 0;
          if (!l) return e;
          if (
            ((l = l.map(function (e) {
              return (
                (e = On(e, t, 1)) &&
                c +
                  (t
                    ? e[0] + ',' + e[1] + '%,' + e[2] + '%,' + e[3]
                    : e.join(',')) +
                  ')'
              );
            })),
            n && ((s = Dn(e)), (r = n.c).join(o) !== s.c.join(o)))
          )
            for (a = (i = e.replace(zn, '1').split(et)).length - 1; u < a; u++)
              o +=
                i[u] +
                (~r.indexOf(u)
                  ? l.shift() || c + '0,0,0,0)'
                  : (s.length ? s : l.length ? l : n).shift());
          if (!i)
            for (a = (i = e.split(zn)).length - 1; u < a; u++) o += i[u] + l[u];
          return o + i[a];
        },
        zn = (function () {
          var e,
            t =
              '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b';
          for (e in Pn) t += '|' + e + '\\b';
          return new RegExp(t + ')', 'gi');
        })(),
        Rn = /hsl[a]?\(/,
        jn = function (e) {
          var t,
            n = e.join(' ');
          if (((zn.lastIndex = 0), zn.test(n)))
            return (
              (t = Rn.test(n)),
              (e[1] = In(e[1], t)),
              (e[0] = In(e[0], t, Dn(e[1]))),
              !0
            );
        },
        Nn = (function () {
          var e,
            t,
            n,
            r,
            i,
            s,
            a = Date.now,
            o = 500,
            l = 33,
            c = a(),
            u = c,
            d = 1e3 / 240,
            p = d,
            f = [],
            h = function n(h) {
              var m,
                g,
                v,
                y,
                b = a() - u,
                w = !0 === h;
              if (
                (b > o && (c += b - l),
                ((m = (v = (u += b) - c) - p) > 0 || w) &&
                  ((y = ++r.frame),
                  (i = v - 1e3 * r.time),
                  (r.time = v /= 1e3),
                  (p += m + (m >= d ? 4 : d - m)),
                  (g = 1)),
                w || (e = t(n)),
                g)
              )
                for (s = 0; s < f.length; s++) f[s](v, i, y, h);
            };
          return (r = {
            time: 0,
            frame: 0,
            tick: function () {
              h(!0);
            },
            deltaRatio: function (e) {
              return i / (1e3 / (e || 60));
            },
            wake: function () {
              _e &&
                (!Te &&
                  Ve() &&
                  ((xe = Te = window),
                  (Ee = xe.document || {}),
                  (st.gsap = jr),
                  (xe.gsapVersions || (xe.gsapVersions = [])).push(jr.version),
                  ot(at || xe.GreenSockGlobals || (!xe.gsap && xe) || {}),
                  (n = xe.requestAnimationFrame),
                  Mn.forEach(kn)),
                e && r.sleep(),
                (t =
                  n ||
                  function (e) {
                    return setTimeout(e, (p - 1e3 * r.time + 1) | 0);
                  }),
                (Me = 1),
                h(2));
            },
            sleep: function () {
              (n ? xe.cancelAnimationFrame : clearTimeout)(e),
                (Me = 0),
                (t = dt);
            },
            lagSmoothing: function (e, t) {
              (o = e || 1 / 0), (l = Math.min(t || 33, o));
            },
            fps: function (e) {
              (d = 1e3 / (e || 240)), (p = 1e3 * r.time + d);
            },
            add: function (e, t, n) {
              var i = t
                ? function (t, n, s, a) {
                    e(t, n, s, a), r.remove(i);
                  }
                : e;
              return r.remove(e), f[n ? 'unshift' : 'push'](i), $n(), i;
            },
            remove: function (e, t) {
              ~(t = f.indexOf(e)) && f.splice(t, 1) && s >= t && s--;
            },
            _listeners: f,
          });
        })(),
        $n = function () {
          return !Me && Nn.wake();
        },
        Fn = {},
        qn = /^[\d.\-M][\d.\-,\s]/,
        Hn = /["']/g,
        Bn = function (e) {
          for (
            var t,
              n,
              r,
              i = {},
              s = e.substr(1, e.length - 3).split(':'),
              a = s[0],
              o = 1,
              l = s.length;
            o < l;
            o++
          )
            (n = s[o]),
              (t = o !== l - 1 ? n.lastIndexOf(',') : n.length),
              (r = n.substr(0, t)),
              (i[a] = isNaN(r) ? r.replace(Hn, '').trim() : +r),
              (a = n.substr(t + 1).trim());
          return i;
        },
        Xn = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        Yn = function e(t, n) {
          for (var r, i = t._first; i; )
            i instanceof Jn
              ? e(i, n)
              : !i.vars.yoyoEase ||
                (i._yoyo && i._repeat) ||
                i._yoyo === n ||
                (i.timeline
                  ? e(i.timeline, n)
                  : ((r = i._ease),
                    (i._ease = i._yEase),
                    (i._yEase = r),
                    (i._yoyo = n))),
              (i = i._next);
        },
        Gn = function (e, t) {
          return (
            (e &&
              (Be(e)
                ? e
                : Fn[e] ||
                  (function (e) {
                    var t,
                      n,
                      r,
                      i,
                      s = (e + '').split('('),
                      a = Fn[s[0]];
                    return a && s.length > 1 && a.config
                      ? a.config.apply(
                          null,
                          ~e.indexOf('{')
                            ? [Bn(s[1])]
                            : ((t = e),
                              (n = t.indexOf('(') + 1),
                              (r = t.indexOf(')')),
                              (i = t.indexOf('(', n)),
                              t.substring(
                                n,
                                ~i && i < r ? t.indexOf(')', r + 1) : r
                              ))
                                .split(',')
                                .map(Dt)
                        )
                      : Fn._CE && qn.test(e)
                      ? Fn._CE('', e)
                      : a;
                  })(e))) ||
            t
          );
        },
        Wn = function (e, t, n, r) {
          void 0 === n &&
            (n = function (e) {
              return 1 - t(1 - e);
            }),
            void 0 === r &&
              (r = function (e) {
                return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
              });
          var i,
            s = { easeIn: t, easeOut: n, easeInOut: r };
          return (
            Ct(e, function (e) {
              for (var t in ((Fn[e] = st[e] = s),
              (Fn[(i = e.toLowerCase())] = n),
              s))
                Fn[
                  i +
                    ('easeIn' === t
                      ? '.in'
                      : 'easeOut' === t
                      ? '.out'
                      : '.inOut')
                ] = Fn[e + '.' + t] = s[t];
            }),
            s
          );
        },
        Vn = function (e) {
          return function (t) {
            return t < 0.5
              ? (1 - e(1 - 2 * t)) / 2
              : 0.5 + e(2 * (t - 0.5)) / 2;
          };
        },
        Un = function e(t, n, r) {
          var i = n >= 1 ? n : 1,
            s = (r || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1),
            a = (s / Re) * (Math.asin(1 / i) || 0),
            o = function (e) {
              return 1 === e
                ? 1
                : i * Math.pow(2, -10 * e) * qe((e - a) * s) + 1;
            },
            l =
              'out' === t
                ? o
                : 'in' === t
                ? function (e) {
                    return 1 - o(1 - e);
                  }
                : Vn(o);
          return (
            (s = Re / s),
            (l.config = function (n, r) {
              return e(t, n, r);
            }),
            l
          );
        },
        Kn = function e(t, n) {
          void 0 === n && (n = 1.70158);
          var r = function (e) {
              return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
            },
            i =
              'out' === t
                ? r
                : 'in' === t
                ? function (e) {
                    return 1 - r(1 - e);
                  }
                : Vn(r);
          return (
            (i.config = function (n) {
              return e(t, n);
            }),
            i
          );
        };
      Ct('Linear,Quad,Cubic,Quart,Quint,Strong', function (e, t) {
        var n = t < 5 ? t + 1 : t;
        Wn(
          e + ',Power' + (n - 1),
          t
            ? function (e) {
                return Math.pow(e, n);
              }
            : function (e) {
                return e;
              },
          function (e) {
            return 1 - Math.pow(1 - e, n);
          },
          function (e) {
            return e < 0.5
              ? Math.pow(2 * e, n) / 2
              : 1 - Math.pow(2 * (1 - e), n) / 2;
          }
        );
      }),
        (Fn.Linear.easeNone = Fn.none = Fn.Linear.easeIn),
        Wn('Elastic', Un('in'), Un('out'), Un()),
        (ke = 7.5625),
        (Pe = 1 / (Ae = 2.75)),
        Wn(
          'Bounce',
          function (e) {
            return 1 - Le(1 - e);
          },
          (Le = function (e) {
            return e < Pe
              ? ke * e * e
              : e < 0.7272727272727273
              ? ke * Math.pow(e - 1.5 / Ae, 2) + 0.75
              : e < 0.9090909090909092
              ? ke * (e -= 2.25 / Ae) * e + 0.9375
              : ke * Math.pow(e - 2.625 / Ae, 2) + 0.984375;
          })
        ),
        Wn('Expo', function (e) {
          return e ? Math.pow(2, 10 * (e - 1)) : 0;
        }),
        Wn('Circ', function (e) {
          return -($e(1 - e * e) - 1);
        }),
        Wn('Sine', function (e) {
          return 1 === e ? 1 : 1 - Fe(e * je);
        }),
        Wn('Back', Kn('in'), Kn('out'), Kn()),
        (Fn.SteppedEase =
          Fn.steps =
          st.SteppedEase =
            {
              config: function (e, t) {
                void 0 === e && (e = 1);
                var n = 1 / e,
                  r = e + (t ? 0 : 1),
                  i = t ? 1 : 0;
                return function (e) {
                  return (((r * un(0, 0.99999999, e)) | 0) + i) * n;
                };
              },
            }),
        (De.ease = Fn['quad.out']),
        Ct(
          'onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt',
          function (e) {
            return (Tt += e + ',' + e + 'Params,');
          }
        );
      var Qn = function (e, t) {
          (this.id = Ne++),
            (e._gsap = this),
            (this.target = e),
            (this.harness = t),
            (this.get = t ? t.get : St),
            (this.set = t ? t.getSetter : mr);
        },
        Zn = (function () {
          function e(e) {
            (this.vars = e),
              (this._delay = +e.delay || 0),
              (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) &&
                ((this._rDelay = e.repeatDelay || 0),
                (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
              (this._ts = 1),
              rn(this, +e.duration, 1, 1),
              (this.data = e.data),
              be && ((this._ctx = be), be.data.push(this)),
              Me || Nn.wake();
          }
          var t = e.prototype;
          return (
            (t.delay = function (e) {
              return e || 0 === e
                ? (this.parent &&
                    this.parent.smoothChildTiming &&
                    this.startTime(this._start + e - this._delay),
                  (this._delay = e),
                  this)
                : this._delay;
            }),
            (t.duration = function (e) {
              return arguments.length
                ? this.totalDuration(
                    this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e
                  )
                : this.totalDuration() && this._dur;
            }),
            (t.totalDuration = function (e) {
              return arguments.length
                ? ((this._dirty = 0),
                  rn(
                    this,
                    this._repeat < 0
                      ? e
                      : (e - this._repeat * this._rDelay) / (this._repeat + 1)
                  ))
                : this._tDur;
            }),
            (t.totalTime = function (e, t) {
              if (($n(), !arguments.length)) return this._tTime;
              var n = this._dp;
              if (n && n.smoothChildTiming && this._ts) {
                for (
                  Kt(this, e), !n._dp || n.parent || Qt(n, this);
                  n && n.parent;

                )
                  n.parent._time !==
                    n._start +
                      (n._ts >= 0
                        ? n._tTime / n._ts
                        : (n.totalDuration() - n._tTime) / -n._ts) &&
                    n.totalTime(n._tTime, !0),
                    (n = n.parent);
                !this.parent &&
                  this._dp.autoRemoveChildren &&
                  ((this._ts > 0 && e < this._tDur) ||
                    (this._ts < 0 && e > 0) ||
                    (!this._tDur && !e)) &&
                  Zt(this._dp, this, this._start - this._delay);
              }
              return (
                (this._tTime !== e ||
                  (!this._dur && !t) ||
                  (this._initted && Math.abs(this._zTime) === ze) ||
                  (!e && !this._initted && (this.add || this._ptLookup))) &&
                  (this._ts || (this._pTime = e), Ot(this, e, t)),
                this
              );
            }),
            (t.time = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    Math.min(this.totalDuration(), e + Gt(this)) %
                      (this._dur + this._rDelay) || (e ? this._dur : 0),
                    t
                  )
                : this._time;
            }),
            (t.totalProgress = function (e, t) {
              return arguments.length
                ? this.totalTime(this.totalDuration() * e, t)
                : this.totalDuration()
                ? Math.min(1, this._tTime / this._tDur)
                : this.ratio;
            }),
            (t.progress = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    this.duration() *
                      (!this._yoyo || 1 & this.iteration() ? e : 1 - e) +
                      Gt(this),
                    t
                  )
                : this.duration()
                ? Math.min(1, this._time / this._dur)
                : this.ratio;
            }),
            (t.iteration = function (e, t) {
              var n = this.duration() + this._rDelay;
              return arguments.length
                ? this.totalTime(this._time + (e - 1) * n, t)
                : this._repeat
                ? Wt(this._tTime, n) + 1
                : 1;
            }),
            (t.timeScale = function (e) {
              if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
              if (this._rts === e) return this;
              var t =
                this.parent && this._ts
                  ? Vt(this.parent._time, this)
                  : this._tTime;
              return (
                (this._rts = +e || 0),
                (this._ts = this._ps || -1e-8 === e ? 0 : this._rts),
                this.totalTime(un(-Math.abs(this._delay), this._tDur, t), !0),
                Ut(this),
                (function (e) {
                  for (var t = e.parent; t && t.parent; )
                    (t._dirty = 1), t.totalDuration(), (t = t.parent);
                  return e;
                })(this)
              );
            }),
            (t.paused = function (e) {
              return arguments.length
                ? (this._ps !== e &&
                    ((this._ps = e),
                    e
                      ? ((this._pTime =
                          this._tTime ||
                          Math.max(-this._delay, this.rawTime())),
                        (this._ts = this._act = 0))
                      : ($n(),
                        (this._ts = this._rts),
                        this.totalTime(
                          this.parent && !this.parent.smoothChildTiming
                            ? this.rawTime()
                            : this._tTime || this._pTime,
                          1 === this.progress() &&
                            Math.abs(this._zTime) !== ze &&
                            (this._tTime -= ze)
                        ))),
                  this)
                : this._ps;
            }),
            (t.startTime = function (e) {
              if (arguments.length) {
                this._start = e;
                var t = this.parent || this._dp;
                return (
                  t &&
                    (t._sort || !this.parent) &&
                    Zt(t, this, e - this._delay),
                  this
                );
              }
              return this._start;
            }),
            (t.endTime = function (e) {
              return (
                this._start +
                (We(e) ? this.totalDuration() : this.duration()) /
                  Math.abs(this._ts || 1)
              );
            }),
            (t.rawTime = function (e) {
              var t = this.parent || this._dp;
              return t
                ? e &&
                  (!this._ts ||
                    (this._repeat && this._time && this.totalProgress() < 1))
                  ? this._tTime % (this._dur + this._rDelay)
                  : this._ts
                  ? Vt(t.rawTime(e), this)
                  : this._tTime
                : this._tTime;
            }),
            (t.revert = function (e) {
              void 0 === e && (e = ht);
              var t = ye;
              return (
                (ye = e),
                (this._initted || this._startAt) &&
                  (this.timeline && this.timeline.revert(e),
                  this.totalTime(-0.01, e.suppressEvents)),
                'nested' !== this.data && !1 !== e.kill && this.kill(),
                (ye = t),
                this
              );
            }),
            (t.globalTime = function (e) {
              for (var t = this, n = arguments.length ? e : t.rawTime(); t; )
                (n = t._start + n / (t._ts || 1)), (t = t._dp);
              return !this.parent && this._sat
                ? this._sat.vars.immediateRender
                  ? -1
                  : this._sat.globalTime(e)
                : n;
            }),
            (t.repeat = function (e) {
              return arguments.length
                ? ((this._repeat = e === 1 / 0 ? -2 : e), sn(this))
                : -2 === this._repeat
                ? 1 / 0
                : this._repeat;
            }),
            (t.repeatDelay = function (e) {
              if (arguments.length) {
                var t = this._time;
                return (this._rDelay = e), sn(this), t ? this.time(t) : this;
              }
              return this._rDelay;
            }),
            (t.yoyo = function (e) {
              return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
            }),
            (t.seek = function (e, t) {
              return this.totalTime(on(this, e), We(t));
            }),
            (t.restart = function (e, t) {
              return this.play().totalTime(e ? -this._delay : 0, We(t));
            }),
            (t.play = function (e, t) {
              return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
            }),
            (t.reverse = function (e, t) {
              return (
                null != e && this.seek(e || this.totalDuration(), t),
                this.reversed(!0).paused(!1)
              );
            }),
            (t.pause = function (e, t) {
              return null != e && this.seek(e, t), this.paused(!0);
            }),
            (t.resume = function () {
              return this.paused(!1);
            }),
            (t.reversed = function (e) {
              return arguments.length
                ? (!!e !== this.reversed() &&
                    this.timeScale(-this._rts || (e ? -1e-8 : 0)),
                  this)
                : this._rts < 0;
            }),
            (t.invalidate = function () {
              return (
                (this._initted = this._act = 0), (this._zTime = -1e-8), this
              );
            }),
            (t.isActive = function () {
              var e,
                t = this.parent || this._dp,
                n = this._start;
              return !(
                t &&
                !(
                  this._ts &&
                  this._initted &&
                  t.isActive() &&
                  (e = t.rawTime(!0)) >= n &&
                  e < this.endTime(!0) - ze
                )
              );
            }),
            (t.eventCallback = function (e, t, n) {
              var r = this.vars;
              return arguments.length > 1
                ? (t
                    ? ((r[e] = t),
                      n && (r[e + 'Params'] = n),
                      'onUpdate' === e && (this._onUpdate = t))
                    : delete r[e],
                  this)
                : r[e];
            }),
            (t.then = function (e) {
              var t = this;
              return new Promise(function (n) {
                var r = Be(e) ? e : It,
                  i = function () {
                    var e = t.then;
                    (t.then = null),
                      Be(r) &&
                        (r = r(t)) &&
                        (r.then || r === t) &&
                        (t.then = e),
                      n(r),
                      (t.then = e);
                  };
                (t._initted && 1 === t.totalProgress() && t._ts >= 0) ||
                (!t._tTime && t._ts < 0)
                  ? i()
                  : (t._prom = i);
              });
            }),
            (t.kill = function () {
              Cn(this);
            }),
            e
          );
        })();
      zt(Zn.prototype, {
        _time: 0,
        _start: 0,
        _end: 0,
        _tTime: 0,
        _tDur: 0,
        _dirty: 0,
        _repeat: 0,
        _yoyo: !1,
        parent: null,
        _initted: !1,
        _rDelay: 0,
        _ts: 1,
        _dp: 0,
        ratio: 0,
        _zTime: -1e-8,
        _prom: 0,
        _ps: !1,
        _rts: 1,
      });
      var Jn = (function (e) {
        function t(t, n) {
          var r;
          return (
            void 0 === t && (t = {}),
            ((r = e.call(this, t) || this).labels = {}),
            (r.smoothChildTiming = !!t.smoothChildTiming),
            (r.autoRemoveChildren = !!t.autoRemoveChildren),
            (r._sort = We(t.sortChildren)),
            we && Zt(t.parent || we, me(r), n),
            t.reversed && r.reverse(),
            t.paused && r.paused(!0),
            t.scrollTrigger && Jt(me(r), t.scrollTrigger),
            r
          );
        }
        ge(t, e);
        var n = t.prototype;
        return (
          (n.to = function (e, t, n) {
            return ln(0, arguments, this), this;
          }),
          (n.from = function (e, t, n) {
            return ln(1, arguments, this), this;
          }),
          (n.fromTo = function (e, t, n, r) {
            return ln(2, arguments, this), this;
          }),
          (n.set = function (e, t, n) {
            return (
              (t.duration = 0),
              (t.parent = this),
              $t(t).repeatDelay || (t.repeat = 0),
              (t.immediateRender = !!t.immediateRender),
              new ur(e, t, on(this, n), 1),
              this
            );
          }),
          (n.call = function (e, t, n) {
            return Zt(this, ur.delayedCall(0, e, t), n);
          }),
          (n.staggerTo = function (e, t, n, r, i, s, a) {
            return (
              (n.duration = t),
              (n.stagger = n.stagger || r),
              (n.onComplete = s),
              (n.onCompleteParams = a),
              (n.parent = this),
              new ur(e, n, on(this, i)),
              this
            );
          }),
          (n.staggerFrom = function (e, t, n, r, i, s, a) {
            return (
              (n.runBackwards = 1),
              ($t(n).immediateRender = We(n.immediateRender)),
              this.staggerTo(e, t, n, r, i, s, a)
            );
          }),
          (n.staggerFromTo = function (e, t, n, r, i, s, a, o) {
            return (
              (r.startAt = n),
              ($t(r).immediateRender = We(r.immediateRender)),
              this.staggerTo(e, t, r, i, s, a, o)
            );
          }),
          (n.render = function (e, t, n) {
            var r,
              i,
              s,
              a,
              o,
              l,
              c,
              u,
              d,
              p,
              f,
              h,
              m = this._time,
              g = this._dirty ? this.totalDuration() : this._tDur,
              v = this._dur,
              y = e <= 0 ? 0 : kt(e),
              b = this._zTime < 0 != e < 0 && (this._initted || !v);
            if (
              (this !== we && y > g && e >= 0 && (y = g),
              y !== this._tTime || n || b)
            ) {
              if (
                (m !== this._time &&
                  v &&
                  ((y += this._time - m), (e += this._time - m)),
                (r = y),
                (d = this._start),
                (l = !(u = this._ts)),
                b && (v || (m = this._zTime), (e || !t) && (this._zTime = e)),
                this._repeat)
              ) {
                if (
                  ((f = this._yoyo),
                  (o = v + this._rDelay),
                  this._repeat < -1 && e < 0)
                )
                  return this.totalTime(100 * o + e, t, n);
                if (
                  ((r = kt(y % o)),
                  y === g
                    ? ((a = this._repeat), (r = v))
                    : ((a = ~~(y / o)) && a === y / o && ((r = v), a--),
                      r > v && (r = v)),
                  (p = Wt(this._tTime, o)),
                  !m &&
                    this._tTime &&
                    p !== a &&
                    this._tTime - p * o - this._dur <= 0 &&
                    (p = a),
                  f && 1 & a && ((r = v - r), (h = 1)),
                  a !== p && !this._lock)
                ) {
                  var w = f && 1 & p,
                    x = w === (f && 1 & a);
                  if (
                    (a < p && (w = !w),
                    (m = w ? 0 : v),
                    (this._lock = 1),
                    (this.render(m || (h ? 0 : kt(a * o)), t, !v)._lock = 0),
                    (this._tTime = y),
                    !t && this.parent && Sn(this, 'onRepeat'),
                    this.vars.repeatRefresh &&
                      !h &&
                      (this.invalidate()._lock = 1),
                    (m && m !== this._time) ||
                      l !== !this._ts ||
                      (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (
                    ((v = this._dur),
                    (g = this._tDur),
                    x &&
                      ((this._lock = 2),
                      (m = w ? v : -1e-4),
                      this.render(m, !0),
                      this.vars.repeatRefresh && !h && this.invalidate()),
                    (this._lock = 0),
                    !this._ts && !l)
                  )
                    return this;
                  Yn(this, h);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  ((c = (function (e, t, n) {
                    var r;
                    if (n > t)
                      for (r = e._first; r && r._start <= n; ) {
                        if ('isPause' === r.data && r._start > t) return r;
                        r = r._next;
                      }
                    else
                      for (r = e._last; r && r._start >= n; ) {
                        if ('isPause' === r.data && r._start < t) return r;
                        r = r._prev;
                      }
                  })(this, kt(m), kt(r))),
                  c && (y -= r - (r = c._start))),
                (this._tTime = y),
                (this._time = r),
                (this._act = !u),
                this._initted ||
                  ((this._onUpdate = this.vars.onUpdate),
                  (this._initted = 1),
                  (this._zTime = e),
                  (m = 0)),
                !m && r && !t && !a && (Sn(this, 'onStart'), this._tTime !== y))
              )
                return this;
              if (r >= m && e >= 0)
                for (i = this._first; i; ) {
                  if (
                    ((s = i._next),
                    (i._act || r >= i._start) && i._ts && c !== i)
                  ) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if (
                      (i.render(
                        i._ts > 0
                          ? (r - i._start) * i._ts
                          : (i._dirty ? i.totalDuration() : i._tDur) +
                              (r - i._start) * i._ts,
                        t,
                        n
                      ),
                      r !== this._time || (!this._ts && !l))
                    ) {
                      (c = 0), s && (y += this._zTime = -1e-8);
                      break;
                    }
                  }
                  i = s;
                }
              else {
                i = this._last;
                for (var T = e < 0 ? e : r; i; ) {
                  if (
                    ((s = i._prev), (i._act || T <= i._end) && i._ts && c !== i)
                  ) {
                    if (i.parent !== this) return this.render(e, t, n);
                    if (
                      (i.render(
                        i._ts > 0
                          ? (T - i._start) * i._ts
                          : (i._dirty ? i.totalDuration() : i._tDur) +
                              (T - i._start) * i._ts,
                        t,
                        n || (ye && (i._initted || i._startAt))
                      ),
                      r !== this._time || (!this._ts && !l))
                    ) {
                      (c = 0), s && (y += this._zTime = T ? -1e-8 : ze);
                      break;
                    }
                  }
                  i = s;
                }
              }
              if (
                c &&
                !t &&
                (this.pause(),
                (c.render(r >= m ? 0 : -1e-8)._zTime = r >= m ? 1 : -1),
                this._ts)
              )
                return (this._start = d), Ut(this), this.render(e, t, n);
              this._onUpdate && !t && Sn(this, 'onUpdate', !0),
                ((y === g && this._tTime >= this.totalDuration()) ||
                  (!y && m)) &&
                  ((d !== this._start && Math.abs(u) === Math.abs(this._ts)) ||
                    this._lock ||
                    ((e || !v) &&
                      ((y === g && this._ts > 0) || (!y && this._ts < 0)) &&
                      Ht(this, 1),
                    t ||
                      (e < 0 && !m) ||
                      (!y && !m && g) ||
                      (Sn(
                        this,
                        y === g && e >= 0 ? 'onComplete' : 'onReverseComplete',
                        !0
                      ),
                      this._prom &&
                        !(y < g && this.timeScale() > 0) &&
                        this._prom())));
            }
            return this;
          }),
          (n.add = function (e, t) {
            var n = this;
            if ((Xe(t) || (t = on(this, t, e)), !(e instanceof Zn))) {
              if (Qe(e))
                return (
                  e.forEach(function (e) {
                    return n.add(e, t);
                  }),
                  this
                );
              if (He(e)) return this.addLabel(e, t);
              if (!Be(e)) return this;
              e = ur.delayedCall(0, e);
            }
            return this !== e ? Zt(this, e, t) : this;
          }),
          (n.getChildren = function (e, t, n, r) {
            void 0 === e && (e = !0),
              void 0 === t && (t = !0),
              void 0 === n && (n = !0),
              void 0 === r && (r = -Ie);
            for (var i = [], s = this._first; s; )
              s._start >= r &&
                (s instanceof ur
                  ? t && i.push(s)
                  : (n && i.push(s),
                    e && i.push.apply(i, s.getChildren(!0, t, n)))),
                (s = s._next);
            return i;
          }),
          (n.getById = function (e) {
            for (var t = this.getChildren(1, 1, 1), n = t.length; n--; )
              if (t[n].vars.id === e) return t[n];
          }),
          (n.remove = function (e) {
            return He(e)
              ? this.removeLabel(e)
              : Be(e)
              ? this.killTweensOf(e)
              : (qt(this, e),
                e === this._recent && (this._recent = this._last),
                Bt(this));
          }),
          (n.totalTime = function (t, n) {
            return arguments.length
              ? ((this._forcing = 1),
                !this._dp &&
                  this._ts &&
                  (this._start = kt(
                    Nn.time -
                      (this._ts > 0
                        ? t / this._ts
                        : (this.totalDuration() - t) / -this._ts)
                  )),
                e.prototype.totalTime.call(this, t, n),
                (this._forcing = 0),
                this)
              : this._tTime;
          }),
          (n.addLabel = function (e, t) {
            return (this.labels[e] = on(this, t)), this;
          }),
          (n.removeLabel = function (e) {
            return delete this.labels[e], this;
          }),
          (n.addPause = function (e, t, n) {
            var r = ur.delayedCall(0, t || dt, n);
            return (
              (r.data = 'isPause'),
              (this._hasPause = 1),
              Zt(this, r, on(this, e))
            );
          }),
          (n.removePause = function (e) {
            var t = this._first;
            for (e = on(this, e); t; )
              t._start === e && 'isPause' === t.data && Ht(t), (t = t._next);
          }),
          (n.killTweensOf = function (e, t, n) {
            for (var r = this.getTweensOf(e, n), i = r.length; i--; )
              er !== r[i] && r[i].kill(e, t);
            return this;
          }),
          (n.getTweensOf = function (e, t) {
            for (var n, r = [], i = hn(e), s = this._first, a = Xe(t); s; )
              s instanceof ur
                ? Pt(s._targets, i) &&
                  (a
                    ? (!er || (s._initted && s._ts)) &&
                      s.globalTime(0) <= t &&
                      s.globalTime(s.totalDuration()) > t
                    : !t || s.isActive()) &&
                  r.push(s)
                : (n = s.getTweensOf(i, t)).length && r.push.apply(r, n),
                (s = s._next);
            return r;
          }),
          (n.tweenTo = function (e, t) {
            t = t || {};
            var n,
              r = this,
              i = on(r, e),
              s = t,
              a = s.startAt,
              o = s.onStart,
              l = s.onStartParams,
              c = s.immediateRender,
              u = ur.to(
                r,
                zt(
                  {
                    ease: t.ease || 'none',
                    lazy: !1,
                    immediateRender: !1,
                    time: i,
                    overwrite: 'auto',
                    duration:
                      t.duration ||
                      Math.abs(
                        (i - (a && 'time' in a ? a.time : r._time)) /
                          r.timeScale()
                      ) ||
                      ze,
                    onStart: function () {
                      if ((r.pause(), !n)) {
                        var e =
                          t.duration ||
                          Math.abs(
                            (i - (a && 'time' in a ? a.time : r._time)) /
                              r.timeScale()
                          );
                        u._dur !== e && rn(u, e, 0, 1).render(u._time, !0, !0),
                          (n = 1);
                      }
                      o && o.apply(u, l || []);
                    },
                  },
                  t
                )
              );
            return c ? u.render(0) : u;
          }),
          (n.tweenFromTo = function (e, t, n) {
            return this.tweenTo(t, zt({ startAt: { time: on(this, e) } }, n));
          }),
          (n.recent = function () {
            return this._recent;
          }),
          (n.nextLabel = function (e) {
            return void 0 === e && (e = this._time), _n(this, on(this, e));
          }),
          (n.previousLabel = function (e) {
            return void 0 === e && (e = this._time), _n(this, on(this, e), 1);
          }),
          (n.currentLabel = function (e) {
            return arguments.length
              ? this.seek(e, !0)
              : this.previousLabel(this._time + ze);
          }),
          (n.shiftChildren = function (e, t, n) {
            void 0 === n && (n = 0);
            for (var r, i = this._first, s = this.labels; i; )
              i._start >= n && ((i._start += e), (i._end += e)), (i = i._next);
            if (t) for (r in s) s[r] >= n && (s[r] += e);
            return Bt(this);
          }),
          (n.invalidate = function (t) {
            var n = this._first;
            for (this._lock = 0; n; ) n.invalidate(t), (n = n._next);
            return e.prototype.invalidate.call(this, t);
          }),
          (n.clear = function (e) {
            void 0 === e && (e = !0);
            for (var t, n = this._first; n; )
              (t = n._next), this.remove(n), (n = t);
            return (
              this._dp && (this._time = this._tTime = this._pTime = 0),
              e && (this.labels = {}),
              Bt(this)
            );
          }),
          (n.totalDuration = function (e) {
            var t,
              n,
              r,
              i = 0,
              s = this,
              a = s._last,
              o = Ie;
            if (arguments.length)
              return s.timeScale(
                (s._repeat < 0 ? s.duration() : s.totalDuration()) /
                  (s.reversed() ? -e : e)
              );
            if (s._dirty) {
              for (r = s.parent; a; )
                (t = a._prev),
                  a._dirty && a.totalDuration(),
                  (n = a._start) > o && s._sort && a._ts && !s._lock
                    ? ((s._lock = 1), (Zt(s, a, n - a._delay, 1)._lock = 0))
                    : (o = n),
                  n < 0 &&
                    a._ts &&
                    ((i -= n),
                    ((!r && !s._dp) || (r && r.smoothChildTiming)) &&
                      ((s._start += n / s._ts),
                      (s._time -= n),
                      (s._tTime -= n)),
                    s.shiftChildren(-n, !1, -Infinity),
                    (o = 0)),
                  a._end > i && a._ts && (i = a._end),
                  (a = t);
              rn(s, s === we && s._time > i ? s._time : i, 1, 1),
                (s._dirty = 0);
            }
            return s._tDur;
          }),
          (t.updateRoot = function (e) {
            if (
              (we._ts && (Ot(we, Vt(e, we)), (Se = Nn.frame)), Nn.frame >= wt)
            ) {
              wt += Oe.autoSleep || 120;
              var t = we._first;
              if ((!t || !t._ts) && Oe.autoSleep && Nn._listeners.length < 2) {
                for (; t && !t._ts; ) t = t._next;
                t || Nn.sleep();
              }
            }
          }),
          t
        );
      })(Zn);
      zt(Jn.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var er,
        tr,
        nr = function (e, t, n, r, i, s, a) {
          var o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m = new _r(this._pt, e, t, 0, 1, yr, null, i),
            g = 0,
            v = 0;
          for (
            m.b = n,
              m.e = r,
              n += '',
              (f = ~(r += '').indexOf('random(')) && (r = Tn(r)),
              s && (s((h = [n, r]), e, t), (n = h[0]), (r = h[1])),
              l = n.match(tt) || [];
            (o = tt.exec(r));

          )
            (u = o[0]),
              (d = r.substring(g, o.index)),
              c ? (c = (c + 1) % 5) : 'rgba(' === d.substr(-5) && (c = 1),
              u !== l[v++] &&
                ((p = parseFloat(l[v - 1]) || 0),
                (m._pt = {
                  _next: m._pt,
                  p: d || 1 === v ? d : ',',
                  s: p,
                  c: '=' === u.charAt(1) ? At(p, u) - p : parseFloat(u) - p,
                  m: c && c < 4 ? Math.round : 0,
                }),
                (g = tt.lastIndex));
          return (
            (m.c = g < r.length ? r.substring(g, r.length) : ''),
            (m.fp = a),
            (nt.test(r) || f) && (m.e = 0),
            (this._pt = m),
            m
          );
        },
        rr = function (e, t, n, r, i, s, a, o, l, c) {
          Be(r) && (r = r(i || 0, e, s));
          var u,
            d = e[t],
            p =
              'get' !== n
                ? n
                : Be(d)
                ? l
                  ? e[
                      t.indexOf('set') || !Be(e['get' + t.substr(3)])
                        ? t
                        : 'get' + t.substr(3)
                    ](l)
                  : e[t]()
                : d,
            f = Be(d) ? (l ? fr : pr) : dr;
          if (
            (He(r) &&
              (~r.indexOf('random(') && (r = Tn(r)),
              '=' === r.charAt(1) &&
                ((u = At(p, r) + (dn(p) || 0)) || 0 === u) &&
                (r = u)),
            !c || p !== r || tr)
          )
            return isNaN(p * r) || '' === r
              ? (!d && !(t in e) && lt(t, r),
                nr.call(this, e, t, p, r, f, o || Oe.stringFilter, l))
              : ((u = new _r(
                  this._pt,
                  e,
                  t,
                  +p || 0,
                  r - (p || 0),
                  'boolean' == typeof d ? vr : gr,
                  0,
                  f
                )),
                l && (u.fp = l),
                a && u.modifier(a, this, e),
                (this._pt = u));
        },
        ir = function (e, t, n, r, i, s) {
          var a, o, l, c;
          if (
            yt[e] &&
            !1 !==
              (a = new yt[e]()).init(
                i,
                a.rawVars
                  ? t[e]
                  : (function (e, t, n, r, i) {
                      if (
                        (Be(e) && (e = or(e, i, t, n, r)),
                        !Ge(e) || (e.style && e.nodeType) || Qe(e) || Ke(e))
                      )
                        return He(e) ? or(e, i, t, n, r) : e;
                      var s,
                        a = {};
                      for (s in e) a[s] = or(e[s], i, t, n, r);
                      return a;
                    })(t[e], r, i, s, n),
                n,
                r,
                s
              ) &&
            ((n._pt = o =
              new _r(n._pt, i, e, 0, 1, a.render, a, 0, a.priority)),
            n !== Ce)
          )
            for (
              l = n._ptLookup[n._targets.indexOf(i)], c = a._props.length;
              c--;

            )
              l[a._props[c]] = o;
          return a;
        },
        sr = function e(t, n, r) {
          var i,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g,
            v = t.vars,
            y = v.ease,
            b = v.startAt,
            w = v.immediateRender,
            x = v.lazy,
            T = v.onUpdate,
            E = v.onUpdateParams,
            _ = v.callbackScope,
            S = v.runBackwards,
            C = v.yoyoEase,
            M = v.keyframes,
            k = v.autoRevert,
            A = t._dur,
            P = t._startAt,
            L = t._targets,
            O = t.parent,
            D = O && 'nested' === O.data ? O.vars.targets : L,
            I = 'auto' === t._overwrite && !ve,
            z = t.timeline;
          if (
            (z && (!M || !y) && (y = 'none'),
            (t._ease = Gn(y, De.ease)),
            (t._yEase = C ? Xn(Gn(!0 === C ? y : C, De.ease)) : 0),
            C &&
              t._yoyo &&
              !t._repeat &&
              ((C = t._yEase), (t._yEase = t._ease), (t._ease = C)),
            (t._from = !z && !!v.runBackwards),
            !z || (M && !v.stagger))
          ) {
            if (
              ((m = (d = L[0] ? _t(L[0]).harness : 0) && v[d.prop]),
              (i = Nt(v, mt)),
              P &&
                (P._zTime < 0 && P.progress(1),
                n < 0 && S && w && !k
                  ? P.render(-1, !0)
                  : P.revert(S && A ? ft : pt),
                (P._lazy = 0)),
              b)
            ) {
              if (
                (Ht(
                  (t._startAt = ur.set(
                    L,
                    zt(
                      {
                        data: 'isStart',
                        overwrite: !1,
                        parent: O,
                        immediateRender: !0,
                        lazy: !P && We(x),
                        startAt: null,
                        delay: 0,
                        onUpdate: T,
                        onUpdateParams: E,
                        callbackScope: _,
                        stagger: 0,
                      },
                      b
                    )
                  ))
                ),
                (t._startAt._dp = 0),
                (t._startAt._sat = t),
                n < 0 && (ye || (!w && !k)) && t._startAt.revert(ft),
                w && A && n <= 0 && r <= 0)
              )
                return void (n && (t._zTime = n));
            } else if (S && A && !P)
              if (
                (n && (w = !1),
                (a = zt(
                  {
                    overwrite: !1,
                    data: 'isFromStart',
                    lazy: w && !P && We(x),
                    immediateRender: w,
                    stagger: 0,
                    parent: O,
                  },
                  i
                )),
                m && (a[d.prop] = m),
                Ht((t._startAt = ur.set(L, a))),
                (t._startAt._dp = 0),
                (t._startAt._sat = t),
                n < 0 &&
                  (ye ? t._startAt.revert(ft) : t._startAt.render(-1, !0)),
                (t._zTime = n),
                w)
              ) {
                if (!n) return;
              } else e(t._startAt, ze, ze);
            for (
              t._pt = t._ptCache = 0, x = (A && We(x)) || (x && !A), s = 0;
              s < L.length;
              s++
            ) {
              if (
                ((u = (l = L[s])._gsap || Et(L)[s]._gsap),
                (t._ptLookup[s] = f = {}),
                vt[u.id] && gt.length && Lt(),
                (h = D === L ? s : D.indexOf(l)),
                d &&
                  !1 !== (p = new d()).init(l, m || i, t, h, D) &&
                  ((t._pt = o =
                    new _r(t._pt, l, p.name, 0, 1, p.render, p, 0, p.priority)),
                  p._props.forEach(function (e) {
                    f[e] = o;
                  }),
                  p.priority && (c = 1)),
                !d || m)
              )
                for (a in i)
                  yt[a] && (p = ir(a, i, t, h, l, D))
                    ? p.priority && (c = 1)
                    : (f[a] = o =
                        rr.call(t, l, a, 'get', i[a], h, D, 0, v.stringFilter));
              t._op && t._op[s] && t.kill(l, t._op[s]),
                I &&
                  t._pt &&
                  ((er = t),
                  we.killTweensOf(l, f, t.globalTime(n)),
                  (g = !t.parent),
                  (er = 0)),
                t._pt && x && (vt[u.id] = 1);
            }
            c && Er(t), t._onInit && t._onInit(t);
          }
          (t._onUpdate = T),
            (t._initted = (!t._op || t._pt) && !g),
            M && n <= 0 && z.render(Ie, !0, !0);
        },
        ar = function (e, t, n, r) {
          var i,
            s,
            a = t.ease || r || 'power1.inOut';
          if (Qe(t))
            (s = n[e] || (n[e] = [])),
              t.forEach(function (e, n) {
                return s.push({ t: (n / (t.length - 1)) * 100, v: e, e: a });
              });
          else
            for (i in t)
              (s = n[i] || (n[i] = [])),
                'ease' === i || s.push({ t: parseFloat(e), v: t[i], e: a });
        },
        or = function (e, t, n, r, i) {
          return Be(e)
            ? e.call(t, n, r, i)
            : He(e) && ~e.indexOf('random(')
            ? Tn(e)
            : e;
        },
        lr = Tt + 'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert',
        cr = {};
      Ct(lr + ',id,stagger,delay,duration,paused,scrollTrigger', function (e) {
        return (cr[e] = 1);
      });
      var ur = (function (e) {
        function t(t, n, r, i) {
          var s;
          'number' == typeof n && ((r.duration = n), (n = r), (r = null));
          var a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h = (s = e.call(this, i ? n : $t(n)) || this).vars,
            m = h.duration,
            g = h.delay,
            v = h.immediateRender,
            y = h.stagger,
            b = h.overwrite,
            w = h.keyframes,
            x = h.defaults,
            T = h.scrollTrigger,
            E = h.yoyoEase,
            _ = n.parent || we,
            S = (Qe(t) || Ke(t) ? Xe(t[0]) : 'length' in n) ? [t] : hn(t);
          if (
            ((s._targets = S.length
              ? Et(S)
              : ct(
                  'GSAP target ' + t + ' not found. https://greensock.com',
                  !Oe.nullTargetWarn
                ) || []),
            (s._ptLookup = []),
            (s._overwrite = b),
            w || y || Ue(m) || Ue(g))
          ) {
            if (
              ((n = s.vars),
              (a = s.timeline =
                new Jn({
                  data: 'nested',
                  defaults: x || {},
                  targets: _ && 'nested' === _.data ? _.vars.targets : S,
                })).kill(),
              (a.parent = a._dp = me(s)),
              (a._start = 0),
              y || Ue(m) || Ue(g))
            ) {
              if (((c = S.length), (p = y && vn(y)), Ge(y)))
                for (u in y) ~lr.indexOf(u) && (f || (f = {}), (f[u] = y[u]));
              for (o = 0; o < c; o++)
                ((l = Nt(n, cr)).stagger = 0),
                  E && (l.yoyoEase = E),
                  f && Rt(l, f),
                  (d = S[o]),
                  (l.duration = +or(m, me(s), o, d, S)),
                  (l.delay = (+or(g, me(s), o, d, S) || 0) - s._delay),
                  !y &&
                    1 === c &&
                    l.delay &&
                    ((s._delay = g = l.delay), (s._start += g), (l.delay = 0)),
                  a.to(d, l, p ? p(o, d, S) : 0),
                  (a._ease = Fn.none);
              a.duration() ? (m = g = 0) : (s.timeline = 0);
            } else if (w) {
              $t(zt(a.vars.defaults, { ease: 'none' })),
                (a._ease = Gn(w.ease || n.ease || 'none'));
              var C,
                M,
                k,
                A = 0;
              if (Qe(w))
                w.forEach(function (e) {
                  return a.to(S, e, '>');
                }),
                  a.duration();
              else {
                for (u in ((l = {}), w))
                  'ease' === u ||
                    'easeEach' === u ||
                    ar(u, w[u], l, w.easeEach);
                for (u in l)
                  for (
                    C = l[u].sort(function (e, t) {
                      return e.t - t.t;
                    }),
                      A = 0,
                      o = 0;
                    o < C.length;
                    o++
                  )
                    ((k = {
                      ease: (M = C[o]).e,
                      duration: ((M.t - (o ? C[o - 1].t : 0)) / 100) * m,
                    })[u] = M.v),
                      a.to(S, k, A),
                      (A += k.duration);
                a.duration() < m && a.to({}, { duration: m - a.duration() });
              }
            }
            m || s.duration((m = a.duration()));
          } else s.timeline = 0;
          return (
            !0 !== b || ve || ((er = me(s)), we.killTweensOf(S), (er = 0)),
            Zt(_, me(s), r),
            n.reversed && s.reverse(),
            n.paused && s.paused(!0),
            (v ||
              (!m &&
                !w &&
                s._start === kt(_._time) &&
                We(v) &&
                Yt(me(s)) &&
                'nested' !== _.data)) &&
              ((s._tTime = -1e-8), s.render(Math.max(0, -g) || 0)),
            T && Jt(me(s), T),
            s
          );
        }
        ge(t, e);
        var n = t.prototype;
        return (
          (n.render = function (e, t, n) {
            var r,
              i,
              s,
              a,
              o,
              l,
              c,
              u,
              d,
              p = this._time,
              f = this._tDur,
              h = this._dur,
              m = e < 0,
              g = e > f - ze && !m ? f : e < ze ? 0 : e;
            if (h) {
              if (
                g !== this._tTime ||
                !e ||
                n ||
                (!this._initted && this._tTime) ||
                (this._startAt && this._zTime < 0 !== m)
              ) {
                if (((r = g), (u = this.timeline), this._repeat)) {
                  if (((a = h + this._rDelay), this._repeat < -1 && m))
                    return this.totalTime(100 * a + e, t, n);
                  if (
                    ((r = kt(g % a)),
                    g === f
                      ? ((s = this._repeat), (r = h))
                      : ((s = ~~(g / a)) && s === g / a && ((r = h), s--),
                        r > h && (r = h)),
                    (l = this._yoyo && 1 & s) &&
                      ((d = this._yEase), (r = h - r)),
                    (o = Wt(this._tTime, a)),
                    r === p && !n && this._initted)
                  )
                    return (this._tTime = g), this;
                  s !== o &&
                    (u && this._yEase && Yn(u, l),
                    !this.vars.repeatRefresh ||
                      l ||
                      this._lock ||
                      ((this._lock = n = 1),
                      (this.render(kt(a * s), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (en(this, m ? e : r, n, t, g))
                    return (this._tTime = 0), this;
                  if (p !== this._time) return this;
                  if (h !== this._dur) return this.render(e, t, n);
                }
                if (
                  ((this._tTime = g),
                  (this._time = r),
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  (this.ratio = c = (d || this._ease)(r / h)),
                  this._from && (this.ratio = c = 1 - c),
                  r &&
                    !p &&
                    !t &&
                    !s &&
                    (Sn(this, 'onStart'), this._tTime !== g))
                )
                  return this;
                for (i = this._pt; i; ) i.r(c, i.d), (i = i._next);
                (u &&
                  u.render(
                    e < 0
                      ? e
                      : !r && l
                      ? -1e-8
                      : u._dur * u._ease(r / this._dur),
                    t,
                    n
                  )) ||
                  (this._startAt && (this._zTime = e)),
                  this._onUpdate &&
                    !t &&
                    (m && Xt(this, e, 0, n), Sn(this, 'onUpdate')),
                  this._repeat &&
                    s !== o &&
                    this.vars.onRepeat &&
                    !t &&
                    this.parent &&
                    Sn(this, 'onRepeat'),
                  (g !== this._tDur && g) ||
                    this._tTime !== g ||
                    (m && !this._onUpdate && Xt(this, e, 0, !0),
                    (e || !h) &&
                      ((g === this._tDur && this._ts > 0) ||
                        (!g && this._ts < 0)) &&
                      Ht(this, 1),
                    t ||
                      (m && !p) ||
                      !(g || p || l) ||
                      (Sn(
                        this,
                        g === f ? 'onComplete' : 'onReverseComplete',
                        !0
                      ),
                      this._prom &&
                        !(g < f && this.timeScale() > 0) &&
                        this._prom()));
              }
            } else
              !(function (e, t, n, r) {
                var i,
                  s,
                  a,
                  o = e.ratio,
                  l =
                    t < 0 ||
                    (!t &&
                      ((!e._start && tn(e) && (e._initted || !nn(e))) ||
                        ((e._ts < 0 || e._dp._ts < 0) && !nn(e))))
                      ? 0
                      : 1,
                  c = e._rDelay,
                  u = 0;
                if (
                  (c &&
                    e._repeat &&
                    ((u = un(0, e._tDur, t)),
                    (s = Wt(u, c)),
                    e._yoyo && 1 & s && (l = 1 - l),
                    s !== Wt(e._tTime, c) &&
                      ((o = 1 - l),
                      e.vars.repeatRefresh && e._initted && e.invalidate())),
                  l !== o || ye || r || e._zTime === ze || (!t && e._zTime))
                ) {
                  if (!e._initted && en(e, t, r, n, u)) return;
                  for (
                    a = e._zTime,
                      e._zTime = t || (n ? ze : 0),
                      n || (n = t && !a),
                      e.ratio = l,
                      e._from && (l = 1 - l),
                      e._time = 0,
                      e._tTime = u,
                      i = e._pt;
                    i;

                  )
                    i.r(l, i.d), (i = i._next);
                  t < 0 && Xt(e, t, 0, !0),
                    e._onUpdate && !n && Sn(e, 'onUpdate'),
                    u && e._repeat && !n && e.parent && Sn(e, 'onRepeat'),
                    (t >= e._tDur || t < 0) &&
                      e.ratio === l &&
                      (l && Ht(e, 1),
                      n ||
                        ye ||
                        (Sn(e, l ? 'onComplete' : 'onReverseComplete', !0),
                        e._prom && e._prom()));
                } else e._zTime || (e._zTime = t);
              })(this, e, t, n);
            return this;
          }),
          (n.targets = function () {
            return this._targets;
          }),
          (n.invalidate = function (t) {
            return (
              (!t || !this.vars.runBackwards) && (this._startAt = 0),
              (this._pt =
                this._op =
                this._onUpdate =
                this._lazy =
                this.ratio =
                  0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(t),
              e.prototype.invalidate.call(this, t)
            );
          }),
          (n.resetTo = function (e, t, n, r) {
            Me || Nn.wake(), this._ts || this.play();
            var i = Math.min(
              this._dur,
              (this._dp._time - this._start) * this._ts
            );
            return (
              this._initted || sr(this, i),
              (function (e, t, n, r, i, s, a) {
                var o,
                  l,
                  c,
                  u,
                  d = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                if (!d)
                  for (
                    d = e._ptCache[t] = [],
                      c = e._ptLookup,
                      u = e._targets.length;
                    u--;

                  ) {
                    if ((o = c[u][t]) && o.d && o.d._pt)
                      for (o = o.d._pt; o && o.p !== t && o.fp !== t; )
                        o = o._next;
                    if (!o)
                      return (
                        (tr = 1), (e.vars[t] = '+=0'), sr(e, a), (tr = 0), 1
                      );
                    d.push(o);
                  }
                for (u = d.length; u--; )
                  ((o = (l = d[u])._pt || l).s =
                    (!r && 0 !== r) || i ? o.s + (r || 0) + s * o.c : r),
                    (o.c = n - o.s),
                    l.e && (l.e = Mt(n) + dn(l.e)),
                    l.b && (l.b = o.s + dn(l.b));
              })(this, e, t, n, r, this._ease(i / this._dur), i)
                ? this.resetTo(e, t, n, r)
                : (Kt(this, 0),
                  this.parent ||
                    Ft(
                      this._dp,
                      this,
                      '_first',
                      '_last',
                      this._dp._sort ? '_start' : 0
                    ),
                  this.render(0))
            );
          }),
          (n.kill = function (e, t) {
            if ((void 0 === t && (t = 'all'), !(e || (t && 'all' !== t))))
              return (this._lazy = this._pt = 0), this.parent ? Cn(this) : this;
            if (this.timeline) {
              var n = this.timeline.totalDuration();
              return (
                this.timeline.killTweensOf(e, t, er && !0 !== er.vars.overwrite)
                  ._first || Cn(this),
                this.parent &&
                  n !== this.timeline.totalDuration() &&
                  rn(this, (this._dur * this.timeline._tDur) / n, 0, 1),
                this
              );
            }
            var r,
              i,
              s,
              a,
              o,
              l,
              c,
              u = this._targets,
              d = e ? hn(e) : u,
              p = this._ptLookup,
              f = this._pt;
            if (
              (!t || 'all' === t) &&
              (function (e, t) {
                for (
                  var n = e.length, r = n === t.length;
                  r && n-- && e[n] === t[n];

                );
                return n < 0;
              })(u, d)
            )
              return 'all' === t && (this._pt = 0), Cn(this);
            for (
              r = this._op = this._op || [],
                'all' !== t &&
                  (He(t) &&
                    ((o = {}),
                    Ct(t, function (e) {
                      return (o[e] = 1);
                    }),
                    (t = o)),
                  (t = (function (e, t) {
                    var n,
                      r,
                      i,
                      s,
                      a = e[0] ? _t(e[0]).harness : 0,
                      o = a && a.aliases;
                    if (!o) return t;
                    for (r in ((n = Rt({}, t)), o))
                      if ((r in n))
                        for (i = (s = o[r].split(',')).length; i--; )
                          n[s[i]] = n[r];
                    return n;
                  })(u, t))),
                c = u.length;
              c--;

            )
              if (~d.indexOf(u[c]))
                for (o in ((i = p[c]),
                'all' === t
                  ? ((r[c] = t), (a = i), (s = {}))
                  : ((s = r[c] = r[c] || {}), (a = t)),
                a))
                  (l = i && i[o]) &&
                    (('kill' in l.d && !0 !== l.d.kill(o)) ||
                      qt(this, l, '_pt'),
                    delete i[o]),
                    'all' !== s && (s[o] = 1);
            return this._initted && !this._pt && f && Cn(this), this;
          }),
          (t.to = function (e, n) {
            return new t(e, n, arguments[2]);
          }),
          (t.from = function (e, t) {
            return ln(1, arguments);
          }),
          (t.delayedCall = function (e, n, r, i) {
            return new t(n, 0, {
              immediateRender: !1,
              lazy: !1,
              overwrite: !1,
              delay: e,
              onComplete: n,
              onReverseComplete: n,
              onCompleteParams: r,
              onReverseCompleteParams: r,
              callbackScope: i,
            });
          }),
          (t.fromTo = function (e, t, n) {
            return ln(2, arguments);
          }),
          (t.set = function (e, n) {
            return (
              (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(e, n)
            );
          }),
          (t.killTweensOf = function (e, t, n) {
            return we.killTweensOf(e, t, n);
          }),
          t
        );
      })(Zn);
      zt(ur.prototype, {
        _targets: [],
        _lazy: 0,
        _startAt: 0,
        _op: 0,
        _onInit: 0,
      }),
        Ct('staggerTo,staggerFrom,staggerFromTo', function (e) {
          ur[e] = function () {
            var t = new Jn(),
              n = pn.call(arguments, 0);
            return (
              n.splice('staggerFromTo' === e ? 5 : 4, 0, 0), t[e].apply(t, n)
            );
          };
        });
      var dr = function (e, t, n) {
          return (e[t] = n);
        },
        pr = function (e, t, n) {
          return e[t](n);
        },
        fr = function (e, t, n, r) {
          return e[t](r.fp, n);
        },
        hr = function (e, t, n) {
          return e.setAttribute(t, n);
        },
        mr = function (e, t) {
          return Be(e[t]) ? pr : Ye(e[t]) && e.setAttribute ? hr : dr;
        },
        gr = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
        },
        vr = function (e, t) {
          return t.set(t.t, t.p, !!(t.s + t.c * e), t);
        },
        yr = function (e, t) {
          var n = t._pt,
            r = '';
          if (!e && t.b) r = t.b;
          else if (1 === e && t.e) r = t.e;
          else {
            for (; n; )
              (r =
                n.p +
                (n.m
                  ? n.m(n.s + n.c * e)
                  : Math.round(1e4 * (n.s + n.c * e)) / 1e4) +
                r),
                (n = n._next);
            r += t.c;
          }
          t.set(t.t, t.p, r, t);
        },
        br = function (e, t) {
          for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
        },
        wr = function (e, t, n, r) {
          for (var i, s = this._pt; s; )
            (i = s._next), s.p === r && s.modifier(e, t, n), (s = i);
        },
        xr = function (e) {
          for (var t, n, r = this._pt; r; )
            (n = r._next),
              (r.p === e && !r.op) || r.op === e
                ? qt(this, r, '_pt')
                : r.dep || (t = 1),
              (r = n);
          return !t;
        },
        Tr = function (e, t, n, r) {
          r.mSet(e, t, r.m.call(r.tween, n, r.mt), r);
        },
        Er = function (e) {
          for (var t, n, r, i, s = e._pt; s; ) {
            for (t = s._next, n = r; n && n.pr > s.pr; ) n = n._next;
            (s._prev = n ? n._prev : i) ? (s._prev._next = s) : (r = s),
              (s._next = n) ? (n._prev = s) : (i = s),
              (s = t);
          }
          e._pt = r;
        },
        _r = (function () {
          function e(e, t, n, r, i, s, a, o, l) {
            (this.t = t),
              (this.s = r),
              (this.c = i),
              (this.p = n),
              (this.r = s || gr),
              (this.d = a || this),
              (this.set = o || dr),
              (this.pr = l || 0),
              (this._next = e),
              e && (e._prev = this);
          }
          return (
            (e.prototype.modifier = function (e, t, n) {
              (this.mSet = this.mSet || this.set),
                (this.set = Tr),
                (this.m = e),
                (this.mt = n),
                (this.tween = t);
            }),
            e
          );
        })();
      Ct(
        Tt +
          'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger',
        function (e) {
          return (mt[e] = 1);
        }
      ),
        (st.TweenMax = st.TweenLite = ur),
        (st.TimelineLite = st.TimelineMax = Jn),
        (we = new Jn({
          sortChildren: !1,
          defaults: De,
          autoRemoveChildren: !0,
          id: 'root',
          smoothChildTiming: !0,
        })),
        (Oe.stringFilter = jn);
      var Sr = [],
        Cr = {},
        Mr = [],
        kr = 0,
        Ar = 0,
        Pr = function (e) {
          return (Cr[e] || Mr).map(function (e) {
            return e();
          });
        },
        Lr = function () {
          var e = Date.now(),
            t = [];
          e - kr > 2 &&
            (Pr('matchMediaInit'),
            Sr.forEach(function (e) {
              var n,
                r,
                i,
                s,
                a = e.queries,
                o = e.conditions;
              for (r in a)
                (n = xe.matchMedia(a[r]).matches) && (i = 1),
                  n !== o[r] && ((o[r] = n), (s = 1));
              s && (e.revert(), i && t.push(e));
            }),
            Pr('matchMediaRevert'),
            t.forEach(function (e) {
              return e.onMatch(e);
            }),
            (kr = e),
            Pr('matchMedia'));
        },
        Or = (function () {
          function e(e, t) {
            (this.selector = t && mn(t)),
              (this.data = []),
              (this._r = []),
              (this.isReverted = !1),
              (this.id = Ar++),
              e && this.add(e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, n) {
              Be(e) && ((n = t), (t = e), (e = Be));
              var r = this,
                i = function () {
                  var e,
                    i = be,
                    s = r.selector;
                  return (
                    i && i !== r && i.data.push(r),
                    n && (r.selector = mn(n)),
                    (be = r),
                    (e = t.apply(r, arguments)),
                    Be(e) && r._r.push(e),
                    (be = i),
                    (r.selector = s),
                    (r.isReverted = !1),
                    e
                  );
                };
              return (r.last = i), e === Be ? i(r) : e ? (r[e] = i) : i;
            }),
            (t.ignore = function (e) {
              var t = be;
              (be = null), e(this), (be = t);
            }),
            (t.getTweens = function () {
              var t = [];
              return (
                this.data.forEach(function (n) {
                  return n instanceof e
                    ? t.push.apply(t, n.getTweens())
                    : n instanceof ur &&
                        !(n.parent && 'nested' === n.parent.data) &&
                        t.push(n);
                }),
                t
              );
            }),
            (t.clear = function () {
              this._r.length = this.data.length = 0;
            }),
            (t.kill = function (e, t) {
              var n = this;
              if (e) {
                var r = this.getTweens();
                this.data.forEach(function (e) {
                  'isFlip' === e.data &&
                    (e.revert(),
                    e.getChildren(!0, !0, !1).forEach(function (e) {
                      return r.splice(r.indexOf(e), 1);
                    }));
                }),
                  r
                    .map(function (e) {
                      return { g: e.globalTime(0), t: e };
                    })
                    .sort(function (e, t) {
                      return t.g - e.g || -1;
                    })
                    .forEach(function (t) {
                      return t.t.revert(e);
                    }),
                  this.data.forEach(function (t) {
                    return t instanceof Jn
                      ? 'nested' !== t.data && t.kill()
                      : !(t instanceof ur) && t.revert && t.revert(e);
                  }),
                  this._r.forEach(function (t) {
                    return t(e, n);
                  }),
                  (this.isReverted = !0);
              } else
                this.data.forEach(function (e) {
                  return e.kill && e.kill();
                });
              if ((this.clear(), t))
                for (var i = Sr.length; i--; )
                  Sr[i].id === this.id && Sr.splice(i, 1);
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            e
          );
        })(),
        Dr = (function () {
          function e(e) {
            (this.contexts = []), (this.scope = e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, n) {
              Ge(e) || (e = { matches: e });
              var r,
                i,
                s,
                a = new Or(0, n || this.scope),
                o = (a.conditions = {});
              for (i in (be && !a.selector && (a.selector = be.selector),
              this.contexts.push(a),
              (t = a.add('onMatch', t)),
              (a.queries = e),
              e))
                'all' === i
                  ? (s = 1)
                  : (r = xe.matchMedia(e[i])) &&
                    (Sr.indexOf(a) < 0 && Sr.push(a),
                    (o[i] = r.matches) && (s = 1),
                    r.addListener
                      ? r.addListener(Lr)
                      : r.addEventListener('change', Lr));
              return s && t(a), this;
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            (t.kill = function (e) {
              this.contexts.forEach(function (t) {
                return t.kill(e, !0);
              });
            }),
            e
          );
        })(),
        Ir = {
          registerPlugin: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            t.forEach(function (e) {
              return kn(e);
            });
          },
          timeline: function (e) {
            return new Jn(e);
          },
          getTweensOf: function (e, t) {
            return we.getTweensOf(e, t);
          },
          getProperty: function (e, t, n, r) {
            He(e) && (e = hn(e)[0]);
            var i = _t(e || {}).get,
              s = n ? It : Dt;
            return (
              'native' === n && (n = ''),
              e
                ? t
                  ? s(((yt[t] && yt[t].get) || i)(e, t, n, r))
                  : function (t, n, r) {
                      return s(((yt[t] && yt[t].get) || i)(e, t, n, r));
                    }
                : e
            );
          },
          quickSetter: function (e, t, n) {
            if ((e = hn(e)).length > 1) {
              var r = e.map(function (e) {
                  return jr.quickSetter(e, t, n);
                }),
                i = r.length;
              return function (e) {
                for (var t = i; t--; ) r[t](e);
              };
            }
            e = e[0] || {};
            var s = yt[t],
              a = _t(e),
              o = (a.harness && (a.harness.aliases || {})[t]) || t,
              l = s
                ? function (t) {
                    var r = new s();
                    (Ce._pt = 0),
                      r.init(e, n ? t + n : t, Ce, 0, [e]),
                      r.render(1, r),
                      Ce._pt && br(1, Ce);
                  }
                : a.set(e, o);
            return s
              ? l
              : function (t) {
                  return l(e, o, n ? t + n : t, a, 1);
                };
          },
          quickTo: function (e, t, n) {
            var r,
              i = jr.to(
                e,
                Rt((((r = {})[t] = '+=0.1'), (r.paused = !0), r), n || {})
              ),
              s = function (e, n, r) {
                return i.resetTo(t, e, n, r);
              };
            return (s.tween = i), s;
          },
          isTweening: function (e) {
            return we.getTweensOf(e, !0).length > 0;
          },
          defaults: function (e) {
            return (
              e && e.ease && (e.ease = Gn(e.ease, De.ease)), jt(De, e || {})
            );
          },
          config: function (e) {
            return jt(Oe, e || {});
          },
          registerEffect: function (e) {
            var t = e.name,
              n = e.effect,
              r = e.plugins,
              i = e.defaults,
              s = e.extendTimeline;
            (r || '').split(',').forEach(function (e) {
              return (
                e &&
                !yt[e] &&
                !st[e] &&
                ct(t + ' effect requires ' + e + ' plugin.')
              );
            }),
              (bt[t] = function (e, t, r) {
                return n(hn(e), zt(t || {}, i), r);
              }),
              s &&
                (Jn.prototype[t] = function (e, n, r) {
                  return this.add(bt[t](e, Ge(n) ? n : (r = n) && {}, this), r);
                });
          },
          registerEase: function (e, t) {
            Fn[e] = Gn(t);
          },
          parseEase: function (e, t) {
            return arguments.length ? Gn(e, t) : Fn;
          },
          getById: function (e) {
            return we.getById(e);
          },
          exportRoot: function (e, t) {
            void 0 === e && (e = {});
            var n,
              r,
              i = new Jn(e);
            for (
              i.smoothChildTiming = We(e.smoothChildTiming),
                we.remove(i),
                i._dp = 0,
                i._time = i._tTime = we._time,
                n = we._first;
              n;

            )
              (r = n._next),
                (!t &&
                  !n._dur &&
                  n instanceof ur &&
                  n.vars.onComplete === n._targets[0]) ||
                  Zt(i, n, n._start - n._delay),
                (n = r);
            return Zt(we, i, 0), i;
          },
          context: function (e, t) {
            return e ? new Or(e, t) : be;
          },
          matchMedia: function (e) {
            return new Dr(e);
          },
          matchMediaRefresh: function () {
            return (
              Sr.forEach(function (e) {
                var t,
                  n,
                  r = e.conditions;
                for (n in r) r[n] && ((r[n] = !1), (t = 1));
                t && e.revert();
              }) || Lr()
            );
          },
          addEventListener: function (e, t) {
            var n = Cr[e] || (Cr[e] = []);
            ~n.indexOf(t) || n.push(t);
          },
          removeEventListener: function (e, t) {
            var n = Cr[e],
              r = n && n.indexOf(t);
            r >= 0 && n.splice(r, 1);
          },
          utils: {
            wrap: function e(t, n, r) {
              var i = n - t;
              return Qe(t)
                ? xn(t, e(0, t.length), n)
                : cn(r, function (e) {
                    return ((i + ((e - t) % i)) % i) + t;
                  });
            },
            wrapYoyo: function e(t, n, r) {
              var i = n - t,
                s = 2 * i;
              return Qe(t)
                ? xn(t, e(0, t.length - 1), n)
                : cn(r, function (e) {
                    return (
                      t + ((e = (s + ((e - t) % s)) % s || 0) > i ? s - e : e)
                    );
                  });
            },
            distribute: vn,
            random: wn,
            snap: bn,
            normalize: function (e, t, n) {
              return En(e, t, 0, 1, n);
            },
            getUnit: dn,
            clamp: function (e, t, n) {
              return cn(n, function (n) {
                return un(e, t, n);
              });
            },
            splitColor: On,
            toArray: hn,
            selector: mn,
            mapRange: En,
            pipe: function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              return function (e) {
                return t.reduce(function (e, t) {
                  return t(e);
                }, e);
              };
            },
            unitize: function (e, t) {
              return function (n) {
                return e(parseFloat(n)) + (t || dn(n));
              };
            },
            interpolate: function e(t, n, r, i) {
              var s = isNaN(t + n)
                ? 0
                : function (e) {
                    return (1 - e) * t + e * n;
                  };
              if (!s) {
                var a,
                  o,
                  l,
                  c,
                  u,
                  d = He(t),
                  p = {};
                if ((!0 === r && (i = 1) && (r = null), d))
                  (t = { p: t }), (n = { p: n });
                else if (Qe(t) && !Qe(n)) {
                  for (l = [], c = t.length, u = c - 2, o = 1; o < c; o++)
                    l.push(e(t[o - 1], t[o]));
                  c--,
                    (s = function (e) {
                      e *= c;
                      var t = Math.min(u, ~~e);
                      return l[t](e - t);
                    }),
                    (r = n);
                } else i || (t = Rt(Qe(t) ? [] : {}, t));
                if (!l) {
                  for (a in n) rr.call(p, t, a, 'get', n[a]);
                  s = function (e) {
                    return br(e, p) || (d ? t.p : t);
                  };
                }
              }
              return cn(r, s);
            },
            shuffle: gn,
          },
          install: ot,
          effects: bt,
          ticker: Nn,
          updateRoot: Jn.updateRoot,
          plugins: yt,
          globalTimeline: we,
          core: {
            PropTween: _r,
            globals: ut,
            Tween: ur,
            Timeline: Jn,
            Animation: Zn,
            getCache: _t,
            _removeLinkedListItem: qt,
            reverting: function () {
              return ye;
            },
            context: function (e) {
              return e && be && (be.data.push(e), (e._ctx = be)), be;
            },
            suppressOverwrites: function (e) {
              return (ve = e);
            },
          },
        };
      Ct('to,from,fromTo,delayedCall,set,killTweensOf', function (e) {
        return (Ir[e] = ur[e]);
      }),
        Nn.add(Jn.updateRoot),
        (Ce = Ir.to({}, { duration: 0 }));
      var zr = function (e, t) {
          for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
            n = n._next;
          return n;
        },
        Rr = function (e, t) {
          return {
            name: e,
            rawVars: 1,
            init: function (e, n, r) {
              r._onInit = function (e) {
                var r, i;
                if (
                  (He(n) &&
                    ((r = {}),
                    Ct(n, function (e) {
                      return (r[e] = 1);
                    }),
                    (n = r)),
                  t)
                ) {
                  for (i in ((r = {}), n)) r[i] = t(n[i]);
                  n = r;
                }
                !(function (e, t) {
                  var n,
                    r,
                    i,
                    s = e._targets;
                  for (n in t)
                    for (r = s.length; r--; )
                      (i = e._ptLookup[r][n]) &&
                        (i = i.d) &&
                        (i._pt && (i = zr(i, n)),
                        i && i.modifier && i.modifier(t[n], e, s[r], n));
                })(e, n);
              };
            },
          };
        },
        jr =
          Ir.registerPlugin(
            {
              name: 'attr',
              init: function (e, t, n, r, i) {
                var s, a, o;
                for (s in ((this.tween = n), t))
                  (o = e.getAttribute(s) || ''),
                    ((a = this.add(
                      e,
                      'setAttribute',
                      (o || 0) + '',
                      t[s],
                      r,
                      i,
                      0,
                      0,
                      s
                    )).op = s),
                    (a.b = o),
                    this._props.push(s);
              },
              render: function (e, t) {
                for (var n = t._pt; n; )
                  ye ? n.set(n.t, n.p, n.b, n) : n.r(e, n.d), (n = n._next);
              },
            },
            {
              name: 'endArray',
              init: function (e, t) {
                for (var n = t.length; n--; )
                  this.add(e, n, e[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
              },
            },
            Rr('roundProps', yn),
            Rr('modifiers'),
            Rr('snap', bn)
          ) || Ir;
      (ur.version = Jn.version = jr.version = '3.12.1'),
        (_e = 1),
        Ve() && $n(),
        Fn.Power0,
        Fn.Power1,
        Fn.Power2,
        Fn.Power3,
        Fn.Power4,
        Fn.Linear,
        Fn.Quad,
        Fn.Cubic,
        Fn.Quart,
        Fn.Quint,
        Fn.Strong,
        Fn.Elastic,
        Fn.Back,
        Fn.SteppedEase,
        Fn.Bounce,
        Fn.Sine,
        Fn.Expo,
        Fn.Circ;
      var Nr,
        $r,
        Fr,
        qr,
        Hr,
        Br,
        Xr,
        Yr,
        Gr = {},
        Wr = 180 / Math.PI,
        Vr = Math.PI / 180,
        Ur = Math.atan2,
        Kr = /([A-Z])/g,
        Qr = /(left|right|width|margin|padding|x)/i,
        Zr = /[\s,\(]\S/,
        Jr = {
          autoAlpha: 'opacity,visibility',
          scale: 'scaleX,scaleY',
          alpha: 'opacity',
        },
        ei = function (e, t) {
          return t.set(
            t.t,
            t.p,
            Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        ti = function (e, t) {
          return t.set(
            t.t,
            t.p,
            1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        ni = function (e, t) {
          return t.set(
            t.t,
            t.p,
            e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b,
            t
          );
        },
        ri = function (e, t) {
          var n = t.s + t.c * e;
          t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
        },
        ii = function (e, t) {
          return t.set(t.t, t.p, e ? t.e : t.b, t);
        },
        si = function (e, t) {
          return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
        },
        ai = function (e, t, n) {
          return (e.style[t] = n);
        },
        oi = function (e, t, n) {
          return e.style.setProperty(t, n);
        },
        li = function (e, t, n) {
          return (e._gsap[t] = n);
        },
        ci = function (e, t, n) {
          return (e._gsap.scaleX = e._gsap.scaleY = n);
        },
        ui = function (e, t, n, r, i) {
          var s = e._gsap;
          (s.scaleX = s.scaleY = n), s.renderTransform(i, s);
        },
        di = function (e, t, n, r, i) {
          var s = e._gsap;
          (s[t] = n), s.renderTransform(i, s);
        },
        pi = 'transform',
        fi = pi + 'Origin',
        hi = function e(t, n) {
          var r = this,
            i = this.target,
            s = i.style;
          if (t in Gr && s) {
            if (((this.tfm = this.tfm || {}), 'transform' === t))
              return Jr.transform.split(',').forEach(function (t) {
                return e.call(r, t, n);
              });
            if (
              (~(t = Jr[t] || t).indexOf(',')
                ? t.split(',').forEach(function (e) {
                    return (r.tfm[e] = Oi(i, e));
                  })
                : (this.tfm[t] = i._gsap.x ? i._gsap[t] : Oi(i, t)),
              this.props.indexOf(pi) >= 0)
            )
              return;
            i._gsap.svg &&
              ((this.svgo = i.getAttribute('data-svg-origin')),
              this.props.push(fi, n, '')),
              (t = pi);
          }
          (s || n) && this.props.push(t, n, s[t]);
        },
        mi = function (e) {
          e.translate &&
            (e.removeProperty('translate'),
            e.removeProperty('scale'),
            e.removeProperty('rotate'));
        },
        gi = function () {
          var e,
            t,
            n = this.props,
            r = this.target,
            i = r.style,
            s = r._gsap;
          for (e = 0; e < n.length; e += 3)
            n[e + 1]
              ? (r[n[e]] = n[e + 2])
              : n[e + 2]
              ? (i[n[e]] = n[e + 2])
              : i.removeProperty(
                  '--' === n[e].substr(0, 2)
                    ? n[e]
                    : n[e].replace(Kr, '-$1').toLowerCase()
                );
          if (this.tfm) {
            for (t in this.tfm) s[t] = this.tfm[t];
            s.svg &&
              (s.renderTransform(),
              r.setAttribute('data-svg-origin', this.svgo || '')),
              ((e = Xr()) && e.isStart) || i[pi] || (mi(i), (s.uncache = 1));
          }
        },
        vi = function (e, t) {
          var n = { target: e, props: [], revert: gi, save: hi };
          return (
            e._gsap || jr.core.getCache(e),
            t &&
              t.split(',').forEach(function (e) {
                return n.save(e);
              }),
            n
          );
        },
        yi = function (e, t) {
          var n = $r.createElementNS
            ? $r.createElementNS(
                (t || 'http://www.w3.org/1999/xhtml').replace(/^https/, 'http'),
                e
              )
            : $r.createElement(e);
          return n.style ? n : $r.createElement(e);
        },
        bi = function e(t, n, r) {
          var i = getComputedStyle(t);
          return (
            i[n] ||
            i.getPropertyValue(n.replace(Kr, '-$1').toLowerCase()) ||
            i.getPropertyValue(n) ||
            (!r && e(t, xi(n) || n, 1)) ||
            ''
          );
        },
        wi = 'O,Moz,ms,Ms,Webkit'.split(','),
        xi = function (e, t, n) {
          var r = (t || Hr).style,
            i = 5;
          if (e in r && !n) return e;
          for (
            e = e.charAt(0).toUpperCase() + e.substr(1);
            i-- && !(wi[i] + e in r);

          );
          return i < 0 ? null : (3 === i ? 'ms' : i >= 0 ? wi[i] : '') + e;
        },
        Ti = function () {
          'undefined' != typeof window &&
            window.document &&
            ((Nr = window),
            ($r = Nr.document),
            (Fr = $r.documentElement),
            (Hr = yi('div') || { style: {} }),
            yi('div'),
            (pi = xi(pi)),
            (fi = pi + 'Origin'),
            (Hr.style.cssText =
              'border-width:0;line-height:0;position:absolute;padding:0'),
            (Yr = !!xi('perspective')),
            (Xr = jr.core.reverting),
            (qr = 1));
        },
        Ei = function e(t) {
          var n,
            r = yi(
              'svg',
              (this.ownerSVGElement &&
                this.ownerSVGElement.getAttribute('xmlns')) ||
                'http://www.w3.org/2000/svg'
            ),
            i = this.parentNode,
            s = this.nextSibling,
            a = this.style.cssText;
          if (
            (Fr.appendChild(r),
            r.appendChild(this),
            (this.style.display = 'block'),
            t)
          )
            try {
              (n = this.getBBox()),
                (this._gsapBBox = this.getBBox),
                (this.getBBox = e);
            } catch (e) {}
          else this._gsapBBox && (n = this._gsapBBox());
          return (
            i && (s ? i.insertBefore(this, s) : i.appendChild(this)),
            Fr.removeChild(r),
            (this.style.cssText = a),
            n
          );
        },
        _i = function (e, t) {
          for (var n = t.length; n--; )
            if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
        },
        Si = function (e) {
          var t;
          try {
            t = e.getBBox();
          } catch (n) {
            t = Ei.call(e, !0);
          }
          return (
            (t && (t.width || t.height)) ||
              e.getBBox === Ei ||
              (t = Ei.call(e, !0)),
            !t || t.width || t.x || t.y
              ? t
              : {
                  x: +_i(e, ['x', 'cx', 'x1']) || 0,
                  y: +_i(e, ['y', 'cy', 'y1']) || 0,
                  width: 0,
                  height: 0,
                }
          );
        },
        Ci = function (e) {
          return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !Si(e));
        },
        Mi = function (e, t) {
          if (t) {
            var n = e.style;
            t in Gr && t !== fi && (t = pi),
              n.removeProperty
                ? (('ms' !== t.substr(0, 2) && 'webkit' !== t.substr(0, 6)) ||
                    (t = '-' + t),
                  n.removeProperty(t.replace(Kr, '-$1').toLowerCase()))
                : n.removeAttribute(t);
          }
        },
        ki = function (e, t, n, r, i, s) {
          var a = new _r(e._pt, t, n, 0, 1, s ? si : ii);
          return (e._pt = a), (a.b = r), (a.e = i), e._props.push(n), a;
        },
        Ai = { deg: 1, rad: 1, turn: 1 },
        Pi = { grid: 1, flex: 1 },
        Li = function e(t, n, r, i) {
          var s,
            a,
            o,
            l,
            c = parseFloat(r) || 0,
            u = (r + '').trim().substr((c + '').length) || 'px',
            d = Hr.style,
            p = Qr.test(n),
            f = 'svg' === t.tagName.toLowerCase(),
            h = (f ? 'client' : 'offset') + (p ? 'Width' : 'Height'),
            m = 100,
            g = 'px' === i,
            v = '%' === i;
          return i === u || !c || Ai[i] || Ai[u]
            ? c
            : ('px' !== u && !g && (c = e(t, n, r, 'px')),
              (l = t.getCTM && Ci(t)),
              (!v && '%' !== u) || (!Gr[n] && !~n.indexOf('adius'))
                ? ((d[p ? 'width' : 'height'] = m + (g ? u : i)),
                  (a =
                    ~n.indexOf('adius') || ('em' === i && t.appendChild && !f)
                      ? t
                      : t.parentNode),
                  l && (a = (t.ownerSVGElement || {}).parentNode),
                  (a && a !== $r && a.appendChild) || (a = $r.body),
                  (o = a._gsap) &&
                  v &&
                  o.width &&
                  p &&
                  o.time === Nn.time &&
                  !o.uncache
                    ? Mt((c / o.width) * m)
                    : ((v || '%' === u) &&
                        !Pi[bi(a, 'display')] &&
                        (d.position = bi(t, 'position')),
                      a === t && (d.position = 'static'),
                      a.appendChild(Hr),
                      (s = Hr[h]),
                      a.removeChild(Hr),
                      (d.position = 'absolute'),
                      p &&
                        v &&
                        (((o = _t(a)).time = Nn.time), (o.width = a[h])),
                      Mt(g ? (s * c) / m : s && c ? (m / s) * c : 0)))
                : ((s = l ? t.getBBox()[p ? 'width' : 'height'] : t[h]),
                  Mt(v ? (c / s) * m : (c / 100) * s)));
        },
        Oi = function (e, t, n, r) {
          var i;
          return (
            qr || Ti(),
            t in Jr &&
              'transform' !== t &&
              ~(t = Jr[t]).indexOf(',') &&
              (t = t.split(',')[0]),
            Gr[t] && 'transform' !== t
              ? ((i = Bi(e, r)),
                (i =
                  'transformOrigin' !== t
                    ? i[t]
                    : i.svg
                    ? i.origin
                    : Xi(bi(e, fi)) + ' ' + i.zOrigin + 'px'))
              : (!(i = e.style[t]) ||
                  'auto' === i ||
                  r ||
                  ~(i + '').indexOf('calc(')) &&
                (i =
                  (Ri[t] && Ri[t](e, t, n)) ||
                  bi(e, t) ||
                  St(e, t) ||
                  ('opacity' === t ? 1 : 0)),
            n && !~(i + '').trim().indexOf(' ') ? Li(e, t, i, n) + n : i
          );
        },
        Di = function (e, t, n, r) {
          if (!n || 'none' === n) {
            var i = xi(t, e, 1),
              s = i && bi(e, i, 1);
            s && s !== n
              ? ((t = i), (n = s))
              : 'borderColor' === t && (n = bi(e, 'borderTopColor'));
          }
          var a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g,
            v = new _r(this._pt, e.style, t, 0, 1, yr),
            y = 0,
            b = 0;
          if (
            ((v.b = n),
            (v.e = r),
            (n += ''),
            'auto' == (r += '') &&
              ((e.style[t] = r), (r = bi(e, t) || r), (e.style[t] = n)),
            jn((a = [n, r])),
            (r = a[1]),
            (l = (n = a[0]).match(et) || []),
            (r.match(et) || []).length)
          ) {
            for (; (o = et.exec(r)); )
              (p = o[0]),
                (h = r.substring(y, o.index)),
                u
                  ? (u = (u + 1) % 5)
                  : ('rgba(' !== h.substr(-5) && 'hsla(' !== h.substr(-5)) ||
                    (u = 1),
                p !== (d = l[b++] || '') &&
                  ((c = parseFloat(d) || 0),
                  (g = d.substr((c + '').length)),
                  '=' === p.charAt(1) && (p = At(c, p) + g),
                  (f = parseFloat(p)),
                  (m = p.substr((f + '').length)),
                  (y = et.lastIndex - m.length),
                  m ||
                    ((m = m || Oe.units[t] || g),
                    y === r.length && ((r += m), (v.e += m))),
                  g !== m && (c = Li(e, t, d, m) || 0),
                  (v._pt = {
                    _next: v._pt,
                    p: h || 1 === b ? h : ',',
                    s: c,
                    c: f - c,
                    m: (u && u < 4) || 'zIndex' === t ? Math.round : 0,
                  }));
            v.c = y < r.length ? r.substring(y, r.length) : '';
          } else v.r = 'display' === t && 'none' === r ? si : ii;
          return nt.test(r) && (v.e = 0), (this._pt = v), v;
        },
        Ii = {
          top: '0%',
          bottom: '100%',
          left: '0%',
          right: '100%',
          center: '50%',
        },
        zi = function (e, t) {
          if (t.tween && t.tween._time === t.tween._dur) {
            var n,
              r,
              i,
              s = t.t,
              a = s.style,
              o = t.u,
              l = s._gsap;
            if ('all' === o || !0 === o) (a.cssText = ''), (r = 1);
            else
              for (i = (o = o.split(',')).length; --i > -1; )
                (n = o[i]),
                  Gr[n] && ((r = 1), (n = 'transformOrigin' === n ? fi : pi)),
                  Mi(s, n);
            r &&
              (Mi(s, pi),
              l &&
                (l.svg && s.removeAttribute('transform'),
                Bi(s, 1),
                (l.uncache = 1),
                mi(a)));
          }
        },
        Ri = {
          clearProps: function (e, t, n, r, i) {
            if ('isFromStart' !== i.data) {
              var s = (e._pt = new _r(e._pt, t, n, 0, 0, zi));
              return (
                (s.u = r), (s.pr = -10), (s.tween = i), e._props.push(n), 1
              );
            }
          },
        },
        ji = [1, 0, 0, 1, 0, 0],
        Ni = {},
        $i = function (e) {
          return 'matrix(1, 0, 0, 1, 0, 0)' === e || 'none' === e || !e;
        },
        Fi = function (e) {
          var t = bi(e, pi);
          return $i(t) ? ji : t.substr(7).match(Je).map(Mt);
        },
        qi = function (e, t) {
          var n,
            r,
            i,
            s,
            a = e._gsap || _t(e),
            o = e.style,
            l = Fi(e);
          return a.svg && e.getAttribute('transform')
            ? '1,0,0,1,0,0' ===
              (l = [
                (i = e.transform.baseVal.consolidate().matrix).a,
                i.b,
                i.c,
                i.d,
                i.e,
                i.f,
              ]).join(',')
              ? ji
              : l
            : (l !== ji ||
                e.offsetParent ||
                e === Fr ||
                a.svg ||
                ((i = o.display),
                (o.display = 'block'),
                ((n = e.parentNode) && e.offsetParent) ||
                  ((s = 1), (r = e.nextElementSibling), Fr.appendChild(e)),
                (l = Fi(e)),
                i ? (o.display = i) : Mi(e, 'display'),
                s &&
                  (r
                    ? n.insertBefore(e, r)
                    : n
                    ? n.appendChild(e)
                    : Fr.removeChild(e))),
              t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
        },
        Hi = function (e, t, n, r, i, s) {
          var a,
            o,
            l,
            c = e._gsap,
            u = i || qi(e, !0),
            d = c.xOrigin || 0,
            p = c.yOrigin || 0,
            f = c.xOffset || 0,
            h = c.yOffset || 0,
            m = u[0],
            g = u[1],
            v = u[2],
            y = u[3],
            b = u[4],
            w = u[5],
            x = t.split(' '),
            T = parseFloat(x[0]) || 0,
            E = parseFloat(x[1]) || 0;
          n
            ? u !== ji &&
              (o = m * y - g * v) &&
              ((l = T * (-g / o) + E * (m / o) - (m * w - g * b) / o),
              (T = T * (y / o) + E * (-v / o) + (v * w - y * b) / o),
              (E = l))
            : ((T =
                (a = Si(e)).x + (~x[0].indexOf('%') ? (T / 100) * a.width : T)),
              (E =
                a.y +
                (~(x[1] || x[0]).indexOf('%') ? (E / 100) * a.height : E))),
            r || (!1 !== r && c.smooth)
              ? ((b = T - d),
                (w = E - p),
                (c.xOffset = f + (b * m + w * v) - b),
                (c.yOffset = h + (b * g + w * y) - w))
              : (c.xOffset = c.yOffset = 0),
            (c.xOrigin = T),
            (c.yOrigin = E),
            (c.smooth = !!r),
            (c.origin = t),
            (c.originIsAbsolute = !!n),
            (e.style[fi] = '0px 0px'),
            s &&
              (ki(s, c, 'xOrigin', d, T),
              ki(s, c, 'yOrigin', p, E),
              ki(s, c, 'xOffset', f, c.xOffset),
              ki(s, c, 'yOffset', h, c.yOffset)),
            e.setAttribute('data-svg-origin', T + ' ' + E);
        },
        Bi = function (e, t) {
          var n = e._gsap || new Qn(e);
          if ('x' in n && !t && !n.uncache) return n;
          var r,
            i,
            s,
            a,
            o,
            l,
            c,
            u,
            d,
            p,
            f,
            h,
            m,
            g,
            v,
            y,
            b,
            w,
            x,
            T,
            E,
            _,
            S,
            C,
            M,
            k,
            A,
            P,
            L,
            O,
            D,
            I,
            z = e.style,
            R = n.scaleX < 0,
            j = 'px',
            N = 'deg',
            $ = getComputedStyle(e),
            F = bi(e, fi) || '0';
          return (
            (r = i = s = l = c = u = d = p = f = 0),
            (a = o = 1),
            (n.svg = !(!e.getCTM || !Ci(e))),
            $.translate &&
              (('none' === $.translate &&
                'none' === $.scale &&
                'none' === $.rotate) ||
                (z[pi] =
                  ('none' !== $.translate
                    ? 'translate3d(' +
                      ($.translate + ' 0 0').split(' ').slice(0, 3).join(', ') +
                      ') '
                    : '') +
                  ('none' !== $.rotate ? 'rotate(' + $.rotate + ') ' : '') +
                  ('none' !== $.scale
                    ? 'scale(' + $.scale.split(' ').join(',') + ') '
                    : '') +
                  ('none' !== $[pi] ? $[pi] : '')),
              (z.scale = z.rotate = z.translate = 'none')),
            (g = qi(e, n.svg)),
            n.svg &&
              (n.uncache
                ? ((M = e.getBBox()),
                  (F = n.xOrigin - M.x + 'px ' + (n.yOrigin - M.y) + 'px'),
                  (C = ''))
                : (C = !t && e.getAttribute('data-svg-origin')),
              Hi(e, C || F, !!C || n.originIsAbsolute, !1 !== n.smooth, g)),
            (h = n.xOrigin || 0),
            (m = n.yOrigin || 0),
            g !== ji &&
              ((w = g[0]),
              (x = g[1]),
              (T = g[2]),
              (E = g[3]),
              (r = _ = g[4]),
              (i = S = g[5]),
              6 === g.length
                ? ((a = Math.sqrt(w * w + x * x)),
                  (o = Math.sqrt(E * E + T * T)),
                  (l = w || x ? Ur(x, w) * Wr : 0),
                  (d = T || E ? Ur(T, E) * Wr + l : 0) &&
                    (o *= Math.abs(Math.cos(d * Vr))),
                  n.svg &&
                    ((r -= h - (h * w + m * T)), (i -= m - (h * x + m * E))))
                : ((I = g[6]),
                  (O = g[7]),
                  (A = g[8]),
                  (P = g[9]),
                  (L = g[10]),
                  (D = g[11]),
                  (r = g[12]),
                  (i = g[13]),
                  (s = g[14]),
                  (c = (v = Ur(I, L)) * Wr),
                  v &&
                    ((C = _ * (y = Math.cos(-v)) + A * (b = Math.sin(-v))),
                    (M = S * y + P * b),
                    (k = I * y + L * b),
                    (A = _ * -b + A * y),
                    (P = S * -b + P * y),
                    (L = I * -b + L * y),
                    (D = O * -b + D * y),
                    (_ = C),
                    (S = M),
                    (I = k)),
                  (u = (v = Ur(-T, L)) * Wr),
                  v &&
                    ((y = Math.cos(-v)),
                    (D = E * (b = Math.sin(-v)) + D * y),
                    (w = C = w * y - A * b),
                    (x = M = x * y - P * b),
                    (T = k = T * y - L * b)),
                  (l = (v = Ur(x, w)) * Wr),
                  v &&
                    ((C = w * (y = Math.cos(v)) + x * (b = Math.sin(v))),
                    (M = _ * y + S * b),
                    (x = x * y - w * b),
                    (S = S * y - _ * b),
                    (w = C),
                    (_ = M)),
                  c &&
                    Math.abs(c) + Math.abs(l) > 359.9 &&
                    ((c = l = 0), (u = 180 - u)),
                  (a = Mt(Math.sqrt(w * w + x * x + T * T))),
                  (o = Mt(Math.sqrt(S * S + I * I))),
                  (v = Ur(_, S)),
                  (d = Math.abs(v) > 2e-4 ? v * Wr : 0),
                  (f = D ? 1 / (D < 0 ? -D : D) : 0)),
              n.svg &&
                ((C = e.getAttribute('transform')),
                (n.forceCSS =
                  e.setAttribute('transform', '') || !$i(bi(e, pi))),
                C && e.setAttribute('transform', C))),
            Math.abs(d) > 90 &&
              Math.abs(d) < 270 &&
              (R
                ? ((a *= -1),
                  (d += l <= 0 ? 180 : -180),
                  (l += l <= 0 ? 180 : -180))
                : ((o *= -1), (d += d <= 0 ? 180 : -180))),
            (t = t || n.uncache),
            (n.x =
              r -
              ((n.xPercent =
                r &&
                ((!t && n.xPercent) ||
                  (Math.round(e.offsetWidth / 2) === Math.round(-r) ? -50 : 0)))
                ? (e.offsetWidth * n.xPercent) / 100
                : 0) +
              j),
            (n.y =
              i -
              ((n.yPercent =
                i &&
                ((!t && n.yPercent) ||
                  (Math.round(e.offsetHeight / 2) === Math.round(-i)
                    ? -50
                    : 0)))
                ? (e.offsetHeight * n.yPercent) / 100
                : 0) +
              j),
            (n.z = s + j),
            (n.scaleX = Mt(a)),
            (n.scaleY = Mt(o)),
            (n.rotation = Mt(l) + N),
            (n.rotationX = Mt(c) + N),
            (n.rotationY = Mt(u) + N),
            (n.skewX = d + N),
            (n.skewY = p + N),
            (n.transformPerspective = f + j),
            (n.zOrigin = parseFloat(F.split(' ')[2]) || 0) && (z[fi] = Xi(F)),
            (n.xOffset = n.yOffset = 0),
            (n.force3D = Oe.force3D),
            (n.renderTransform = n.svg ? Qi : Yr ? Ki : Gi),
            (n.uncache = 0),
            n
          );
        },
        Xi = function (e) {
          return (e = e.split(' '))[0] + ' ' + e[1];
        },
        Yi = function (e, t, n) {
          var r = dn(t);
          return Mt(parseFloat(t) + parseFloat(Li(e, 'x', n + 'px', r))) + r;
        },
        Gi = function (e, t) {
          (t.z = '0px'),
            (t.rotationY = t.rotationX = '0deg'),
            (t.force3D = 0),
            Ki(e, t);
        },
        Wi = '0deg',
        Vi = '0px',
        Ui = ') ',
        Ki = function (e, t) {
          var n = t || this,
            r = n.xPercent,
            i = n.yPercent,
            s = n.x,
            a = n.y,
            o = n.z,
            l = n.rotation,
            c = n.rotationY,
            u = n.rotationX,
            d = n.skewX,
            p = n.skewY,
            f = n.scaleX,
            h = n.scaleY,
            m = n.transformPerspective,
            g = n.force3D,
            v = n.target,
            y = n.zOrigin,
            b = '',
            w = ('auto' === g && e && 1 !== e) || !0 === g;
          if (y && (u !== Wi || c !== Wi)) {
            var x,
              T = parseFloat(c) * Vr,
              E = Math.sin(T),
              _ = Math.cos(T);
            (T = parseFloat(u) * Vr),
              (x = Math.cos(T)),
              (s = Yi(v, s, E * x * -y)),
              (a = Yi(v, a, -Math.sin(T) * -y)),
              (o = Yi(v, o, _ * x * -y + y));
          }
          m !== Vi && (b += 'perspective(' + m + Ui),
            (r || i) && (b += 'translate(' + r + '%, ' + i + '%) '),
            (w || s !== Vi || a !== Vi || o !== Vi) &&
              (b +=
                o !== Vi || w
                  ? 'translate3d(' + s + ', ' + a + ', ' + o + ') '
                  : 'translate(' + s + ', ' + a + Ui),
            l !== Wi && (b += 'rotate(' + l + Ui),
            c !== Wi && (b += 'rotateY(' + c + Ui),
            u !== Wi && (b += 'rotateX(' + u + Ui),
            (d === Wi && p === Wi) || (b += 'skew(' + d + ', ' + p + Ui),
            (1 === f && 1 === h) || (b += 'scale(' + f + ', ' + h + Ui),
            (v.style[pi] = b || 'translate(0, 0)');
        },
        Qi = function (e, t) {
          var n,
            r,
            i,
            s,
            a,
            o = t || this,
            l = o.xPercent,
            c = o.yPercent,
            u = o.x,
            d = o.y,
            p = o.rotation,
            f = o.skewX,
            h = o.skewY,
            m = o.scaleX,
            g = o.scaleY,
            v = o.target,
            y = o.xOrigin,
            b = o.yOrigin,
            w = o.xOffset,
            x = o.yOffset,
            T = o.forceCSS,
            E = parseFloat(u),
            _ = parseFloat(d);
          (p = parseFloat(p)),
            (f = parseFloat(f)),
            (h = parseFloat(h)) && ((f += h = parseFloat(h)), (p += h)),
            p || f
              ? ((p *= Vr),
                (f *= Vr),
                (n = Math.cos(p) * m),
                (r = Math.sin(p) * m),
                (i = Math.sin(p - f) * -g),
                (s = Math.cos(p - f) * g),
                f &&
                  ((h *= Vr),
                  (a = Math.tan(f - h)),
                  (i *= a = Math.sqrt(1 + a * a)),
                  (s *= a),
                  h &&
                    ((a = Math.tan(h)),
                    (n *= a = Math.sqrt(1 + a * a)),
                    (r *= a))),
                (n = Mt(n)),
                (r = Mt(r)),
                (i = Mt(i)),
                (s = Mt(s)))
              : ((n = m), (s = g), (r = i = 0)),
            ((E && !~(u + '').indexOf('px')) ||
              (_ && !~(d + '').indexOf('px'))) &&
              ((E = Li(v, 'x', u, 'px')), (_ = Li(v, 'y', d, 'px'))),
            (y || b || w || x) &&
              ((E = Mt(E + y - (y * n + b * i) + w)),
              (_ = Mt(_ + b - (y * r + b * s) + x))),
            (l || c) &&
              ((a = v.getBBox()),
              (E = Mt(E + (l / 100) * a.width)),
              (_ = Mt(_ + (c / 100) * a.height))),
            (a =
              'matrix(' +
              n +
              ',' +
              r +
              ',' +
              i +
              ',' +
              s +
              ',' +
              E +
              ',' +
              _ +
              ')'),
            v.setAttribute('transform', a),
            T && (v.style[pi] = a);
        },
        Zi = function (e, t, n, r, i) {
          var s,
            a,
            o = 360,
            l = He(i),
            c = parseFloat(i) * (l && ~i.indexOf('rad') ? Wr : 1) - r,
            u = r + c + 'deg';
          return (
            l &&
              ('short' === (s = i.split('_')[1]) &&
                (c %= o) != c % 180 &&
                (c += c < 0 ? o : -360),
              'cw' === s && c < 0
                ? (c = ((c + 36e9) % o) - ~~(c / o) * o)
                : 'ccw' === s &&
                  c > 0 &&
                  (c = ((c - 36e9) % o) - ~~(c / o) * o)),
            (e._pt = a = new _r(e._pt, t, n, r, c, ti)),
            (a.e = u),
            (a.u = 'deg'),
            e._props.push(n),
            a
          );
        },
        Ji = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        es = function (e, t, n) {
          var r,
            i,
            s,
            a,
            o,
            l,
            c,
            u = Ji({}, n._gsap),
            d = n.style;
          for (i in (u.svg
            ? ((s = n.getAttribute('transform')),
              n.setAttribute('transform', ''),
              (d[pi] = t),
              (r = Bi(n, 1)),
              Mi(n, pi),
              n.setAttribute('transform', s))
            : ((s = getComputedStyle(n)[pi]),
              (d[pi] = t),
              (r = Bi(n, 1)),
              (d[pi] = s)),
          Gr))
            (s = u[i]) !== (a = r[i]) &&
              'perspective,force3D,transformOrigin,svgOrigin'.indexOf(i) < 0 &&
              ((o = dn(s) !== (c = dn(a)) ? Li(n, i, s, c) : parseFloat(s)),
              (l = parseFloat(a)),
              (e._pt = new _r(e._pt, r, i, o, l - o, ei)),
              (e._pt.u = c || 0),
              e._props.push(i));
          Ji(r, u);
        };
      Ct('padding,margin,Width,Radius', function (e, t) {
        var n = 'Top',
          r = 'Right',
          i = 'Bottom',
          s = 'Left',
          a = (t < 3 ? [n, r, i, s] : [n + s, n + r, i + r, i + s]).map(
            function (n) {
              return t < 2 ? e + n : 'border' + n + e;
            }
          );
        Ri[t > 1 ? 'border' + e : e] = function (e, t, n, r, i) {
          var s, o;
          if (arguments.length < 4)
            return (
              (s = a.map(function (t) {
                return Oi(e, t, n);
              })),
              5 === (o = s.join(' ')).split(s[0]).length ? s[0] : o
            );
          (s = (r + '').split(' ')),
            (o = {}),
            a.forEach(function (e, t) {
              return (o[e] = s[t] = s[t] || s[((t - 1) / 2) | 0]);
            }),
            e.init(t, o, i);
        };
      });
      var ts,
        ns,
        rs = {
          name: 'css',
          register: Ti,
          targetTest: function (e) {
            return e.style && e.nodeType;
          },
          init: function (e, t, n, r, i) {
            var s,
              a,
              o,
              l,
              c,
              u,
              d,
              p,
              f,
              h,
              m,
              g,
              v,
              y,
              b,
              w,
              x,
              T,
              E,
              _,
              S = this._props,
              C = e.style,
              M = n.vars.startAt;
            for (d in (qr || Ti(),
            (this.styles = this.styles || vi(e)),
            (w = this.styles.props),
            (this.tween = n),
            t))
              if (
                'autoRound' !== d &&
                ((a = t[d]), !yt[d] || !ir(d, t, n, r, e, i))
              )
                if (
                  ((c = typeof a),
                  (u = Ri[d]),
                  'function' === c && (c = typeof (a = a.call(n, r, e, i))),
                  'string' === c && ~a.indexOf('random(') && (a = Tn(a)),
                  u)
                )
                  u(this, e, d, a, n) && (b = 1);
                else if ('--' === d.substr(0, 2))
                  (s = (getComputedStyle(e).getPropertyValue(d) + '').trim()),
                    (a += ''),
                    (zn.lastIndex = 0),
                    zn.test(s) || ((p = dn(s)), (f = dn(a))),
                    f ? p !== f && (s = Li(e, d, s, f) + f) : p && (a += p),
                    this.add(C, 'setProperty', s, a, r, i, 0, 0, d),
                    S.push(d),
                    w.push(d, 0, C[d]);
                else if ('undefined' !== c) {
                  if (
                    (M && d in M
                      ? ((s =
                          'function' == typeof M[d]
                            ? M[d].call(n, r, e, i)
                            : M[d]),
                        He(s) && ~s.indexOf('random(') && (s = Tn(s)),
                        dn(s + '') || (s += Oe.units[d] || dn(Oi(e, d)) || ''),
                        '=' === (s + '').charAt(1) && (s = Oi(e, d)))
                      : (s = Oi(e, d)),
                    (l = parseFloat(s)),
                    (h =
                      'string' === c &&
                      '=' === a.charAt(1) &&
                      a.substr(0, 2)) && (a = a.substr(2)),
                    (o = parseFloat(a)),
                    d in Jr &&
                      ('autoAlpha' === d &&
                        (1 === l &&
                          'hidden' === Oi(e, 'visibility') &&
                          o &&
                          (l = 0),
                        w.push('visibility', 0, C.visibility),
                        ki(
                          this,
                          C,
                          'visibility',
                          l ? 'inherit' : 'hidden',
                          o ? 'inherit' : 'hidden',
                          !o
                        )),
                      'scale' !== d &&
                        'transform' !== d &&
                        ~(d = Jr[d]).indexOf(',') &&
                        (d = d.split(',')[0])),
                    (m = d in Gr))
                  )
                    if (
                      (this.styles.save(d),
                      g ||
                        (((v = e._gsap).renderTransform && !t.parseTransform) ||
                          Bi(e, t.parseTransform),
                        (y = !1 !== t.smoothOrigin && v.smooth),
                        ((g = this._pt =
                          new _r(
                            this._pt,
                            C,
                            pi,
                            0,
                            1,
                            v.renderTransform,
                            v,
                            0,
                            -1
                          )).dep = 1)),
                      'scale' === d)
                    )
                      (this._pt = new _r(
                        this._pt,
                        v,
                        'scaleY',
                        v.scaleY,
                        (h ? At(v.scaleY, h + o) : o) - v.scaleY || 0,
                        ei
                      )),
                        (this._pt.u = 0),
                        S.push('scaleY', d),
                        (d += 'X');
                    else {
                      if ('transformOrigin' === d) {
                        w.push(fi, 0, C[fi]),
                          (T = void 0),
                          (E = void 0),
                          (_ = void 0),
                          (E = (T = (x = a).split(' '))[0]),
                          (_ = T[1] || '50%'),
                          ('top' !== E &&
                            'bottom' !== E &&
                            'left' !== _ &&
                            'right' !== _) ||
                            ((x = E), (E = _), (_ = x)),
                          (T[0] = Ii[E] || E),
                          (T[1] = Ii[_] || _),
                          (a = T.join(' ')),
                          v.svg
                            ? Hi(e, a, 0, y, 0, this)
                            : ((f = parseFloat(a.split(' ')[2]) || 0) !==
                                v.zOrigin &&
                                ki(this, v, 'zOrigin', v.zOrigin, f),
                              ki(this, C, d, Xi(s), Xi(a)));
                        continue;
                      }
                      if ('svgOrigin' === d) {
                        Hi(e, a, 1, y, 0, this);
                        continue;
                      }
                      if (d in Ni) {
                        Zi(this, v, d, l, h ? At(l, h + a) : a);
                        continue;
                      }
                      if ('smoothOrigin' === d) {
                        ki(this, v, 'smooth', v.smooth, a);
                        continue;
                      }
                      if ('force3D' === d) {
                        v[d] = a;
                        continue;
                      }
                      if ('transform' === d) {
                        es(this, a, e);
                        continue;
                      }
                    }
                  else d in C || (d = xi(d) || d);
                  if (
                    m ||
                    ((o || 0 === o) && (l || 0 === l) && !Zr.test(a) && d in C)
                  )
                    o || (o = 0),
                      (p = (s + '').substr((l + '').length)) !==
                        (f = dn(a) || (d in Oe.units ? Oe.units[d] : p)) &&
                        (l = Li(e, d, s, f)),
                      (this._pt = new _r(
                        this._pt,
                        m ? v : C,
                        d,
                        l,
                        (h ? At(l, h + o) : o) - l,
                        m ||
                        ('px' !== f && 'zIndex' !== d) ||
                        !1 === t.autoRound
                          ? ei
                          : ri
                      )),
                      (this._pt.u = f || 0),
                      p !== f &&
                        '%' !== f &&
                        ((this._pt.b = s), (this._pt.r = ni));
                  else if (d in C) Di.call(this, e, d, s, h ? h + a : a);
                  else if (d in e)
                    this.add(e, d, s || e[d], h ? h + a : a, r, i);
                  else if ('parseTransform' !== d) {
                    lt(d, a);
                    continue;
                  }
                  m || (d in C ? w.push(d, 0, C[d]) : w.push(d, 1, s || e[d])),
                    S.push(d);
                }
            b && Er(this);
          },
          render: function (e, t) {
            if (t.tween._time || !Xr())
              for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
            else t.styles.revert();
          },
          get: Oi,
          aliases: Jr,
          getSetter: function (e, t, n) {
            var r = Jr[t];
            return (
              r && r.indexOf(',') < 0 && (t = r),
              t in Gr && t !== fi && (e._gsap.x || Oi(e, 'x'))
                ? n && Br === n
                  ? 'scale' === t
                    ? ci
                    : li
                  : (Br = n || {}) && ('scale' === t ? ui : di)
                : e.style && !Ye(e.style[t])
                ? ai
                : ~t.indexOf('-')
                ? oi
                : mr(e, t)
            );
          },
          core: { _removeProperty: Mi, _getMatrix: qi },
        };
      (jr.utils.checkPrefix = xi),
        (jr.core.getStyleSaver = vi),
        (ns = Ct(
          'x,y,z,scale,scaleX,scaleY,xPercent,yPercent' +
            ',' +
            (ts = 'rotation,rotationX,rotationY,skewX,skewY') +
            ',transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective',
          function (e) {
            Gr[e] = 1;
          }
        )),
        Ct(ts, function (e) {
          (Oe.units[e] = 'deg'), (Ni[e] = 1);
        }),
        (Jr[ns[13]] = 'x,y,z,scale,scaleX,scaleY,xPercent,yPercent,' + ts),
        Ct(
          '0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY',
          function (e) {
            var t = e.split(':');
            Jr[t[1]] = ns[t[0]];
          }
        ),
        Ct(
          'x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective',
          function (e) {
            Oe.units[e] = 'px';
          }
        ),
        jr.registerPlugin(rs);
      var is = jr.registerPlugin(rs) || jr;
      function ss(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            'value' in r && (r.writable = !0),
            Object.defineProperty(e, r.key, r);
        }
      }
      is.core.Tween;
      var as,
        os,
        ls,
        cs,
        us,
        ds,
        ps,
        fs,
        hs,
        ms,
        gs,
        vs,
        ys,
        bs = function () {
          return (
            as ||
            ('undefined' != typeof window &&
              (as = window.gsap) &&
              as.registerPlugin &&
              as)
          );
        },
        ws = 1,
        xs = [],
        Ts = [],
        Es = [],
        _s = Date.now,
        Ss = function (e, t) {
          return t;
        },
        Cs = function (e, t) {
          return ~Es.indexOf(e) && Es[Es.indexOf(e) + 1][t];
        },
        Ms = function (e) {
          return !!~ms.indexOf(e);
        },
        ks = function (e, t, n, r, i) {
          return e.addEventListener(t, n, { passive: !r, capture: !!i });
        },
        As = function (e, t, n, r) {
          return e.removeEventListener(t, n, !!r);
        },
        Ps = 'scrollLeft',
        Ls = 'scrollTop',
        Os = function () {
          return (gs && gs.isPressed) || Ts.cache++;
        },
        Ds = function (e, t) {
          var n = function n(r) {
            if (r || 0 === r) {
              ws && (ls.history.scrollRestoration = 'manual');
              var i = gs && gs.isPressed;
              (r = n.v = Math.round(r) || (gs && gs.iOS ? 1 : 0)),
                e(r),
                (n.cacheID = Ts.cache),
                i && Ss('ss', r);
            } else
              (t || Ts.cache !== n.cacheID || Ss('ref')) &&
                ((n.cacheID = Ts.cache), (n.v = e()));
            return n.v + n.offset;
          };
          return (n.offset = 0), e && n;
        },
        Is = {
          s: Ps,
          p: 'left',
          p2: 'Left',
          os: 'right',
          os2: 'Right',
          d: 'width',
          d2: 'Width',
          a: 'x',
          sc: Ds(function (e) {
            return arguments.length
              ? ls.scrollTo(e, zs.sc())
              : ls.pageXOffset || cs[Ps] || us[Ps] || ds[Ps] || 0;
          }),
        },
        zs = {
          s: Ls,
          p: 'top',
          p2: 'Top',
          os: 'bottom',
          os2: 'Bottom',
          d: 'height',
          d2: 'Height',
          a: 'y',
          op: Is,
          sc: Ds(function (e) {
            return arguments.length
              ? ls.scrollTo(Is.sc(), e)
              : ls.pageYOffset || cs[Ls] || us[Ls] || ds[Ls] || 0;
          }),
        },
        Rs = function (e, t) {
          return (
            ((t && t._ctx && t._ctx.selector) || as.utils.toArray)(e)[0] ||
            ('string' == typeof e && !1 !== as.config().nullTargetWarn
              ? console.warn('Element not found:', e)
              : null)
          );
        },
        js = function (e, t) {
          var n = t.s,
            r = t.sc;
          Ms(e) && (e = cs.scrollingElement || us);
          var i = Ts.indexOf(e),
            s = r === zs.sc ? 1 : 2;
          !~i && (i = Ts.push(e) - 1),
            Ts[i + s] || e.addEventListener('scroll', Os);
          var a = Ts[i + s],
            o =
              a ||
              (Ts[i + s] =
                Ds(Cs(e, n), !0) ||
                (Ms(e)
                  ? r
                  : Ds(function (t) {
                      return arguments.length ? (e[n] = t) : e[n];
                    })));
          return (
            (o.target = e),
            a || (o.smooth = 'smooth' === as.getProperty(e, 'scrollBehavior')),
            o
          );
        },
        Ns = function (e, t, n) {
          var r = e,
            i = e,
            s = _s(),
            a = s,
            o = t || 50,
            l = Math.max(500, 3 * o),
            c = function (e, t) {
              var l = _s();
              t || l - s > o
                ? ((i = r), (r = e), (a = s), (s = l))
                : n
                ? (r += e)
                : (r = i + ((e - i) / (l - a)) * (s - a));
            };
          return {
            update: c,
            reset: function () {
              (i = r = n ? 0 : r), (a = s = 0);
            },
            getVelocity: function (e) {
              var t = a,
                o = i,
                u = _s();
              return (
                (e || 0 === e) && e !== r && c(e),
                s === a || u - a > l
                  ? 0
                  : ((r + (n ? o : -o)) / ((n ? u : s) - t)) * 1e3
              );
            },
          };
        },
        $s = function (e, t) {
          return (
            t && !e._gsapAllow && e.preventDefault(),
            e.changedTouches ? e.changedTouches[0] : e
          );
        },
        Fs = function (e) {
          var t = Math.max.apply(Math, e),
            n = Math.min.apply(Math, e);
          return Math.abs(t) >= Math.abs(n) ? t : n;
        },
        qs = function () {
          (hs = as.core.globals().ScrollTrigger) &&
            hs.core &&
            (function () {
              var e = hs.core,
                t = e.bridge || {},
                n = e._scrollers,
                r = e._proxies;
              n.push.apply(n, Ts),
                r.push.apply(r, Es),
                (Ts = n),
                (Es = r),
                (Ss = function (e, n) {
                  return t[e](n);
                });
            })();
        },
        Hs = function (e) {
          return (
            (as = e || bs()) &&
              'undefined' != typeof document &&
              document.body &&
              ((ls = window),
              (cs = document),
              (us = cs.documentElement),
              (ds = cs.body),
              (ms = [ls, cs, us, ds]),
              as.utils.clamp,
              (ys = as.core.context || function () {}),
              (fs = 'onpointerenter' in ds ? 'pointer' : 'mouse'),
              (ps = Bs.isTouch =
                ls.matchMedia &&
                ls.matchMedia('(hover: none), (pointer: coarse)').matches
                  ? 1
                  : 'ontouchstart' in ls ||
                    navigator.maxTouchPoints > 0 ||
                    navigator.msMaxTouchPoints > 0
                  ? 2
                  : 0),
              (vs = Bs.eventTypes =
                (
                  'ontouchstart' in us
                    ? 'touchstart,touchmove,touchcancel,touchend'
                    : 'onpointerdown' in us
                    ? 'pointerdown,pointermove,pointercancel,pointerup'
                    : 'mousedown,mousemove,mouseup,mouseup'
                ).split(',')),
              setTimeout(function () {
                return (ws = 0);
              }, 500),
              qs(),
              (os = 1)),
            os
          );
        };
      (Is.op = zs), (Ts.cache = 0);
      var Bs = (function () {
        function e(e) {
          this.init(e);
        }
        var t, n;
        return (
          (e.prototype.init = function (e) {
            os ||
              Hs(as) ||
              console.warn('Please gsap.registerPlugin(Observer)'),
              hs || qs();
            var t = e.tolerance,
              n = e.dragMinimum,
              r = e.type,
              i = e.target,
              s = e.lineHeight,
              a = e.debounce,
              o = e.preventDefault,
              l = e.onStop,
              c = e.onStopDelay,
              u = e.ignore,
              d = e.wheelSpeed,
              p = e.event,
              f = e.onDragStart,
              h = e.onDragEnd,
              m = e.onDrag,
              g = e.onPress,
              v = e.onRelease,
              y = e.onRight,
              b = e.onLeft,
              w = e.onUp,
              x = e.onDown,
              T = e.onChangeX,
              E = e.onChangeY,
              _ = e.onChange,
              S = e.onToggleX,
              C = e.onToggleY,
              M = e.onHover,
              k = e.onHoverEnd,
              A = e.onMove,
              P = e.ignoreCheck,
              L = e.isNormalizer,
              O = e.onGestureStart,
              D = e.onGestureEnd,
              I = e.onWheel,
              z = e.onEnable,
              R = e.onDisable,
              j = e.onClick,
              N = e.scrollSpeed,
              $ = e.capture,
              F = e.allowClicks,
              q = e.lockAxis,
              H = e.onLockAxis;
            (this.target = i = Rs(i) || us),
              (this.vars = e),
              u && (u = as.utils.toArray(u)),
              (t = t || 1e-9),
              (n = n || 0),
              (d = d || 1),
              (N = N || 1),
              (r = r || 'wheel,touch,pointer'),
              (a = !1 !== a),
              s || (s = parseFloat(ls.getComputedStyle(ds).lineHeight) || 22);
            var B,
              X,
              Y,
              G,
              W,
              V,
              U,
              K = this,
              Q = 0,
              Z = 0,
              J = js(i, Is),
              ee = js(i, zs),
              te = J(),
              ne = ee(),
              re =
                ~r.indexOf('touch') &&
                !~r.indexOf('pointer') &&
                'pointerdown' === vs[0],
              ie = Ms(i),
              se = i.ownerDocument || cs,
              ae = [0, 0, 0],
              oe = [0, 0, 0],
              le = 0,
              ce = function () {
                return (le = _s());
              },
              ue = function (e, t) {
                return (
                  ((K.event = e) && u && ~u.indexOf(e.target)) ||
                  (t && re && 'touch' !== e.pointerType) ||
                  (P && P(e, t))
                );
              },
              de = function () {
                var e = (K.deltaX = Fs(ae)),
                  n = (K.deltaY = Fs(oe)),
                  r = Math.abs(e) >= t,
                  i = Math.abs(n) >= t;
                _ && (r || i) && _(K, e, n, ae, oe),
                  r &&
                    (y && K.deltaX > 0 && y(K),
                    b && K.deltaX < 0 && b(K),
                    T && T(K),
                    S && K.deltaX < 0 != Q < 0 && S(K),
                    (Q = K.deltaX),
                    (ae[0] = ae[1] = ae[2] = 0)),
                  i &&
                    (x && K.deltaY > 0 && x(K),
                    w && K.deltaY < 0 && w(K),
                    E && E(K),
                    C && K.deltaY < 0 != Z < 0 && C(K),
                    (Z = K.deltaY),
                    (oe[0] = oe[1] = oe[2] = 0)),
                  (G || Y) && (A && A(K), Y && (m(K), (Y = !1)), (G = !1)),
                  V && !(V = !1) && H && H(K),
                  W && (I(K), (W = !1)),
                  (B = 0);
              },
              pe = function (e, t, n) {
                (ae[n] += e),
                  (oe[n] += t),
                  K._vx.update(e),
                  K._vy.update(t),
                  a ? B || (B = requestAnimationFrame(de)) : de();
              },
              fe = function (e, t) {
                q &&
                  !U &&
                  ((K.axis = U = Math.abs(e) > Math.abs(t) ? 'x' : 'y'),
                  (V = !0)),
                  'y' !== U && ((ae[2] += e), K._vx.update(e, !0)),
                  'x' !== U && ((oe[2] += t), K._vy.update(t, !0)),
                  a ? B || (B = requestAnimationFrame(de)) : de();
              },
              he = function (e) {
                if (!ue(e, 1)) {
                  var t = (e = $s(e, o)).clientX,
                    r = e.clientY,
                    i = t - K.x,
                    s = r - K.y,
                    a = K.isDragging;
                  (K.x = t),
                    (K.y = r),
                    (a ||
                      Math.abs(K.startX - t) >= n ||
                      Math.abs(K.startY - r) >= n) &&
                      (m && (Y = !0),
                      a || (K.isDragging = !0),
                      fe(i, s),
                      a || (f && f(K)));
                }
              },
              me = (K.onPress = function (e) {
                ue(e, 1) ||
                  (e && e.button) ||
                  ((K.axis = U = null),
                  X.pause(),
                  (K.isPressed = !0),
                  (e = $s(e)),
                  (Q = Z = 0),
                  (K.startX = K.x = e.clientX),
                  (K.startY = K.y = e.clientY),
                  K._vx.reset(),
                  K._vy.reset(),
                  ks(L ? i : se, vs[1], he, o, !0),
                  (K.deltaX = K.deltaY = 0),
                  g && g(K));
              }),
              ge = (K.onRelease = function (e) {
                if (!ue(e, 1)) {
                  As(L ? i : se, vs[1], he, !0);
                  var t = !isNaN(K.y - K.startY),
                    n =
                      K.isDragging &&
                      (Math.abs(K.x - K.startX) > 3 ||
                        Math.abs(K.y - K.startY) > 3),
                    r = $s(e);
                  !n &&
                    t &&
                    (K._vx.reset(),
                    K._vy.reset(),
                    o &&
                      F &&
                      as.delayedCall(0.08, function () {
                        if (_s() - le > 300 && !e.defaultPrevented)
                          if (e.target.click) e.target.click();
                          else if (se.createEvent) {
                            var t = se.createEvent('MouseEvents');
                            t.initMouseEvent(
                              'click',
                              !0,
                              !0,
                              ls,
                              1,
                              r.screenX,
                              r.screenY,
                              r.clientX,
                              r.clientY,
                              !1,
                              !1,
                              !1,
                              !1,
                              0,
                              null
                            ),
                              e.target.dispatchEvent(t);
                          }
                      })),
                    (K.isDragging = K.isGesturing = K.isPressed = !1),
                    l && !L && X.restart(!0),
                    h && n && h(K),
                    v && v(K, n);
                }
              }),
              ve = function (e) {
                return (
                  e.touches &&
                  e.touches.length > 1 &&
                  (K.isGesturing = !0) &&
                  O(e, K.isDragging)
                );
              },
              ye = function () {
                return (K.isGesturing = !1) || D(K);
              },
              be = function (e) {
                if (!ue(e)) {
                  var t = J(),
                    n = ee();
                  pe((t - te) * N, (n - ne) * N, 1),
                    (te = t),
                    (ne = n),
                    l && X.restart(!0);
                }
              },
              we = function (e) {
                if (!ue(e)) {
                  (e = $s(e, o)), I && (W = !0);
                  var t =
                    (1 === e.deltaMode
                      ? s
                      : 2 === e.deltaMode
                      ? ls.innerHeight
                      : 1) * d;
                  pe(e.deltaX * t, e.deltaY * t, 0), l && !L && X.restart(!0);
                }
              },
              xe = function (e) {
                if (!ue(e)) {
                  var t = e.clientX,
                    n = e.clientY,
                    r = t - K.x,
                    i = n - K.y;
                  (K.x = t), (K.y = n), (G = !0), (r || i) && fe(r, i);
                }
              },
              Te = function (e) {
                (K.event = e), M(K);
              },
              Ee = function (e) {
                (K.event = e), k(K);
              },
              _e = function (e) {
                return ue(e) || ($s(e, o) && j(K));
              };
            (X = K._dc =
              as
                .delayedCall(c || 0.25, function () {
                  K._vx.reset(), K._vy.reset(), X.pause(), l && l(K);
                })
                .pause()),
              (K.deltaX = K.deltaY = 0),
              (K._vx = Ns(0, 50, !0)),
              (K._vy = Ns(0, 50, !0)),
              (K.scrollX = J),
              (K.scrollY = ee),
              (K.isDragging = K.isGesturing = K.isPressed = !1),
              ys(this),
              (K.enable = function (e) {
                return (
                  K.isEnabled ||
                    (ks(ie ? se : i, 'scroll', Os),
                    r.indexOf('scroll') >= 0 &&
                      ks(ie ? se : i, 'scroll', be, o, $),
                    r.indexOf('wheel') >= 0 && ks(i, 'wheel', we, o, $),
                    ((r.indexOf('touch') >= 0 && ps) ||
                      r.indexOf('pointer') >= 0) &&
                      (ks(i, vs[0], me, o, $),
                      ks(se, vs[2], ge),
                      ks(se, vs[3], ge),
                      F && ks(i, 'click', ce, !1, !0),
                      j && ks(i, 'click', _e),
                      O && ks(se, 'gesturestart', ve),
                      D && ks(se, 'gestureend', ye),
                      M && ks(i, fs + 'enter', Te),
                      k && ks(i, fs + 'leave', Ee),
                      A && ks(i, fs + 'move', xe)),
                    (K.isEnabled = !0),
                    e && e.type && me(e),
                    z && z(K)),
                  K
                );
              }),
              (K.disable = function () {
                K.isEnabled &&
                  (xs.filter(function (e) {
                    return e !== K && Ms(e.target);
                  }).length || As(ie ? se : i, 'scroll', Os),
                  K.isPressed &&
                    (K._vx.reset(),
                    K._vy.reset(),
                    As(L ? i : se, vs[1], he, !0)),
                  As(ie ? se : i, 'scroll', be, $),
                  As(i, 'wheel', we, $),
                  As(i, vs[0], me, $),
                  As(se, vs[2], ge),
                  As(se, vs[3], ge),
                  As(i, 'click', ce, !0),
                  As(i, 'click', _e),
                  As(se, 'gesturestart', ve),
                  As(se, 'gestureend', ye),
                  As(i, fs + 'enter', Te),
                  As(i, fs + 'leave', Ee),
                  As(i, fs + 'move', xe),
                  (K.isEnabled = K.isPressed = K.isDragging = !1),
                  R && R(K));
              }),
              (K.kill = K.revert =
                function () {
                  K.disable();
                  var e = xs.indexOf(K);
                  e >= 0 && xs.splice(e, 1), gs === K && (gs = 0);
                }),
              xs.push(K),
              L && Ms(i) && (gs = K),
              K.enable(p);
          }),
          (t = e),
          (n = [
            {
              key: 'velocityX',
              get: function () {
                return this._vx.getVelocity();
              },
            },
            {
              key: 'velocityY',
              get: function () {
                return this._vy.getVelocity();
              },
            },
          ]) && ss(t.prototype, n),
          e
        );
      })();
      (Bs.version = '3.12.1'),
        (Bs.create = function (e) {
          return new Bs(e);
        }),
        (Bs.register = Hs),
        (Bs.getAll = function () {
          return xs.slice();
        }),
        (Bs.getById = function (e) {
          return xs.filter(function (t) {
            return t.vars.id === e;
          })[0];
        }),
        bs() && as.registerPlugin(Bs);
      var Xs,
        Ys,
        Gs,
        Ws,
        Vs,
        Us,
        Ks,
        Qs,
        Zs,
        Js,
        ea,
        ta,
        na,
        ra,
        ia,
        sa,
        aa,
        oa,
        la,
        ca,
        ua,
        da,
        pa,
        fa,
        ha,
        ma,
        ga,
        va,
        ya,
        ba,
        wa,
        xa,
        Ta,
        Ea,
        _a = 1,
        Sa = Date.now,
        Ca = Sa(),
        Ma = 0,
        ka = 0,
        Aa = function (e, t, n) {
          var r =
            Ha(e) && ('clamp(' === e.substr(0, 6) || e.indexOf('max') > -1);
          return (n['_' + t + 'Clamp'] = r), r ? e.substr(6, e.length - 7) : e;
        },
        Pa = function (e, t) {
          return !t || (Ha(e) && 'clamp(' === e.substr(0, 6))
            ? e
            : 'clamp(' + e + ')';
        },
        La = function e() {
          return ka && requestAnimationFrame(e);
        },
        Oa = function () {
          return (ra = 1);
        },
        Da = function () {
          return (ra = 0);
        },
        Ia = function (e) {
          return e;
        },
        za = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        Ra = function () {
          return 'undefined' != typeof window;
        },
        ja = function () {
          return Xs || (Ra() && (Xs = window.gsap) && Xs.registerPlugin && Xs);
        },
        Na = function (e) {
          return !!~Ks.indexOf(e);
        },
        $a = function (e) {
          return (
            Cs(e, 'getBoundingClientRect') ||
            (Na(e)
              ? function () {
                  return (
                    (Qo.width = Gs.innerWidth), (Qo.height = Gs.innerHeight), Qo
                  );
                }
              : function () {
                  return po(e);
                })
          );
        },
        Fa = function (e, t) {
          var n = t.s,
            r = t.d2,
            i = t.d,
            s = t.a;
          return Math.max(
            0,
            (n = 'scroll' + r) && (s = Cs(e, n))
              ? s() - $a(e)()[i]
              : Na(e)
              ? (Vs[n] || Us[n]) -
                (Gs['inner' + r] || Vs['client' + r] || Us['client' + r])
              : e[n] - e['offset' + r]
          );
        },
        qa = function (e, t) {
          for (var n = 0; n < la.length; n += 3)
            (!t || ~t.indexOf(la[n + 1])) && e(la[n], la[n + 1], la[n + 2]);
        },
        Ha = function (e) {
          return 'string' == typeof e;
        },
        Ba = function (e) {
          return 'function' == typeof e;
        },
        Xa = function (e) {
          return 'number' == typeof e;
        },
        Ya = function (e) {
          return 'object' == typeof e;
        },
        Ga = function (e, t, n) {
          return e && e.progress(t ? 0 : 1) && n && e.pause();
        },
        Wa = function (e, t) {
          if (e.enabled) {
            var n = t(e);
            n && n.totalTime && (e.callbackAnimation = n);
          }
        },
        Va = Math.abs,
        Ua = 'left',
        Ka = 'right',
        Qa = 'bottom',
        Za = 'width',
        Ja = 'height',
        eo = 'Right',
        to = 'Left',
        no = 'Top',
        ro = 'Bottom',
        io = 'padding',
        so = 'margin',
        ao = 'Width',
        oo = 'Height',
        lo = 'px',
        co = function (e) {
          return Gs.getComputedStyle(e);
        },
        uo = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        po = function (e, t) {
          var n =
              t &&
              'matrix(1, 0, 0, 1, 0, 0)' !== co(e)[ia] &&
              Xs.to(e, {
                x: 0,
                y: 0,
                xPercent: 0,
                yPercent: 0,
                rotation: 0,
                rotationX: 0,
                rotationY: 0,
                scale: 1,
                skewX: 0,
                skewY: 0,
              }).progress(1),
            r = e.getBoundingClientRect();
          return n && n.progress(0).kill(), r;
        },
        fo = function (e, t) {
          var n = t.d2;
          return e['offset' + n] || e['client' + n] || 0;
        },
        ho = function (e) {
          var t,
            n = [],
            r = e.labels,
            i = e.duration();
          for (t in r) n.push(r[t] / i);
          return n;
        },
        mo = function (e) {
          var t = Xs.utils.snap(e),
            n =
              Array.isArray(e) &&
              e.slice(0).sort(function (e, t) {
                return e - t;
              });
          return n
            ? function (e, r, i) {
                var s;
                if ((void 0 === i && (i = 0.001), !r)) return t(e);
                if (r > 0) {
                  for (e -= i, s = 0; s < n.length; s++)
                    if (n[s] >= e) return n[s];
                  return n[s - 1];
                }
                for (s = n.length, e += i; s--; ) if (n[s] <= e) return n[s];
                return n[0];
              }
            : function (n, r, i) {
                void 0 === i && (i = 0.001);
                var s = t(n);
                return !r || Math.abs(s - n) < i || s - n < 0 == r < 0
                  ? s
                  : t(r < 0 ? n - e : n + e);
              };
        },
        go = function (e, t, n, r) {
          return n.split(',').forEach(function (n) {
            return e(t, n, r);
          });
        },
        vo = function (e, t, n, r, i) {
          return e.addEventListener(t, n, { passive: !r, capture: !!i });
        },
        yo = function (e, t, n, r) {
          return e.removeEventListener(t, n, !!r);
        },
        bo = function (e, t, n) {
          (n = n && n.wheelHandler) && (e(t, 'wheel', n), e(t, 'touchmove', n));
        },
        wo = {
          startColor: 'green',
          endColor: 'red',
          indent: 0,
          fontSize: '16px',
          fontWeight: 'normal',
        },
        xo = { toggleActions: 'play', anticipatePin: 0 },
        To = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
        Eo = function (e, t) {
          if (Ha(e)) {
            var n = e.indexOf('='),
              r = ~n ? +(e.charAt(n - 1) + 1) * parseFloat(e.substr(n + 1)) : 0;
            ~n &&
              (e.indexOf('%') > n && (r *= t / 100), (e = e.substr(0, n - 1))),
              (e =
                r +
                (e in To
                  ? To[e] * t
                  : ~e.indexOf('%')
                  ? (parseFloat(e) * t) / 100
                  : parseFloat(e) || 0));
          }
          return e;
        },
        _o = function (e, t, n, r, i, s, a, o) {
          var l = i.startColor,
            c = i.endColor,
            u = i.fontSize,
            d = i.indent,
            p = i.fontWeight,
            f = Ws.createElement('div'),
            h = Na(n) || 'fixed' === Cs(n, 'pinType'),
            m = -1 !== e.indexOf('scroller'),
            g = h ? Us : n,
            v = -1 !== e.indexOf('start'),
            y = v ? l : c,
            b =
              'border-color:' +
              y +
              ';font-size:' +
              u +
              ';color:' +
              y +
              ';font-weight:' +
              p +
              ';pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;';
          return (
            (b += 'position:' + ((m || o) && h ? 'fixed;' : 'absolute;')),
            (m || o || !h) &&
              (b += (r === zs ? Ka : Qa) + ':' + (s + parseFloat(d)) + 'px;'),
            a &&
              (b +=
                'box-sizing:border-box;text-align:left;width:' +
                a.offsetWidth +
                'px;'),
            (f._isStart = v),
            f.setAttribute(
              'class',
              'gsap-marker-' + e + (t ? ' marker-' + t : '')
            ),
            (f.style.cssText = b),
            (f.innerText = t || 0 === t ? e + '-' + t : e),
            g.children[0] ? g.insertBefore(f, g.children[0]) : g.appendChild(f),
            (f._offset = f['offset' + r.op.d2]),
            So(f, 0, r, v),
            f
          );
        },
        So = function (e, t, n, r) {
          var i = { display: 'block' },
            s = n[r ? 'os2' : 'p2'],
            a = n[r ? 'p2' : 'os2'];
          (e._isFlipped = r),
            (i[n.a + 'Percent'] = r ? -100 : 0),
            (i[n.a] = r ? '1px' : 0),
            (i['border' + s + ao] = 1),
            (i['border' + a + ao] = 0),
            (i[n.p] = t + 'px'),
            Xs.set(e, i);
        },
        Co = [],
        Mo = {},
        ko = function () {
          return Sa() - Ma > 34 && (wa || (wa = requestAnimationFrame(Xo)));
        },
        Ao = function () {
          (!pa || !pa.isPressed || pa.startX > Us.clientWidth) &&
            (Ts.cache++,
            pa ? wa || (wa = requestAnimationFrame(Xo)) : Xo(),
            Ma || zo('scrollStart'),
            (Ma = Sa()));
        },
        Po = function () {
          (ma = Gs.innerWidth), (ha = Gs.innerHeight);
        },
        Lo = function () {
          Ts.cache++,
            !na &&
              !da &&
              !Ws.fullscreenElement &&
              !Ws.webkitFullscreenElement &&
              (!fa ||
                ma !== Gs.innerWidth ||
                Math.abs(Gs.innerHeight - ha) > 0.25 * Gs.innerHeight) &&
              Qs.restart(!0);
        },
        Oo = {},
        Do = [],
        Io = function e() {
          return yo(il, 'scrollEnd', e) || qo(!0);
        },
        zo = function (e) {
          return (
            (Oo[e] &&
              Oo[e].map(function (e) {
                return e();
              })) ||
            Do
          );
        },
        Ro = [],
        jo = function (e) {
          for (var t = 0; t < Ro.length; t += 5)
            (!e || (Ro[t + 4] && Ro[t + 4].query === e)) &&
              ((Ro[t].style.cssText = Ro[t + 1]),
              Ro[t].getBBox && Ro[t].setAttribute('transform', Ro[t + 2] || ''),
              (Ro[t + 3].uncache = 1));
        },
        No = function (e, t) {
          var n;
          for (sa = 0; sa < Co.length; sa++)
            !(n = Co[sa]) ||
              (t && n._ctx !== t) ||
              (e ? n.kill(1) : n.revert(!0, !0));
          t && jo(t), t || zo('revert');
        },
        $o = function (e, t) {
          Ts.cache++,
            (t || !xa) &&
              Ts.forEach(function (e) {
                return Ba(e) && e.cacheID++ && (e.rec = 0);
              }),
            Ha(e) && (Gs.history.scrollRestoration = ya = e);
        },
        Fo = 0,
        qo = function (e, t) {
          if (!Ma || e) {
            (xa = il.isRefreshing = !0),
              Ts.forEach(function (e) {
                return Ba(e) && ++e.cacheID && (e.rec = e());
              });
            var n = zo('refreshInit');
            ca && il.sort(),
              t || No(),
              Ts.forEach(function (e) {
                Ba(e) &&
                  (e.smooth && (e.target.style.scrollBehavior = 'auto'), e(0));
              }),
              Co.slice(0).forEach(function (e) {
                return e.refresh();
              }),
              Co.forEach(function (e, t) {
                if (e._subPinOffset && e.pin) {
                  var n = e.vars.horizontal ? 'offsetWidth' : 'offsetHeight',
                    r = e.pin[n];
                  e.revert(!0, 1),
                    e.adjustPinSpacing(e.pin[n] - r),
                    e.refresh();
                }
              }),
              Co.forEach(function (e) {
                var t = Fa(e.scroller, e._dir);
                ('max' === e.vars.end || (e._endClamp && e.end > t)) &&
                  e.setPositions(e.start, Math.max(e.start + 1, t), !0);
              }),
              n.forEach(function (e) {
                return e && e.render && e.render(-1);
              }),
              Ts.forEach(function (e) {
                Ba(e) &&
                  (e.smooth &&
                    requestAnimationFrame(function () {
                      return (e.target.style.scrollBehavior = 'smooth');
                    }),
                  e.rec && e(e.rec));
              }),
              $o(ya, 1),
              Qs.pause(),
              Fo++,
              (xa = 2),
              Xo(2),
              Co.forEach(function (e) {
                return Ba(e.vars.onRefresh) && e.vars.onRefresh(e);
              }),
              (xa = il.isRefreshing = !1),
              zo('refresh');
          } else vo(il, 'scrollEnd', Io);
        },
        Ho = 0,
        Bo = 1,
        Xo = function (e) {
          if (!xa || 2 === e) {
            (il.isUpdating = !0), Ea && Ea.update(0);
            var t = Co.length,
              n = Sa(),
              r = n - Ca >= 50,
              i = t && Co[0].scroll();
            if (
              ((Bo = Ho > i ? -1 : 1),
              xa || (Ho = i),
              r &&
                (Ma && !ra && n - Ma > 200 && ((Ma = 0), zo('scrollEnd')),
                (ea = Ca),
                (Ca = n)),
              Bo < 0)
            ) {
              for (sa = t; sa-- > 0; ) Co[sa] && Co[sa].update(0, r);
              Bo = 1;
            } else for (sa = 0; sa < t; sa++) Co[sa] && Co[sa].update(0, r);
            il.isUpdating = !1;
          }
          wa = 0;
        },
        Yo = [
          Ua,
          'top',
          Qa,
          Ka,
          so + ro,
          so + eo,
          so + no,
          so + to,
          'display',
          'flexShrink',
          'float',
          'zIndex',
          'gridColumnStart',
          'gridColumnEnd',
          'gridRowStart',
          'gridRowEnd',
          'gridArea',
          'justifySelf',
          'alignSelf',
          'placeSelf',
          'order',
        ],
        Go = Yo.concat([
          Za,
          Ja,
          'boxSizing',
          'max' + ao,
          'max' + oo,
          'position',
          so,
          io,
          io + no,
          io + eo,
          io + ro,
          io + to,
        ]),
        Wo = function (e, t, n, r) {
          if (!e._gsap.swappedIn) {
            for (var i, s = Yo.length, a = t.style, o = e.style; s--; )
              a[(i = Yo[s])] = n[i];
            (a.position = 'absolute' === n.position ? 'absolute' : 'relative'),
              'inline' === n.display && (a.display = 'inline-block'),
              (o[Qa] = o[Ka] = 'auto'),
              (a.flexBasis = n.flexBasis || 'auto'),
              (a.overflow = 'visible'),
              (a.boxSizing = 'border-box'),
              (a[Za] = fo(e, Is) + lo),
              (a[Ja] = fo(e, zs) + lo),
              (a[io] = o[so] = o.top = o[Ua] = '0'),
              Uo(r),
              (o[Za] = o['max' + ao] = n[Za]),
              (o[Ja] = o['max' + oo] = n[Ja]),
              (o[io] = n[io]),
              e.parentNode !== t &&
                (e.parentNode.insertBefore(t, e), t.appendChild(e)),
              (e._gsap.swappedIn = !0);
          }
        },
        Vo = /([A-Z])/g,
        Uo = function (e) {
          if (e) {
            var t,
              n,
              r = e.t.style,
              i = e.length,
              s = 0;
            for (
              (e.t._gsap || Xs.core.getCache(e.t)).uncache = 1;
              s < i;
              s += 2
            )
              (n = e[s + 1]),
                (t = e[s]),
                n
                  ? (r[t] = n)
                  : r[t] &&
                    r.removeProperty(t.replace(Vo, '-$1').toLowerCase());
          }
        },
        Ko = function (e) {
          for (var t = Go.length, n = e.style, r = [], i = 0; i < t; i++)
            r.push(Go[i], n[Go[i]]);
          return (r.t = e), r;
        },
        Qo = { left: 0, top: 0 },
        Zo = function (e, t, n, r, i, s, a, o, l, c, u, d, p, f) {
          Ba(e) && (e = e(o)),
            Ha(e) &&
              'max' === e.substr(0, 3) &&
              (e = d + ('=' === e.charAt(4) ? Eo('0' + e.substr(3), n) : 0));
          var h,
            m,
            g,
            v = p ? p.time() : 0;
          if ((p && p.seek(0), isNaN(e) || (e = +e), Xa(e)))
            p &&
              (e = Xs.utils.mapRange(
                p.scrollTrigger.start,
                p.scrollTrigger.end,
                0,
                d,
                e
              )),
              a && So(a, n, r, !0);
          else {
            Ba(t) && (t = t(o));
            var y,
              b,
              w,
              x,
              T = (e || '0').split(' ');
            (g = Rs(t, o) || Us),
              ((y = po(g) || {}) && (y.left || y.top)) ||
                'none' !== co(g).display ||
                ((x = g.style.display),
                (g.style.display = 'block'),
                (y = po(g)),
                x ? (g.style.display = x) : g.style.removeProperty('display')),
              (b = Eo(T[0], y[r.d])),
              (w = Eo(T[1] || '0', n)),
              (e = y[r.p] - l[r.p] - c + b + i - w),
              a && So(a, w, r, n - w < 20 || (a._isStart && w > 20)),
              (n -= n - w);
          }
          if ((f && ((o[f] = e || -0.001), e < 0 && (e = 0)), s)) {
            var E = e + n,
              _ = s._isStart;
            (h = 'scroll' + r.d2),
              So(
                s,
                E,
                r,
                (_ && E > 20) ||
                  (!_ &&
                    (u ? Math.max(Us[h], Vs[h]) : s.parentNode[h]) <= E + 1)
              ),
              u &&
                ((l = po(a)),
                u && (s.style[r.op.p] = l[r.op.p] - r.op.m - s._offset + lo));
          }
          return (
            p &&
              g &&
              ((h = po(g)),
              p.seek(d),
              (m = po(g)),
              (p._caScrollDist = h[r.p] - m[r.p]),
              (e = (e / p._caScrollDist) * d)),
            p && p.seek(v),
            p ? e : Math.round(e)
          );
        },
        Jo = /(webkit|moz|length|cssText|inset)/i,
        el = function (e, t, n, r) {
          if (e.parentNode !== t) {
            var i,
              s,
              a = e.style;
            if (t === Us) {
              for (i in ((e._stOrig = a.cssText), (s = co(e))))
                +i ||
                  Jo.test(i) ||
                  !s[i] ||
                  'string' != typeof a[i] ||
                  '0' === i ||
                  (a[i] = s[i]);
              (a.top = n), (a.left = r);
            } else a.cssText = e._stOrig;
            (Xs.core.getCache(e).uncache = 1), t.appendChild(e);
          }
        },
        tl = function (e, t, n) {
          var r = t,
            i = r;
          return function (t) {
            var s = Math.round(e());
            return (
              s !== r &&
                s !== i &&
                Math.abs(s - r) > 3 &&
                Math.abs(s - i) > 3 &&
                ((t = s), n && n()),
              (i = r),
              (r = t),
              t
            );
          };
        },
        nl = function (e, t, n) {
          var r = {};
          (r[t.p] = '+=' + n), Xs.set(e, r);
        },
        rl = function (e, t) {
          var n = js(e, t),
            r = '_scroll' + t.p2,
            i = function t(i, s, a, o, l) {
              var c = t.tween,
                u = s.onComplete,
                d = {};
              a = a || n();
              var p = tl(n, a, function () {
                c.kill(), (t.tween = 0);
              });
              return (
                (l = (o && l) || 0),
                (o = o || i - a),
                c && c.kill(),
                (s[r] = i),
                (s.modifiers = d),
                (d[r] = function () {
                  return p(a + o * c.ratio + l * c.ratio * c.ratio);
                }),
                (s.onUpdate = function () {
                  Ts.cache++, Xo();
                }),
                (s.onComplete = function () {
                  (t.tween = 0), u && u.call(c);
                }),
                (c = t.tween = Xs.to(e, s))
              );
            };
          return (
            (e[r] = n),
            (n.wheelHandler = function () {
              return i.tween && i.tween.kill() && (i.tween = 0);
            }),
            vo(e, 'wheel', n.wheelHandler),
            il.isTouch && vo(e, 'touchmove', n.wheelHandler),
            i
          );
        },
        il = (function () {
          function e(t, n) {
            Ys ||
              e.register(Xs) ||
              console.warn('Please gsap.registerPlugin(ScrollTrigger)'),
              va(this),
              this.init(t, n);
          }
          return (
            (e.prototype.init = function (t, n) {
              if (
                ((this.progress = this.start = 0),
                this.vars && this.kill(!0, !0),
                ka)
              ) {
                var r,
                  i,
                  s,
                  a,
                  o,
                  l,
                  c,
                  u,
                  d,
                  p,
                  f,
                  h,
                  m,
                  g,
                  v,
                  y,
                  b,
                  w,
                  x,
                  T,
                  E,
                  _,
                  S,
                  C,
                  M,
                  k,
                  A,
                  P,
                  L,
                  O,
                  D,
                  I,
                  z,
                  R,
                  j,
                  N,
                  $,
                  F,
                  q,
                  H,
                  B,
                  X,
                  Y = (t = uo(
                    Ha(t) || Xa(t) || t.nodeType ? { trigger: t } : t,
                    xo
                  )),
                  G = Y.onUpdate,
                  W = Y.toggleClass,
                  V = Y.id,
                  U = Y.onToggle,
                  K = Y.onRefresh,
                  Q = Y.scrub,
                  Z = Y.trigger,
                  J = Y.pin,
                  ee = Y.pinSpacing,
                  te = Y.invalidateOnRefresh,
                  ne = Y.anticipatePin,
                  re = Y.onScrubComplete,
                  ie = Y.onSnapComplete,
                  se = Y.once,
                  ae = Y.snap,
                  oe = Y.pinReparent,
                  le = Y.pinSpacer,
                  ce = Y.containerAnimation,
                  ue = Y.fastScrollEnd,
                  de = Y.preventOverlaps,
                  pe =
                    t.horizontal ||
                    (t.containerAnimation && !1 !== t.horizontal)
                      ? Is
                      : zs,
                  fe = !Q && 0 !== Q,
                  he = Rs(t.scroller || Gs),
                  me = Xs.core.getCache(he),
                  ge = Na(he),
                  ve =
                    'fixed' ===
                    ('pinType' in t
                      ? t.pinType
                      : Cs(he, 'pinType') || (ge && 'fixed')),
                  ye = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
                  be = fe && t.toggleActions.split(' '),
                  we = 'markers' in t ? t.markers : xo.markers,
                  xe = ge ? 0 : parseFloat(co(he)['border' + pe.p2 + ao]) || 0,
                  Te = this,
                  Ee =
                    t.onRefreshInit &&
                    function () {
                      return t.onRefreshInit(Te);
                    },
                  _e = (function (e, t, n) {
                    var r = n.d,
                      i = n.d2,
                      s = n.a;
                    return (s = Cs(e, 'getBoundingClientRect'))
                      ? function () {
                          return s()[r];
                        }
                      : function () {
                          return (t ? Gs['inner' + i] : e['client' + i]) || 0;
                        };
                  })(he, ge, pe),
                  Se = (function (e, t) {
                    return !t || ~Es.indexOf(e)
                      ? $a(e)
                      : function () {
                          return Qo;
                        };
                  })(he, ge),
                  Ce = 0,
                  Me = 0,
                  ke = 0,
                  Ae = js(he, pe);
                if (
                  ((Te._startClamp = Te._endClamp = !1),
                  (Te._dir = pe),
                  (ne *= 45),
                  (Te.scroller = he),
                  (Te.scroll = ce ? ce.time.bind(ce) : Ae),
                  (a = Ae()),
                  (Te.vars = t),
                  (n = n || t.animation),
                  'refreshPriority' in t &&
                    ((ca = 1), -9999 === t.refreshPriority && (Ea = Te)),
                  (me.tweenScroll = me.tweenScroll || {
                    top: rl(he, zs),
                    left: rl(he, Is),
                  }),
                  (Te.tweenTo = r = me.tweenScroll[pe.p]),
                  (Te.scrubDuration = function (e) {
                    (z = Xa(e) && e)
                      ? I
                        ? I.duration(e)
                        : (I = Xs.to(n, {
                            ease: 'expo',
                            totalProgress: '+=0',
                            duration: z,
                            paused: !0,
                            onComplete: function () {
                              return re && re(Te);
                            },
                          }))
                      : (I && I.progress(1).kill(), (I = 0));
                  }),
                  n &&
                    ((n.vars.lazy = !1),
                    (n._initted && !Te.isReverted) ||
                      (!1 !== n.vars.immediateRender &&
                        !1 !== t.immediateRender &&
                        n.duration() &&
                        n.render(0, !0, !0)),
                    (Te.animation = n.pause()),
                    (n.scrollTrigger = Te),
                    Te.scrubDuration(Q),
                    (O = 0),
                    V || (V = n.vars.id)),
                  ae &&
                    ((Ya(ae) && !ae.push) || (ae = { snapTo: ae }),
                    'scrollBehavior' in Us.style &&
                      Xs.set(ge ? [Us, Vs] : he, { scrollBehavior: 'auto' }),
                    Ts.forEach(function (e) {
                      return (
                        Ba(e) &&
                        e.target === (ge ? Ws.scrollingElement || Vs : he) &&
                        (e.smooth = !1)
                      );
                    }),
                    (s = Ba(ae.snapTo)
                      ? ae.snapTo
                      : 'labels' === ae.snapTo
                      ? (function (e) {
                          return function (t) {
                            return Xs.utils.snap(ho(e), t);
                          };
                        })(n)
                      : 'labelsDirectional' === ae.snapTo
                      ? ((H = n),
                        function (e, t) {
                          return mo(ho(H))(e, t.direction);
                        })
                      : !1 !== ae.directional
                      ? function (e, t) {
                          return mo(ae.snapTo)(
                            e,
                            Sa() - Me < 500 ? 0 : t.direction
                          );
                        }
                      : Xs.utils.snap(ae.snapTo)),
                    (R = ae.duration || { min: 0.1, max: 2 }),
                    (R = Ya(R) ? Js(R.min, R.max) : Js(R, R)),
                    (j = Xs.delayedCall(ae.delay || z / 2 || 0.1, function () {
                      var e = Ae(),
                        t = Sa() - Me < 500,
                        i = r.tween;
                      if (
                        !(t || Math.abs(Te.getVelocity()) < 10) ||
                        i ||
                        ra ||
                        Ce === e
                      )
                        Te.isActive && Ce !== e && j.restart(!0);
                      else {
                        var a = (e - l) / g,
                          o = n && !fe ? n.totalProgress() : a,
                          u = t ? 0 : ((o - D) / (Sa() - ea)) * 1e3 || 0,
                          d = Xs.utils.clamp(
                            -a,
                            1 - a,
                            (Va(u / 2) * u) / 0.185
                          ),
                          p = a + (!1 === ae.inertia ? 0 : d),
                          f = Js(0, 1, s(p, Te)),
                          h = Math.round(l + f * g),
                          m = ae,
                          v = m.onStart,
                          y = m.onInterrupt,
                          b = m.onComplete;
                        if (e <= c && e >= l && h !== e) {
                          if (i && !i._initted && i.data <= Va(h - e)) return;
                          !1 === ae.inertia && (d = f - a),
                            r(
                              h,
                              {
                                duration: R(
                                  Va(
                                    (0.185 * Math.max(Va(p - o), Va(f - o))) /
                                      u /
                                      0.05 || 0
                                  )
                                ),
                                ease: ae.ease || 'power3',
                                data: Va(h - e),
                                onInterrupt: function () {
                                  return j.restart(!0) && y && y(Te);
                                },
                                onComplete: function () {
                                  Te.update(),
                                    (Ce = Ae()),
                                    (O = D =
                                      n && !fe
                                        ? n.totalProgress()
                                        : Te.progress),
                                    ie && ie(Te),
                                    b && b(Te);
                                },
                              },
                              e,
                              d * g,
                              h - e - d * g
                            ),
                            v && v(Te, r.tween);
                        }
                      }
                    }).pause())),
                  V && (Mo[V] = Te),
                  (q =
                    (Z = Te.trigger = Rs(Z || (!0 !== J && J))) &&
                    Z._gsap &&
                    Z._gsap.stRevert) && (q = q(Te)),
                  (J = !0 === J ? Z : Rs(J)),
                  Ha(W) && (W = { targets: Z, className: W }),
                  J &&
                    (!1 === ee ||
                      ee === so ||
                      (ee =
                        !(
                          !ee &&
                          J.parentNode &&
                          J.parentNode.style &&
                          'flex' === co(J.parentNode).display
                        ) && io),
                    (Te.pin = J),
                    (i = Xs.core.getCache(J)).spacer
                      ? (v = i.pinState)
                      : (le &&
                          ((le = Rs(le)) &&
                            !le.nodeType &&
                            (le = le.current || le.nativeElement),
                          (i.spacerIsNative = !!le),
                          le && (i.spacerState = Ko(le))),
                        (i.spacer = w = le || Ws.createElement('div')),
                        w.classList.add('pin-spacer'),
                        V && w.classList.add('pin-spacer-' + V),
                        (i.pinState = v = Ko(J))),
                    !1 !== t.force3D && Xs.set(J, { force3D: !0 }),
                    (Te.spacer = w = i.spacer),
                    (L = co(J)),
                    (C = L[ee + pe.os2]),
                    (T = Xs.getProperty(J)),
                    (E = Xs.quickSetter(J, pe.a, lo)),
                    Wo(J, w, L),
                    (b = Ko(J))),
                  we)
                ) {
                  (h = Ya(we) ? uo(we, wo) : wo),
                    (p = _o('scroller-start', V, he, pe, h, 0)),
                    (f = _o('scroller-end', V, he, pe, h, 0, p)),
                    (x = p['offset' + pe.op.d2]);
                  var Pe = Rs(Cs(he, 'content') || he);
                  (u = this.markerStart = _o('start', V, Pe, pe, h, x, 0, ce)),
                    (d = this.markerEnd = _o('end', V, Pe, pe, h, x, 0, ce)),
                    ce && (F = Xs.quickSetter([u, d], pe.a, lo)),
                    ve ||
                      (Es.length && !0 === Cs(he, 'fixedMarkers')) ||
                      ((X = co((B = ge ? Us : he)).position),
                      (B.style.position =
                        'absolute' === X || 'fixed' === X ? X : 'relative'),
                      Xs.set([p, f], { force3D: !0 }),
                      (k = Xs.quickSetter(p, pe.a, lo)),
                      (P = Xs.quickSetter(f, pe.a, lo)));
                }
                if (ce) {
                  var Le = ce.vars.onUpdate,
                    Oe = ce.vars.onUpdateParams;
                  ce.eventCallback('onUpdate', function () {
                    Te.update(0, 0, 1), Le && Le.apply(ce, Oe || []);
                  });
                }
                if (
                  ((Te.previous = function () {
                    return Co[Co.indexOf(Te) - 1];
                  }),
                  (Te.next = function () {
                    return Co[Co.indexOf(Te) + 1];
                  }),
                  (Te.revert = function (e, t) {
                    if (!t) return Te.kill(!0);
                    var r = !1 !== e || !Te.enabled,
                      i = na;
                    r !== Te.isReverted &&
                      (r &&
                        ((N = Math.max(Ae(), Te.scroll.rec || 0)),
                        (ke = Te.progress),
                        ($ = n && n.progress())),
                      u &&
                        [u, d, p, f].forEach(function (e) {
                          return (e.style.display = r ? 'none' : 'block');
                        }),
                      r && ((na = Te), Te.update(r)),
                      !J ||
                        (oe && Te.isActive) ||
                        (r
                          ? (function (e, t, n) {
                              Uo(n);
                              var r = e._gsap;
                              if (r.spacerIsNative) Uo(r.spacerState);
                              else if (e._gsap.swappedIn) {
                                var i = t.parentNode;
                                i && (i.insertBefore(e, t), i.removeChild(t));
                              }
                              e._gsap.swappedIn = !1;
                            })(J, w, v)
                          : Wo(J, w, co(J), M)),
                      r || Te.update(r),
                      (na = i),
                      (Te.isReverted = r));
                  }),
                  (Te.refresh = function (i, s, h, x) {
                    if ((!na && Te.enabled) || s)
                      if (J && i && Ma) vo(e, 'scrollEnd', Io);
                      else {
                        !xa && Ee && Ee(Te),
                          (na = Te),
                          r.tween && (r.tween.kill(), (r.tween = 0)),
                          I && I.pause(),
                          te && n && n.revert({ kill: !1 }).invalidate(),
                          Te.isReverted || Te.revert(!0, !0),
                          (Te._subPinOffset = !1);
                        var E,
                          C,
                          k,
                          P,
                          L,
                          O,
                          D,
                          z,
                          R,
                          F,
                          q,
                          H,
                          B,
                          X = _e(),
                          Y = Se(),
                          G = ce ? ce.duration() : Fa(he, pe),
                          W = g <= 0.01,
                          V = 0,
                          U = x || 0,
                          Q = Ya(h) ? h.end : t.end,
                          ne = t.endTrigger || Z,
                          re = Ya(h)
                            ? h.start
                            : t.start ||
                              (0 !== t.start && Z ? (J ? '0 0' : '0 100%') : 0),
                          ie = (Te.pinnedContainer =
                            t.pinnedContainer && Rs(t.pinnedContainer, Te)),
                          se = (Z && Math.max(0, Co.indexOf(Te))) || 0,
                          ae = se;
                        for (
                          we &&
                          Ya(h) &&
                          ((H = Xs.getProperty(p, pe.p)),
                          (B = Xs.getProperty(f, pe.p)));
                          ae--;

                        )
                          (O = Co[ae]).end || O.refresh(0, 1) || (na = Te),
                            !(D = O.pin) ||
                              (D !== Z && D !== J && D !== ie) ||
                              O.isReverted ||
                              (F || (F = []), F.unshift(O), O.revert(!0, !0)),
                            O !== Co[ae] && (se--, ae--);
                        for (
                          Ba(re) && (re = re(Te)),
                            re = Aa(re, 'start', Te),
                            l =
                              Zo(
                                re,
                                Z,
                                X,
                                pe,
                                Ae(),
                                u,
                                p,
                                Te,
                                Y,
                                xe,
                                ve,
                                G,
                                ce,
                                Te._startClamp && '_startClamp'
                              ) || (J ? -0.001 : 0),
                            Ba(Q) && (Q = Q(Te)),
                            Ha(Q) &&
                              !Q.indexOf('+=') &&
                              (~Q.indexOf(' ')
                                ? (Q = (Ha(re) ? re.split(' ')[0] : '') + Q)
                                : ((V = Eo(Q.substr(2), X)),
                                  (Q = Ha(re)
                                    ? re
                                    : (ce
                                        ? Xs.utils.mapRange(
                                            0,
                                            ce.duration(),
                                            ce.scrollTrigger.start,
                                            ce.scrollTrigger.end,
                                            l
                                          )
                                        : l) + V),
                                  (ne = Z))),
                            Q = Aa(Q, 'end', Te),
                            c =
                              Math.max(
                                l,
                                Zo(
                                  Q || (ne ? '100% 0' : G),
                                  ne,
                                  X,
                                  pe,
                                  Ae() + V,
                                  d,
                                  f,
                                  Te,
                                  Y,
                                  xe,
                                  ve,
                                  G,
                                  ce,
                                  Te._endClamp && '_endClamp'
                                )
                              ) || -0.001,
                            V = 0,
                            ae = se;
                          ae--;

                        )
                          (D = (O = Co[ae]).pin) &&
                            O.start - O._pinPush <= l &&
                            !ce &&
                            O.end > 0 &&
                            ((E =
                              O.end -
                              (Te._startClamp
                                ? Math.max(0, O.start)
                                : O.start)),
                            ((D === Z && O.start - O._pinPush < l) ||
                              D === ie) &&
                              isNaN(re) &&
                              (V += E * (1 - O.progress)),
                            D === J && (U += E));
                        if (
                          ((l += V),
                          (c += V),
                          Te._startClamp && (Te._startClamp += V),
                          Te._endClamp &&
                            !xa &&
                            ((Te._endClamp = c || -0.001),
                            (c = Math.min(c, Fa(he, pe)))),
                          (g = c - l || ((l -= 0.01) && 0.001)),
                          W &&
                            (ke = Xs.utils.clamp(
                              0,
                              1,
                              Xs.utils.normalize(l, c, N)
                            )),
                          (Te._pinPush = U),
                          u &&
                            V &&
                            (((E = {})[pe.a] = '+=' + V),
                            ie && (E[pe.p] = '-=' + Ae()),
                            Xs.set([u, d], E)),
                          J)
                        )
                          (E = co(J)),
                            (P = pe === zs),
                            (k = Ae()),
                            (_ = parseFloat(T(pe.a)) + U),
                            !G &&
                              c > 1 &&
                              ((q = {
                                style: (q = (
                                  ge ? Ws.scrollingElement || Vs : he
                                ).style),
                                value: q['overflow' + pe.a.toUpperCase()],
                              }),
                              ge &&
                                'scroll' !==
                                  co(Us)['overflow' + pe.a.toUpperCase()] &&
                                (q.style['overflow' + pe.a.toUpperCase()] =
                                  'scroll')),
                            Wo(J, w, E),
                            (b = Ko(J)),
                            (C = po(J, !0)),
                            (z = ve && js(he, P ? Is : zs)()),
                            ee &&
                              (((M = [ee + pe.os2, g + U + lo]).t = w),
                              (ae = ee === io ? fo(J, pe) + g + U : 0) &&
                                M.push(pe.d, ae + lo),
                              Uo(M),
                              ie &&
                                Co.forEach(function (e) {
                                  e.pin === ie &&
                                    !1 !== e.vars.pinSpacing &&
                                    (e._subPinOffset = !0);
                                }),
                              ve && Ae(N)),
                            ve &&
                              (((L = {
                                top: C.top + (P ? k - l : z) + lo,
                                left: C.left + (P ? z : k - l) + lo,
                                boxSizing: 'border-box',
                                position: 'fixed',
                              })[Za] = L['max' + ao] =
                                Math.ceil(C.width) + lo),
                              (L[Ja] = L['max' + oo] =
                                Math.ceil(C.height) + lo),
                              (L[so] =
                                L[so + no] =
                                L[so + eo] =
                                L[so + ro] =
                                L[so + to] =
                                  '0'),
                              (L[io] = E[io]),
                              (L[io + no] = E[io + no]),
                              (L[io + eo] = E[io + eo]),
                              (L[io + ro] = E[io + ro]),
                              (L[io + to] = E[io + to]),
                              (y = (function (e, t, n) {
                                for (
                                  var r, i = [], s = e.length, a = n ? 8 : 0;
                                  a < s;
                                  a += 2
                                )
                                  (r = e[a]),
                                    i.push(r, r in t ? t[r] : e[a + 1]);
                                return (i.t = e.t), i;
                              })(v, L, oe)),
                              xa && Ae(0)),
                            n
                              ? ((R = n._initted),
                                ua(1),
                                n.render(n.duration(), !0, !0),
                                (S = T(pe.a) - _ + g + U),
                                (A = Math.abs(g - S) > 1),
                                ve && A && y.splice(y.length - 2, 2),
                                n.render(0, !0, !0),
                                R || n.invalidate(!0),
                                n.parent || n.totalTime(n.totalTime()),
                                ua(0))
                              : (S = g),
                            q &&
                              (q.value
                                ? (q.style['overflow' + pe.a.toUpperCase()] =
                                    q.value)
                                : q.style.removeProperty('overflow-' + pe.a));
                        else if (Z && Ae() && !ce)
                          for (C = Z.parentNode; C && C !== Us; )
                            C._pinOffset &&
                              ((l -= C._pinOffset), (c -= C._pinOffset)),
                              (C = C.parentNode);
                        F &&
                          F.forEach(function (e) {
                            return e.revert(!1, !0);
                          }),
                          (Te.start = l),
                          (Te.end = c),
                          (a = o = xa ? N : Ae()),
                          ce || xa || (a < N && Ae(N), (Te.scroll.rec = 0)),
                          Te.revert(!1, !0),
                          (Me = Sa()),
                          j &&
                            ((Ce = -1),
                            Te.isActive && Ae(l + g * ke),
                            j.restart(!0)),
                          (na = 0),
                          n &&
                            fe &&
                            (n._initted || $) &&
                            n.progress() !== $ &&
                            n.progress($ || 0, !0).render(n.time(), !0, !0),
                          (W || ke !== Te.progress || ce) &&
                            (n &&
                              !fe &&
                              n.totalProgress(
                                ce && l < -0.001 && !ke
                                  ? Xs.utils.normalize(l, c, 0)
                                  : ke,
                                !0
                              ),
                            (Te.progress = W || (a - l) / g === ke ? 0 : ke)),
                          J &&
                            ee &&
                            (w._pinOffset = Math.round(Te.progress * S)),
                          I && I.invalidate(),
                          isNaN(H) ||
                            ((H -= Xs.getProperty(p, pe.p)),
                            (B -= Xs.getProperty(f, pe.p)),
                            nl(p, pe, H),
                            nl(u, pe, H - (x || 0)),
                            nl(f, pe, B),
                            nl(d, pe, B - (x || 0))),
                          W && !xa && Te.update(),
                          !K || xa || m || ((m = !0), K(Te), (m = !1));
                      }
                  }),
                  (Te.getVelocity = function () {
                    return ((Ae() - o) / (Sa() - ea)) * 1e3 || 0;
                  }),
                  (Te.endAnimation = function () {
                    Ga(Te.callbackAnimation),
                      n &&
                        (I
                          ? I.progress(1)
                          : n.paused()
                          ? fe || Ga(n, Te.direction < 0, 1)
                          : Ga(n, n.reversed()));
                  }),
                  (Te.labelToScroll = function (e) {
                    return (
                      (n &&
                        n.labels &&
                        (l || Te.refresh() || l) +
                          (n.labels[e] / n.duration()) * g) ||
                      0
                    );
                  }),
                  (Te.getTrailing = function (e) {
                    var t = Co.indexOf(Te),
                      n =
                        Te.direction > 0
                          ? Co.slice(0, t).reverse()
                          : Co.slice(t + 1);
                    return (
                      Ha(e)
                        ? n.filter(function (t) {
                            return t.vars.preventOverlaps === e;
                          })
                        : n
                    ).filter(function (e) {
                      return Te.direction > 0 ? e.end <= l : e.start >= c;
                    });
                  }),
                  (Te.update = function (e, t, i) {
                    if (!ce || i || e) {
                      var s,
                        u,
                        d,
                        f,
                        h,
                        m,
                        v,
                        x = !0 === xa ? N : Te.scroll(),
                        T = e ? 0 : (x - l) / g,
                        M = T < 0 ? 0 : T > 1 ? 1 : T || 0,
                        L = Te.progress;
                      if (
                        (t &&
                          ((o = a),
                          (a = ce ? Ae() : x),
                          ae &&
                            ((D = O), (O = n && !fe ? n.totalProgress() : M))),
                        ne &&
                          !M &&
                          J &&
                          !na &&
                          !_a &&
                          Ma &&
                          l < x + ((x - o) / (Sa() - ea)) * ne &&
                          (M = 1e-4),
                        M !== L && Te.enabled)
                      ) {
                        if (
                          ((f =
                            (h =
                              (s = Te.isActive = !!M && M < 1) !=
                              (!!L && L < 1)) || !!M != !!L),
                          (Te.direction = M > L ? 1 : -1),
                          (Te.progress = M),
                          f &&
                            !na &&
                            ((u = M && !L ? 0 : 1 === M ? 1 : 1 === L ? 2 : 3),
                            fe &&
                              ((d =
                                (!h && 'none' !== be[u + 1] && be[u + 1]) ||
                                be[u]),
                              (v =
                                n &&
                                ('complete' === d ||
                                  'reset' === d ||
                                  d in n)))),
                          de &&
                            (h || v) &&
                            (v || Q || !n) &&
                            (Ba(de)
                              ? de(Te)
                              : Te.getTrailing(de).forEach(function (e) {
                                  return e.endAnimation();
                                })),
                          fe ||
                            (!I || na || _a
                              ? n && n.totalProgress(M, !(!na || (!Me && !e)))
                              : (I._dp._time - I._start !== I._time &&
                                  I.render(I._dp._time - I._start),
                                I.resetTo
                                  ? I.resetTo(
                                      'totalProgress',
                                      M,
                                      n._tTime / n._tDur
                                    )
                                  : ((I.vars.totalProgress = M),
                                    I.invalidate().restart()))),
                          J)
                        )
                          if ((e && ee && (w.style[ee + pe.os2] = C), ve)) {
                            if (f) {
                              if (
                                ((m =
                                  !e &&
                                  M > L &&
                                  c + 1 > x &&
                                  x + 1 >= Fa(he, pe)),
                                oe)
                              )
                                if (e || (!s && !m)) el(J, w);
                                else {
                                  var z = po(J, !0),
                                    R = x - l;
                                  el(
                                    J,
                                    Us,
                                    z.top + (pe === zs ? R : 0) + lo,
                                    z.left + (pe === zs ? 0 : R) + lo
                                  );
                                }
                              Uo(s || m ? y : b),
                                (A && M < 1 && s) ||
                                  E(_ + (1 !== M || m ? 0 : S));
                            }
                          } else E(za(_ + S * M));
                        ae && !r.tween && !na && !_a && j.restart(!0),
                          W &&
                            (h || (se && M && (M < 1 || !ba))) &&
                            Zs(W.targets).forEach(function (e) {
                              return e.classList[s || se ? 'add' : 'remove'](
                                W.className
                              );
                            }),
                          G && !fe && !e && G(Te),
                          f && !na
                            ? (fe &&
                                (v &&
                                  ('complete' === d
                                    ? n.pause().totalProgress(1)
                                    : 'reset' === d
                                    ? n.restart(!0).pause()
                                    : 'restart' === d
                                    ? n.restart(!0)
                                    : n[d]()),
                                G && G(Te)),
                              (!h && ba) ||
                                (U && h && Wa(Te, U),
                                ye[u] && Wa(Te, ye[u]),
                                se && (1 === M ? Te.kill(!1, 1) : (ye[u] = 0)),
                                h ||
                                  (ye[(u = 1 === M ? 1 : 3)] && Wa(Te, ye[u]))),
                              ue &&
                                !s &&
                                Math.abs(Te.getVelocity()) >
                                  (Xa(ue) ? ue : 2500) &&
                                (Ga(Te.callbackAnimation),
                                I
                                  ? I.progress(1)
                                  : Ga(n, 'reverse' === d ? 1 : !M, 1)))
                            : fe && G && !na && G(Te);
                      }
                      if (P) {
                        var $ = ce
                          ? (x / ce.duration()) * (ce._caScrollDist || 0)
                          : x;
                        k($ + (p._isFlipped ? 1 : 0)), P($);
                      }
                      F && F((-x / ce.duration()) * (ce._caScrollDist || 0));
                    }
                  }),
                  (Te.enable = function (t, n) {
                    Te.enabled ||
                      ((Te.enabled = !0),
                      vo(he, 'resize', Lo),
                      vo(ge ? Ws : he, 'scroll', Ao),
                      Ee && vo(e, 'refreshInit', Ee),
                      !1 !== t && ((Te.progress = ke = 0), (a = o = Ce = Ae())),
                      !1 !== n && Te.refresh());
                  }),
                  (Te.getTween = function (e) {
                    return e && r ? r.tween : I;
                  }),
                  (Te.setPositions = function (e, t, n, r) {
                    if (ce) {
                      var i = ce.scrollTrigger,
                        s = ce.duration(),
                        a = i.end - i.start;
                      (e = i.start + (a * e) / s), (t = i.start + (a * t) / s);
                    }
                    Te.refresh(
                      !1,
                      !1,
                      {
                        start: Pa(e, n && !!Te._startClamp),
                        end: Pa(t, n && !!Te._endClamp),
                      },
                      r
                    ),
                      Te.update();
                  }),
                  (Te.adjustPinSpacing = function (e) {
                    if (M && e) {
                      var t = M.indexOf(pe.d) + 1;
                      (M[t] = parseFloat(M[t]) + e + lo),
                        (M[1] = parseFloat(M[1]) + e + lo),
                        Uo(M);
                    }
                  }),
                  (Te.disable = function (t, n) {
                    if (
                      Te.enabled &&
                      (!1 !== t && Te.revert(!0, !0),
                      (Te.enabled = Te.isActive = !1),
                      n || (I && I.pause()),
                      (N = 0),
                      i && (i.uncache = 1),
                      Ee && yo(e, 'refreshInit', Ee),
                      j &&
                        (j.pause(), r.tween && r.tween.kill() && (r.tween = 0)),
                      !ge)
                    ) {
                      for (var s = Co.length; s--; )
                        if (Co[s].scroller === he && Co[s] !== Te) return;
                      yo(he, 'resize', Lo), yo(he, 'scroll', Ao);
                    }
                  }),
                  (Te.kill = function (e, r) {
                    Te.disable(e, r), I && !r && I.kill(), V && delete Mo[V];
                    var s = Co.indexOf(Te);
                    s >= 0 && Co.splice(s, 1),
                      s === sa && Bo > 0 && sa--,
                      (s = 0),
                      Co.forEach(function (e) {
                        return e.scroller === Te.scroller && (s = 1);
                      }),
                      s || xa || (Te.scroll.rec = 0),
                      n &&
                        ((n.scrollTrigger = null),
                        e && n.revert({ kill: !1 }),
                        r || n.kill()),
                      u &&
                        [u, d, p, f].forEach(function (e) {
                          return e.parentNode && e.parentNode.removeChild(e);
                        }),
                      Ea === Te && (Ea = 0),
                      J &&
                        (i && (i.uncache = 1),
                        (s = 0),
                        Co.forEach(function (e) {
                          return e.pin === J && s++;
                        }),
                        s || (i.spacer = 0)),
                      t.onKill && t.onKill(Te);
                  }),
                  Co.push(Te),
                  Te.enable(!1, !1),
                  q && q(Te),
                  n && n.add && !g)
                ) {
                  var De = Te.update;
                  (Te.update = function () {
                    (Te.update = De), l || c || Te.refresh();
                  }),
                    Xs.delayedCall(0.01, Te.update),
                    (g = 0.01),
                    (l = c = 0);
                } else Te.refresh();
                J &&
                  (function () {
                    if (Ta !== Fo) {
                      var e = (Ta = Fo);
                      requestAnimationFrame(function () {
                        return e === Fo && qo(!0);
                      });
                    }
                  })();
              } else this.update = this.refresh = this.kill = Ia;
            }),
            (e.register = function (t) {
              return (
                Ys ||
                  ((Xs = t || ja()),
                  Ra() && window.document && e.enable(),
                  (Ys = ka)),
                Ys
              );
            }),
            (e.defaults = function (e) {
              if (e) for (var t in e) xo[t] = e[t];
              return xo;
            }),
            (e.disable = function (e, t) {
              (ka = 0),
                Co.forEach(function (n) {
                  return n[t ? 'kill' : 'disable'](e);
                }),
                yo(Gs, 'wheel', Ao),
                yo(Ws, 'scroll', Ao),
                clearInterval(ta),
                yo(Ws, 'touchcancel', Ia),
                yo(Us, 'touchstart', Ia),
                go(yo, Ws, 'pointerdown,touchstart,mousedown', Oa),
                go(yo, Ws, 'pointerup,touchend,mouseup', Da),
                Qs.kill(),
                qa(yo);
              for (var n = 0; n < Ts.length; n += 3)
                bo(yo, Ts[n], Ts[n + 1]), bo(yo, Ts[n], Ts[n + 2]);
            }),
            (e.enable = function () {
              if (
                ((Gs = window),
                (Ws = document),
                (Vs = Ws.documentElement),
                (Us = Ws.body),
                Xs &&
                  ((Zs = Xs.utils.toArray),
                  (Js = Xs.utils.clamp),
                  (va = Xs.core.context || Ia),
                  (ua = Xs.core.suppressOverwrites || Ia),
                  (ya = Gs.history.scrollRestoration || 'auto'),
                  (Ho = Gs.pageYOffset),
                  Xs.core.globals('ScrollTrigger', e),
                  Us))
              ) {
                (ka = 1),
                  La(),
                  Bs.register(Xs),
                  (e.isTouch = Bs.isTouch),
                  (ga =
                    Bs.isTouch &&
                    /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                  vo(Gs, 'wheel', Ao),
                  (Ks = [Gs, Ws, Vs, Us]),
                  Xs.matchMedia
                    ? ((e.matchMedia = function (e) {
                        var t,
                          n = Xs.matchMedia();
                        for (t in e) n.add(t, e[t]);
                        return n;
                      }),
                      Xs.addEventListener('matchMediaInit', function () {
                        return No();
                      }),
                      Xs.addEventListener('matchMediaRevert', function () {
                        return jo();
                      }),
                      Xs.addEventListener('matchMedia', function () {
                        qo(0, 1), zo('matchMedia');
                      }),
                      Xs.matchMedia('(orientation: portrait)', function () {
                        return Po(), Po;
                      }))
                    : console.warn('Requires GSAP 3.11.0 or later'),
                  Po(),
                  vo(Ws, 'scroll', Ao);
                var t,
                  n,
                  r = Us.style,
                  i = r.borderTopStyle,
                  s = Xs.core.Animation.prototype;
                for (
                  s.revert ||
                    Object.defineProperty(s, 'revert', {
                      value: function () {
                        return this.time(-0.01, !0);
                      },
                    }),
                    r.borderTopStyle = 'solid',
                    t = po(Us),
                    zs.m = Math.round(t.top + zs.sc()) || 0,
                    Is.m = Math.round(t.left + Is.sc()) || 0,
                    i
                      ? (r.borderTopStyle = i)
                      : r.removeProperty('border-top-style'),
                    ta = setInterval(ko, 250),
                    Xs.delayedCall(0.5, function () {
                      return (_a = 0);
                    }),
                    vo(Ws, 'touchcancel', Ia),
                    vo(Us, 'touchstart', Ia),
                    go(vo, Ws, 'pointerdown,touchstart,mousedown', Oa),
                    go(vo, Ws, 'pointerup,touchend,mouseup', Da),
                    ia = Xs.utils.checkPrefix('transform'),
                    Go.push(ia),
                    Ys = Sa(),
                    Qs = Xs.delayedCall(0.2, qo).pause(),
                    la = [
                      Ws,
                      'visibilitychange',
                      function () {
                        var e = Gs.innerWidth,
                          t = Gs.innerHeight;
                        Ws.hidden
                          ? ((aa = e), (oa = t))
                          : (aa === e && oa === t) || Lo();
                      },
                      Ws,
                      'DOMContentLoaded',
                      qo,
                      Gs,
                      'load',
                      qo,
                      Gs,
                      'resize',
                      Lo,
                    ],
                    qa(vo),
                    Co.forEach(function (e) {
                      return e.enable(0, 1);
                    }),
                    n = 0;
                  n < Ts.length;
                  n += 3
                )
                  bo(yo, Ts[n], Ts[n + 1]), bo(yo, Ts[n], Ts[n + 2]);
              }
            }),
            (e.config = function (t) {
              'limitCallbacks' in t && (ba = !!t.limitCallbacks);
              var n = t.syncInterval;
              (n && clearInterval(ta)) || ((ta = n) && setInterval(ko, n)),
                'ignoreMobileResize' in t &&
                  (fa = 1 === e.isTouch && t.ignoreMobileResize),
                'autoRefreshEvents' in t &&
                  (qa(yo) || qa(vo, t.autoRefreshEvents || 'none'),
                  (da = -1 === (t.autoRefreshEvents + '').indexOf('resize')));
            }),
            (e.scrollerProxy = function (e, t) {
              var n = Rs(e),
                r = Ts.indexOf(n),
                i = Na(n);
              ~r && Ts.splice(r, i ? 6 : 2),
                t && (i ? Es.unshift(Gs, t, Us, t, Vs, t) : Es.unshift(n, t));
            }),
            (e.clearMatchMedia = function (e) {
              Co.forEach(function (t) {
                return t._ctx && t._ctx.query === e && t._ctx.kill(!0, !0);
              });
            }),
            (e.isInViewport = function (e, t, n) {
              var r = (Ha(e) ? Rs(e) : e).getBoundingClientRect(),
                i = r[n ? Za : Ja] * t || 0;
              return n
                ? r.right - i > 0 && r.left + i < Gs.innerWidth
                : r.bottom - i > 0 && r.top + i < Gs.innerHeight;
            }),
            (e.positionInViewport = function (e, t, n) {
              Ha(e) && (e = Rs(e));
              var r = e.getBoundingClientRect(),
                i = r[n ? Za : Ja],
                s =
                  null == t
                    ? i / 2
                    : t in To
                    ? To[t] * i
                    : ~t.indexOf('%')
                    ? (parseFloat(t) * i) / 100
                    : parseFloat(t) || 0;
              return n
                ? (r.left + s) / Gs.innerWidth
                : (r.top + s) / Gs.innerHeight;
            }),
            (e.killAll = function (e) {
              if (
                (Co.slice(0).forEach(function (e) {
                  return 'ScrollSmoother' !== e.vars.id && e.kill();
                }),
                !0 !== e)
              ) {
                var t = Oo.killAll || [];
                (Oo = {}),
                  t.forEach(function (e) {
                    return e();
                  });
              }
            }),
            e
          );
        })();
      (il.version = '3.12.1'),
        (il.saveStyles = function (e) {
          return e
            ? Zs(e).forEach(function (e) {
                if (e && e.style) {
                  var t = Ro.indexOf(e);
                  t >= 0 && Ro.splice(t, 5),
                    Ro.push(
                      e,
                      e.style.cssText,
                      e.getBBox && e.getAttribute('transform'),
                      Xs.core.getCache(e),
                      va()
                    );
                }
              })
            : Ro;
        }),
        (il.revert = function (e, t) {
          return No(!e, t);
        }),
        (il.create = function (e, t) {
          return new il(e, t);
        }),
        (il.refresh = function (e) {
          return e ? Lo() : (Ys || il.register()) && qo(!0);
        }),
        (il.update = function (e) {
          return ++Ts.cache && Xo(!0 === e ? 2 : 0);
        }),
        (il.clearScrollMemory = $o),
        (il.maxScroll = function (e, t) {
          return Fa(e, t ? Is : zs);
        }),
        (il.getScrollFunc = function (e, t) {
          return js(Rs(e), t ? Is : zs);
        }),
        (il.getById = function (e) {
          return Mo[e];
        }),
        (il.getAll = function () {
          return Co.filter(function (e) {
            return 'ScrollSmoother' !== e.vars.id;
          });
        }),
        (il.isScrolling = function () {
          return !!Ma;
        }),
        (il.snapDirectional = mo),
        (il.addEventListener = function (e, t) {
          var n = Oo[e] || (Oo[e] = []);
          ~n.indexOf(t) || n.push(t);
        }),
        (il.removeEventListener = function (e, t) {
          var n = Oo[e],
            r = n && n.indexOf(t);
          r >= 0 && n.splice(r, 1);
        }),
        (il.batch = function (e, t) {
          var n,
            r = [],
            i = {},
            s = t.interval || 0.016,
            a = t.batchMax || 1e9,
            o = function (e, t) {
              var n = [],
                r = [],
                i = Xs.delayedCall(s, function () {
                  t(n, r), (n = []), (r = []);
                }).pause();
              return function (e) {
                n.length || i.restart(!0),
                  n.push(e.trigger),
                  r.push(e),
                  a <= n.length && i.progress(1);
              };
            };
          for (n in t)
            i[n] =
              'on' === n.substr(0, 2) && Ba(t[n]) && 'onRefreshInit' !== n
                ? o(0, t[n])
                : t[n];
          return (
            Ba(a) &&
              ((a = a()),
              vo(il, 'refresh', function () {
                return (a = t.batchMax());
              })),
            Zs(e).forEach(function (e) {
              var t = {};
              for (n in i) t[n] = i[n];
              (t.trigger = e), r.push(il.create(t));
            }),
            r
          );
        });
      var sl,
        al = function (e, t, n, r) {
          return (
            t > r ? e(r) : t < 0 && e(0),
            n > r ? (r - t) / (n - t) : n < 0 ? t / (t - n) : 1
          );
        },
        ol = function e(t, n) {
          !0 === n
            ? t.style.removeProperty('touch-action')
            : (t.style.touchAction =
                !0 === n
                  ? 'auto'
                  : n
                  ? 'pan-' + n + (Bs.isTouch ? ' pinch-zoom' : '')
                  : 'none'),
            t === Vs && e(Us, n);
        },
        ll = { auto: 1, scroll: 1 },
        cl = function (e) {
          var t,
            n = e.event,
            r = e.target,
            i = e.axis,
            s = (n.changedTouches ? n.changedTouches[0] : n).target,
            a = s._gsap || Xs.core.getCache(s),
            o = Sa();
          if (!a._isScrollT || o - a._isScrollT > 2e3) {
            for (
              ;
              s &&
              s !== Us &&
              ((s.scrollHeight <= s.clientHeight &&
                s.scrollWidth <= s.clientWidth) ||
                (!ll[(t = co(s)).overflowY] && !ll[t.overflowX]));

            )
              s = s.parentNode;
            (a._isScroll =
              s &&
              s !== r &&
              !Na(s) &&
              (ll[(t = co(s)).overflowY] || ll[t.overflowX])),
              (a._isScrollT = o);
          }
          (a._isScroll || 'x' === i) &&
            (n.stopPropagation(), (n._gsapAllow = !0));
        },
        ul = function (e, t, n, r) {
          return Bs.create({
            target: e,
            capture: !0,
            debounce: !1,
            lockAxis: !0,
            type: t,
            onWheel: (r = r && cl),
            onPress: r,
            onDrag: r,
            onScroll: r,
            onEnable: function () {
              return n && vo(Ws, Bs.eventTypes[0], pl, !1, !0);
            },
            onDisable: function () {
              return yo(Ws, Bs.eventTypes[0], pl, !0);
            },
          });
        },
        dl = /(input|label|select|textarea)/i,
        pl = function (e) {
          var t = dl.test(e.target.tagName);
          (t || sl) && ((e._gsapAllow = !0), (sl = t));
        };
      (il.sort = function (e) {
        return Co.sort(
          e ||
            function (e, t) {
              return (
                -1e6 * (e.vars.refreshPriority || 0) +
                e.start -
                (t.start + -1e6 * (t.vars.refreshPriority || 0))
              );
            }
        );
      }),
        (il.observe = function (e) {
          return new Bs(e);
        }),
        (il.normalizeScroll = function (e) {
          if (void 0 === e) return pa;
          if (!0 === e && pa) return pa.enable();
          if (!1 === e) return pa && pa.kill();
          var t =
            e instanceof Bs
              ? e
              : (function (e) {
                  Ya(e) || (e = {}),
                    (e.preventDefault = e.isNormalizer = e.allowClicks = !0),
                    e.type || (e.type = 'wheel,touch'),
                    (e.debounce = !!e.debounce),
                    (e.id = e.id || 'normalizer');
                  var t,
                    n,
                    r,
                    i,
                    s,
                    a,
                    o,
                    l,
                    c = e,
                    u = c.normalizeScrollX,
                    d = c.momentum,
                    p = c.allowNestedScroll,
                    f = c.onRelease,
                    h = Rs(e.target) || Vs,
                    m = Xs.core.globals().ScrollSmoother,
                    g = m && m.get(),
                    v =
                      ga &&
                      ((e.content && Rs(e.content)) ||
                        (g && !1 !== e.content && !g.smooth() && g.content())),
                    y = js(h, zs),
                    b = js(h, Is),
                    w = 1,
                    x =
                      (Bs.isTouch && Gs.visualViewport
                        ? Gs.visualViewport.scale * Gs.visualViewport.width
                        : Gs.outerWidth) / Gs.innerWidth,
                    T = 0,
                    E = Ba(d)
                      ? function () {
                          return d(t);
                        }
                      : function () {
                          return d || 2.8;
                        },
                    _ = ul(h, e.type, !0, p),
                    S = function () {
                      return (i = !1);
                    },
                    C = Ia,
                    M = Ia,
                    k = function () {
                      (n = Fa(h, zs)),
                        (M = Js(ga ? 1 : 0, n)),
                        u && (C = Js(0, Fa(h, Is))),
                        (r = Fo);
                    },
                    A = function () {
                      (v._gsap.y = za(parseFloat(v._gsap.y) + y.offset) + 'px'),
                        (v.style.transform =
                          'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ' +
                          parseFloat(v._gsap.y) +
                          ', 0, 1)'),
                        (y.offset = y.cacheID = 0);
                    },
                    P = function () {
                      k(),
                        s.isActive() &&
                          s.vars.scrollY > n &&
                          (y() > n
                            ? s.progress(1) && y(n)
                            : s.resetTo('scrollY', n));
                    };
                  return (
                    v && Xs.set(v, { y: '+=0' }),
                    (e.ignoreCheck = function (e) {
                      return (
                        (ga &&
                          'touchmove' === e.type &&
                          (function () {
                            if (i) {
                              requestAnimationFrame(S);
                              var e = za(t.deltaY / 2),
                                n = M(y.v - e);
                              if (v && n !== y.v + y.offset) {
                                y.offset = n - y.v;
                                var r = za(
                                  (parseFloat(v && v._gsap.y) || 0) - y.offset
                                );
                                (v.style.transform =
                                  'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ' +
                                  r +
                                  ', 0, 1)'),
                                  (v._gsap.y = r + 'px'),
                                  (y.cacheID = Ts.cache),
                                  Xo();
                              }
                              return !0;
                            }
                            y.offset && A(), (i = !0);
                          })()) ||
                        (w > 1.05 && 'touchstart' !== e.type) ||
                        t.isGesturing ||
                        (e.touches && e.touches.length > 1)
                      );
                    }),
                    (e.onPress = function () {
                      i = !1;
                      var e = w;
                      (w = za(
                        ((Gs.visualViewport && Gs.visualViewport.scale) || 1) /
                          x
                      )),
                        s.pause(),
                        e !== w && ol(h, w > 1.01 || (!u && 'x')),
                        (a = b()),
                        (o = y()),
                        k(),
                        (r = Fo);
                    }),
                    (e.onRelease = e.onGestureStart =
                      function (e, t) {
                        if ((y.offset && A(), t)) {
                          Ts.cache++;
                          var r,
                            i,
                            a = E();
                          u &&
                            ((i =
                              (r = b()) + (0.05 * a * -e.velocityX) / 0.227),
                            (a *= al(b, r, i, Fa(h, Is))),
                            (s.vars.scrollX = C(i))),
                            (i = (r = y()) + (0.05 * a * -e.velocityY) / 0.227),
                            (a *= al(y, r, i, Fa(h, zs))),
                            (s.vars.scrollY = M(i)),
                            s.invalidate().duration(a).play(0.01),
                            ((ga && s.vars.scrollY >= n) || r >= n - 1) &&
                              Xs.to({}, { onUpdate: P, duration: a });
                        } else l.restart(!0);
                        f && f(e);
                      }),
                    (e.onWheel = function () {
                      s._ts && s.pause(),
                        Sa() - T > 1e3 && ((r = 0), (T = Sa()));
                    }),
                    (e.onChange = function (e, t, n, i, s) {
                      if (
                        (Fo !== r && k(),
                        t &&
                          u &&
                          b(
                            C(
                              i[2] === t ? a + (e.startX - e.x) : b() + t - i[1]
                            )
                          ),
                        n)
                      ) {
                        y.offset && A();
                        var l = s[2] === n,
                          c = l ? o + e.startY - e.y : y() + n - s[1],
                          d = M(c);
                        l && c !== d && (o += d - c), y(d);
                      }
                      (n || t) && Xo();
                    }),
                    (e.onEnable = function () {
                      ol(h, !u && 'x'),
                        il.addEventListener('refresh', P),
                        vo(Gs, 'resize', P),
                        y.smooth &&
                          ((y.target.style.scrollBehavior = 'auto'),
                          (y.smooth = b.smooth = !1)),
                        _.enable();
                    }),
                    (e.onDisable = function () {
                      ol(h, !0),
                        yo(Gs, 'resize', P),
                        il.removeEventListener('refresh', P),
                        _.kill();
                    }),
                    (e.lockAxis = !1 !== e.lockAxis),
                    ((t = new Bs(e)).iOS = ga),
                    ga && !y() && y(1),
                    ga && Xs.ticker.add(Ia),
                    (l = t._dc),
                    (s = Xs.to(t, {
                      ease: 'power4',
                      paused: !0,
                      scrollX: u ? '+=0.1' : '+=0',
                      scrollY: '+=0.1',
                      modifiers: {
                        scrollY: tl(y, y(), function () {
                          return s.pause();
                        }),
                      },
                      onUpdate: Xo,
                      onComplete: l.vars.onComplete,
                    })),
                    t
                  );
                })(e);
          return (
            pa && pa.target === t.target && pa.kill(),
            Na(t.target) && (pa = t),
            t
          );
        }),
        (il.core = {
          _getVelocityProp: Ns,
          _inputObserver: ul,
          _scrollers: Ts,
          _proxies: Es,
          bridge: {
            ss: function () {
              Ma || zo('scrollStart'), (Ma = Sa());
            },
            ref: function () {
              return na;
            },
          },
        }),
        ja() && Xs.registerPlugin(il),
        is.registerPlugin(il),
        il.config({ ignoreMobileResize: !0 });
      var fl = n(752),
        hl = n.n(fl);
      is.registerPlugin(il),
        il.config({ ignoreMobileResize: !0 }),
        is.registerPlugin(il),
        il.config({ ignoreMobileResize: !0 });
      var ml = function () {
        document.querySelector('.js-mv-lines');
        var e = document.querySelectorAll('.js-mv-lines .js-mv-line svg');
        fe()('.js-mv-lines').once('enter', function () {
          e.forEach(function (e, t) {
            var n = new (hl())(e.id, {
              duration: 80,
              forceRender: !1,
              animTimingFunction: hl().EASE,
            });
            setTimeout(function () {
              n.play(1);
            }, 300 * t);
          });
        });
      };
      is.registerPlugin(il),
        il.config({ ignoreMobileResize: !0 }),
        t()(function () {
          var e, n, r, i, s, a, o, l, c, u, d, p;
          0 !== t()('.js-front-page').length &&
            (function () {
              var e,
                n,
                r,
                i = t()('#top-lines'),
                s = window.matchMedia('(max-width: 768px)'),
                a = function (t) {
                  t.matches
                    ? ((e = 'translate(-25%, 10%)'),
                      (n = 'rotate(-30deg) translate(-30%, -30%)'),
                      (r = 'rotate(200deg) translate(30%, -28%)'))
                    : ((e = 'translate(-20%, 10%)'),
                      (n = 'rotate(-45deg) translate(-12%, -40%)'),
                      (r = 'rotate(200deg) translate(24%, -28%)'));
                };
              s.addEventListener('change', a), a(s);
              var o = new (hl())('top-lines', {
                duration: 120,
                forceRender: !1,
                animTimingFunction: hl().EASE,
              });
              function l() {
                o.play(1),
                  i.css('transform', e),
                  setTimeout(function () {
                    o.play(-1);
                  }, 5e3),
                  setTimeout(c, 8e3);
              }
              function c() {
                o.play(1),
                  i.css('transform', n),
                  setTimeout(function () {
                    o.play(-1);
                  }, 5e3),
                  setTimeout(u, 8e3);
              }
              function u() {
                o.play(1),
                  i.css('transform', r),
                  setTimeout(function () {
                    o.play(-1);
                  }, 5e3),
                  setTimeout(l, 8e3);
              }
              setTimeout(l, 0),
                is.to(i, {
                  scrollTrigger: {
                    start: 'top 20%',
                    toggleClass: {
                      targets: '#top-lines',
                      className: 'is-gray',
                    },
                    trigger: t()('#about'),
                  },
                });
            })(),
            0 !== t()('.js-pagination').length &&
              (function () {
                t()('.pagination .extend').html('<span></span>'),
                  t()('.pagination .first').text('01'),
                  t()('.pagination .page').each(function (e, n) {
                    var r,
                      i = Number(t()(n).text());
                    (r = i < 10 ? 0 + String(i) : String(i)), t()(n).text(r);
                  });
                var e,
                  n = t()('.pagination .current'),
                  r = Number(t()(n).text());
                (e = r < 10 ? 0 + String(r) : String(r)), t()(n).text(e);
                var i,
                  s = t()('.pagination .last'),
                  a = Number(t()(s).text());
                (i = a < 10 ? 0 + String(a) : String(a)), t()(s).text(i);
              })(),
            0 !== t()('.js-contact-box').length &&
              ((e = document.querySelectorAll('.js-contact-box')[0]),
              (n = document.querySelectorAll('.js-contact-box')[1]),
              (r = document.querySelector('.js-contact-box-area')),
              (i = new (hl())('contact-left-line', {
                duration: 60,
                forceRender: !1,
                animTimingFunction: hl().EASE,
                start: 'manual',
              })),
              (s = new (hl())('business-right-line', {
                duration: 60,
                forceRender: !1,
                animTimingFunction: hl().EASE,
                start: 'manual',
              })),
              e.addEventListener('mouseenter', function (e) {
                  e.target.classList.add('is-on'),
                  r.classList.contains('is-business-hovered') &&
                    r.classList.remove('is-business-hovered'),
                  r.classList.add('is-contact-hovered'),
                  i.play(1);
              }),
              e.addEventListener('mouseleave', function (e) {
                  e.target.classList.remove('is-on'),
                  r.classList.remove('is-contact-hovered'),
                  i.play(-1);
              }),
              n.addEventListener('mouseenter', function (e) {
                  e.target.classList.add('is-on'),
                  r.classList.contains('is-contact-hovered') &&
                    r.classList.remove('is-contact-hovered'),
                  r.classList.add('is-business-hovered'),
                  s.play(1);
              }),
              n.addEventListener('mouseleave', function (e) {
                  e.target.classList.remove('is-on'),
                  r.classList.remove('is-business-hovered'),
                  s.play(-1);
              })),
            0 !== t()('.js-form').length &&
              document.querySelector('.wpcf7').addEventListener(
                'wpcf7invalid',
                function () {
                  var e = t()('#header').innerHeight();
                  setTimeout(function () {
                    var n =
                      t()('.wpcf7-not-valid:first')
                        .parent()
                        .parent()
                        .parent()
                        .offset().top - e;
                    t()('html, body').animate({ scrollTop: n }, 1e3, 'swing');
                  }, 500);
                },
                !1
              ),
            0 !== t()('.js-sub-mv-lines-inview').length &&
              (function () {
                var e = new (hl())('sub-mv-top-line-left', {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  }),
                  t = new (hl())('sub-mv-top-line-right', {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                fe()('.js-sub-mv-lines-inview').once('enter', function (n) {
                  e.play(1), t.play(1);
                });
              })(),
            0 !== t()('.js-inview-mindset').length &&
              (fe()('.js-inview-mindset-01').once('enter', function (e) {
                e.classList.add('inview-is-visible');
                var t = e.querySelector('svg').id,
                  n = new (hl())(t, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                setTimeout(function () {
                  n.play(1);
                }, 500);
              }),
              fe()('.js-inview-mindset-02').once('enter', function (e) {
                e.classList.add('inview-is-visible');
                var t = e.querySelector('svg').id,
                  n = new (hl())(t, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                setTimeout(function () {
                  n.play(1);
                }, 500);
              }),
              fe()('.js-inview-mindset-03').once('enter', function (e) {
                e.classList.add('inview-is-visible');
                var t = e.querySelector('svg').id,
                  n = new (hl())(t, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                setTimeout(function () {
                  n.play(1);
                }, 500);
              }),
              fe()('.js-inview-mindset-04').once('enter', function (e) {
                e.classList.add('inview-is-visible');
                var t = e.querySelector('svg').id,
                  n = new (hl())(t, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                setTimeout(function () {
                  n.play(1);
                }, 500);
              }),
              fe()('.js-inview-mindset-05').once('enter', function (e) {
                e.classList.add('inview-is-visible');
                var t = e.querySelector('svg').id,
                  n = new (hl())(t, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                setTimeout(function () {
                  n.play(1);
                }, 500);
              })),
            0 !== t()('.js-line-anim-inview').length &&
              document
                .querySelectorAll('.js-line-anim-inview svg')
                .forEach(function (e) {
                  var t = new (hl())(e.id, {
                    duration: 80,
                    forceRender: !1,
                    animTimingFunction: hl().EASE,
                  });
                  fe()(''.concat(e.id)).once('enter', function () {
                    t.play(1);
                  });
                }),
            0 !== t()('.js-mv-lines').length && ml(),
            0 !== t()('.js-section-lines').length &&
              ((a = document.querySelectorAll('.js-section-lines')),
              (o = new IntersectionObserver(
                function (e, t) {
                  e.forEach(function (e) {
                    e.isIntersecting &&
                      (
                      e.target
                        .querySelectorAll('.js-section-line')
                        .forEach(function (e, t) {
                          var n,
                            r = e.querySelector('svg'),
                            i = new (hl())(r.id, {
                              duration: 80,
                              forceRender: !1,
                              animTimingFunction: hl().EASE,
                            });
                          if ((i.stop(), e.dataset.sectionLineDelay)) {
                            n = e.dataset.sectionLineDelay;
                            var s = Number(n);
                            setTimeout(function () {
                              i.play(1);
                            }, s);
                          } else
                            setTimeout(function () {
                              i.play(1);
                            }, 300 * t);
                        }),
                      t.unobserve(e.target));
                  });
                },
                { rootMargin: '-50px 0px' }
              )),
              a.forEach(function (e) {
                o.observe(e);
              })),
            new J('.js-logo-slider', {
              spaceBetween: 0,
              width: 690,
              freeMode: !0,
            }),
            window
              .matchMedia('(max-width:768px)')
              .addEventListener('change', function () {
                window.location.reload();
              }),
            new J('.js-gallery-slider', {
              spaceBetween: 8,
              loop: !0,
              slidesPerView: 1.2,
              loopedSlides: 2,
              centeredSlides: !0,
              autoplay: { delay: 0 },
              speed: 6e3,
              allowTouchMove: !1,
              breakpoints: { 769: { slidesPerView: 2.5 } },
            }),
            is.utils.toArray('.js-text-scroll-trigger').forEach(function (e) {
              var t = e.querySelector('.js-text-scroll');
              is.to(t, {
                x: '-50%',
                ease: 'power1.in',
                scrollTrigger: {
                  trigger: e,
                  start: 'top center',
                  end: '+=1000',
                  scrub: 4,
                },
              });
            }),
            new J('.js-service-slider', {
              spaceBetween: 12,
              slidesPerView: 1,
              autoplay: { delay: 5e3, disableOnInteraction: !1 },
              speed: 1e3,
              on: {
                slideChange: function () {
                  this.el.classList.contains('not-first-round') ||
                    this.el.classList.add('not-first-round');
                },
              },
            }),
            (l = t()('#manager-modal')),
            (c = t()('.js-manager-modal-close')),
            (u = t()('.js-manager-modal-item')),
            t()('.js-manager-modal-btn').on('click', function () {
              var e = t()(this).data('manager-modal-id');
              l.addClass('is-active'),
                t()('[data-manager-modal="'.concat(e, '"]')).addClass(
                  'is-active'
                ),
                t()('body').addClass('is-scroll-disabled');
            }),
            c.on('click', function () {
              t()('body').removeClass('is-scroll-disabled'),
                l.removeClass('is-active'),
                u.removeClass('is-active');
            }),
            fe()('.inview').on('enter', function (e) {
              e.classList.add('inview-is-visible');
            }),
            fe()('.inview-custom').on('enter', function (e) {
              e.classList.add('inview-is-visible');
            }),
            fe()('.js-inview-data-01').once('enter', function (e) {
              e.classList.add('inview-is-visible'),
                t()(e)
                  .find('.js-count-up')
                  .each(function () {
                    var e = this,
                      n = t()(this).data('delay');
                    setTimeout(function () {
                      he(t()(e));
                    }, n);
                  });
            }),
            fe()('.js-inview-data-02').once('enter', function (e) {
              e.classList.add('inview-is-visible'),
                t()(e)
                  .find('.js-count-up')
                  .each(function () {
                    var e = this,
                      n = t()(this).data('delay');
                    setTimeout(function () {
                      he(t()(e));
                    }, n);
                  });
            }),
            fe()('.js-inview-data-03').once('enter', function (e) {
              e.classList.add('inview-is-visible'),
                t()(e)
                  .find('.js-count-up')
                  .each(function () {
                    var e = this,
                      n = t()(this).data('delay');
                    setTimeout(function () {
                      he(t()(e));
                    }, n);
                  });
            }),
            t()('.js-accordion').each(function () {
              var e = t()(this).find('.js-accordion-trigger');
              t()(this).find('.js-accordion-content').hide(),
                t()(this).find('.js-accordion-content').eq(0).show(),
                t()(this)
                  .find('.js-accordion-trigger')
                  .eq(0)
                  .addClass('is-open'),
                e.on('click', function () {
                  t()(this).toggleClass('is-open'),
                    t()(this).find('.js-accordion-content').slideToggle();
                });
            }),
            (function () {
              var e = t()('.js-header-trigger');
              if (0 !== e.length) {
                var n = e.outerHeight() - 80;
                window.addEventListener('scroll', function () {
                  var e = window.scrollY,
                    r = t()('body');
                  e <= 522
                    ? r.hasClass('is-scrolled') && r.removeClass('is-scrolled')
                    : r.hasClass('is-scrolled') || r.addClass('is-scrolled');
                });
              } else
                window.addEventListener('scroll', function () {
                  var e = window.scrollY,
                    n = t()('body');
                  e <= 100
                    ? n.hasClass('is-scrolled') && n.removeClass('is-scrolled')
                    : n.hasClass('is-scrolled') || n.addClass('is-scrolled');
                });
            })(),
            (d = t()('.js-news-tab-selector')),
            (p = t()('.js-news-tab')),
            t()('.js-news-tab:first-of-type').css('display', 'block'),
            d.on('click', function () {
              var e = t()(this).parent().index();
              d.removeClass('is-active'),
                t()(this).addClass('is-active'),
                p.hide().eq(e).fadeIn(300);
            }),
            (function () {
              var e = new (hl())('line-menu-left', {
                  duration: 80,
                  forceRender: !1,
                  animTimingFunction: hl().EASE,
                }),
                n = new (hl())('line-menu-right', {
                  duration: 80,
                  forceRender: !1,
                  animTimingFunction: hl().EASE,
                });
              t()('#hamburger-btn').on('click', function () {
                t()('body').toggleClass('is-hamburger-open'),
                  t()('.js-hamburger-menu').toggleClass('is-open'),
                  t()('body').hasClass('is-hamburger-open')
                    ? (e.play(1), n.play(1))
                    : (e.play(-1), n.play(-1));
              });
            })(),
            t()('.js-scroll-to-top').on('click', function () {
              t()('html, body').animate({ scrollTop: 0 });
            }),
            (function () {
              var e,
                n = window.matchMedia('(max-width: 768px)'),
                r = function (n) {
                  e = n.matches
                    ? t()('#header').innerHeight()
                    : t()('#header').innerHeight() - 52;
                };
              n.addEventListener('change', r), r(n);
              var i = location.hash;
              i &&
                (t()('body,html').stop().scrollTop(0),
                setTimeout(function () {
                  var n = t()(i).offset().top - e;
                  t()('body,html').stop().animate({ scrollTop: n }, 500),
                    setTimeout(function () {
                      t()('body').addClass('is-scrolled');
                    }, 550);
                }, 500)),
                t()('a[href^="#"]').on('click', function () {
                  if (!t()(this).hasClass('js-no-scroll')) {
                    var n = t()(this).attr('href'),
                      r = t()(n).offset().top - e;
                    t()('body,html').stop().animate({ scrollTop: r }, 500),
                      setTimeout(function () {
                        t()('body').addClass('is-scrolled');
                      }, 550);
                  }
                });
            })(),
            is.utils.toArray('.js-hr-scroll').forEach(function (e) {
              var n = e.querySelector('.js-hr-scroll-wrapper'),
                r = e.querySelector('.js-hr-scroll-content');
              function i() {
                t()(window).width() > 768 &&
                  is.to(r, {
                    x: function () {
                      return -(r.clientWidth - n.clientWidth);
                    },
                    ease: 'none',
                    scrollTrigger: {
                      trigger: e,
                      start: 'top 5%',
                      end: function () {
                        return '+='.concat(r.clientWidth - n.clientWidth);
                      },
                      scrub: !0,
                      pin: !0,
                      anticipatePin: 1,
                      invalidateOnRefresh: !0,
                    },
                  });
              }
              t()(window).resize(function () {
                i();
              }),
                i();
            }),
            (function () {
              var e = t()('#service-modal'),
                n = t()('.js-service-modal-close'),
                r = t()('.js-service-modal-group');
              t()('.js-service-modal-btn').on('click', function () {
                var n = t()(this).data('service-modal-id');
                e.addClass('is-active'),
                  t()('[data-service-modal="'.concat(n, '"]')).addClass(
                    'is-active'
                  ),
                  t()('body').addClass('is-scroll-disabled');
              }),
                n.on('click', function () {
                  t()('body').removeClass('is-scroll-disabled'),
                    e.removeClass('is-active'),
                    r.removeClass('is-active');
                });
            })(),
            (function () {
              var e = t()('.js-job-tab-selector'),
                n = t()('.js-job-tab');
              t()('.js-job-tab:first-of-type').css('display', 'block'),
                e.on('click', function () {
                  var r = t()(this).parent().index();
                  e.removeClass('is-active'),
                    t()(this).addClass('is-active'),
                    n.hide().eq(r).fadeIn(300);
                });
            })(),
            ml(),
            t()('.js-nav-sub-trigger')
              .on('mouseover', function () {
                t()(this).addClass('is-active'),
                  t()(this).find('.js-nav-sub-parent').addClass('is-active'),
                  t()(this).find('.js-nav-sub').addClass('is-active');
              })
              .on('mouseout', function () {
                t()(this).removeClass('is-active'),
                  t()(this).find('.js-nav-sub-parent').removeClass('is-active'),
                  t()(this).find('.js-nav-sub').removeClass('is-active');
              }),
            is.utils.toArray('.js-auto-scroll').forEach(function (e, t) {
              var n = 0,
                r = !0,
                i = e.querySelectorAll('.js-auto-scroll-el'),
                s = is
                  .to(i, {
                    xPercent: -100,
                    repeat: -1,
                    duration: 10,
                    ease: 'linear',
                  })
                  .totalProgress(0.5);
              is.set(e, { xPercent: 0 }),
                window.addEventListener('scroll', function () {
                  (r = window.scrollY > n),
                    is.to(s, { timeScale: r ? 1 : -1 }),
                    (n = window.scrollY);
                });
            });
        });
    })();
})();
//# sourceMappingURL=main.js.map

/* =====================================================================
 * お知らせバー(PHP脆弱性に関する弊社サービスへの影響について / 一時掲載)
 * 全ページ共通。沈静化後に撤去する際は、このブロックごと削除すればよい。
 * ・ヘッダー(position:fixed)の上に固定表示し、ヘッダーを実測分だけ下げる
 * ・localStorage で閉じた状態を記憶(再表示しない)
 * ===================================================================== */
(function () {
  var KEY = 'sparticleNoticePhp2026';
  try { if (localStorage.getItem(KEY) === 'closed') return; } catch (e) {}

  // 注:当サイトの WP テーマは html{font-size:12px} のため rem を避け px で固定する
  var CSS =
    '.sp-notice{position:fixed;top:0;left:0;right:0;z-index:11;display:flex;align-items:center;justify-content:center;gap:12px;padding:9px 44px;background:#eaf1fd;color:#202733;font-size:14px;line-height:1.5;text-align:center;border-bottom:1px solid #c9d1db;font-family:"Hiragino Kaku Gothic ProN","Yu Gothic",Meiryo,system-ui,sans-serif}' +
    '.sp-notice-txt{font-weight:600;color:inherit;text-decoration:none}.sp-notice-txt:hover{text-decoration:underline}' +
    '.sp-notice-close{position:absolute;right:10px;top:50%;transform:translateY(-50%);display:flex;align-items:center;justify-content:center;width:28px;height:28px;padding:0;border:0;border-radius:6px;background:transparent;color:#5b6472;font-size:20px;line-height:1;cursor:pointer}' +
    '.sp-notice-close:hover{background:rgba(5,83,221,.08);color:#202733}' +
    '.sp-notice-on .header{top:var(--sp-nb-h,40px)}' +
    '@media(max-width:640px){.sp-notice{font-size:13px;padding:8px 40px}}';

  function setH(bar) {
    try { document.documentElement.style.setProperty('--sp-nb-h', bar.offsetHeight + 'px'); } catch (e) {}
  }

  function init() {
    if (document.getElementById('spNotice')) return;

    var st = document.createElement('style');
    st.id = 'spNoticeStyle';
    st.textContent = CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'sp-notice';
    bar.id = 'spNotice';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'お知らせ');
    bar.innerHTML =
      '<a class="sp-notice-txt" href="/ja/php-vulnerability-notice">【重要なお知らせ】PHPの脆弱性に関する弊社サービスへの影響について（影響なし）</a>' +
      '<button type="button" class="sp-notice-close" aria-label="このお知らせを閉じる">×</button>';
    document.body.insertBefore(bar, document.body.firstChild);
    document.documentElement.classList.add('sp-notice-on');
    setH(bar);
    window.addEventListener('resize', function () { setH(bar); });

    bar.querySelector('.sp-notice-close').addEventListener('click', function () {
      try { localStorage.setItem(KEY, 'closed'); } catch (e) {}
      document.documentElement.classList.remove('sp-notice-on');
      try { document.documentElement.style.removeProperty('--sp-nb-h'); } catch (e) {}
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
